import * as React from 'react';
import React__default, { useState, useEffect, useRef } from 'react';
import purify from 'dompurify';
import require$$0$3 from 'util';
import react_dom_1 from 'react-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$3 = Array.isArray;

var isArray_1 = isArray$3;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = _freeGlobal || freeSelf || Function('return this')();

var _root = root$1;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$4.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$3.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$2(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol$2;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$1.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

var apiUrl = {
    insuranceDetails: '/msapi/salesproductorchestration/v1/{0}?skuId={1}&mode={2}&productTypes={3}&expand=compatibleFeatures&losgTypes={4}&paymentType={5}&source={6}&zipCode={7}',
    planContentFragments: '/msapi/idp-content-orchestration/v1/idpcms/sales/wireless/productselectionconfig',
    zipCodeValidation: '/msapi/cart/v1/zipCode'
};

var zipCodeContent = {
    zipCodeLabel: 'Billing ZIP Code',
    zipCodeCopy: "We’ll use your billing ZIP Code to show what’s available to you.",
    zipCodeUpdateCTA: 'UPDATE',
};
var insuranceConstants = {
    insuranceNoThanksOfferId: 'NA',
    protectedAdvantage: 'Protected Advantage',
    mobileInsurance: 'Mobile Insurance',
};
var alertMessage = "You've changed your ZIP Code. Here are updated pricing and coverage options for your area.";
var errorLabel = 'Hmm, that’s not a valid ZIP Code. Please try again.';
var alertOnApiFail = 'System error - content was not able to load properly. Please try again.';
var signupModalConstants = {
    cancelCTALabel: 'Cancel',
    signUpCTALabel: 'Sign Up',
    modalErrorMessage: 'Oops, Something went wrong!! Please try again.',
};
var requestItem;
(function (requestItem) {
    requestItem["mode"] = "buyflow";
    requestItem["productTypes"] = "device";
    requestItem["losgTypes"] = "NEW";
    requestItem["paymentType"] = "postpaid";
    requestItem["source"] = "PSC";
})(requestItem || (requestItem = {}));

/**
 * Search for multiple placeholders from input string and replace it using an array of strings.
 * @param {String} text with placeholder.
 * @param {Array} content to be passed and replace in with placeholder.
 * @returns {String} text with replaced content.
 */
function interpolatePlaceholders(textWithPlaceholder, content) {
    if (textWithPlaceholder !== undefined && content.length > 0) {
        content.map(function (value, index) {
            textWithPlaceholder = textWithPlaceholder.replace('{' + index + '}', value);
        });
        return textWithPlaceholder;
    }
}
var processedNoInsuranceHeader = function (noThanksDesc) {
    var noInsuranceHeader;
    if (noThanksDesc) {
        var list = noThanksDesc.split(':</p>');
        if (list && list.length > 1) {
            noInsuranceHeader = list[0].replace('<p>', '');
        }
    }
    return noInsuranceHeader;
};
var processedNoInsuranceContent = function (noThanksDesc, price) {
    var processedDesc;
    if (noThanksDesc) {
        var list = noThanksDesc.split(':</p>');
        if (list && list.length > 1) {
            processedDesc = list[1];
        }
        if (price != null) {
            processedDesc = processedDesc.replace('[[fullprice]]', price);
        }
        else {
            processedDesc = processedDesc.replace(' ($[[fullprice]])', '');
        }
    }
    return processedDesc;
};

var plansContentFragment = {
    "master": {
        "addInsuranceLabel": "Add",
        "finalizeDeviceLabel": "Done with device",
        "goBackLabel": "Go back",
        "md5Heading": "What you need to know before you sign up",
        "panelHeading": "Add Insurance",
        "panelImage": "/buy/images/wireless/insurance_desktop.png",
        "removeInsuranceLabel": "Remove",
        "seeMoreOptionsLabel": "See more insurance options",
        "selectedButtonLabel": "Selected",
        "updateInsuranceLabel": "Update Cart",
        "viewButtonLabel": "View",
        "enrollInsuranceLabel": "Sign up",
        "cancelInsuranceLabel": "Cancel",
        "selectButtonLabel": "Select",
        "switchToThis": "Switch to this",
        "keepThis": "Keep this",
        "dontWantInsurance": "Skip insurance",
        "addMoreInsurance": "Add more insurance",
        "protectionRemoved": "Device Protection Removed",
        "reconsider": "Reconsider",
        "primaryDeviceLabel": "Primary device:",
        "enrollMoreDevices": "Enroll another device",
        "noInsuranceSelected": "You didn’t insure your device",
        "insuranceDeclineMsg": "Remember: You only have 30 days to sign up.",
        "addInsuranceCta": "Add insurance",
        "imagePath": "https://www.att.com/idpassets/buy/wireless/insurance/wireless_ins_broken_device.png",
        "addInsuranceAndSupportLabel": "Add insurance & support",
        "devicesToEnroll": "Devices to enroll",
        "primaryDeviceToEnroll": "Primary device to enroll",
        "pa4Description": "This insurance covers up to 4 devices. Pick one device now to be the primary device. You can add the other devices any time after you enroll.",
        "noThanks": "I don’t want device protection",
        "continueWithout": "Continue without device protection",
        "addInsuranceSubHeading": "Replace your lost, stolen, or broken phone and get the support you need fast.",
        "addInsuranceSubHeadingCollapsed": "Replace your lost, stolen, or broken phone and get the support you need fast.",
        "addNoInsuranceDropDown": "I don’t want device protection",
        "addToCart": "Add to cart",
        "edit": "Edit",
        "insuranceSupportText": "Insurance & support for ",
        "dropdownHeading": "How would you like to protect your device?",
        "enrollingYour": "Enrolling your ",
        "insuranceSelectionHeadingExpanded": "Device protection",
        "insuranceSelectionHeadingCollapsed": "Device protection",
        "suffix": "/mo.",
        "prefix": "+",
        "insurancePrice": "$[[insuranceprice]]",
        "insuranceContinueCTA": "Continue",
        "continueWithoutCTALabel": "Continue without device protection",
        "insuranceHeadsUpModalHeading": "Some things to keep in mind",
        "insuranceHeadsUpModalDescription": "<p>If you decide you don’t want device protection, keep in mind:</p><ul><li>Your device might not be protected if it's lost, stolen, damaged, or has other issues not covered by warranty.</li><li>You may have to pay full retail price ($[[fullprice]]) for a replacement.</li><li>You're responsible for any remaining installment payments on a lost, stolen, or damaged device.</li><li>You only have 30 days from activation or upgrade to sign up if you change your mind.</li></ul>",
        "seeInsuranceCTALabel": "See insurance options",
        "insuranceModalHeading": "Heads up! Your device isn’t protected.",
        "insuranceModalSubHeader": "If you decide not to insure your device, keep in mind:",
        "insuranceModalContent": "<ul><li>Your device might not be protected if it's lost, stolen, or damaged.</li><li>You may have to pay full retail price to replace it.</li><li>You’ll still owe any remaining installment payments if you need to replace your device.</li><li>You only have 30 days from activation or upgrade to sign up.</li></ul>",
        "insuranceModalSeeOptions": "See insurance options",
        "insuranceModalContinue": "Continue without insurance",
        "insurancesList": [
            {
                "master": {
                    "offerId": "prod1040075",
                    "ranking": "100",
                    "legal": [
                        {
                            "master": {
                                "shortTextURL": "/ecms/sharedcontent/en/legal/ipd-platform/sales/buy/wireless/deductibles_10-22-19_MI/jcr:content/desktoplegal/legalsharedcontent.json",
                                "variationID": "5a954382-8774-3476-bdd7-4e63b30fb851"
                            }
                        }
                    ],
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Insurance for 1 device",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "80eaacfc-6fa0-3ca2-b40c-218db3501d45"
                            }
                        },
                        {
                            "master": {
                                "description": "$49 screen-repair deductible",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "3781497f-b7e5-30f3-a9fe-70c79166a5c8"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalModalPath": [
                                "/idpassets/fragment/legal/prod/legalmodal/wireless/plans/insurance_mobileinsurance_con-and-smb/att-mobile-insurance-tooltip.cmsfeed.js"
                            ],
                            "legalShortPath": {
                                "master": {
                                    "heading": "What you need to know before you sign up",
                                    "legalText": "<ul>\n<li>There’s a non-refundable deductible required when you file a claim. Deductibles range from $25 to $299. <a name=\"deductible\" datatype=\"tooltip\"></a></li>\n<li>You can have 2 claims, each with a maximum device value of $2,500, per 12-month period.</li>\n<li>Your replacement may be new or AT&T Certified Restored.<a name=\"restored\" datatype=\"tooltip\"></a></li>\n<li>Coverage is optional. You can cancel anytime with no penalty.</li>\n<li>See the sales brochure for additional details (<a href=\"https://www.att.com/ecms/dam/att/consumer/help/pdf/ATT-Device-Protection-Plan-Details-042020-English.pdf\" target=\"_blank\">English</a> | <a href=\"https://www.att.com/ecms/dam/att/consumer/help/pdf/ATT-Device-Protection-Plan-Details-042020-Spanish.pdf\" target=\"_blank\">Spanish</a>)</li>\n</ul>",
                                    "variationID": "ac6fe5b6-5e56-3b48-a2d2-eeec15a46fc2"
                                }
                            },
                            "variationID": "934bb2bf-d657-37dc-9662-b9b9f1706aa9"
                        }
                    },
                    "variationID": "64055a22-6972-3a2d-a2e9-ede9ef9210bf"
                }
            },
            {
                "master": {
                    "offerId": "prod10350232",
                    "ranking": "200",
                    "legal": [
                        {
                            "master": {
                                "shortTextURL": "/ecms/sharedcontent/en/legal/ipd-platform/sales/buy/wireless/deductibles_pa1/jcr:content/desktoplegal/legalsharedcontent.json",
                                "variationID": "bcc6b6b6-6d1d-3fbc-a0d5-ccb0d012a6f9"
                            }
                        }
                    ],
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Insurance for 1 device",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "f3f7dc14-ad1e-39e8-a702-eaddef00433f"
                            }
                        },
                        {
                            "master": {
                                "description": "U.S.-based expert support",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "c09f2f8a-49c8-35a3-8ddf-95da0ddbfce4"
                            }
                        },
                        {
                            "master": {
                                "description": "Same-day replacement &amp; setup",
                                "imageName": "checkMark",
                                "ranking": "300",
                                "variationID": "a82d0dde-78e2-32eb-adb1-88dbcaab1b6d"
                            }
                        },
                        {
                            "master": {
                                "description": "$29 screen-repair deductible",
                                "imageName": "checkMark",
                                "ranking": "400",
                                "variationID": "1d99c3fe-399b-3eca-888b-4720724f425b"
                            }
                        },
                        {
                            "master": {
                                "description": "Unlimited battery replacement",
                                "imageName": "checkMark",
                                "ranking": "500",
                                "variationID": "69e60d7c-7f75-314b-9047-fc30da93726e"
                            }
                        },
                        {
                            "master": {
                                "description": "Unlimited photo &amp; video storage",
                                "imageName": "checkMark",
                                "ranking": "600",
                                "variationID": "80d3d0f3-68c6-3556-8174-a8c8eabef9d4"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalModalPath": [
                                "/idpassets/fragment/legal/prod/legalmodal/wireless/plans/insurance_protect-advantage-1/protect-advantage-1-tooltip.cmsfeed.js"
                            ],
                            "legalShortPath": {
                                "master": {
                                    "heading": "What you need to know before you sign up",
                                    "legalText": "<ul>\n<li><b>3 claims for loss, theft, and physical damage</b></li>\n<li><b>2 claims for accidental damage from handling</b></li>\n<li><b>Unlimited out-of-warranty malfunction claims</b></li>\n<li>Coverage is optional. You can cancel anytime with no penalty.</li>\n<li>Maximum device value of $3,500 per claim</li>\n<li>There’s a non-refundable deductible /service fee required when you file a claim. Deductibles / service fees range from $25 to $275.</li>\n<li>Your replacement may be new, refurbished or remanufactured.</li>\n<li>Terms and Conditions for device protection products contain binding Arbitration Agreements.&nbsp;</li>\n</ul>\n<p>See the sales brochure for additional details (<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_CONS_ENG_PROPD022207120Eab_FFL.pdf\" style=\"background-color: rgb(255, 255, 255);\">English</a>&nbsp;|&nbsp;<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_CONS_SPA_PROPD022207121Sab_FFL.pdf\" style=\"background-color: rgb(255, 255, 255);\">Spanish</a>)<br>\n</p>\n<p>#!</p>\n<p>#*See additional important disclosures for New York customers.*#</p>\n<ul>\n<li>See additional important disclosures for New York customers.</li>\n<li>See the New York sales brochure for additional details (<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_NY_CONS_ENG_PROPD022207123Eab_FFL.pdf\">English</a>&nbsp;|&nbsp;<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_NY_CONS_SPA_PROPD022207124Sab_FFL.pdf\">Spanish</a>)</li>\n<li>You can purchase Protect Insurance for 1 or 4, Protect Extended Service Contract for 1 or 4, or ProTech for 1 or 4 separately by calling 800-331-0500.</li>\n<li>If you are enrolled in Protect Insurance, and you submit proof that you have purchased and maintain a separate extended service contract, the premium for Protect Insurance for 1 will be reduced by: $0.25 (Tiers 1–3) and $0.50 (Tier 4).&nbsp;&nbsp;&nbsp;</li>\n<li>AT&amp;T has a limited license to sell wireless communications equipment insurance in New York (license #LR-1133676) and will be paid a portion of your contract purchase price by the insurer, CNA. AT&amp;T will be compensated by the insurer if you purchase the insurance.&nbsp; AT&amp;T's compensation may vary based on the product you purchased. For more information about compensation, please contact a sales representative.</li>\n<li>If your device is damaged or if your lost device is later found, you can avoid non-return fees of up to $850 (the fee is based on the cost of the claim to the insurance company) by simply returning the device as directed by us in the return envelope that we provide to you.</li>\n<li>This insurance coverage does contain limitations and exclusions. Loss due to indirect or consequential loss, intentional acts, abuse, technological obsolescence or depreciation, cosmetic damage, accidental damage from handling, unauthorized repair or replacement, pollutants, failure to follow the manufacturer’s instructions, manufacturer recall, mechanical or electrical failure, batteries unless it is part of the covered loss, malware, nuclear reaction or radiation, war, governmental action, damage to data, nonstandard external media, and nonstandard software, failure to reasonably protect the device from any further loss, accidental damage from handling, are excluded. All exclusions and limitations can be found in the full terms and conditions.!#</li>\n</ul>\n",
                                    "variationID": "66698b50-d9cc-3cbe-a217-203463a6dd1d"
                                }
                            },
                            "variationID": "0d96f0dd-1266-39cd-bc0f-6f773ba1497c"
                        }
                    },
                    "variationID": "52da3d55-0b0b-30c2-a6b8-aa62d7803185"
                }
            },
            {
                "master": {
                    "offerId": "prod7950364",
                    "ranking": "300",
                    "legal": [
                        {
                            "master": {
                                "shortTextURL": "/ecms/sharedcontent/en/legal/ipd-platform/sales/buy/wireless/deductibles_pa4/jcr:content/desktoplegal/legalsharedcontent.json",
                                "variationID": "d7cef502-c293-31d0-a3ed-cc172e30b166"
                            }
                        }
                    ],
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Everything in Protect Advantage for 1",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "cfa27ec9-c3e8-3146-b1d0-dbf91f567dd6"
                            }
                        },
                        {
                            "master": {
                                "description": "Coverage for up to 3 more devices— even ones that aren't on your AT&amp;T WIRELESS<sup>SM</sup> plan",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "5aa09a2a-54de-347b-8673-46e497f159a1"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalModalPath": [
                                "/idpassets/fragment/legal/prod/legalmodal/wireless/plans/insurance_protect-advantage-4/protect-advantage-4-tooltip.cmsfeed.js"
                            ],
                            "legalShortPath": {
                                "master": {
                                    "heading": "What you need to know before you sign up",
                                    "legalText": "<ul>\n<li><b>8 shared claims for loss, theft, and physical damage</b></li>\n<li><b>6 shared claims for accidental damage from handling<br>\n</b></li>\n<li><b>Unlimited out-of-warranty malfunction claims</b><br>\n</li>\n<li>Coverage is optional. You can cancel anytime with no penalty.<br>\n</li>\n<li>Maximum device value of $3,500 per claim</li>\n<li>There’s a non-refundable deductible /service fee required when you file a claim. Deductibles / service fees range from $25 to $275.</li>\n<li>Your replacement may be new, refurbished or remanufactured.</li>\n<li>Terms and Conditions for device protection products contain binding Arbitration Agreements.&nbsp;</li>\n</ul>\n<p>See the sales brochure for additional details (<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_CONS_ENG_PROPD022207120Eab_FFL.pdf\">English</a>&nbsp;|&nbsp;<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_CONS_SPA_PROPD022207121Sab_FFL.pdf\">Spanish</a>)</p>\n<p>#!</p>\n<p>#*See additional important disclosures for New York customers.*#</p>\n<ul>\n<li>See additional important disclosures for New York customers.</li>\n<li>See the New York sales brochure for additional details (<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_NY_CONS_ENG_PROPD022207123Eab_FFL.pdf\">English</a>&nbsp;|&nbsp;<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_NY_CONS_SPA_PROPD022207124Sab_FFL.pdf\">Spanish</a>)</li>\n<li>You can purchase Protect Insurance for 1 or 4, Protect Extended Service Contract for 1 or 4, or ProTech for 1 or 4 separately by calling 800-331-0500.</li>\n<li>If you are enrolled in Protect Insurance, and you submit proof that you have purchased and maintain a separate extended service contract, the premium for Protect Insurance for 1 will be reduced by: $0.25 (Tiers 1–3) and $0.50 (Tier 4).&nbsp;&nbsp;&nbsp;</li>\n<li>AT&amp;T has a limited license to sell wireless communications equipment insurance in New York (license #LR-1133676) and will be paid a portion of your contract purchase price by the insurer, CNA. AT&amp;T will be compensated by the insurer if you purchase the insurance.&nbsp; AT&amp;T's compensation may vary based on the product you purchased. For more information about compensation, please contact a sales representative.</li>\n<li>If your device is damaged or if your lost device is later found, you can avoid non-return fees of up to $850 (the fee is based on the cost of the claim to the insurance company) by simply returning the device as directed by us in the return envelope that we provide to you.</li>\n<li>This insurance coverage does contain limitations and exclusions. Loss due to indirect or consequential loss, intentional acts, abuse, technological obsolescence or depreciation, cosmetic damage, accidental damage from handling, unauthorized repair or replacement, pollutants, failure to follow the manufacturer’s instructions, manufacturer recall, mechanical or electrical failure, batteries unless it is part of the covered loss, malware, nuclear reaction or radiation, war, governmental action, damage to data, nonstandard external media, and nonstandard software, failure to reasonably protect the device from any further loss, accidental damage from handling, are excluded. All exclusions and limitations can be found in the full terms and conditions.!#</li>\n</ul>\n",
                                    "variationID": "da046f3b-21a1-3248-ba5e-35a034743a46"
                                }
                            },
                            "variationID": "7fed27d3-31be-32e0-a23a-a4b91a25a2be"
                        }
                    },
                    "variationID": "03e6e1d1-8a00-3591-8106-cca16a2f3008"
                }
            },
            {
                "master": {
                    "offerId": "prod10350236",
                    "ranking": "300",
                    "description": "Protect more devices.",
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Insurance &amp; ProTech support for 4 devices",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "bf9e361b-90db-37da-9db9-b501525fb6d1"
                            }
                        },
                        {
                            "master": {
                                "description": "$29 screen repair deductible",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "52663c01-c554-34de-b65e-340fbc0dcc3f"
                            }
                        },
                        {
                            "master": {
                                "description": "Battery replacement with no deductible",
                                "imageName": "checkMark",
                                "ranking": "300",
                                "variationID": "f730fd48-1988-3fb6-8ef8-86fe6616545e"
                            }
                        },
                        {
                            "master": {
                                "description": "Unlimited cloud storage for photos &amp; videos",
                                "imageName": "checkMark",
                                "ranking": "400",
                                "variationID": "080e0f87-5483-32b5-ad93-ab0a6d32264b"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalModalPath": [
                                "/idpassets/fragment/legal/prod/legalmodal/wireless/plans/insurance_protect-advantage-business-4/att-protect-advantage-business-4-tooltip.cmsfeed.js"
                            ],
                            "legalShortPath": {
                                "master": {
                                    "heading": "What you need to know before you sign up",
                                    "legalText": "<ul>\n<li>There's a non-refundable deductible required when you file a claim. Deductibles range from $25 to $299. <a name=\"deductible\" datatype=\"tooltip\"></a></li>\n<li>You can have 8 claims, each with a maximum device value of $2,500, per 12-month period.</li>\n<li>Your replacement may be new or AT&T Certified Restored.<a name=\"restored\" datatype=\"tooltip\"></a></li>\n<li>There may be limitations on the size of each video that is to be backed up and secured within the cloud storage.</li>\n<li>Coverage is optional. You can cancel any time with no penalty.</li>\n</ul>",
                                    "variationID": "e781c68a-c363-3661-a99c-549f41906a72"
                                }
                            },
                            "variationID": "13231988-ef5c-3720-942b-53405be3c9c7"
                        }
                    },
                    "variationID": "50cc7315-8d5c-35cd-8ab7-f431cdaddff2"
                }
            },
            {
                "master": {
                    "offerId": "prod10350234",
                    "ranking": "300",
                    "description": "Get help with your device when you need it most.",
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Insurance &amp; ProTech support for 1 device",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "0a9a256e-2459-39f8-993e-a4cf43a510e7"
                            }
                        },
                        {
                            "master": {
                                "description": "$29 screen repair deductible",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "2228ff8a-457a-3137-95e3-aa9509d1d5b9"
                            }
                        },
                        {
                            "master": {
                                "description": "Battery replacement with no deductible",
                                "imageName": "checkMark",
                                "ranking": "300",
                                "variationID": "8b07a882-d12f-3dc3-9807-def33b0604ca"
                            }
                        },
                        {
                            "master": {
                                "description": "Unlimited cloud storage for photos &amp; videos",
                                "imageName": "checkMark",
                                "ranking": "400",
                                "variationID": "c9a2a992-16cc-3ec5-94b0-4f701c91c05b"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalModalPath": [
                                "/idpassets/fragment/legal/prod/legalmodal/wireless/plans/insurance_protect-advantage-business-1/att-protect-advantage-business-1-tooltip.cmsfeed.js"
                            ],
                            "legalShortPath": {
                                "master": {
                                    "heading": "What you need to know before you sign up",
                                    "legalText": "<ul>\n<li>There's a non-refundable deductible required when you file a claim. Deductibles range from $25 to $299. <a name=\"deductible\" datatype=\"tooltip\"></a></li>\n<li>You can have 3 claims, each with a maximum device value of $2,500, per 12-month period.</li>\n<li>Your replacement may be new or AT&T Certified Restored.<a name=\"restored\" datatype=\"tooltip\"></a></li>\n<li>There may be limitations on the size of each video that is to be backed up and secured within the cloud storage.</li>\n<li>Coverage is optional. You can cancel any time with no penalty.</li>\n</ul>",
                                    "variationID": "476cba70-a0db-3d15-b206-f8a370350af0"
                                }
                            },
                            "variationID": "d4b1a613-af46-3952-ba5e-ebbbbe7edccc"
                        }
                    },
                    "variationID": "571afeda-85f6-39b1-8443-c1645ac45da8"
                }
            },
            {
                "master": {
                    "offerId": "NA",
                    "ranking": "400",
                    "description": "If you decide you don’t want device protection, keep in mind:",
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Your device might not be protected if it's lost, stolen, damaged, or has other issues not covered by warranty.",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "8e609019-3524-3a30-8d48-ea36882b58f0"
                            }
                        },
                        {
                            "master": {
                                "description": "You may have to pay full retail price ($[[fullprice]]) for a replacement.",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "9c499bf4-edf9-35e4-9116-fb6728052736"
                            }
                        },
                        {
                            "master": {
                                "description": "You're responsible for any remaining installment payments on a lost, stolen, or damaged device.",
                                "imageName": "checkMark",
                                "ranking": "300",
                                "variationID": "312041bf-b360-3a22-84b8-45fe5c9ee080"
                            }
                        },
                        {
                            "master": {
                                "description": "You only have 30 days from activation or upgrade to sign up if you change your mind.",
                                "imageName": "checkMark",
                                "ranking": "400",
                                "variationID": "38db76ef-a0e8-3e3b-b6c8-08cd1e52dd60"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalShortPath": {},
                            "variationID": "fc487b2f-6120-3f1c-9023-ca26d47442d1"
                        }
                    },
                    "variationID": "9a369fef-75ea-39d8-b0b2-8d79a855babe"
                }
            },
            {
                "master": {
                    "offerId": "NA_SMB",
                    "ranking": "400",
                    "description": "By declining device protection:",
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Your device might not be protected if it's lost, stolen, damaged, or has other issues not covered by warranty.",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "f7ab74e7-25b0-36da-ba22-688857b5b431"
                            }
                        },
                        {
                            "master": {
                                "description": "You may have to pay full retail price for a replacement or pay the remaining installment payments on a lost, stolen, or damaged device.&nbsp;",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "9efbbd17-b280-3b71-8b4e-481ac9c1693e"
                            }
                        },
                        {
                            "master": {
                                "description": "You're responsible for any remaining installment payments on a lost, stolen, or damaged device.",
                                "imageName": "checkMark",
                                "ranking": "300",
                                "variationID": "9a633b19-e424-3c7b-97bb-ee1ad66654fc"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalShortPath": {
                                "master": {
                                    "heading": "By declining device protection:",
                                    "legalText": "<ul>\n<li>Your device may not be protected if it’s lost, damaged, or has other issues not covered by warranty.</li>\n<li>You might have to pay full retail price for a replacement or pay your remaining installment payments on a lost, stolen, or damaged device. </li>\n<li>If you change your mind, you have 30 days from device activation to enroll.</li>\n</ul>",
                                    "variationID": "051f0d8f-2633-340a-ad35-db2026d266b6"
                                }
                            },
                            "variationID": "20023f08-a699-381a-8d99-f432851a886c"
                        }
                    },
                    "variationID": "274e7d0a-d451-3c5d-b6bd-badac931ec7a"
                }
            },
            {
                "master": {
                    "offerId": "prod11490252,prod11490253,prod11480289,prod11490251,prod11480290",
                    "ranking": "300",
                    "legal": [
                        {
                            "master": {
                                "shortTextURL": "/ecms/sharedcontent/en/legal/ipd-platform/sales/buy/wireless/deductibles_pa4/jcr:content/desktoplegal/legalsharedcontent.json",
                                "variationID": "d7cef502-c293-31d0-a3ed-cc172e30b166"
                            }
                        }
                    ],
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Coverage for up to 4-devices even ones that aren’t on your AT&amp;T WIRELESS plan",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "0812ecb4-b06d-36dd-bccb-a86375e35d70"
                            }
                        },
                        {
                            "master": {
                                "description": "Same benefits of Protect Advantage for 1 and more",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "40a54ddd-4e3e-3f7e-b349-fc80e3641b91"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalModalPath": [
                                "/idpassets/fragment/legal/prod/legalmodal/wireless/plans/insurance_protect-advantage-4/protect-advantage-4-tooltip.cmsfeed.js"
                            ],
                            "legalShortPath": {
                                "master": {
                                    "heading": "What you need to know before you sign up",
                                    "legalText": "<ul>\n<li><b>8 shared claims for loss, theft, and physical damage</b></li>\n<li><b>6 shared claims for accidental damage from handling<br>\n</b></li>\n<li><b>Unlimited out-of-warranty malfunction claims</b><br>\n</li>\n<li>Coverage is optional. You can cancel anytime with no penalty.<br>\n</li>\n<li>Maximum device value of $3,500 per claim</li>\n<li>There’s a non-refundable deductible /service fee required when you file a claim. Deductibles / service fees range from $25 to $275.</li>\n<li>Your replacement may be new, refurbished or remanufactured.</li>\n<li>Terms and Conditions for device protection products contain binding Arbitration Agreements.&nbsp;</li>\n</ul>\n<p>See the sales brochure for additional details (<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_CONS_ENG_PROPD022207120Eab_FFL.pdf\">English</a>&nbsp;|&nbsp;<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_CONS_SPA_PROPD022207121Sab_FFL.pdf\">Spanish</a>)</p>\n<p>#!</p>\n<p>#*See additional important disclosures for New York customers.*#</p>\n<ul>\n<li>See additional important disclosures for New York customers.</li>\n<li>See the New York sales brochure for additional details (<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_NY_CONS_ENG_PROPD022207123Eab_FFL.pdf\">English</a>&nbsp;|&nbsp;<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_NY_CONS_SPA_PROPD022207124Sab_FFL.pdf\">Spanish</a>)</li>\n<li>You can purchase Protect Insurance for 1 or 4, Protect Extended Service Contract for 1 or 4, or ProTech for 1 or 4 separately by calling 800-331-0500.</li>\n<li>If you are enrolled in Protect Insurance, and you submit proof that you have purchased and maintain a separate extended service contract, the premium for Protect Insurance for 1 will be reduced by: $0.25 (Tiers 1–3) and $0.50 (Tier 4).&nbsp;&nbsp;&nbsp;</li>\n<li>AT&amp;T has a limited license to sell wireless communications equipment insurance in New York (license #LR-1133676) and will be paid a portion of your contract purchase price by the insurer, CNA. AT&amp;T will be compensated by the insurer if you purchase the insurance.&nbsp; AT&amp;T's compensation may vary based on the product you purchased. For more information about compensation, please contact a sales representative.</li>\n<li>If your device is damaged or if your lost device is later found, you can avoid non-return fees of up to $850 (the fee is based on the cost of the claim to the insurance company) by simply returning the device as directed by us in the return envelope that we provide to you.</li>\n<li>This insurance coverage does contain limitations and exclusions. Loss due to indirect or consequential loss, intentional acts, abuse, technological obsolescence or depreciation, cosmetic damage, accidental damage from handling, unauthorized repair or replacement, pollutants, failure to follow the manufacturer’s instructions, manufacturer recall, mechanical or electrical failure, batteries unless it is part of the covered loss, malware, nuclear reaction or radiation, war, governmental action, damage to data, nonstandard external media, and nonstandard software, failure to reasonably protect the device from any further loss, accidental damage from handling, are excluded. All exclusions and limitations can be found in the full terms and conditions.!#</li>\n</ul>\n",
                                    "variationID": "da046f3b-21a1-3248-ba5e-35a034743a46"
                                }
                            },
                            "variationID": "7fed27d3-31be-32e0-a23a-a4b91a25a2be"
                        }
                    },
                    "variationID": "c8831a03-7914-3216-8236-be509ecfe901"
                }
            },
            {
                "master": {
                    "offerId": "prod11480320,prod11480322,prod11480321,prod11490224,prod1149022,prod11490225,prod11490226,prod11490245,prod11490247,prod11480287,prod11490230,prod11490234,prod1149023,prod11490231,prod11490232,prod11490244,prod11490235,prod11490236,prod11490237,prod11490246,prod11480323,prod11480329,prod11480331,prod11480330,prod11480288,prod11490249,prod11490248,prod11490250",
                    "ranking": "200",
                    "legal": [
                        {
                            "master": {
                                "shortTextURL": "/ecms/sharedcontent/en/legal/ipd-platform/sales/buy/wireless/deductibles_pa1/jcr:content/desktoplegal/legalsharedcontent.json",
                                "variationID": "bcc6b6b6-6d1d-3fbc-a0d5-ccb0d012a6f9"
                            }
                        }
                    ],
                    "shortDetailsExpanded": [
                        {
                            "master": {
                                "description": "Same day replacement and set up",
                                "imageName": "checkMark",
                                "ranking": "100",
                                "variationID": "7dda7f72-82c1-3300-8de6-8a177a2b81ea"
                            }
                        },
                        {
                            "master": {
                                "description": "Unlimited screen repairs",
                                "imageName": "checkMark",
                                "ranking": "200",
                                "variationID": "00bf36db-ccc2-3e8b-a0a4-fb4af4a37f61"
                            }
                        },
                        {
                            "master": {
                                "description": "Unlimited battery replacement",
                                "imageName": "checkMark",
                                "ranking": "300",
                                "variationID": "7ffa020f-037e-3059-9646-993edc6b3dc6"
                            }
                        },
                        {
                            "master": {
                                "description": "Unlimited photo and video storage",
                                "imageName": "checkMark",
                                "ranking": "400",
                                "variationID": "ea258567-dd71-3424-8569-b383fbc8a173"
                            }
                        }
                    ],
                    "legalIDP": {
                        "master": {
                            "legalModalPath": [
                                "/idpassets/fragment/legal/prod/legalmodal/wireless/plans/insurance_protect-advantage-1/protect-advantage-1-tooltip.cmsfeed.js"
                            ],
                            "legalShortPath": {
                                "master": {
                                    "heading": "What you need to know before you sign up",
                                    "legalText": "<ul>\n<li><b>3 claims for loss, theft, and physical damage</b></li>\n<li><b>2 claims for accidental damage from handling</b></li>\n<li><b>Unlimited out-of-warranty malfunction claims</b></li>\n<li>Coverage is optional. You can cancel anytime with no penalty.</li>\n<li>Maximum device value of $3,500 per claim</li>\n<li>There’s a non-refundable deductible /service fee required when you file a claim. Deductibles / service fees range from $25 to $275.</li>\n<li>Your replacement may be new, refurbished or remanufactured.</li>\n<li>Terms and Conditions for device protection products contain binding Arbitration Agreements.&nbsp;</li>\n</ul>\n<p>See the sales brochure for additional details (<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_CONS_ENG_PROPD022207120Eab_FFL.pdf\" style=\"background-color: rgb(255, 255, 255);\">English</a>&nbsp;|&nbsp;<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_CONS_SPA_PROPD022207121Sab_FFL.pdf\" style=\"background-color: rgb(255, 255, 255);\">Spanish</a>)<br>\n</p>\n<p>#!</p>\n<p>#*See additional important disclosures for New York customers.*#</p>\n<ul>\n<li>See additional important disclosures for New York customers.</li>\n<li>See the New York sales brochure for additional details (<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_NY_CONS_ENG_PROPD022207123Eab_FFL.pdf\">English</a>&nbsp;|&nbsp;<a href=\"https://www.att.com/idpassets/buy/wireless/pdfs/PA_NY_CONS_SPA_PROPD022207124Sab_FFL.pdf\">Spanish</a>)</li>\n<li>You can purchase Protect Insurance for 1 or 4, Protect Extended Service Contract for 1 or 4, or ProTech for 1 or 4 separately by calling 800-331-0500.</li>\n<li>If you are enrolled in Protect Insurance, and you submit proof that you have purchased and maintain a separate extended service contract, the premium for Protect Insurance for 1 will be reduced by: $0.25 (Tiers 1–3) and $0.50 (Tier 4).&nbsp;&nbsp;&nbsp;</li>\n<li>AT&amp;T has a limited license to sell wireless communications equipment insurance in New York (license #LR-1133676) and will be paid a portion of your contract purchase price by the insurer, CNA. AT&amp;T will be compensated by the insurer if you purchase the insurance.&nbsp; AT&amp;T's compensation may vary based on the product you purchased. For more information about compensation, please contact a sales representative.</li>\n<li>If your device is damaged or if your lost device is later found, you can avoid non-return fees of up to $850 (the fee is based on the cost of the claim to the insurance company) by simply returning the device as directed by us in the return envelope that we provide to you.</li>\n<li>This insurance coverage does contain limitations and exclusions. Loss due to indirect or consequential loss, intentional acts, abuse, technological obsolescence or depreciation, cosmetic damage, accidental damage from handling, unauthorized repair or replacement, pollutants, failure to follow the manufacturer’s instructions, manufacturer recall, mechanical or electrical failure, batteries unless it is part of the covered loss, malware, nuclear reaction or radiation, war, governmental action, damage to data, nonstandard external media, and nonstandard software, failure to reasonably protect the device from any further loss, accidental damage from handling, are excluded. All exclusions and limitations can be found in the full terms and conditions.!#</li>\n</ul>\n",
                                    "variationID": "66698b50-d9cc-3cbe-a217-203463a6dd1d"
                                }
                            },
                            "variationID": "0d96f0dd-1266-39cd-bc0f-6f773ba1497c"
                        }
                    },
                    "variationID": "10fa10d2-56b6-33fd-b733-e8badf886da7"
                }
            }
        ],
        "variationID": "6f4a89c2-0ade-333a-9c26-c83a5306eeb3"
    }
};

var insuranceApiUrl = apiUrl.insuranceDetails;
var insurancePlansList = get_1(plansContentFragment, 'master.insurancesList', []);
var currentProductId = '';
var initInsuranceSupportObject = '';
var insuranceSupportObject = initInsuranceSupportObject;
var fetchInsuranceSupportUI = function (url, campaignIdHeader) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    headers: __assign({ 'accept-encoding': 'gzip,deflate' }, campaignIdHeader && { 'idp-campaign-id': campaignIdHeader }),
                }).then(function (data) {
                    return data
                        .json()
                        .then(function (response) {
                        var _a, _b;
                        if (response) {
                            var objLength = Object.keys((_b = (_a = response['idp-cms-feed']) === null || _a === void 0 ? void 0 : _a.productselectionconfig) === null || _b === void 0 ? void 0 : _b.contentFragments).length;
                            if (objLength) {
                                insuranceSupportObject =
                                    response['idp-cms-feed'].productselectionconfig.contentFragments.insurance;
                                return insuranceSupportObject;
                            }
                            else {
                                console.warn('fetchInsuranceSupportUI: response length is: ' + objLength);
                            }
                        }
                    })
                        .catch(function (err) { return console.error('fetchInsuranceSupportUI: fetch error: ' + err); });
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var fetchInsuranceList = function (skuId, productId, zipCode, campaignIdHeader, requestObject) { return __awaiter(void 0, void 0, void 0, function () {
    var mode, productTypes, losgTypes, paymentType, source, contentArray, processedUrl, headers, res, dataJson, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentProductId = productId;
                mode = (requestObject === null || requestObject === void 0 ? void 0 : requestObject.mode) ? requestObject === null || requestObject === void 0 ? void 0 : requestObject.mode : requestItem.mode;
                productTypes = (requestObject === null || requestObject === void 0 ? void 0 : requestObject.productTypes) ? requestObject === null || requestObject === void 0 ? void 0 : requestObject.productTypes : requestItem.productTypes;
                losgTypes = (requestObject === null || requestObject === void 0 ? void 0 : requestObject.losgTypes) ? requestObject === null || requestObject === void 0 ? void 0 : requestObject.losgTypes : requestItem.losgTypes;
                paymentType = (requestObject === null || requestObject === void 0 ? void 0 : requestObject.paymentType) ? requestObject === null || requestObject === void 0 ? void 0 : requestObject.paymentType : requestItem.paymentType;
                source = (requestObject === null || requestObject === void 0 ? void 0 : requestObject.source) ? requestObject === null || requestObject === void 0 ? void 0 : requestObject.source : requestItem.source;
                contentArray = [productId, skuId, mode, productTypes, losgTypes, paymentType, source, zipCode];
                processedUrl = interpolatePlaceholders(insuranceApiUrl, contentArray);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                headers = __assign({ 'Access-Control-Allow-Origin': '*', 'Cache-Control': 'no-cache', ContentType: 'application/json' }, campaignIdHeader && { 'idp-campaign-id': campaignIdHeader });
                return [4 /*yield*/, fetch("" + processedUrl, { method: 'GET', headers: headers })];
            case 2:
                res = _a.sent();
                if (!(res && res.ok)) return [3 /*break*/, 4];
                return [4 /*yield*/, res.json()];
            case 3:
                dataJson = _a.sent();
                return [2 /*return*/, createInsurancePlansList(dataJson)];
            case 4: return [3 /*break*/, 6];
            case 5:
                e_1 = _a.sent();
                console.error('fetchInsuranceList: fetch error: ' + e_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
var updateValidZipcode = function (zipcode, campaignIdHeader) { return __awaiter(void 0, void 0, void 0, function () {
    var postRes, jsonResponse, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("" + apiUrl.zipCodeValidation, {
                        body: JSON.stringify({ zipCode: zipcode }),
                        method: 'POST',
                        headers: __assign({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }, campaignIdHeader && { 'idp-campaign-id': campaignIdHeader }),
                    })];
            case 1:
                postRes = _a.sent();
                return [4 /*yield*/, postRes.json()];
            case 2:
                jsonResponse = _a.sent();
                return [2 /*return*/, jsonResponse];
            case 3:
                e_2 = _a.sent();
                console.log(e_2);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
var createInsurancePlansList = function (insuranceData) {
    var insuranceList = [];
    var applicableFeature = get_1(insuranceData, "content.wireless.devices." + currentProductId + ".product.childSkus", undefined);
    var insuranceOptions = get_1(insuranceData, 'content.wireless.features', undefined);
    if (insuranceOptions) {
        Object.keys(insuranceOptions).forEach(function (productId) {
            applicableFeature[0].applicableFeatures.map(function (applicableFeatureId) {
                if (applicableFeatureId === productId) {
                    var insuranceItem_1 = insuranceOptions[productId];
                    var shortDetailsExpanded_1 = [];
                    insurancePlansList.map(function (currentInsurance) {
                        var offerId = get_1(currentInsurance, 'master.offerId', undefined);
                        if (offerId.split(',').includes(productId)) {
                            shortDetailsExpanded_1 = get_1(currentInsurance, 'master.shortDetailsExpanded', []);
                            insuranceItem_1.shortDetailsExpanded = shortDetailsExpanded_1;
                        }
                    });
                    appendShotDetailsExpanded(insuranceItem_1, productId);
                    insuranceList.push(insuranceItem_1);
                }
            });
        });
    }
    return insuranceList;
};
var appendShotDetailsExpanded = function (insuranceItem, productId) {
    var shortDetailsExpanded = [];
    insurancePlansList.map(function (currentInsurance) {
        var offerId = get_1(currentInsurance, 'master.offerId', undefined);
        if (offerId.split(',').includes(productId)) {
            shortDetailsExpanded = get_1(currentInsurance, 'master.shortDetailsExpanded', []);
            insuranceItem.shortDetailsExpanded = shortDetailsExpanded;
        }
    });
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var insuranceModal = "InsuranceModal-module_insuranceModal__1Xm8T";
var cardShell = "InsuranceModal-module_cardShell__oQSMo";
var noSelection = "InsuranceModal-module_noSelection__DpdkR";
var collapseSection = "InsuranceModal-module_collapseSection__v4BLn";
var insuranceModelSize = "InsuranceModal-module_insuranceModelSize__pNvCg";
var roundBorder = "InsuranceModal-module_roundBorder__8DiV2";
var container = "InsuranceModal-module_container__WFdCF";
var error$1 = "InsuranceModal-module_error__hx-6B";
var alert$1 = "InsuranceModal-module_alert__9-rhi";
var fontsize = "InsuranceModal-module_fontsize__7BNgG";
var alertIcon = "InsuranceModal-module_alertIcon__-yRuU";
var labelPosition = "InsuranceModal-module_labelPosition__glvkY";
var zipCodeFont = "InsuranceModal-module_zipCodeFont__nv8qs";
var buttonClass = "InsuranceModal-module_buttonClass__c-aba";
var panel = "InsuranceModal-module_panel__CPzQW";
var panelMain = "InsuranceModal-module_panelMain__N-vaH";
var bannerText = "InsuranceModal-module_bannerText__TvC-s";
var overallPadding = "InsuranceModal-module_overallPadding__qWYB0";
var expanded = "InsuranceModal-module_expanded__-yqpx";
var arrowIcon = "InsuranceModal-module_arrowIcon__fG-j0";
var editArrowIcon = "InsuranceModal-module_editArrowIcon__TiEMv";
var toggleText = "InsuranceModal-module_toggleText__UqlSy";
var noThanksSubcontent = "InsuranceModal-module_noThanksSubcontent__fRUTi";
var fontNothanks = "InsuranceModal-module_fontNothanks__xYLRN";
var insurancePlanHeading = "InsuranceModal-module_insurancePlanHeading__fEjfz";
var planDescription = "InsuranceModal-module_planDescription__FsUfI";
var noThanksDesc = "InsuranceModal-module_noThanksDesc__8QDPB";
var drawerOuter = "InsuranceModal-module_drawerOuter__We0yd";
var insuranceHeading = "InsuranceModal-module_insuranceHeading__9sRbd";
var bannerToggle = "InsuranceModal-module_bannerToggle__GICif";
var insurancePlanWrapper = "InsuranceModal-module_insurancePlanWrapper__pW9E8";
var toggleScroll = "InsuranceModal-module_toggleScroll__hxHde";
var css_248z$K = ".InsuranceModal-module_insuranceModal__1Xm8T .InsuranceModal-module_cardShell__oQSMo [class*='card'][class*='selected'] {\n  box-shadow: 0 0 0 2px #0057b8 inset;\n  border-radius: 3px; }\n\n.InsuranceModal-module_insuranceModal__1Xm8T .InsuranceModal-module_noSelection__DpdkR [class*='card'] {\n  border-radius: 3px; }\n\n.InsuranceModal-module_insuranceModal__1Xm8T .InsuranceModal-module_noSelection__DpdkR [class*='card']:hover {\n  box-shadow: #53aef3 0px 0px 2px 2px inset;\n  border-radius: 3px; }\n\n.InsuranceModal-module_collapseSection__v4BLn [class*='rel'] {\n  max-height: none !important; }\n\n@media (max-width: 425px) {\n  .InsuranceModal-module_insuranceModelSize__pNvCg {\n    margin-left: 8px;\n    margin-right: 8px; } }\n\n.InsuranceModal-module_roundBorder__8DiV2 {\n  border: 1px solid #dcdef3;\n  border-radius: 14px;\n  padding-top: 24px;\n  padding-bottom: 24px;\n  padding-left: 16px;\n  padding-right: 16px; }\n\n.InsuranceModal-module_apiFailMessage__B8psT {\n  border: 1px solid #dcdef3;\n  border-radius: 10px;\n  background-color: #f2f2f2; }\n\n.InsuranceModal-module_container__WFdCF {\n  width: 100%;\n  margin: auto;\n  max-width: 1324px; }\n\n.InsuranceModal-module_error__hx-6B svg {\n  width: 24px;\n  max-height: 24px;\n  display: inline-flex;\n  padding-right: 6px;\n  font-size: 22px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  fill: #c70032; }\n  .InsuranceModal-module_error__hx-6B svg [class*='svg-base'] {\n    fill: #c70032 !important; }\n\n.InsuranceModal-module_error__hx-6B p {\n  padding-top: 0px;\n  padding-bottom: 0px;\n  margin-top: 0px !important; }\n\n.InsuranceModal-module_error__hx-6B div [class*='flex'] {\n  padding: 0px !important;\n  margin-right: 0px !important; }\n\n.InsuranceModal-module_alert__9-rhi {\n  padding-left: 0px !important;\n  padding-bottom: 0px !important; }\n\n.InsuranceModal-module_error__hx-6B div [class*='grid'] {\n  padding-right: 0px !important;\n  padding-left: 0px !important;\n  padding-bottom: 0px !important; }\n\n.InsuranceModal-module_error__hx-6B p [class*='type-sm'] {\n  font-size: 1.2rem !important; }\n\n.InsuranceModal-module_fontsize__7BNgG {\n  font-size: 1.2rem !important; }\n\n.InsuranceModal-module_alertIcon__-yRuU div div div {\n  padding: 0px !important; }\n  .InsuranceModal-module_alertIcon__-yRuU div div div div svg {\n    color: #ff6f00; }\n\n.InsuranceModal-module_alertIcon__-yRuU svg {\n  fill: #ff6f00; }\n\n.InsuranceModal-module_labelPosition__glvkY {\n  float: right;\n  margin-left: auto;\n  font-size: 1.5rem !important; }\n\n.InsuranceModal-module_zipCodeFont__nv8qs {\n  font-size: 15px;\n  line-height: 1.6; }\n\n.InsuranceModal-module_buttonClass__c-aba {\n  position: absolute;\n  left: 165px;\n  top: 8px;\n  min-width: 100px;\n  max-width: 100px; }\n\n.InsuranceModal-module_invalidZipCode__ccaUI {\n  color: red;\n  font-family: att_regular, sans-serif;\n  font-size: 14px;\n  margin-top: 10px; }\n\n.InsuranceModal-module_panel__CPzQW {\n  display: flex;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  background-color: transparent;\n  width: 100%;\n  border: none;\n  text-align: left; }\n\n.InsuranceModal-module_panelMain__N-vaH {\n  display: inline-flex;\n  position: relative;\n  align-items: flex-start;\n  height: auto;\n  padding-right: 16px; }\n\n.InsuranceModal-module_bannerText__TvC-s {\n  flex: 1 auto;\n  padding: 0 0 4px 0; }\n  .InsuranceModal-module_bannerText__TvC-s label {\n    display: block; }\n\n.InsuranceModal-module_overallPadding__qWYB0 {\n  padding: 0 0 4px 0; }\n\n.InsuranceModal-module_expanded__-yqpx .InsuranceModal-module_arrowIcon__fG-j0 {\n  transform: rotate(270deg);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 10'%3E%3Cpath fill='%231d2329' fill-rule='nonzero' d='M5.276 4.602a.481.481 0 0 1 0 .768L.814 9.833a.477.477 0 1 1-.674-.675l4.172-4.172L.14.814A.477.477 0 0 1 .814.14l4.462 4.462z'/%3E%3C/svg%3E\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 9.08px;\n  width: 16.5px; }\n\n.InsuranceModal-module_expanded__-yqpx .InsuranceModal-module_editArrowIcon__TiEMv {\n  transform: rotate(270deg);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 10'%3E%3Cpath fill='%231d2329' fill-rule='nonzero' d='M5.276 4.602a.481.481 0 0 1 0 .768L.814 9.833a.477.477 0 1 1-.674-.675l4.172-4.172L.14.814A.477.477 0 0 1 .814.14l4.462 4.462z'/%3E%3C/svg%3E\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 12px;\n  width: 12px; }\n\n.InsuranceModal-module_toggleText__UqlSy {\n  vertical-align: baseline;\n  padding-right: 0px; }\n\n.InsuranceModal-module_arrowIcon__fG-j0 {\n  transition: transform 250ms cubic-bezier(0.445, 0.05, 0.55, 0.95) 0ms;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 10'%3E%3Cpath fill='%231d2329' fill-rule='nonzero' d='M5.276 4.602a.481.481 0 0 1 0 .768L.814 9.833a.477.477 0 1 1-.674-.675l4.172-4.172L.14.814A.477.477 0 0 1 .814.14l4.462 4.462z'/%3E%3C/svg%3E\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 9.08px;\n  width: 16.5px;\n  transform: rotate(90deg); }\n\n.InsuranceModal-module_editArrowIcon__TiEMv {\n  transition: transform 250ms cubic-bezier(0.445, 0.05, 0.55, 0.95) 0ms;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 10'%3E%3Cpath fill='%231d2329' fill-rule='nonzero' d='M5.276 4.602a.481.481 0 0 1 0 .768L.814 9.833a.477.477 0 1 1-.674-.675l4.172-4.172L.14.814A.477.477 0 0 1 .814.14l4.462 4.462z'/%3E%3C/svg%3E\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 12px;\n  width: 12px;\n  transform: rotate(90deg); }\n\n.InsuranceModal-module_noThanksSubcontent__fRUTi {\n  padding-left: 42px;\n  padding-right: 22px; }\n\n.InsuranceModal-module_fontNothanks__xYLRN {\n  font-size: 15px !important; }\n\n.InsuranceModal-module_insurancePlanHeading__fEjfz {\n  display: inline-block;\n  font-size: 1.5rem !important; }\n\n.InsuranceModal-module_planDescription__FsUfI ul {\n  list-style: disc;\n  padding-left: 16px; }\n  .InsuranceModal-module_planDescription__FsUfI ul li {\n    display: list-item;\n    margin: 8px 0px;\n    font-size: 15px; }\n\n.InsuranceModal-module_noThanksDesc__8QDPB ul {\n  list-style: disc; }\n  .InsuranceModal-module_noThanksDesc__8QDPB ul li {\n    display: list-item; }\n\n.InsuranceModal-module_drawerOuter__We0yd .flex-1 {\n  flex: 1 auto; }\n\n.is-tabbing .InsuranceModal-module_panel__CPzQW:focus {\n  outline-color: transparent; }\n\n@media (max-width: 767px) {\n  .InsuranceModal-module_panelMain__N-vaH {\n    flex: 1 100%; }\n  .InsuranceModal-module_insuranceHeading__9sRbd {\n    display: inline-block;\n    padding: 0px !important; }\n    .InsuranceModal-module_insuranceHeading__9sRbd + .InsuranceModal-module_bannerToggle__GICif {\n      display: inline-block;\n      padding-right: 0px; }\n  .InsuranceModal-module_error__hx-6B {\n    padding-bottom: 0px; }\n  .InsuranceModal-module_error__hx-6B svg {\n    max-height: 24px;\n    max-width: 24px; }\n  .InsuranceModal-module_arrowIcon__fG-j0 {\n    position: relative;\n    display: inline-block;\n    vertical-align: text-bottom;\n    vertical-align: middle;\n    padding-right: 0px; }\n  .InsuranceModal-module_editArrowIcon__TiEMv {\n    position: relative;\n    display: inline-block;\n    vertical-align: text-bottom;\n    vertical-align: middle;\n    padding-right: 0px; }\n  .InsuranceModal-module_insurancePlanWrapper__pW9E8 {\n    display: flex; } }\n\n@media (min-width: 768px) {\n  .InsuranceModal-module_panel__CPzQW {\n    justify-content: space-between; }\n  .InsuranceModal-module_insuranceHeading__9sRbd {\n    display: inline-block;\n    padding: 0px !important;\n    color: #191919; }\n    .InsuranceModal-module_insuranceHeading__9sRbd + .InsuranceModal-module_bannerToggle__GICif {\n      display: inline-block;\n      padding-right: 0px; }\n  .InsuranceModal-module_error__hx-6B {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important; }\n  .InsuranceModal-module_arrowIcon__fG-j0 {\n    position: relative;\n    display: inline-block;\n    vertical-align: text-bottom;\n    vertical-align: middle;\n    padding-right: 0px; }\n  .InsuranceModal-module_editArrowIcon__TiEMv {\n    position: relative;\n    display: inline-block;\n    vertical-align: text-bottom;\n    vertical-align: middle;\n    padding-right: 0px; }\n  .InsuranceModal-module_insurancePlanWrapper__pW9E8 {\n    display: flex; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .InsuranceModal-module_insuranceHeading__9sRbd {\n    display: inline;\n    padding: 0px !important; }\n    .InsuranceModal-module_insuranceHeading__9sRbd + .InsuranceModal-module_bannerToggle__GICif {\n      display: inline-block;\n      padding-right: 0px; }\n  .InsuranceModal-module_insurancePlanWrapper__pW9E8 {\n    display: flex; } }\n\n@media (min-width: 252px) and (max-width: 320px) {\n  .InsuranceModal-module_toggleScroll__hxHde {\n    overflow-x: auto;\n    padding-bottom: 16px; } }\n";
styleInject(css_248z$K);

var accordionBlock = "AccordionBlock_accordionBlock__OurS5";
var accordionBlockInner = "AccordionBlock_accordionBlockInner__HYIdP";
var accordionChevron = "AccordionBlock_accordionChevron__3W79m";
var accordionBlockInnerFocus = "AccordionBlock_accordionBlockInnerFocus__RVgjK";
var accordionBlockChildren = "AccordionBlock_accordionBlockChildren__DkaYc";
var accordionBlockChildrenDisabled = "AccordionBlock_accordionBlockChildrenDisabled__WNqdZ";
var makeAccordionChildrenInvisible = "AccordionBlock_makeAccordionChildrenInvisible__2PXgV";
var accordionBlockChildrenEnabled = "AccordionBlock_accordionBlockChildrenEnabled__4r135";
var makeAccordionChildrenVisible = "AccordionBlock_makeAccordionChildrenVisible__XI1xn";
var css_248z$J = ".AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockInner__HYIdP {\n  background: 0;\n  border: 0;\n  outline: 0;\n  padding-right: 8px !important;\n  width: 100%; }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionChevron__3W79m {\n  margin-top: 6px;\n  transition: 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n  @media (min-width: 768px) {\n    .AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionChevron__3W79m {\n      margin-top: 8px; } }\n  @media (min-width: 1025px) {\n    .AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionChevron__3W79m {\n      margin-top: 10px; } }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockInnerFocus__RVgjK:focus {\n  outline: 1px dotted #1d2329 !important;\n  outline-offset: -1px; }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockChildren__DkaYc {\n  transition: margin-bottom 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95), max-height 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockChildrenDisabled__WNqdZ {\n  -webkit-animation-name: AccordionBlock_makeAccordionChildrenInvisible__2PXgV;\n          animation-name: AccordionBlock_makeAccordionChildrenInvisible__2PXgV;\n  -webkit-animation-duration: 0.25s;\n          animation-duration: 0.25s;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards; }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockChildrenEnabled__4r135 {\n  -webkit-animation-name: AccordionBlock_makeAccordionChildrenVisible__XI1xn;\n          animation-name: AccordionBlock_makeAccordionChildrenVisible__XI1xn;\n  -webkit-animation-duration: 0.25s;\n          animation-duration: 0.25s;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards; }\n\n@-webkit-keyframes AccordionBlock_makeAccordionChildrenInvisible__2PXgV {\n  0% {\n    visibility: visible; }\n  99% {\n    visibility: visible; }\n  100% {\n    visibility: hidden; } }\n\n@keyframes AccordionBlock_makeAccordionChildrenInvisible__2PXgV {\n  0% {\n    visibility: visible; }\n  99% {\n    visibility: visible; }\n  100% {\n    visibility: hidden; } }\n\n@-webkit-keyframes AccordionBlock_makeAccordionChildrenVisible__XI1xn {\n  0% {\n    visibility: hidden; }\n  1% {\n    visibility: visible; }\n  100% {\n    visibility: visible; } }\n\n@keyframes AccordionBlock_makeAccordionChildrenVisible__XI1xn {\n  0% {\n    visibility: hidden; }\n  1% {\n    visibility: visible; }\n  100% {\n    visibility: visible; } }\n";
var AccordionBlock$1 = {"accordionBlock":"AccordionBlock_accordionBlock__OurS5","accordionBlockInner":"AccordionBlock_accordionBlockInner__HYIdP","accordionChevron":"AccordionBlock_accordionChevron__3W79m","accordionBlockInnerFocus":"AccordionBlock_accordionBlockInnerFocus__RVgjK","accordionBlockChildren":"AccordionBlock_accordionBlockChildren__DkaYc","accordionBlockChildrenDisabled":"AccordionBlock_accordionBlockChildrenDisabled__WNqdZ","makeAccordionChildrenInvisible":"AccordionBlock_makeAccordionChildrenInvisible__2PXgV","accordionBlockChildrenEnabled":"AccordionBlock_accordionBlockChildrenEnabled__4r135","makeAccordionChildrenVisible":"AccordionBlock_makeAccordionChildrenVisible__XI1xn"};
var stylesheet$D=".AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockInner__HYIdP {\n  background: 0;\n  border: 0;\n  outline: 0;\n  padding-right: 8px !important;\n  width: 100%; }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionChevron__3W79m {\n  margin-top: 6px;\n  transition: 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n  @media (min-width: 768px) {\n    .AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionChevron__3W79m {\n      margin-top: 8px; } }\n  @media (min-width: 1025px) {\n    .AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionChevron__3W79m {\n      margin-top: 10px; } }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockInnerFocus__RVgjK:focus {\n  outline: 1px dotted #1d2329 !important;\n  outline-offset: -1px; }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockChildren__DkaYc {\n  transition: margin-bottom 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95), max-height 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockChildrenDisabled__WNqdZ {\n  -webkit-animation-name: AccordionBlock_makeAccordionChildrenInvisible__2PXgV;\n          animation-name: AccordionBlock_makeAccordionChildrenInvisible__2PXgV;\n  -webkit-animation-duration: 0.25s;\n          animation-duration: 0.25s;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards; }\n\n.AccordionBlock_accordionBlock__OurS5 .AccordionBlock_accordionBlockChildrenEnabled__4r135 {\n  -webkit-animation-name: AccordionBlock_makeAccordionChildrenVisible__XI1xn;\n          animation-name: AccordionBlock_makeAccordionChildrenVisible__XI1xn;\n  -webkit-animation-duration: 0.25s;\n          animation-duration: 0.25s;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards; }\n\n@-webkit-keyframes AccordionBlock_makeAccordionChildrenInvisible__2PXgV {\n  0% {\n    visibility: visible; }\n  99% {\n    visibility: visible; }\n  100% {\n    visibility: hidden; } }\n\n@keyframes AccordionBlock_makeAccordionChildrenInvisible__2PXgV {\n  0% {\n    visibility: visible; }\n  99% {\n    visibility: visible; }\n  100% {\n    visibility: hidden; } }\n\n@-webkit-keyframes AccordionBlock_makeAccordionChildrenVisible__XI1xn {\n  0% {\n    visibility: hidden; }\n  1% {\n    visibility: visible; }\n  100% {\n    visibility: visible; } }\n\n@keyframes AccordionBlock_makeAccordionChildrenVisible__XI1xn {\n  0% {\n    visibility: hidden; }\n  1% {\n    visibility: visible; }\n  100% {\n    visibility: visible; } }\n";
styleInject(css_248z$J);

var AccordionBlock$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    accordionBlock: accordionBlock,
    accordionBlockInner: accordionBlockInner,
    accordionChevron: accordionChevron,
    accordionBlockInnerFocus: accordionBlockInnerFocus,
    accordionBlockChildren: accordionBlockChildren,
    accordionBlockChildrenDisabled: accordionBlockChildrenDisabled,
    makeAccordionChildrenInvisible: makeAccordionChildrenInvisible,
    accordionBlockChildrenEnabled: accordionBlockChildrenEnabled,
    makeAccordionChildrenVisible: makeAccordionChildrenVisible,
    'default': AccordionBlock$1,
    stylesheet: stylesheet$D
});

var styles$y = /*@__PURE__*/getAugmentedNamespace(AccordionBlock$2);

var AccordionBlock_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });


var AccordionBlock = /** @class */ (function (_super) {
    __extends(AccordionBlock, _super);
    function AccordionBlock(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var options = _this.props.options;
            var defaultExpanded = false;
            if (options && options.isOpen !== undefined) {
                defaultExpanded = options.isOpen;
            }
            else if (options && options.withExpand !== undefined) {
                defaultExpanded = options.withExpand;
            }
            _this.toggleOpen(defaultExpanded, true);
        };
        _this.componentDidUpdate = function (prevProps) {
            var options = _this.props.options;
            var openToResize = true;
            if (options && options.state && prevProps.options && prevProps.options.state) {
                var _a = options.state, isClosed = _a.isClosed, isOpen = _a.isOpen;
                if (prevProps.options.state.isOpen === false && isOpen === true) {
                    _this.toggleOpen(true, undefined);
                }
                else if (prevProps.options.state.isClosed === false && isClosed === true) {
                    _this.toggleOpen(false, undefined);
                    openToResize = false;
                }
            }
            if (openToResize && options && options.reSize === true) {
                _this.reSize();
            }
        };
        _this.onMouseDown = function (e) {
            if (e.button === 0) {
                var options = _this.props.options;
                if (options && options.state && options.setState) {
                    options.setState(__assign(__assign({}, options.state), { hideFocus: true }));
                }
                if (!options || !options.disabled) {
                    _this.toggleOpen(undefined, undefined);
                }
            }
        };
        _this.onKeyUp = function (e) {
            var keyCode = e.keyCode;
            var options = _this.props.options;
            if (options && options.state && options.setState) {
                options.setState(__assign(__assign({}, options.state), { hideFocus: false }));
            }
            if ((keyCode === 13 || keyCode === 32) && (!options || !options.disabled)) {
                _this.toggleOpen(undefined, undefined);
            }
        };
        _this.toggleOpen = function (isOpen, addTransition) {
            var uniqueId = _this.state.uniqueId;
            var el = document.getElementById(uniqueId);
            var _a = _this.props, events = _a.events, options = _a.options;
            if (el) {
                if (isOpen === false || (isOpen === undefined && el.style.maxHeight !== "0px")) {
                    if (isOpen === undefined &&
                        events &&
                        events.onToggle &&
                        options &&
                        options.index !== undefined) {
                        events.onToggle(false, options.index);
                    }
                    el.style.maxHeight = "0px";
                    _this.setState({ isOpen: false }, function () { return _this.setIsOpenArrProps(false); });
                }
                else {
                    if (isOpen === undefined &&
                        events &&
                        events.onToggle &&
                        options &&
                        options.index !== undefined) {
                        events.onToggle(true, options.index);
                    }
                    el.style.maxHeight = el.scrollHeight + "px";
                    _this.setState({ isOpen: true }, function () { return _this.setIsOpenArrProps(true); });
                }
            }
            if (addTransition !== undefined) {
                _this.setState({ addTransition: addTransition });
            }
        };
        _this.setIsOpenArrProps = function (value) {
            var options = _this.props.options;
            if (options &&
                options.index !== undefined &&
                options.state !== undefined &&
                options.setState !== undefined) {
                options.state.isOpenArr[options.index] = value;
                if (options.state.isOpenArr.indexOf(false) === -1 &&
                    options.state.isExpandAll === true) {
                    options.setState(__assign(__assign({}, options.state), { isClosed: false, isExpandAll: false, isOpen: true, isOpenArr: options.state.isOpenArr.slice() }));
                }
                else if (options.state.isOpenArr.indexOf(true) === -1 &&
                    options.state.isExpandAll === false) {
                    options.setState(__assign(__assign({}, options.state), { isClosed: true, isExpandAll: true, isOpen: false, isOpenArr: options.state.isOpenArr.slice() }));
                }
            }
        };
        _this.reSize = function () {
            var _a = _this.state, uniqueId = _a.uniqueId, isOpen = _a.isOpen;
            var el = document.getElementById(uniqueId);
            if (el && isOpen) {
                el.style.maxHeight = el.scrollHeight + "px";
            }
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, options = _a.options;
            var _b = _this.state, addTransition = _b.addTransition, isInitiallyOpen = _b.isInitiallyOpen, isOpen = _b.isOpen, uniqueId = _b.uniqueId;
            var pad = options && options.paddingType === "small" ? "sm" : "md";
            return (React__default.createElement("div", { className: styles$y.accordionBlock + " border-bottom border-light-gray overflow-hidden" },
                React__default.createElement("button", { "aria-controls": uniqueId, "aria-haspopup": "true", "aria-expanded": isOpen, className: "" + styles$y.accordionBlockInner + (options && options.state && options.state.hideFocus
                        ? ""
                        : " " + styles$y.accordionBlockInnerFocus) + " border-bottom border-light-gray flex flex-items-start justify-between no-border pad-l-none pad-r-none pad-b-" + pad + " pad-t-" + pad, onKeyUp: !(options === null || options === void 0 ? void 0 : options.noArrowDown) ? _this.onKeyUp : undefined, onMouseDown: !(options === null || options === void 0 ? void 0 : options.noArrowDown) ? _this.onMouseDown : undefined, style: { cursor: options && options.disabled ? "not-allowed" : (options === null || options === void 0 ? void 0 : options.noArrowDown) ? "auto" : "pointer" } },
                    React__default.createElement("span", { className: (options && options.disabled ? "color-ui-medium-gray" : "color-ui-black") + " text-left flex-1 font-medium mar-b-none " + (data.className ? data.className : "type-md") }, data.title),
                    !(options === null || options === void 0 ? void 0 : options.noArrowDown) && (React__default.createElement("i", { className: "icon-chevron mar-l-sm " + (isOpen ? "rotate270" : "rotate90") + " " + styles$y.accordionChevron }))),
                !(options === null || options === void 0 ? void 0 : options.noArrowDown) && (React__default.createElement("div", { "aria-hidden": !isOpen, className: "" + (addTransition ? styles$y.accordionBlockChildren + " height-full " : "") + (isOpen && !(options && options.disabled) ? "mar-b-md " : "") + (!isOpen
                        ? styles$y.accordionBlockChildrenDisabled + " "
                        : isInitiallyOpen
                            ? ""
                            : styles$y.accordionBlockChildrenEnabled + " ") + "text-left type-base", id: uniqueId, role: "region", style: { overflow: "hidden" } }, data.children))));
        };
        _this.state = {
            addTransition: false,
            isInitiallyOpen: props.options && props.options.state && props.options.state.isOpen ? true : false,
            isOpen: props.options && props.options.state && props.options.state.isOpen ? true : false,
            uniqueId: (props.testId ? props.testId : "") + "-" + (props.options && props.options.index ? props.options.index : ""),
        };
        return _this;
    }
    return AccordionBlock;
}(React__default.PureComponent));
exports.default = AccordionBlock;
});

var AccordionBlock = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = AccordionBlock_1.default;
});

var Accordion_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });


var Accordion = function (_a) {
    var data = _a.data, name = _a.name, options = _a.options, events = _a.events, testId = _a.testId;
    var initIsOpenArr = data.map(function (item) { return item.options !== undefined && item.options.isOpen === true; });
    var _b = __read(React__default.useState({
        hideFocus: true,
        isClosed: initIsOpenArr.indexOf(false) !== -1,
        isExpandAll: initIsOpenArr.indexOf(false) !== -1,
        isOpen: initIsOpenArr.indexOf(false) === -1,
        isOpenArr: initIsOpenArr,
    }), 2), state = _b[0], setState = _b[1];
    React__default.useEffect(function () {
        setState(__assign(__assign({}, state), { isOpenArr: initIsOpenArr }));
    }, [data]);
    var isClosed = state.isClosed, isExpandAll = state.isExpandAll, isOpen = state.isOpen;
    var toggleExpandAll = function (e) {
        var updtState = true;
        if (e.key) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
                e.preventDefault();
            }
            else {
                updtState = false;
            }
        }
        if (updtState) {
            setState(__assign(__assign({}, state), { isClosed: !isClosed && !isExpandAll, isExpandAll: isClosed && !isOpen, isOpen: !isOpen && isExpandAll }));
            if (events && events.onExpandAll) {
                events.onExpandAll(isClosed && !isOpen);
            }
        }
    };
    var staticDataToPass = {
        setState: setState,
        state: state,
        withExpand: options && options.withExpand ? true : false,
    };
    return (React__default.createElement("div", { className: "align-items-center flex flex-column text-center", "data-testid": testId },
        options && options.title && (React__default.createElement("h2", { className: options && options.titleClassName
                ? options.titleClassName
                : "heading-xxxl mar-b-md" }, options.title)),
        options && options.withExpand && (React__default.createElement("div", { className: "flex " + (options && options.expandAlignment === "right"
                ? "justify-end"
                : "justify-center") + (options && options.expandBtnClassName
                ? " " + options.expandBtnClassName
                : " mar-b-xl") },
            React__default.createElement("a", { className: "link-text3 solo", onClick: toggleExpandAll, onKeyDown: toggleExpandAll, tabIndex: 0, role: "button" }, isExpandAll ? "Expand all" : "Collapse all"))),
        React__default.createElement("div", { className: "border-top border-light-gray" }, data.map(function (item, index) {
            var childData = item.data, itemProps = item.options;
            var newOptions = __assign(__assign({}, itemProps), { index: index, paddingType: options && options.paddingType ? options.paddingType : "medium" });
            return (React__default.createElement(AccordionBlock.default, { events: events, data: childData, options: __assign(__assign({}, newOptions), staticDataToPass), testId: name, key: index }));
        }))));
};
exports.default = Accordion;
});

var Accordion = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Accordion_1.default;
});

var alert = "Alert_alert__Ieytd";
var padBxxxxS = "Alert_padBxxxxS__b7yKi";
var positionClose$1 = "Alert_position-close__tY2qs";
var flexShrink = "Alert_flex-shrink__vmAQ8";
var onWhite = "Alert_on-white__Ix2ef";
var hideSides = "Alert_hide-sides__csZWZ";
var padTxxxxSSm = "Alert_padTxxxxSSm__JVA21";
var css_248z$I = "/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.Alert_alert__Ieytd .Alert_padBxxxxS__b7yKi {\n  padding-bottom: 2px; }\n\n.Alert_alert__Ieytd .Alert_position-close__tY2qs {\n  top: -4px;\n  right: -4px; }\n\n.Alert_alert__Ieytd .Alert_flex-shrink__vmAQ8 {\n  flex-shrink: 0; }\n\n@media (min-width: 0px) and (max-width: 767px) {\n  .Alert_alert__Ieytd svg {\n    height: 24px !important;\n    min-width: 24px; }\n  .Alert_alert__Ieytd.Alert_on-white__Ix2ef.Alert_hide-sides__csZWZ {\n    box-shadow: inset 0 1px 0 0 #dcdfe3, inset 0 -1px 0 0 #dcdfe3; }\n  .Alert_alert__Ieytd .Alert_padTxxxxSSm__JVA21 {\n    padding-top: 2px; } }\n\n@media (min-width: 1025px) {\n  .Alert_alert__Ieytd svg {\n    height: 32px !important; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .Alert_alert__Ieytd svg {\n    height: 32px !important; } }\n";
var Alert$1 = {"alert":"Alert_alert__Ieytd","padBxxxxS":"Alert_padBxxxxS__b7yKi","position-close":"Alert_position-close__tY2qs","flex-shrink":"Alert_flex-shrink__vmAQ8","on-white":"Alert_on-white__Ix2ef","hide-sides":"Alert_hide-sides__csZWZ","padTxxxxSSm":"Alert_padTxxxxSSm__JVA21","positionClose":"Alert_position-close__tY2qs","flexShrink":"Alert_flex-shrink__vmAQ8","onWhite":"Alert_on-white__Ix2ef","hideSides":"Alert_hide-sides__csZWZ"};
var stylesheet$C="/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.Alert_alert__Ieytd .Alert_padBxxxxS__b7yKi {\n  padding-bottom: 2px; }\n\n.Alert_alert__Ieytd .Alert_position-close__tY2qs {\n  top: -4px;\n  right: -4px; }\n\n.Alert_alert__Ieytd .Alert_flex-shrink__vmAQ8 {\n  flex-shrink: 0; }\n\n@media (min-width: 0px) and (max-width: 767px) {\n  .Alert_alert__Ieytd svg {\n    height: 24px !important;\n    min-width: 24px; }\n  .Alert_alert__Ieytd.Alert_on-white__Ix2ef.Alert_hide-sides__csZWZ {\n    box-shadow: inset 0 1px 0 0 #dcdfe3, inset 0 -1px 0 0 #dcdfe3; }\n  .Alert_alert__Ieytd .Alert_padTxxxxSSm__JVA21 {\n    padding-top: 2px; } }\n\n@media (min-width: 1025px) {\n  .Alert_alert__Ieytd svg {\n    height: 32px !important; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .Alert_alert__Ieytd svg {\n    height: 32px !important; } }\n";
styleInject(css_248z$I);

var Alert$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    alert: alert,
    padBxxxxS: padBxxxxS,
    positionClose: positionClose$1,
    flexShrink: flexShrink,
    onWhite: onWhite,
    hideSides: hideSides,
    padTxxxxSSm: padTxxxxSSm,
    'default': Alert$1,
    stylesheet: stylesheet$C
});

var css_248z$H = "[class=\"svg-base\"] {\n  fill: currentColor !important; }\n\n:not([class*=\"color-\"]) [class=\"svg-accent\"] {\n  fill: currentColor; }\n\n[class*=\"svg-accent-att-blue\"] [class=\"svg-accent\"] {\n  fill: #009fdb; }\n";
styleInject(css_248z$H);

var IconSvg_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });


var IconSvg = /** @class */ (function (_super) {
    __extends(IconSvg, _super);
    function IconSvg(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var svgUrl = _this.props.svgUrl;
            if (svgUrl) {
                _this.getIconFromUrl();
            }
        };
        _this.getIconFromUrl = function () { return __awaiter(_this, void 0, void 0, function () {
            var svgUrl, response, svgMarkUp, svgContent, viewBoxVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        svgUrl = this.props.svgUrl;
                        return [4 /*yield*/, fetch(svgUrl)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        svgMarkUp = _a.sent();
                        svgContent = this.getIconContent(svgMarkUp);
                        viewBoxVal = this.getViewBoxVal(svgMarkUp);
                        this.setState({ svgContent: svgContent, viewBoxVal: viewBoxVal });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderIconFromStr = function () {
            var svgNodeStr = _this.props.svgNodeStr;
            if (svgNodeStr) {
                var svgContent = _this.getIconContent(svgNodeStr);
                var viewBoxVal = _this.getViewBoxVal(svgNodeStr);
                return _this.renderSvg(svgContent, viewBoxVal);
            }
            return null;
        };
        _this.getIconContent = function (svgNode) {
            var trimmedStr = svgNode.trim();
            var index = trimmedStr.indexOf("><");
            var returnStr = trimmedStr.substring(index + 1, trimmedStr.length - 6);
            return returnStr;
        };
        _this.getViewBoxVal = function (svgFromSource) {
            var splitA = svgFromSource.split('viewBox="');
            var splitB = splitA[1].split('"');
            var viewBoxVal = splitB[0];
            return viewBoxVal;
        };
        _this.renderSvg = function (svgContent, viewBoxVal) {
            var _a = _this.props, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel, className = _a.className, colorClass = _a.colorClass, pictogramAccent = _a.pictogramAccent, pictogramDarkBg = _a.pictogramDarkBg, size = _a.size;
            var iconClass = colorClass;
            if (pictogramAccent) {
                iconClass = "svg-accent-att-blue " + (pictogramDarkBg ? "color-ui-white" : "color-black");
            }
            return (React__default.createElement("svg", { "aria-hidden": ariaHidden !== false, "aria-label": ariaHidden !== false ? undefined : ariaLabel, className: "inline-block " + iconClass + (className ? " " + className : ""), focusable: !(ariaHidden !== false), role: ariaHidden !== false ? undefined : "img", height: size ? size + "px" : undefined, width: size ? size + "px" : undefined, viewBox: viewBoxVal, dangerouslySetInnerHTML: {
                    __html: svgContent,
                } }));
        };
        _this.render = function () {
            var _a = _this.props, svgNodeStr = _a.svgNodeStr, svgUrl = _a.svgUrl;
            if (svgUrl) {
                var _b = _this.state, svgContent = _b.svgContent, viewBoxVal = _b.viewBoxVal;
                if (svgContent && viewBoxVal) {
                    return _this.renderSvg(svgContent, viewBoxVal);
                }
            }
            else if (svgNodeStr && svgNodeStr.trim().substring(1, 4) === "svg") {
                return _this.renderIconFromStr();
            }
            return null;
        };
        _this.state = {
            svgContent: null,
            viewBoxVal: null,
        };
        return _this;
    }
    return IconSvg;
}(React__default.PureComponent));
exports.default = IconSvg;
});

var IconSvg = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = IconSvg_1.default;
});

var AlertProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultType = exports.TypeIcon = void 0;


exports.TypeIcon = {
    error: (React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Error", colorClass: "color-functional-dk-red", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M16 1a15 15 0 1015 15A15 15 0 0016 1zm1 22h-2v-2h2zm0-4h-2V9h2z\"/></svg>" })),
    info: (React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Info", colorClass: "color-cobalt", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M16 1a15 15 0 1015 15A15 15 0 0016 1zm1 22h-2V13h2zm0-12h-2V9h2z\"/></svg>" })),
    success: (React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Success", colorClass: "color-functional-dk-green", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M16 1a15 15 0 1015 15A15 15 0 0016 1zm-2.33 21.08l-5.38-5.37 1.42-1.42 4 4 8.62-8.62L23.71 12z\"/></svg>" })),
    warning: (React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Warning", colorClass: "color-functional-dk-orange", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M29.21 24.53L18.62 5.63a3 3 0 00-5.24 0L2.79 24.53A3 3 0 005.41 29h21.18a3 3 0 002.62-4.47zM17 24h-2v-2h2zm0-4h-2v-8h2z\"/></svg>" })),
};
exports.defaultType = "info";
});

var styles$x = /*@__PURE__*/getAugmentedNamespace(Alert$2);

var Alert_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });



var Alert = function (_a) {
    var children = _a.children, className = _a.className, closeable = _a.closeable, _b = _a.type, type = _b === void 0 ? AlertProps.defaultType : _b, _c = _a.icon, icon = _c === void 0 ? type && AlertProps.TypeIcon[type] : _c, _d = _a.hideSideBordersOnMobile, hideSideBordersOnMobile = _d === void 0 ? true : _d, name = _a.name, onClose = _a.onClose, _e = _a.onWhite, onWhite = _e === void 0 ? false : _e, testId = _a.testId;
    var _f = __read(React__default.useState({
        closed: false,
        render: true,
    }), 2), state = _f[0], setState = _f[1];
    var render = state.render;
    var alertElement = React__default.useRef(null);
    var close = React__default.useCallback(function () {
        setState(__assign(__assign({}, state), { closed: true }));
        setState(__assign(__assign({}, state), { render: false }));
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    var classes = [
        styles$x.alert,
        "flex",
        "flex-items-top",
        "bg-ui-white pad-l-sm-lg pad-t-sm-lg pad-b-sm-lg pad-r-md-lg pad-t-xs-sm pad-b-xs-sm ",
        "rel",
        className,
    ];
    if (onWhite) {
        classes.push(styles$x.onWhite + " border-shadow");
    }
    if (hideSideBordersOnMobile) {
        classes.push(styles$x.hideSides);
    }
    return render ? (React__default.createElement("div", { className: classes.join(" "), "data-testid": testId, ref: alertElement },
        React__default.createElement("div", { className: "width-md-lg height-md-lg width-lg-md height-lg-md width-lg-sm height-lg-sm mar-r-xxs mar-r-none-sm " + styles$x.padBxxxxS + " pad-r-xxxs pad-none-sm mar-t-none-sm " + styles$x.flexShrink }, icon),
        React__default.createElement("div", { className: "type-base line-h-md color-ui-dark-gray mar-b-none mar-t-none-sm rel " + styles$x.padTxxxxSSm + " mar-l-xxxs mar-l-xxs-sm mar-t-xxxs" }, children),
        closeable && (React__default.createElement("button", { "aria-label": "Close " + (name || "alert"), name: "Close_" + (name || "alert"), className: styles$x.positionClose + " icon-close absolute color-ui-black", onClick: close })))) : null;
};
exports.default = Alert;
});

var Alert = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Alert_1, exports);
__exportStar(AlertProps, exports);
var Alert_1$1 = Alert_1;
exports.default = Alert_1$1.default;
});

var toStr$7 = Object.prototype.toString;

var isArguments = function isArguments(value) {
	var str = toStr$7.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr$7.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim$1;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has$5 = Object.prototype.hasOwnProperty;
	var toStr$6 = Object.prototype.toString;
	var isArgs = isArguments; // eslint-disable-line global-require
	var isEnumerable$1 = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable$1.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable$1.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has$5.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim$1 = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$6.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$6.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has$5.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has$5.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has$5.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation$2 = keysShim$1;

var slice$1 = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : implementation$2;

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments(object)) {
					return originalKeys(slice$1.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

var objectKeys = keysShim;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams$1 = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;


var hasSymbols$3 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams$1();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$5 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$5.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation$1;

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError$2 = SyntaxError;
var $Function = Function;
var $TypeError$i = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD$2 = Object.getOwnPropertyDescriptor;
if ($gOPD$2) {
	try {
		$gOPD$2({}, '');
	} catch (e) {
		$gOPD$2 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$i();
};
var ThrowTypeError = $gOPD$2
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$2(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$2 = hasSymbols$3();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$2 ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$2 ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$2 ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError$2,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$i,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat$1 = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace$2 = functionBind.call(Function.call, String.prototype.replace);
var $strSlice$1 = functionBind.call(Function.call, String.prototype.slice);
var $exec$2 = functionBind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice$1(string, 0, 1);
	var last = $strSlice$1(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError$2('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError$2('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$2(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$2(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$i('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError$2('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$i('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$i('"allowMissing" argument must be a boolean');
	}

	if ($exec$2(/^%?[^%]*%?$/g, name) === null) {
		throw new $SyntaxError$2('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice$1(part, 0, 1);
		var last = $strSlice$1(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError$2('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$i('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD$2 && (i + 1) >= parts.length) {
				var desc = $gOPD$2(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var $defineProperty$1 = getIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors$2 = function hasPropertyDescriptors() {
	if ($defineProperty$1) {
		try {
			$defineProperty$1({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors$2.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors$2()) {
		return null;
	}
	try {
		return $defineProperty$1([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

var hasPropertyDescriptors_1 = hasPropertyDescriptors$2;

var hasPropertyDescriptors$1 = hasPropertyDescriptors_1;

var hasSymbols$1 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$4 = Object.prototype.toString;
var concat$1 = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction$1 = function (fn) {
	return typeof fn === 'function' && toStr$4.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = hasPropertyDescriptors$1();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction$1(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols$1) {
		props = concat$1.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

var hasUnscopables = typeof Symbol === 'function' && typeof Symbol.unscopables === 'symbol';

var map$1 = hasUnscopables && Array.prototype[Symbol.unscopables];

var $TypeError$h = TypeError;

var esShimUnscopables = function shimUnscopables(method) {
	if (typeof method !== 'string' || !method) {
		throw new $TypeError$h('method must be a non-empty string');
	}
	if (!src(Array.prototype, method)) {
		throw new $TypeError$h('method must be on Array.prototype');
	}
	if (hasUnscopables) {
		map$1[method] = true;
	}
};

var $abs = getIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

var abs$1 = function abs(x) {
	return $abs(x);
};

// var modulo = require('./modulo');
var $floor$1 = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

var floor$1 = function floor(x) {
	// return x - modulo(x, 1);
	return $floor$1(x);
};

// https://262.ecma-international.org/5.1/#sec-8

var Type$2 = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};

var ES5Type = Type$2;

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

var Type$1 = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return ES5Type(x);
};

var _isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};

var $isNaN$1 = Number.isNaN || function (a) { return a !== a; };

var _isFinite = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN$1(x) && x !== Infinity && x !== -Infinity; };

var abs = abs$1;

var floor = floor$1;

var Type = Type$1;

var $isNaN = _isNaN;

var $isFinite = _isFinite;

// https://tc39.es/ecma262/#sec-isintegralnumber

var IsIntegralNumber$1 = function IsIntegralNumber(argument) {
	if (Type(argument) !== 'Number' || $isNaN(argument) || !$isFinite(argument)) {
		return false;
	}
	var absValue = abs(argument);
	return floor(absValue) === absValue;
};

var IsIntegralNumber = IsIntegralNumber$1;

var $ArrayPrototype = getIntrinsic('%Array.prototype%');
var $RangeError = getIntrinsic('%RangeError%');
var $SyntaxError$1 = getIntrinsic('%SyntaxError%');
var $TypeError$g = getIntrinsic('%TypeError%');



var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var $setProto = getIntrinsic('%Object.setPrototypeOf%', true) || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayPrototype
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);

// https://www.ecma-international.org/ecma-262/12.0/#sec-arraycreate

var ArrayCreate$1 = function ArrayCreate(length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError$g('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 3, 5
	if (proto !== $ArrayPrototype) { // step 4
		if (!$setProto) {
			throw new $SyntaxError$1('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 6
		A.length = length;
	}
	/* step 6, the above as a shortcut for the below
	OrdinaryDefineOwnProperty(A, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': true
	});
	*/
	return A;
};

var util_inspect = require$$0$3.inspect;

var utilInspect = util_inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match$1 = String.prototype.match;
var $slice = String.prototype.slice;
var $replace$1 = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace$1.call(intStr, sepRegex, '$&_') + '.' + $replace$1.call($replace$1.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace$1.call(str, sepRegex, '$&_');
}


var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol$1(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$4(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$4(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$4(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$4(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$4(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$2(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$4(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol$1(obj)) {
        var symString = hasShammedSymbols ? $replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement$1(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$2(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr$3(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace$1.call(String(s), /"/g, '&quot;');
}

function isArray$2(obj) { return toStr$3(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr$3(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr$3(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr$3(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr$3(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr$3(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr$3(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol$1(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$4(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr$3(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match$1.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement$1(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace$1.call($replace$1.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$2(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$4(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$4(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

var IsPropertyKey$1 = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};

var inspect = objectInspect;

var IsPropertyKey = IsPropertyKey$1;

var $TypeError$f = getIntrinsic('%TypeError%');






// https://ecma-international.org/ecma-262/6.0/#sec-get-o-p

var Get$1 = function Get(O, P) {
	// 7.3.1.1
	if (Type(O) !== 'Object') {
		throw new $TypeError$f('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError$f('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
	}
	// 7.3.1.3
	return O[P];
};

var callBind = createCommonjsModule(function (module) {




var $apply = getIntrinsic('%Function.prototype.apply%');
var $call = getIntrinsic('%Function.prototype.call%');
var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $gOPD = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = getIntrinsic('%Object.defineProperty%', true);
var $max = getIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(functionBind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});

var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = getIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var $Array = getIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr$2 = !$Array.isArray && callBound('Object.prototype.toString');

var IsArray$2 = $Array.isArray || function IsArray(argument) {
	return toStr$2(argument) === '[object Array]';
};

var require$$0$2 = IsArray$2;

// https://ecma-international.org/ecma-262/6.0/#sec-isarray
var IsArray$1 = require$$0$2;

// TODO: remove, semver-major

var GetIntrinsic$1 = getIntrinsic;

var $TypeError$e = getIntrinsic('%TypeError%');

var isPropertyDescriptor$1 = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (src(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError$e('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};

var $defineProperty = hasPropertyDescriptors$1() && getIntrinsic('%Object.defineProperty%', true);

var hasArrayLengthDefineBug = hasPropertyDescriptors$1.hasArrayLengthDefineBug();

// eslint-disable-next-line global-require
var isArray$1 = hasArrayLengthDefineBug && require$$0$2;



var $isEnumerable$1 = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
var DefineOwnProperty$1 = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable$1(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray$1(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};

// https://262.ecma-international.org/13.0/#sec-match-records

var isMatchRecord$1 = function isMatchRecord(record) {
	return (
		src(record, '[[StartIndex]]')
        && src(record, '[[EndIndex]]')
        && record['[[StartIndex]]'] >= 0
        && record['[[EndIndex]]'] >= record['[[StartIndex]]']
        && String(parseInt(record['[[StartIndex]]'], 10)) === String(record['[[StartIndex]]'])
        && String(parseInt(record['[[EndIndex]]'], 10)) === String(record['[[EndIndex]]'])
	);
};

var isMatchRecord = isMatchRecord$1;

var $TypeError$d = getIntrinsic('%TypeError%');
var $SyntaxError = getIntrinsic('%SyntaxError%');





var predicates = {
	// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Desc) {
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (src(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = src(Desc, '[[Value]]');
		var IsAccessor = src(Desc, '[[Get]]') || src(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError$d('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},
	// https://262.ecma-international.org/13.0/#sec-match-records
	'Match Record': isMatchRecord
};

var assertRecord$1 = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (Type(value) !== 'Object' || !predicate(value)) {
		throw new $TypeError$d(argumentName + ' must be a ' + recordType);
	}
};

var fromPropertyDescriptor$1 = function fromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}
	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = !!Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = !!Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = !!Desc['[[Configurable]]'];
	}
	return obj;
};

var assertRecord = assertRecord$1;

var fromPropertyDescriptor = fromPropertyDescriptor$1;

// https://ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

var FromPropertyDescriptor$1 = function FromPropertyDescriptor(Desc) {
	if (typeof Desc !== 'undefined') {
		assertRecord(Type, 'Property Descriptor', 'Desc', Desc);
	}

	return fromPropertyDescriptor(Desc);
};

// https://ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

var IsAccessorDescriptor$1 = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Get]]') && !src(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};

// https://ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

var IsDataDescriptor$1 = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Value]]') && !src(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};

// http://262.ecma-international.org/5.1/#sec-9.12

var SameValue$1 = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return $isNaN(x) && $isNaN(y);
};

// http://262.ecma-international.org/5.1/#sec-9.2

var ToBoolean$1 = function ToBoolean(value) { return !!value; };

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$1 = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag$2 = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

var isCallable = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag$2) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr$1.call(value);
		return strClass === fnClass || strClass === genClass;
	};

// http://262.ecma-international.org/5.1/#sec-9.11

var IsCallable$1 = isCallable;

var ToBoolean = ToBoolean$1;

var IsCallable = IsCallable$1;

var $TypeError$c = getIntrinsic('%TypeError%');





// https://262.ecma-international.org/5.1/#sec-8.10.5

var ToPropertyDescriptor$1 = function ToPropertyDescriptor(Obj) {
	if (Type(Obj) !== 'Object') {
		throw new $TypeError$c('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (src(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (src(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (src(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (src(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (src(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError$c('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (src(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError$c('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((src(desc, '[[Get]]') || src(desc, '[[Set]]')) && (src(desc, '[[Value]]') || src(desc, '[[Writable]]'))) {
		throw new $TypeError$c('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};

var isPropertyDescriptor = isPropertyDescriptor$1;

var DefineOwnProperty = DefineOwnProperty$1;

var FromPropertyDescriptor = FromPropertyDescriptor$1;

var IsAccessorDescriptor = IsAccessorDescriptor$1;

var IsDataDescriptor = IsDataDescriptor$1;

var SameValue = SameValue$1;

var ToPropertyDescriptor = ToPropertyDescriptor$1;

var $TypeError$b = getIntrinsic('%TypeError%');












// https://ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

var DefinePropertyOrThrow = function DefinePropertyOrThrow(O, P, desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$b('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError$b('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError$b('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};

var GetIntrinsic = GetIntrinsic$1;

var require$$0$1 = DefinePropertyOrThrow;

var IsConstructor$1 = createCommonjsModule(function (module) {



var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow = require$$0$1;
try {
	DefinePropertyOrThrow({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow = null;
}

// https://ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}
});

var ArrayCreate = ArrayCreate$1;

var Get = Get$1;

var IsArray = IsArray$1;

var IsConstructor = IsConstructor$1;

var $species = getIntrinsic('%Symbol.species%', true);
var $TypeError$a = getIntrinsic('%TypeError%');








// https://ecma-international.org/ecma-262/12.0/#sec-arrayspeciescreate

var ArraySpeciesCreate$1 = function ArraySpeciesCreate(originalArray, length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError$a('Assertion failed: length must be an integer >= 0');
	}

	var isArray = IsArray(originalArray);
	if (!isArray) {
		return ArrayCreate(length);
	}

	var C = Get(originalArray, 'constructor');
	// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
	// if (IsConstructor(C)) {
	// 	if C is another realm's Array, C = undefined
	// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
	// }
	if ($species && Type(C) === 'Object') {
		C = Get(C, $species);
		if (C === null) {
			C = void 0;
		}
	}

	if (typeof C === 'undefined') {
		return ArrayCreate(length);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError$a('C must be a constructor');
	}
	return new C(length); // Construct(C, length);
};

var $Math = getIntrinsic('%Math%');
var $Number$1 = getIntrinsic('%Number%');

var maxSafeInteger = $Number$1.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;

var $TypeError$9 = getIntrinsic('%TypeError%');



var $apply = getIntrinsic('%Reflect.apply%', true) || callBound('%Function.prototype.apply%');

// https://ecma-international.org/ecma-262/6.0/#sec-call

var Call$1 = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError$9('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};

var $gOPD$1 = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD$1) {
	try {
		$gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD$1 = null;
	}
}

var getOwnPropertyDescriptor = $gOPD$1;

var shams = function hasToStringTagShams() {
	return shams$1() && !!Symbol.toStringTag;
};

var hasToStringTag$1 = shams();
var has$3;
var $exec$1;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$1) {
	has$3 = callBound('Object.prototype.hasOwnProperty');
	$exec$1 = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex = hasToStringTag$1
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has$3(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec$1(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};

var $match = getIntrinsic('%Symbol.match%', true);





// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

var IsRegExp$1 = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match) {
		var isRegExp = argument[$match];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return isRegex(argument);
};

var $gOPD = getOwnPropertyDescriptor;

var IsRegExp = IsRegExp$1;

var $TypeError$8 = getIntrinsic('%TypeError%');



var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');









// https://ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

var OrdinaryGetOwnProperty$1 = function OrdinaryGetOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$8('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$8('Assertion failed: P must be a Property Key');
	}
	if (!src(O, P)) {
		return void 0;
	}
	if (!$gOPD) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor($gOPD(O, P));
};

var isPrimitive$2 = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var isPrimitive$1 = isPrimitive$2;

var $preventExtensions = getIntrinsic('%Object.preventExtensions%', true);
var $isExtensible = getIntrinsic('%Object.isExtensible%', true);



// https://ecma-international.org/ecma-262/6.0/#sec-isextensible-o

var IsExtensible$1 = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive$1(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive$1(obj);
	};

var OrdinaryGetOwnProperty = OrdinaryGetOwnProperty$1;

var IsExtensible = IsExtensible$1;

var $TypeError$7 = getIntrinsic('%TypeError%');











// https://ecma-international.org/ecma-262/6.0/#sec-createdataproperty

var CreateDataProperty$1 = function CreateDataProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$7('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$7('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var nonConfigurable = oldDesc && !oldDesc['[[Configurable]]'];
	if (nonConfigurable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};

var CreateDataProperty = CreateDataProperty$1;

var $TypeError$6 = getIntrinsic('%TypeError%');





// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

var CreateDataPropertyOrThrow$1 = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$6('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$6('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError$6('unable to create data property');
	}
	return success;
};

var $TypeError$5 = getIntrinsic('%TypeError%');




// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

var HasProperty$1 = function HasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$5('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$5('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};

var $exec = callBound('RegExp.prototype.exec');

var regexTester$1 = function regexTester(regex) {
	return function test(s) { return $exec(regex, s) !== null; };
};

var isPrimitive = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = shams();

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

var isSymbol = createCommonjsModule(function (module) {

var toStr = Object.prototype.toString;
var hasSymbols = hasSymbols$3();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}
});

var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';






var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
var es2015 = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDateObject(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive

var ToPrimitive$1 = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return es2015(input, arguments[1]);
	}
	return es2015(input);
};

var regexTester = regexTester$1;

var ToPrimitive = ToPrimitive$1;

var $TypeError$4 = getIntrinsic('%TypeError%');
var $Number = getIntrinsic('%Number%');
var $RegExp = getIntrinsic('%RegExp%');
var $parseInteger = getIntrinsic('%parseInt%');





var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace(value, trimRegex, '');
};



// https://ecma-international.org/ecma-262/6.0/#sec-tonumber

var ToNumber$1 = function ToNumber(argument) {
	var value = isPrimitive$1(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError$4('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new $TypeError$4('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		}
		var trimmed = $trim(value);
		if (trimmed !== value) {
			return ToNumber(trimmed);
		}

	}
	return $Number(value);
};

var sign = function sign(number) {
	return number >= 0 ? 1 : -1;
};

var ToNumber = ToNumber$1;

var $sign = sign;

// https://262.ecma-international.org/12.0/#sec-tointegerorinfinity

var ToIntegerOrInfinity$1 = function ToIntegerOrInfinity(value) {
	var number = ToNumber(value);
	if ($isNaN(number) || number === 0) { return 0; }
	if (!$isFinite(number)) { return number; }
	return $sign(number) * floor(abs(number));
};

var MAX_SAFE_INTEGER = maxSafeInteger;

var ToIntegerOrInfinity = ToIntegerOrInfinity$1;

var ToLength$1 = function ToLength(argument) {
	var len = ToIntegerOrInfinity(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
	return len;
};

var ToLength = ToLength$1;

var $TypeError$3 = getIntrinsic('%TypeError%');





// https://262.ecma-international.org/11.0/#sec-lengthofarraylike

var LengthOfArrayLike$1 = function LengthOfArrayLike(obj) {
	if (Type(obj) !== 'Object') {
		throw new $TypeError$3('Assertion failed: `obj` must be an Object');
	}
	return ToLength(Get(obj, 'length'));
};

var $String = getIntrinsic('%String%');
var $TypeError$2 = getIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

var ToString$1 = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError$2('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};

var Call = Call$1;

var CreateDataPropertyOrThrow = CreateDataPropertyOrThrow$1;

var HasProperty = HasProperty$1;

var LengthOfArrayLike = LengthOfArrayLike$1;

var ToString = ToString$1;

var $TypeError$1 = getIntrinsic('%TypeError%');











// https://262.ecma-international.org/11.0/#sec-flattenintoarray

// eslint-disable-next-line max-params
var FlattenIntoArray$1 = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}

	var targetIndex = start;
	var sourceIndex = 0;
	while (sourceIndex < sourceLen) {
		var P = ToString(sourceIndex);
		var exists = HasProperty(source, P);
		if (exists === true) {
			var element = Get(source, P);
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new $TypeError$1('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = IsArray(element);
			}
			if (shouldFlatten) {
				var elementLen = LengthOfArrayLike(element);
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= MAX_SAFE_INTEGER) {
					throw new $TypeError$1('index too large');
				}
				CreateDataPropertyOrThrow(target, ToString(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};

var $TypeError = getIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

var CheckObjectCoercible = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

var require$$0 = CheckObjectCoercible;

var RequireObjectCoercible$1 = require$$0;

var RequireObjectCoercible = RequireObjectCoercible$1;

var $Object = getIntrinsic('%Object%');



// https://ecma-international.org/ecma-262/6.0/#sec-toobject

var ToObject$1 = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};

var ArraySpeciesCreate = ArraySpeciesCreate$1;

var FlattenIntoArray = FlattenIntoArray$1;

var ToObject = ToObject$1;

var implementation = function flat() {
	var O = ToObject(this);
	var sourceLen = ToLength(Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ToIntegerOrInfinity(arguments[0]);
	}

	var A = ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};

var polyfill = function getPolyfill() {
	return Array.prototype.flat || implementation;
};

var shim = function shimFlat() {
	var polyfill$1 = polyfill();

	defineProperties_1(
		Array.prototype,
		{ flat: polyfill$1 },
		{ flat: function () { return Array.prototype.flat !== polyfill$1; } }
	);

	esShimUnscopables('flat');

	return polyfill$1;
};

shim();

var FlatFilter = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatfiltermap = exports.filtermap = exports.flatfilter = exports.flatmap = exports.flat = exports.map = exports.filter = exports.assertType = void 0;
/** Asserts the type of obj at compile-time */
function assertType(_obj) {
    return;
}
exports.assertType = assertType;
function wrap(array) {
    return Array.isArray(array) ? array : [array];
}
function filter(array) {
    return wrap(array).filter(Boolean);
}
exports.filter = filter;
function map(array, mapper) {
    return wrap(array).map(mapper);
}
exports.map = map;
function flat(array) {
    return wrap(array).flat(Infinity);
}
exports.flat = flat;
function flatmap(array, mapper) {
    return map(flat(array), mapper);
}
exports.flatmap = flatmap;
function flatfilter(array) {
    return filter(flat(array));
}
exports.flatfilter = flatfilter;
function filtermap(array, mapper) {
    return filter(map(array, mapper));
}
exports.filtermap = filtermap;
function flatfiltermap(array, mapper) {
    return filtermap(flat(array), mapper);
}
exports.flatfiltermap = flatfiltermap;
});

var Join = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = void 0;

/** Create a single CSS class from a set of classes or conditional classes. */
function join() {
    var potentials = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        potentials[_i] = arguments[_i];
    }
    // Edge is stubborn and adds commas anyways. Let's replace them with spaces.
    return FlatFilter.flatfilter(potentials)
        .join(" ")
        .replace(/,/g, " ");
}
exports.join = join;
});

var flexShrink0 = "AlertBanner_flex-shrink-0__gqAIJ";
var css_248z$G = ".AlertBanner_flex-shrink-0__gqAIJ {\n  flex-shrink: 0 !important; }\n";
var AlertBanner$1 = {"flex-shrink-0":"AlertBanner_flex-shrink-0__gqAIJ","flexShrink0":"AlertBanner_flex-shrink-0__gqAIJ"};
var stylesheet$B=".AlertBanner_flex-shrink-0__gqAIJ {\n  flex-shrink: 0 !important; }\n";
styleInject(css_248z$G);

var AlertBanner$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    flexShrink0: flexShrink0,
    'default': AlertBanner$1,
    stylesheet: stylesheet$B
});

var styles$w = /*@__PURE__*/getAugmentedNamespace(AlertBanner$2);

var AlertBanner_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });



var AlertBanner = /** @class */ (function (_super) {
    __extends(AlertBanner, _super);
    function AlertBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.fadeOut = function () {
            _this.setState({ isFadingOut: true });
            setTimeout(function () { return _this.onClose(); }, 300);
        };
        _this.onClose = function () {
            _this.setState({ render: false });
            if (_this.props && _this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.formatImage = function (imgStr) {
            var imgSrc = "";
            var imgClass = "";
            var imgAlt = "";
            var imgStyle;
            if (imgStr.indexOf("src") !== -1) {
                imgSrc = imgStr.split('src="')[1] ? imgStr.split('src="')[1] : "";
                imgSrc = imgSrc.split('"')[0];
            }
            if (imgStr.indexOf("class") !== -1) {
                imgClass = imgStr.split('class="')[1] ? imgStr.split('class="')[1] : "";
                imgClass = imgClass.split('"')[0];
            }
            if (imgStr.indexOf("alt") !== -1) {
                imgAlt = imgStr.split('alt="')[1] ? imgStr.split('alt="')[1] : "";
                imgAlt = imgAlt.split('"')[0];
            }
            if (imgStr.indexOf("style") !== -1) {
                imgStyle = imgStr.split("style='")[1] ? imgStr.split("style='")[1] : "";
                imgStyle = JSON.parse(imgStyle.split("'")[0]);
            }
            return React__default.createElement("img", { src: imgSrc, alt: imgAlt, style: imgStyle, className: imgClass });
        };
        _this.state = {
            render: true,
            isFadingOut: false,
            icon: _this.props.icon,
        };
        return _this;
    }
    AlertBanner.prototype.render = function () {
        var wrapperClasses = this.props.className
            ? this.props.className
            : "bg-ui-background-gray";
        var btnColor = wrapperClasses.indexOf("bg-ui-background-gray") !== -1
            ? "color-ui-black"
            : "color-ui-white";
        var isIconImg = this.state.icon && typeof this.state.icon === "string" ? true : false;
        return this.state.render ? (React__default.createElement("div", { "data-testid": this.props.testId, className: Join.join(wrapperClasses, "max-width-container mar-b-xs", this.state.isFadingOut ? "fadeout" : "") },
            React__default.createElement("div", { className: "container" },
                React__default.createElement("div", { className: "row" },
                    React__default.createElement("div", { className: Join.join(isIconImg ? "flex-items-center" : "flex-items-top", "flex justify-center grid-col-8 grid-col-10-md centered pad-r-xl-sm pad-t-xs pad-b-xs") },
                        this.state.icon && isIconImg ? (this.formatImage(this.state.icon)) : typeof this.props.icon === "object" ? (React__default.createElement("div", { className: "width-md-all height-md-all mar-r-xs " + styles$w.flexShrink0 }, this.state.icon)) : null,
                        React__default.createElement("p", { className: Join.join(wrapperClasses.indexOf("bg-ui-background-gray") !== -1
                                ? "color-ui-black"
                                : "color-ui-white", "type-base line-h-md mar-b-none", this.state.icon ? "text-left" : "text-center", this.state.icon && !isIconImg ? "pad-t-xxxs" : "") }, this.props.children),
                        React__default.createElement("button", { "aria-label": "" + (this.props.closeAccessability
                                ? this.props.closeAccessability
                                : "Dismiss Alert"), className: "top right height-md-all width-md-all icon-close absolute " + btnColor, onClick: this.fadeOut })))))) : null;
    };
    return AlertBanner;
}(React__default.Component));
exports.default = AlertBanner;
});

var AlertBanner = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = AlertBanner_1.default;
});

var AlertList_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });




var sortOrder = {
    error: 0,
    warning: 1,
    info: 2,
    success: 3,
};
var comparator = function (_a, _b) {
    var _c = _a.type, lhs = _c === void 0 ? Alert.defaultType : _c;
    var _d = _b.type, rhs = _d === void 0 ? Alert.defaultType : _d;
    return sortOrder[lhs] - sortOrder[rhs];
};
/** Render a list of alerts. This will also sort them in the proper order automatically and atomically. */
var AlertList = function (_a) {
    var className = _a.className, alerts = _a.alerts, style = _a.style; _a.addBottomMargin; var testId = _a.testId, listProps = __rest(_a, ["className", "alerts", "style", "addBottomMargin", "testId"]);
    var filtered = FlatFilter.flatfilter(alerts);
    return filtered.length > 0 ? (React__default.createElement("ul", { "data-testid": testId }, filtered
        .sort(comparator)
        .map(function (_a, index) {
        var nClassName = _a.className, nStyle = _a.style, alertProps = __rest(_a, ["className", "style"]);
        return (React__default.createElement("li", { className: "mar-b-md" },
            React__default.createElement(Alert.default, __assign({ className: Join.join(className, nClassName), key: index, renderInList: true, style: __assign(__assign({}, style), nStyle) }, alertProps, listProps))));
    }))) : null;
};
exports.default = AlertList;
});

var AlertListProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
});

var AlertList = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(AlertList_1, exports);
__exportStar(AlertListProps, exports);
var AlertList_1$1 = AlertList_1;
exports.default = AlertList_1$1.default;
});

var utils = createCommonjsModule(function (module, exports) {
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSsrSafe = exports.ssrSafe = exports.isMobile = void 0;
/**
 * @param {string} parentTestId testId of parent component
 * @param {string} component Callee component's definition. Ex: Button
 * @param {string} testIdSuffix Describes callee component's feature/property. Ex: SelectPrice
 */
function getTestId(parentTestId, component, testIdSuffix) {
    return parentTestId
        ? parentTestId + "_" + component + (testIdSuffix ? "_" + testIdSuffix : "")
        : "";
}
exports.default = getTestId;
function isMobile() {
    if (process.browser) {
        return /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    return false;
}
exports.isMobile = isMobile;
/**
 * Run a function if it is safe to do so when taking SSR into account.
 * @param func The function to run if it is safe to do so.
 * @param dependencies Any extra dependencies to check.
 */
function ssrSafe(func, dependencies) {
    if (dependencies === void 0) { dependencies = [
        (typeof process === "object" && process.browser) || typeof window === "object",
    ]; }
    // ensures browser specific functions are run only if browser is available whether in ssr or client
    if (dependencies.every(Boolean)) {
        return func();
    }
    return undefined;
}
exports.ssrSafe = ssrSafe;
function makeSsrSafe(func, dependencies) {
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ssrSafe(function () {
            var _a;
            return (_a = func).call.apply(_a, __spread([_this], args));
        }, dependencies);
    };
}
exports.makeSsrSafe = makeSsrSafe;
});

var Constants = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusableSelector = void 0;
/** A selector that will match elements that can be focused. */
exports.focusableSelector = 'a:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'area:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'button:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'input:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'object:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'select:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'textarea:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    '[tabindex]:not([tabindex^="-"]):not([tabindex=""])';
});

var Focus = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.focus = exports.getFocusableChildren = void 0;


/** Get all the children of this element that are focusable. */
function getFocusableChildren(inElement) {
    return inElement ? Array.from(inElement.querySelectorAll(Constants.focusableSelector)) : [];
}
exports.getFocusableChildren = getFocusableChildren;
/** Transfer the focus to an element that isn't traditionally focusable. This is for accessibility purposes if you need to move the focus somewhere but don't exactly have a precise target for it. */
exports.focus = utils.makeSsrSafe(function (element, preventScroll) {
    if (preventScroll === void 0) { preventScroll = true; }
    if (!element) {
        return;
    }
    var selectable = element.matches(Constants.focusableSelector);
    var tabIndex;
    if (!selectable) {
        tabIndex = element.getAttribute("tabindex");
        element.tabIndex = 0;
    }
    var scrollX = window.scrollX, scrollY = window.scrollY;
    element.focus({
        preventScroll: preventScroll,
    });
    if (preventScroll && (window.scrollY !== scrollY || window.scrollX !== scrollX)) {
        window.scrollTo(scrollX, scrollY);
    }
    if (tabIndex) {
        element.setAttribute("tabindex", tabIndex);
    }
    else {
        element.removeAttribute("tabindex");
    }
});
});

var Refs = createCommonjsModule(function (module, exports) {
var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refs = void 0;

/** Combine a set of refs into a single ref callback. */
function refs() {
    var refsToCombine = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refsToCombine[_i] = arguments[_i];
    }
    return function (instance) {
        var e_1, _a;
        try {
            for (var _b = __values(FlatFilter.flatfilter(refsToCombine)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var ref = _c.value;
                if (typeof ref === "function") {
                    ref(instance);
                }
                else if (ref && typeof ref === "object" && "current" in ref) {
                    ref.current = instance;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
}
exports.refs = refs;
});

var Simplify = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplify = void 0;
/**
 * Turns all optional values in an object to the value itself if it is truthy, or undefined if not.
 * @param obj The object to simplify.
 */
function simplify(obj) {
    var except = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        except[_i - 1] = arguments[_i];
    }
    var ret = {};
    // tslint:disable-next-line: forin
    for (var key in obj) {
        if (except.includes && except.includes(key)) {
            continue;
        }
        ret[key] = obj[key] || undefined;
    }
    return ret;
}
exports.simplify = simplify;
});

var ConcatUrls = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatUrls = void 0;

function concatUrls() {
    var urls = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        urls[_i] = arguments[_i];
    }
    var filtered = FlatFilter.flatfilter(urls);
    return filtered.length > 0 ? "/" + filtered.join("/").replace(/^\/+|\/+$|\/+(\/)/g, "$1") : "";
}
exports.concatUrls = concatUrls;
});

var Reporting = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingHelper = void 0;



var service;
exports.ReportingHelper = {
    get initialized() {
        return Boolean(service);
    },
    initialize: function (ReportingServiceClass) {
        service = ReportingServiceClass.getInstance();
    },
    pageLoad: function (_a) {
        var suffix = _a.url, prefix = _a.prefix, flowCode = _a.flowCode, lineOfBusiness = _a.lineOfBusiness, maybeDisplayedMessage = _a.displayedMessage, additionalParameters = _a.additionalParameters;
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var url = ConcatUrls.concatUrls(prefix, suffix);
        var displayedMessage = FlatFilter.flatfilter(maybeDisplayedMessage).join("|");
        // 	console.log(`ReportingHelper: pageLoad ->
        // url : ${url}
        // flowCode : ${flowCode}
        // lineOfBusiness: ${lineOfBusiness}${
        // 		displayedMessage
        // 			? `
        // displayedMessage: ${displayedMessage}`
        // 			: ``
        // 	}`)
        service.firePageLoadEvent(__assign({ url: url, "page.pageInfo.flowCode": flowCode, "page.pageInfo.lineOfBusiness": lineOfBusiness, "page.attributes.displayedMessage": displayedMessage }, additionalParameters));
    },
    linkClick: function (_a) {
        var name = _a.name, _b = _a.position, position = _b === void 0 ? "Body" : _b, suffix = _a.url, prefix = _a.prefix, pageUrl = _a.pageUrl, pagePrefix = _a.pagePrefix, additionalParameters = _a.additionalParameters;
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var url = ConcatUrls.concatUrls(prefix, suffix);
        // 	console.log(
        // 		`ReportingHelper: linkClick ->
        // name: ${name}
        // position: ${position}${
        // 			url
        // 				? `
        // url: ${url}`
        // 				: ""
        // 		}`
        // 	)
        if (pageUrl) {
            this.pageLoad({ url: pageUrl, prefix: pagePrefix });
        }
        service.fireLinkClickEvent(__assign({ linkName: name, linkPosition: position, linkDestinationUrl: url }, additionalParameters));
    },
    systemEvent: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireSystemEvent(name, data);
    },
    formSubmit: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireFormSubmitEvent(name, data);
    },
    formResponse: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireFormResponseEvent(name, data);
    },
    impression: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var data = Simplify.simplify(payload).data;
        // console.log(
        // 	`ReportingHelper: impression ->
        //         data: ${data ? JSON.stringify(data) : ""}
        //     `
        // )
        service.fireImpression(data);
    },
};
/** Function for logging, simplifying, and returning payloads for systemEvent or formSubmit due to their similarity */
function logEventPayload(payload, _eventType) {
    var _a = Simplify.simplify(payload), name = _a.name, data = _a.data;
    // 	console.log(
    // 		`ReportingHelper: ${_eventType} ->
    // eventName: ${name}${
    // 			data
    // 				? `
    // additionalData: ${JSON.stringify(data)}`
    // 				: ``
    // 		}`
    // 	)
    return { name: name, data: data };
}
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
    return typeof x === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}

/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
var empty$1 = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (config.useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            hostReportError(err);
        }
    },
    complete: function () { }
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = /*@__PURE__*/ (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x !== null && typeof x === 'object';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var UnsubscriptionErrorImpl = /*@__PURE__*/ (function () {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ?
            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
})();
var UnsubscriptionError = UnsubscriptionErrorImpl;

/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */
var Subscription = /*@__PURE__*/ (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) {
            _parentOrParents.remove(this);
        }
        else if (_parentOrParents !== null) {
            for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
            }
        }
        if (isFunction(_unsubscribe)) {
            if (_ctorUnsubscribe) {
                this._unsubscribe = undefined;
            }
            try {
                _unsubscribe.call(this);
            }
            catch (e) {
                errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
            }
        }
        if (isArray(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject(sub)) {
                    try {
                        sub.unsubscribe();
                    }
                    catch (e) {
                        errors = errors || [];
                        if (e instanceof UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                        }
                        else {
                            errors.push(e);
                        }
                    }
                }
            }
        }
        if (errors) {
            throw new UnsubscriptionError(errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        var subscription = teardown;
        if (!teardown) {
            return Subscription.EMPTY;
        }
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default: {
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
            subscription._parentOrParents = this;
        }
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) {
                return subscription;
            }
            subscription._parentOrParents = [_parentOrParents, this];
        }
        else if (_parentOrParents.indexOf(this) === -1) {
            _parentOrParents.push(this);
        }
        else {
            return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
            this._subscriptions = [subscription];
        }
        else {
            subscriptions.push(subscription);
        }
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError) ? err.errors : err); }, []);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = /*@__PURE__*/ (function () {
    return typeof Symbol === 'function'
        ? /*@__PURE__*/ Symbol('rxSubscriber')
        : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
})();

/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */
var Subscriber = /*@__PURE__*/ (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = empty$1;
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = empty$1;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[rxSubscriber] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}(Subscription));
var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== empty$1) {
                context = Object.create(observerOrNext);
                if (isFunction(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                hostReportError(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    hostReportError(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (config.useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                hostReportError(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!config.useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                hostReportError(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof Subscriber) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}

/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber]) {
            return nextOrObserver[rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber(empty$1);
    }
    return new Subscriber(nextOrObserver, error, complete);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = /*@__PURE__*/ (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
    return x;
}

/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}

/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */
var Observable = /*@__PURE__*/ (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber(observerOrNext, error, complete);
        if (operator) {
            sink.add(operator.call(sink, this.source));
        }
        else {
            sink.add(this.source || (config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (config.useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if (canReportError(sink)) {
                sink.error(err);
            }
            else {
                console.warn(err);
            }
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = config.Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ (function () {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = 'object unsubscribed';
        this.name = 'ObjectUnsubscribedError';
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
})();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */
var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(Subscriber));
var Subject = /*@__PURE__*/ (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable));
var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */
var ConnectableObservable = /*@__PURE__*/ (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription.EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount()(this);
    };
    return ConnectableObservable;
}(Observable));
var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(SubjectSubscriber));

/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */
var GroupedObservable = /*@__PURE__*/ (function (_super) {
    __extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(Observable));
var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
    __extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */
var BehaviorSubject = /*@__PURE__*/ (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(Subject));

/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
var Action = /*@__PURE__*/ (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        return this;
    };
    return Action;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */
var AsyncAction = /*@__PURE__*/ (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action));

/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
var QueueAction = /*@__PURE__*/ (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction));

var Scheduler = /*@__PURE__*/ (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function () { return Date.now(); };
    return Scheduler;
}());

/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */
var AsyncScheduler = /*@__PURE__*/ (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var QueueScheduler = /*@__PURE__*/ (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */
var queueScheduler = /*@__PURE__*/ new QueueScheduler(QueueAction);
var queue = queueScheduler;

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
var EMPTY = /*@__PURE__*/ new Observable(function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    };
};

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function scheduleArray(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        var i = 0;
        sub.add(scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
                sub.add(this.schedule());
            }
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */
function fromArray(input, scheduler) {
    if (!scheduler) {
        return new Observable(subscribeToArray(input));
    }
    else {
        return scheduleArray(input, scheduler);
    }
}

/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */
function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (isScheduler(scheduler)) {
        args.pop();
        return scheduleArray(args, scheduler);
    }
    else {
        return fromArray(args);
    }
}

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function throwError(error, scheduler) {
    if (!scheduler) {
        return new Observable(function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new Observable(function (subscriber) { return scheduler.schedule(dispatch$7, 0, { error: error, subscriber: subscriber }); });
    }
}
function dispatch$7(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */
var NotificationKind;
/*@__PURE__*/ (function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return of(this.value);
            case 'E':
                return throwError(this.error);
            case 'C':
                return empty();
        }
        throw new Error('unexpected notification kind value');
    };
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());

/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */
var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification.createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification.createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}(Subscriber));
var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());

/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */
var ReplaySubject = /*@__PURE__*/ (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
            bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
            windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) {
                _events.shift();
            }
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        if (!this.isStopped) {
            this._events.push(new ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else if (this.isStopped || this.hasError) {
            subscription = Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new ObserveOnSubscriber(subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject));
var ReplayEvent = /*@__PURE__*/ (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());

/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */
var AsyncSubject = /*@__PURE__*/ (function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription.EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(Subject));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ (function () { return /*@__PURE__*/ Promise.resolve(); })();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};

/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */
var AsapAction = /*@__PURE__*/ (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(AsyncAction));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var AsapScheduler = /*@__PURE__*/ (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */
var asapScheduler = /*@__PURE__*/ new AsapScheduler(AsapAction);
var asap = asapScheduler;

/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
var asyncScheduler = /*@__PURE__*/ new AsyncScheduler(AsyncAction);
var async = asyncScheduler;

/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
var AnimationFrameAction = /*@__PURE__*/ (function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */
var animationFrameScheduler = /*@__PURE__*/ new AnimationFrameScheduler(AnimationFrameAction);
var animationFrame = animationFrameScheduler;

/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
            SchedulerAction = VirtualAction;
        }
        if (maxFrames === void 0) {
            maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler));
var VirtualAction = /*@__PURE__*/ (function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) {
            index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function isObservable(obj) {
    return !!obj && (obj instanceof Observable || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ (function () {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = 'argument out of range';
        this.name = 'ArgumentOutOfRangeError';
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
})();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var EmptyErrorImpl = /*@__PURE__*/ (function () {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = 'no elements in sequence';
        this.name = 'EmptyError';
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
})();
var EmptyError = EmptyErrorImpl;

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var TimeoutErrorImpl = /*@__PURE__*/ (function () {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
})();
var TimeoutError = TimeoutErrorImpl;

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
var MapSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */
function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new Observable(function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new AsyncSubject();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (canReportError(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(dispatch$6, 0, state);
            }
        });
    };
}
function dispatch$6(state) {
    var _this = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext$1, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext$1(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}

/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new Observable(function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new AsyncSubject();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (canReportError(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(dispatch$5, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
function dispatch$5(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
var OuterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
var InnerSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, hostReportError);
        return subscriber;
    };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator$1 = iterable[iterator]();
        do {
            var item = void 0;
            try {
                item = iterator$1.next();
            }
            catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        if (typeof iterator$1.return === 'function') {
            subscriber.add(function () {
                if (iterator$1.return) {
                    iterator$1.return();
                }
            });
        }
        return subscriber;
    };
};

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[observable]();
        if (typeof obs.subscribe !== 'function') {
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}

/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
var subscribeTo = function (result) {
    if (!!result && typeof result[observable] === 'function') {
        return subscribeToObservable(result);
    }
    else if (isArrayLike(result)) {
        return subscribeToArray(result);
    }
    else if (isPromise(result)) {
        return subscribeToPromise(result);
    }
    else if (!!result && typeof result[iterator] === 'function') {
        return subscribeToIterable(result);
    }
    else {
        var value = isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};

/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) {
        innerSubscriber = new InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    }
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof Observable) {
        return result.subscribe(innerSubscriber);
    }
    return subscribeTo(result)(innerSubscriber);
}

/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */
var NONE = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = undefined;
    var scheduler = undefined;
    if (isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1 && isArray(observables[0])) {
        observables = observables[0];
    }
    return fromArray(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());
var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(subscribeToResult(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(OuterSubscriber));

/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */
function scheduleObservable(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        sub.add(scheduler.schedule(function () {
            var observable$1 = input[observable]();
            sub.add(observable$1.subscribe({
                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
            }));
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function schedulePromise(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        sub.add(scheduler.schedule(function () {
            return input.then(function (value) {
                sub.add(scheduler.schedule(function () {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                }));
            }, function (err) {
                sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
            });
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */
function scheduleIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        var iterator$1;
        sub.add(function () {
            if (iterator$1 && typeof iterator$1.return === 'function') {
                iterator$1.return();
            }
        });
        sub.add(scheduler.schedule(function () {
            iterator$1 = input[iterator]();
            sub.add(scheduler.schedule(function () {
                if (subscriber.closed) {
                    return;
                }
                var value;
                var done;
                try {
                    var result = iterator$1.next();
                    value = result.value;
                    done = result.done;
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
function isInteropObservable(input) {
    return input && typeof input[observable] === 'function';
}

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
function isIterable(input) {
    return input && typeof input[iterator] === 'function';
}

/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */
function scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable(input)) {
            return scheduleObservable(input, scheduler);
        }
        else if (isPromise(input)) {
            return schedulePromise(input, scheduler);
        }
        else if (isArrayLike(input)) {
            return scheduleArray(input, scheduler);
        }
        else if (isIterable(input) || typeof input === 'string') {
            return scheduleIterable(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}

/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof Observable) {
            return input;
        }
        return new Observable(subscribeTo(input));
    }
    else {
        return scheduled(input, scheduler);
    }
}

/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */
var SimpleInnerSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}(Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function () {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}(Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof Observable) {
        return result.subscribe(innerSubscriber);
    }
    var subscription;
    try {
        subscription = subscribeTo(result)(innerSubscriber);
    }
    catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(mergeMap(function (a, i) { return from(project(a, i)).pipe(map(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());
var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish) {
        var innerSubscriber = new SimpleInnerSubscriber(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = innerSubscribe(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function () {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(SimpleOuterSubscriber));

/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */
function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeMap(identity, concurrent);
}

/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */
function concatAll() {
    return mergeAll(1);
}

/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return concatAll()(of.apply(void 0, observables));
}

/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */
function defer(observableFactory) {
    return new Observable(function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? from(input) : empty();
        return source.subscribe(subscriber);
    });
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */
function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 1) {
        var first_1 = sources[0];
        if (isArray(first_1)) {
            return forkJoinInternal(first_1, null);
        }
        if (isObject(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === 'function') {
        var resultSelector_1 = sources.pop();
        sources = (sources.length === 1 && isArray(sources[0])) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe(map(function (args) { return resultSelector_1.apply(void 0, args); }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new Observable(function (subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function (i) {
            var source = from(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function (value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function (err) { return subscriber.error(err); },
                complete: function () {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) {
                            subscriber.next(keys ?
                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                                values);
                        }
                        subscriber.complete();
                    }
                }
            }));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
    });
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
function fromEvent(target, eventName, options, resultSelector) {
    if (isFunction(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable(function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable(function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!isFunction(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}

/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || identity;
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || isScheduler(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = identity;
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new Observable(function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(dispatch$4, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
function dispatch$4(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}

/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */
function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) {
        trueResult = EMPTY;
    }
    if (falseResult === void 0) {
        falseResult = EMPTY;
    }
    return defer(function () { return condition() ? trueResult : falseResult; });
}

/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */
function isNumeric(val) {
    return !isArray(val) && (val - parseFloat(val) + 1) >= 0;
}

/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */
function interval(period, scheduler) {
    if (period === void 0) {
        period = 0;
    }
    if (scheduler === void 0) {
        scheduler = async;
    }
    if (!isNumeric(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = async;
    }
    return new Observable(function (subscriber) {
        subscriber.add(scheduler.schedule(dispatch$3, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
function dispatch$3(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}

/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable) {
        return observables[0];
    }
    return mergeAll(concurrent)(fromArray(observables, scheduler));
}

/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */
var NEVER = /*@__PURE__*/ new Observable(noop);
function never() {
    return NEVER;
}

/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */
function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return EMPTY;
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && isArray(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new Observable(function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return from(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function pairs(obj, scheduler) {
    if (!scheduler) {
        return new Observable(function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new Observable(function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new Subscription();
            subscription.add(scheduler.schedule(dispatch$2, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
function dispatch$2(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */
function partition(source, predicate, thisArg) {
    return [
        filter(predicate, thisArg)(new Observable(subscribeTo(source))),
        filter(not(predicate, thisArg))(new Observable(subscribeTo(source)))
    ];
}

/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1) {
        if (isArray(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return fromArray(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());
var RaceSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = subscribeToResult(this, observable, undefined, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(OuterSubscriber));

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function range(start, count, scheduler) {
    if (start === void 0) {
        start = 0;
    }
    return new Observable(function (subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) {
            return scheduler.schedule(dispatch$1, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(current++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
function dispatch$1(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}

/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    var period = -1;
    if (isNumeric(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (isScheduler(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!isScheduler(scheduler)) {
        scheduler = async;
    }
    return new Observable(function (subscriber) {
        var due = isNumeric(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(dispatch, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}

/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */
function using(resourceFactory, observableFactory) {
    return new Observable(function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? from(result) : EMPTY;
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}

/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */
function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return fromArray(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());
var ZipSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (isArray(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[iterator] === 'function') {
            iterators.push(new StaticIterator(value[iterator]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            }
            else {
                this.active--;
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(Subscriber));
var StaticIterator = /*@__PURE__*/ (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}());
var StaticArrayIterator = /*@__PURE__*/ (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[iterator] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
    __extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[iterator] = function () {
        return this;
    };
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function () {
        return innerSubscribe(this.observable, new SimpleInnerSubscriber(this));
    };
    return ZipBufferIterator;
}(SimpleOuterSubscriber));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */

var _esm5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Observable: Observable,
    ConnectableObservable: ConnectableObservable,
    GroupedObservable: GroupedObservable,
    observable: observable,
    Subject: Subject,
    BehaviorSubject: BehaviorSubject,
    ReplaySubject: ReplaySubject,
    AsyncSubject: AsyncSubject,
    asap: asap,
    asapScheduler: asapScheduler,
    async: async,
    asyncScheduler: asyncScheduler,
    queue: queue,
    queueScheduler: queueScheduler,
    animationFrame: animationFrame,
    animationFrameScheduler: animationFrameScheduler,
    VirtualTimeScheduler: VirtualTimeScheduler,
    VirtualAction: VirtualAction,
    Scheduler: Scheduler,
    Subscription: Subscription,
    Subscriber: Subscriber,
    Notification: Notification,
    get NotificationKind () { return NotificationKind; },
    pipe: pipe,
    noop: noop,
    identity: identity,
    isObservable: isObservable,
    ArgumentOutOfRangeError: ArgumentOutOfRangeError,
    EmptyError: EmptyError,
    ObjectUnsubscribedError: ObjectUnsubscribedError,
    UnsubscriptionError: UnsubscriptionError,
    TimeoutError: TimeoutError,
    bindCallback: bindCallback,
    bindNodeCallback: bindNodeCallback,
    combineLatest: combineLatest,
    concat: concat,
    defer: defer,
    empty: empty,
    forkJoin: forkJoin,
    from: from,
    fromEvent: fromEvent,
    fromEventPattern: fromEventPattern,
    generate: generate,
    iif: iif,
    interval: interval,
    merge: merge,
    never: never,
    of: of,
    onErrorResumeNext: onErrorResumeNext,
    pairs: pairs,
    partition: partition,
    race: race,
    range: range,
    throwError: throwError,
    timer: timer,
    using: using,
    zip: zip,
    scheduled: scheduled,
    EMPTY: EMPTY,
    NEVER: NEVER,
    config: config
});

var UserAgent = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouch = exports.isFirefox = exports.isSafari = exports.isEdge = exports.isChrome = exports.isPCDevice = exports.isMac = exports.isKindle = exports.isMobileDevice = exports.isIE = exports.isAndroid = exports.isIos = void 0;

exports.isIos = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent && /ipad|iphone|ipod/i.test(navigator.userAgent));
});
exports.isAndroid = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent && /android/i.test(navigator.userAgent));
});
exports.isIE = utils.makeSsrSafe(function () {
    return Boolean(/MSIE|Trident/i.test(window.navigator.userAgent));
});
exports.isMobileDevice = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent &&
        /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Silk/i.test(navigator.userAgent));
});
exports.isKindle = utils.makeSsrSafe(function () {
    return Boolean(/Silk/i.test(window.navigator.userAgent));
});
exports.isMac = utils.makeSsrSafe(function () {
    return Boolean(/Macintosh/i.test(window.navigator.userAgent));
});
exports.isPCDevice = utils.makeSsrSafe(function () {
    return Boolean(!exports.isAndroid() && !exports.isIos() && !exports.isKindle() && !exports.isMac());
});
exports.isChrome = utils.makeSsrSafe(function () {
    return Boolean(/Chrome/i.test(window.navigator.userAgent));
});
exports.isEdge = utils.makeSsrSafe(function () {
    return Boolean(/(?=.*AppleWebKit)(?=.*Safari)(?=.*Edg)/i.test(window.navigator.userAgent));
});
exports.isSafari = utils.makeSsrSafe(function () {
    return Boolean(exports.isMac && !exports.isMobileDevice && !exports.isChrome && /Safari/i.test(window.navigator.userAgent));
});
exports.isFirefox = utils.makeSsrSafe(function () {
    return Boolean(/Firefox/i.test(window.navigator.userAgent) &&
        "MozAppearance" in document.documentElement.style);
});
exports.isTouch = utils.makeSsrSafe(function () {
    return Boolean("ontouchstart" in document.documentElement);
});
});

var rxjs_1 = /*@__PURE__*/getAugmentedNamespace(_esm5);

var TabWatcher = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabWatcher = void 0;



/** The subject that will emit events when tabbing state changes */
var subject = new rxjs_1.Subject();
var isTabbing = false;
var initialized = false;
var checkFocusable = function (ele) {
    var eleArray = ["a", "button", "input", "select", "textarea", "label"];
    var eleTag = ele.nodeName.toLowerCase();
    if (eleArray.indexOf(eleTag) > -1) {
        return true;
    }
    else {
        if (ele.getAttribute("tabindex") !== null && ele.getAttribute("tabindex") !== "-1") {
            return true;
        }
        else {
            return false;
        }
    }
};
var maybeStartTabbing = function (event) {
    var key = event.which || event.keyCode || 0;
    var eleFocusable = checkFocusable(event.target);
    if ((!isTabbing && key === 9) || key === 13 || key === 32 || key === 37 || key === 38 || key === 39 || key === 40) {
        if (initialized && eleFocusable) {
            document.documentElement.classList.add("is-tabbing");
            document.documentElement.classList.remove("is-mouse");
        }
        isTabbing = true;
        subject.next(isTabbing);
    }
};
var mouseClick = function () {
    var eleFocusable = checkFocusable(document.activeElement);
    if (eleFocusable) {
        document.documentElement.classList.add("is-mouse");
        document.documentElement.classList.remove("is-tabbing");
        isTabbing = false;
        subject.next(isTabbing);
    }
};
var stopTabbing = function () {
    if (isTabbing) {
        if (initialized) {
            document.documentElement.classList.remove("is-mouse");
            document.documentElement.classList.remove("is-tabbing");
        }
        isTabbing = false;
        subject.next(isTabbing);
    }
};
var addDeviceClass = function () {
    if (UserAgent.isAndroid()) {
        document.documentElement.classList.add("isAndroid");
    }
    if (UserAgent.isIos()) {
        document.documentElement.classList.add("isIOS");
    }
    if (UserAgent.isIE()) {
        document.documentElement.classList.add("isIE");
    }
    if (UserAgent.isMobileDevice()) {
        document.documentElement.classList.add("isMobile");
    }
    if (UserAgent.isKindle()) {
        document.documentElement.classList.add("isKindle");
    }
    if (UserAgent.isMac()) {
        document.documentElement.classList.add("isMac");
    }
    if (UserAgent.isPCDevice()) {
        document.documentElement.classList.add("isPC");
    }
    if (UserAgent.isChrome()) {
        document.documentElement.classList.add("isChrome");
    }
    if (UserAgent.isEdge()) {
        document.documentElement.classList.add("isEdge");
    }
    if (UserAgent.isSafari()) {
        document.documentElement.classList.add("isSafari");
    }
    if (UserAgent.isFirefox()) {
        document.documentElement.classList.add("isFirefox");
    }
    if (UserAgent.isTouch()) {
        document.documentElement.classList.add("isTouch");
    }
    addOrientationClass();
};
var addOrientationClass = function () {
    if (window.innerWidth < window.innerHeight) {
        document.documentElement.classList.add("isPortrait");
        document.documentElement.classList.remove("isLandscape");
    }
    if (window.innerWidth > window.innerHeight) {
        document.documentElement.classList.remove("isPortrait");
        document.documentElement.classList.add("isLandscape");
    }
};
utils.ssrSafe(function () {
    addEventListener("keyup", maybeStartTabbing);
    addEventListener("click", mouseClick);
    addEventListener("touchstart", stopTabbing);
    addEventListener("resize", addOrientationClass);
    if (document.readyState === "complete") {
        addDeviceClass();
    }
    else {
        addEventListener("DOMContentLoaded", addDeviceClass);
    }
}, [typeof addEventListener === "function"]);
var observable = subject.asObservable();
/**
 * Subscribe to this to see whenever the user starts or stops tabbing.
 */
exports.TabWatcher = {
    /** Initialize the default action (adding `is-tabbing` class to body). */
    initialize: function () {
        initialized = true;
    },
    /** Whether we are currently using tab to navigate. */
    get isTabbing() {
        return isTabbing;
    },
    /** Subscribe to this observable. */
    subscribe: observable.subscribe.bind(observable),
    /** Pipe this observable with operators. */
    pipe: observable.pipe.bind(observable),
};
});

var baseCta = "BaseCta_base-cta__rJBl3";
var googlePlayLg = "BaseCta_google-play-lg__26W15";
var googlePlaySm = "BaseCta_google-play-sm__fgrG2";
var appleAppStoreLg = "BaseCta_apple-app-store-lg__iENHQ";
var appleAppStoreSm = "BaseCta_apple-app-store-sm__YNBA8";
var css_248z$F = ".BaseCta_base-cta__rJBl3 {\n  background: none;\n  border: none; }\n  body.is-tabbing .BaseCta_base-cta__rJBl3:focus {\n    outline: 2px solid #0057b8; }\n\na.BaseCta_google-play-lg__26W15, a.BaseCta_google-play-sm__fgrG2 {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzUgNDAiPjxkZWZzLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIyMS44IiB4Mj0iNS4wMiIgeTE9IjE3My4yOSIgeTI9IjE1Ni41MSIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDE4MikiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMGEwZmYiLz48c3RvcCBvZmZzZXQ9Ii4wMSIgc3RvcC1jb2xvcj0iIzAwYTFmZiIvPjxzdG9wIG9mZnNldD0iLjI2IiBzdG9wLWNvbG9yPSIjMDBiZWZmIi8+PHN0b3Agb2Zmc2V0PSIuNTEiIHN0b3AtY29sb3I9IiMwMGQyZmYiLz48c3RvcCBvZmZzZXQ9Ii43NiIgc3RvcC1jb2xvcj0iIzAwZGZmZiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwZTNmZiIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJiIiB4MT0iMzMuODMiIHgyPSI5LjY0IiB5MT0iMTYyIiB5Mj0iMTYyIiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDAgMTgyKSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmZTAwMCIvPjxzdG9wIG9mZnNldD0iLjQxIiBzdG9wLWNvbG9yPSIjZmZiZDAwIi8+PHN0b3Agb2Zmc2V0PSIuNzgiIHN0b3AtY29sb3I9Im9yYW5nZSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmOWMwMCIvPjwvbGluZWFyR3JhZGllbnQ+PGxpbmVhckdyYWRpZW50IGlkPSJjIiB4MT0iMjQuODMiIHgyPSIyLjA3IiB5MT0iMTU5LjciIHkyPSIxMzYuOTUiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMCAxODIpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmYzYTQ0Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjYzMxMTYyIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImQiIHgxPSI3LjMiIHgyPSIxNy40NiIgeTE9IjE4MS44MiIgeTI9IjE3MS42NiIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDE4MikiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMzMmEwNzEiLz48c3RvcCBvZmZzZXQ9Ii4wNyIgc3RvcC1jb2xvcj0iIzJkYTc3MSIvPjxzdG9wIG9mZnNldD0iLjQ4IiBzdG9wLWNvbG9yPSIjMTVjZjc0Ii8+PHN0b3Agb2Zmc2V0PSIuOCIgc3RvcC1jb2xvcj0iIzA2ZTc3NSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwZjA3NiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMzUiIGhlaWdodD0iNDAiIHJ4PSI1IiByeT0iNSIvPjxwYXRoIGZpbGw9IiNhNmE2YTYiIGQ9Ik0xMzAgLjhhNC4yIDQuMiAwIDAxNC4yIDQuMnYzMGE0LjIgNC4yIDAgMDEtNC4yIDQuMkg1QTQuMiA0LjIgMCAwMS44IDM1VjVBNC4yIDQuMiAwIDAxNSAuOGgxMjVtMC0uOEg1YTUuMDEgNS4wMSAwIDAwLTUgNXYzMGE1LjAxIDUuMDEgMCAwMDUgNWgxMjVhNS4wMSA1LjAxIDAgMDA1LTVWNWE1LjAxIDUuMDEgMCAwMC01LTV6Ii8+PHBhdGggZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iLjIiIGQ9Ik00Ny40MiAxMC4yNGEyLjcgMi43IDAgMDEtLjc1IDIgMi45IDIuOSAwIDAxLTIuMi45QTMuMDkgMy4wOSAwIDAxNDEuMzUgMTBhMy4xIDMuMSAwIDAxMy4xMi0zLjEzIDMuMSAzLjEgMCAwMTEuMjMuMjUgMi40OCAyLjQ4IDAgMDEuOTQuNjdsLS41My41M2EyLjAzIDIuMDMgMCAwMC0xLjY0LS43MiAyLjMyIDIuMzIgMCAwMC0yLjMzIDIuNCAyLjM2IDIuMzYgMCAwMDQgMS43MyAxLjg5IDEuODkgMCAwMC41LTEuMjJoLTIuMTdWOS44aDIuOWEyLjU0IDIuNTQgMCAwMS4wNS40NXptNC42MS0yLjVINDkuM3YxLjloMi40NnYuNzJINDkuM3YxLjloMi43M1YxM2gtMy41VjdoMy41ek01NS4yOCAxM2gtLjc3VjcuNzRoLTEuNjhWN2g0LjEydi43NGgtMS42N3ptNC42NiAwVjdoLjc3djZ6bTQuMTkgMGgtLjc3VjcuNzRoLTEuNjhWN2g0LjEydi43NGgtMS42N3ptOS40Ny0uNzhhMy4xMiAzLjEyIDAgMDEtNC40IDAgMy4wNyAzLjA3IDAgMDEtLjg3LTIuMjIgMy4wNyAzLjA3IDAgMDEuODgtMi4yMyAzLjEgMy4xIDAgMDE0LjQgMCAzLjA3IDMuMDcgMCAwMS44OCAyLjIzIDMuMDcgMy4wNyAwIDAxLS44OCAyLjIyem0tMy44Mi0uNWEyLjMgMi4zIDAgMDAzLjI2IDBBMi4zNSAyLjM1IDAgMDA3My43IDEwYTIuMzUgMi4zNSAwIDAwLS42Ny0xLjcyIDIuMyAyLjMgMCAwMC0zLjI2IDBBMi4zNSAyLjM1IDAgMDA2OS4xIDEwYTIuMzUgMi4zNSAwIDAwLjY3IDEuNzJ6bTUuOCAxLjI4VjdoLjkzbDIuOTIgNC42N2guMDNsLS4wMy0xLjE2VjdoLjc3djZoLS44bC0zLjA1LTQuOWgtLjA0bC4wNCAxLjE2VjEzeiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik02OC4xNCAyMS43NUE0LjI1IDQuMjUgMCAxMDcyLjQgMjZhNC4yIDQuMiAwIDAwLTQuMjctNC4yNXptMCA2LjgzYTIuNTggMi41OCAwIDExMi40LTIuNTggMi40NiAyLjQ2IDAgMDEtMi40IDIuNTh6bS05LjMyLTYuODNBNC4yNSA0LjI1IDAgMTA2My4xIDI2YTQuMiA0LjIgMCAwMC00LjI3LTQuMjV6bTAgNi44M2EyLjU4IDIuNTggMCAxMTIuNC0yLjU4IDIuNDYgMi40NiAwIDAxLTIuNCAyLjU4em0tMTEuMDgtNS41MnYxLjhoNC4zMmEzLjc3IDMuNzcgMCAwMS0uOTggMi4yNyA0LjQyIDQuNDIgMCAwMS0zLjM0IDEuMzIgNC44IDQuOCAwIDAxMC05LjYgNC42IDQuNiAwIDAxMy4yNiAxLjNsMS4yNy0xLjI4YTYuMyA2LjMgMCAwMC00LjUyLTEuODIgNi42IDYuNiAwIDEwMCAxMy4yIDYuMDQgNi4wNCAwIDAwNC42LTEuODQgNS45NiA1Ljk2IDAgMDAxLjU3LTQuMjMgNS44NyA1Ljg3IDAgMDAtLjEtMS4xMnptNDUuMzEgMS40YTMuOTUgMy45NSAwIDAwLTMuNjQtMi43MUE0LjA0IDQuMDQgMCAwMDg1LjQgMjZhNC4xNiA0LjE2IDAgMDA0LjIyIDQuMjUgNC4yMyA0LjIzIDAgMDAzLjU1LTEuODhsLTEuNDUtLjk3YTIuNDMgMi40MyAwIDAxLTIuMSAxLjE4IDIuMTYgMi4xNiAwIDAxLTIuMDYtMS4zbDUuNjktMi4zNHptLTUuOCAxLjQxYTIuMzMgMi4zMyAwIDAxMi4yMi0yLjQ3IDEuNjUgMS42NSAwIDAxMS41OC45ek04Mi42MyAzMGgxLjg3VjE3LjVoLTEuODd6bS0zLjA2LTcuM2gtLjA3YTIuOTUgMi45NSAwIDAwLTIuMjQtLjk1IDQuMjYgNC4yNiAwIDAwMCA4LjUgMi45IDIuOSAwIDAwMi4yNC0uOTZoLjA2di42MWMwIDEuNjMtLjg3IDIuNS0yLjI3IDIuNWEyLjM1IDIuMzUgMCAwMS0yLjE0LTEuNTFsLTEuNjMuNjdhNC4wNSA0LjA1IDAgMDAzLjc3IDIuNTJjMi4yIDAgNC4wNS0xLjMgNC4wNS00LjQzVjIyaC0xLjc3em0tMi4xNSA1Ljg4YTIuNTkgMi41OSAwIDAxMC01LjE2IDIuNCAyLjQgMCAwMTIuMjggMi42IDIuMzggMi4zOCAwIDAxLTIuMjggMi41NnptMjQuMzktMTEuMDhoLTQuNDhWMzBoMS44N3YtNC43NGgyLjZhMy44OSAzLjg5IDAgMTAwLTcuNzZ6bS4wNCA2LjAzSDk5LjJ2LTQuM2gyLjY1YTIuMTQgMi4xNCAwIDExMCA0LjN6bTExLjU0LTEuOGEzLjUgMy41IDAgMDAtMy4zMyAxLjlsMS42NS43YTEuNzcgMS43NyAwIDAxMS43LS45MiAxLjggMS44IDAgMDExLjk3IDEuNjF2LjEzYTQuMTMgNC4xMyAwIDAwLTEuOTUtLjQ4Yy0xLjc4IDAtMy42Ljk4LTMuNiAyLjgxYTIuODkgMi44OSAwIDAwMy4xIDIuNzUgMi42MyAyLjYzIDAgMDAyLjM4LTEuMjJoLjA2di45N2gxLjh2LTQuOGMuMDEtMi4yMS0xLjY0LTMuNDUtMy43OC0zLjQ1em0tLjIzIDYuODVjLS42MSAwLTEuNDYtLjMxLTEuNDYtMS4wNyAwLS45NiAxLjA2LTEuMzMgMS45Ny0xLjMzYTMuMzIgMy4zMiAwIDAxMS43LjQyIDIuMjYgMi4yNiAwIDAxLTIuMjEgMS45OHpNMTIzLjc0IDIybC0yLjE0IDUuNDJoLS4wNkwxMTkuMzIgMjJoLTIuMDFsMy4zMyA3LjU4LTEuOSA0LjJoMS45NEwxMjUuODIgMjJ6bS0xNi44IDhoMS44NlYxNy41aC0xLjg3eiIvPjxwYXRoIGZpbGw9InVybCgjYSkiIGQ9Ik0xMC40NCA3LjU0YTIgMiAwIDAwLS40NyAxLjR2MjIuMTJhMiAyIDAgMDAuNDcgMS40bC4wNy4wN0wyMi45IDIwLjE1di0uM0wxMC41IDcuNDd6Ii8+PHBhdGggZmlsbD0idXJsKCNiKSIgZD0iTTI3LjAzIDI0LjI4bC00LjEzLTQuMTN2LS4zbDQuMTMtNC4xMy4xLjA2IDQuODkgMi43OGMxLjQuOCAxLjQgMi4xIDAgMi44OWwtNC45IDIuNzh6Ii8+PHBhdGggZmlsbD0idXJsKCNjKSIgZD0iTTI3LjEyIDI0LjIzTDIyLjkgMjAgMTAuNDQgMzIuNDZhMS42MyAxLjYzIDAgMDAyLjA3LjA2bDE0LjYxLTguMyIvPjxwYXRoIGZpbGw9InVybCgjZCkiIGQ9Ik0yNy4xMiAxNS43OGwtMTQuNi04LjNhMS42MyAxLjYzIDAgMDAtMi4wOC4wNkwyMi45IDIweiIvPjxwYXRoIHN0eWxlPSJpc29sYXRpb246aXNvbGF0ZSIgZD0iTTI3LjAzIDI0LjEzTDEyLjUgMzIuMzhhMS42NyAxLjY3IDAgMDEtMiAuMDFsLS4wNy4wNy4wNy4wOGExLjY3IDEuNjcgMCAwMDItLjAxbDE0LjYxLTguM3oiIG9wYWNpdHk9Ii4yIi8+PHBhdGggc3R5bGU9Imlzb2xhdGlvbjppc29sYXRlIiBkPSJNMTAuNDQgMzIuMzJhMiAyIDAgMDEtLjQ3LTEuNHYuMTRhMiAyIDAgMDAuNDcgMS40bC4wNy0uMDd6TTMyLjAyIDIxLjNsLTUgMi44My4xLjEgNC45LTIuNzhBMS43NSAxLjc1IDAgMDAzMy4wNSAyMCAxLjg2IDEuODYgMCAwMTMyIDIxLjN6IiBvcGFjaXR5PSIuMTIiLz48cGF0aCBmaWxsPSIjZmZmIiBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiIGQ9Ik0xMi41MSA3LjYybDE5LjUgMTEuMDhhMS44NiAxLjg2IDAgMDExLjA1IDEuMyAxLjc1IDEuNzUgMCAwMC0xLjA0LTEuNDRMMTIuNTIgNy40OGMtMS40LS44LTIuNTUtLjE0LTIuNTUgMS40NnYuMTVjMC0xLjYgMS4xNS0yLjI2IDIuNTQtMS40N3oiIG9wYWNpdHk9Ii4yNSIvPjwvc3ZnPg==\"); }\n\na.BaseCta_apple-app-store-lg__iENHQ, a.BaseCta_apple-app-store-sm__YNBA8 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_google-play-lg__26W15, a.BaseCta_apple-app-store-lg__iENHQ {\n  height: 48px;\n  width: 162px; }\n\na.BaseCta_google-play-sm__fgrG2, a.BaseCta_apple-app-store-sm__YNBA8 {\n  height: 32px;\n  width: 108px; }\n";
var BaseCta$2 = {"base-cta":"BaseCta_base-cta__rJBl3","google-play-lg":"BaseCta_google-play-lg__26W15","google-play-sm":"BaseCta_google-play-sm__fgrG2","apple-app-store-lg":"BaseCta_apple-app-store-lg__iENHQ","apple-app-store-sm":"BaseCta_apple-app-store-sm__YNBA8","baseCta":"BaseCta_base-cta__rJBl3","googlePlayLg":"BaseCta_google-play-lg__26W15","googlePlaySm":"BaseCta_google-play-sm__fgrG2","appleAppStoreLg":"BaseCta_apple-app-store-lg__iENHQ","appleAppStoreSm":"BaseCta_apple-app-store-sm__YNBA8"};
var stylesheet$A=".BaseCta_base-cta__rJBl3 {\n  background: none;\n  border: none; }\n  body.is-tabbing .BaseCta_base-cta__rJBl3:focus {\n    outline: 2px solid #0057b8; }\n\na.BaseCta_google-play-lg__26W15, a.BaseCta_google-play-sm__fgrG2 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_apple-app-store-lg__iENHQ, a.BaseCta_apple-app-store-sm__YNBA8 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_google-play-lg__26W15, a.BaseCta_apple-app-store-lg__iENHQ {\n  height: 48px;\n  width: 162px; }\n\na.BaseCta_google-play-sm__fgrG2, a.BaseCta_apple-app-store-sm__YNBA8 {\n  height: 32px;\n  width: 108px; }\n";
styleInject(css_248z$F);

var BaseCta$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    baseCta: baseCta,
    googlePlayLg: googlePlayLg,
    googlePlaySm: googlePlaySm,
    appleAppStoreLg: appleAppStoreLg,
    appleAppStoreSm: appleAppStoreSm,
    'default': BaseCta$2,
    stylesheet: stylesheet$A
});

var BaseCtaProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Classes = void 0;
(function (Classes) {
    Classes["onDark"] = "on-dark";
    Classes["disabled"] = "disabled";
})(exports.Classes || (exports.Classes = {}));
});

var styles$v = /*@__PURE__*/getAugmentedNamespace(BaseCta$3);

var BaseCta$1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MakeCtaFromBase = exports.BaseCta = void 0;









TabWatcher.TabWatcher.initialize();
/** A CTA without any styling. */
exports.BaseCta = MakeCtaFromBase(function (props) { return ({ props: props, classes: styles$v.baseCta }); });
function MakeCtaFromBase(customizer) {
    if (customizer === void 0) { customizer = function (props) { return ({ props: props }); }; }
    return React__default.forwardRef(function (allProps, ref) {
        var _a = customizer(allProps), props = _a.props, classes = _a.classes, prepend = _a.prepend, append = _a.append;
        // Separate the properties that will be passed to the CTA directly. Parse the rest manually.
        var _b = Simplify.simplify(props), children = _b.children, _c = _b.onDark, onDark = _c === void 0 ? false : _c, appsDownload = _b.appsDownload, _d = _b.suppressLinkClick, suppressLinkClick = _d === void 0 ? false : _d, _e = _b.name, name = _e === void 0 ? typeof props.children === "string" ? props.children : undefined : _e, position = _b.position, url = _b.url, prefix = _b.urlPrefix, onClick = _b.onClick, className = _b.className, style = _b.style, _f = _b.openInNewWindow, openInNewWindow = _f === void 0 ? false : _f, _g = _b.link, link = _g === void 0 ? props.overrideLink ? true : !props.onClick && Boolean(props.url) : _g, _h = _b.overrideLink, overrideLink = _h === void 0 ? false : _h, _j = _b.disabled, disabled = _j === void 0 ? false : _j, deviceOptimization = _b.deviceOptimization, mediaType = _b.mediaType, download = _b.download, relationship = _b.relationship, autoFocus = _b.autoFocus, form = _b.form, _k = _b.buttonType, buttonType = _k === void 0 ? "button" : _k, formAction = _b.formAction, formEncType = _b.formEncType, formMethod = _b.formMethod, formNoValidate = _b.formNoValidate, testId = _b.testId, passthrough = __rest(_b, ["children", "onDark", "appsDownload", "suppressLinkClick", "name", "position", "url", "urlPrefix", "onClick", "className", "style", "openInNewWindow", "link", "overrideLink", "disabled", "deviceOptimization", "mediaType", "download", "relationship", "autoFocus", "form", "buttonType", "formAction", "formEncType", "formMethod", "formNoValidate", "testId"]);
        var combinedOnClick = function (event) {
            if (!suppressLinkClick && name && Reporting.ReportingHelper.initialized) {
                Reporting.ReportingHelper.linkClick({
                    name: name,
                    position: position,
                    url: url,
                    prefix: prefix,
                });
            }
            if (onClick) {
                onClick(event);
            }
        };
        var handleKeyPress = function (event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                if (onClick) {
                    combinedOnClick(event);
                }
            }
        };
        var otherProps = link
            ? {
                href: (overrideLink && url) || (!overrideLink && !disabled) ? url : undefined,
                target: openInNewWindow ? "_blank" : undefined,
                rel: relationship,
                media: deviceOptimization,
                type: mediaType,
                download: download,
            }
            : {
                autoFocus: autoFocus,
                type: buttonType,
                form: form,
                formAction: formAction,
                formEncType: formEncType,
                formMethod: formMethod,
                formNoValidate: formNoValidate,
                formTarget: openInNewWindow ? "_blank" : undefined,
            };
        var lnkRole = props.role ? { role: props.role } : { role: "button" };
        var eleRole = link ? (overrideLink && onClick ? lnkRole : "") : "";
        var Element = link ? "a" : "button";
        var myRef = React__default.useRef(null);
        var opensInNewWindowText = overrideLink && openInNewWindow ? children + " (opens in a new window)" : "";
        var ariaProps = overrideLink && openInNewWindow ? { "aria-label": opensInNewWindowText } : {};
        React__default.useEffect(function () {
            if (link && autoFocus && myRef.current) {
                Focus.focus(myRef.current);
            }
        }, [autoFocus, link]);
        return (React__default.createElement(Element, __assign({ className: Join.join(onDark && BaseCtaProps.Classes.onDark, link && disabled && BaseCtaProps.Classes.disabled, className, classes, appsDownload === "google-lg" ? "" + styles$v.googlePlayLg : "", appsDownload === "apple-lg" ? "" + styles$v.appleAppStoreLg : "", appsDownload === "google-sm" ? "" + styles$v.googlePlaySm : "", appsDownload === "apple-sm" ? "" + styles$v.appleAppStoreSm : ""), "data-testid": testId, disabled: (!link && disabled) || undefined, onClick: combinedOnClick, style: style, ref: Refs.refs(myRef, ref) }, { tabIndex: overrideLink ? 0 : undefined }, {
            onKeyDown: link
                ? overrideLink && onClick
                    ? handleKeyPress
                    : undefined
                : undefined,
        }, passthrough, eleRole, otherProps, ariaProps),
            prepend,
            link && (prepend !== "" || append !== "") ? React__default.createElement("span", null, children) : children,
            append));
    });
}
exports.MakeCtaFromBase = MakeCtaFromBase;
});

var BaseCta = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(BaseCta$1, exports);
__exportStar(BaseCtaProps, exports);
var BaseCta_1 = BaseCta$1;
exports.default = BaseCta_1.BaseCta;
});

var loader = "Spinner_loader__Iiay6";
var loaderSvg = "Spinner_loader-svg__8RImA";
var path = "Spinner_path__bUbFt";
var loadingSpinner = "Spinner_loading-spinner__QAyLH";
var loadingSpinnerInner = "Spinner_loading-spinner-inner__o63Dg";
var loadingSpinnerOuter = "Spinner_loading-spinner-outer__EFfre";
var css_248z$E = ".Spinner_loader__Iiay6 {\n  flex-flow: column;\n  margin: 0 auto; }\n  .Spinner_loader__Iiay6 .Spinner_loader-svg__8RImA:not(:last-child) {\n    margin-bottom: 10px; }\n\n.Spinner_loader-svg__8RImA {\n  height: 42px; }\n\n[disabled] > .Spinner_loader__Iiay6 .Spinner_path__bUbFt,\n.disabled > .Spinner_loader__Iiay6 .Spinner_path__bUbFt {\n  stroke: #ffffff;\n  opacity: 0.56; }\n\n.btn-primary-2:not([disabled]):not(.disabled) > .Spinner_loader__Iiay6 .Spinner_path__bUbFt {\n  stroke: #f2f2f2; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .Spinner_loading-spinner__QAyLH {\n    -webkit-animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n            animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n    transform-origin: center center; } }\n\n.Spinner_loading-spinner__QAyLH g {\n  -webkit-animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n          animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n  transform-origin: center center; }\n\n.Spinner_loading-spinner-inner__o63Dg {\n  stroke-width: 3;\n  stroke: #878c94;\n  opacity: 0.25; }\n\n.Spinner_loading-spinner-outer__EFfre {\n  stroke-width: 3;\n  stroke-dasharray: 89, 200;\n  stroke-dashoffset: 0;\n  stroke: #009fdb;\n  -webkit-animation: Spinner_loading-spinner-outer__EFfre 1.6875s ease-in-out infinite;\n          animation: Spinner_loading-spinner-outer__EFfre 1.6875s ease-in-out infinite;\n  stroke-linecap: round; }\n\n@-webkit-keyframes Spinner_loading-spinner__QAyLH {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes Spinner_loading-spinner__QAyLH {\n  100% {\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes Spinner_loading-spinner-outer__EFfre {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n\n@keyframes Spinner_loading-spinner-outer__EFfre {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n";
var Spinner$1 = {"loader":"Spinner_loader__Iiay6","loader-svg":"Spinner_loader-svg__8RImA","path":"Spinner_path__bUbFt","loading-spinner":"Spinner_loading-spinner__QAyLH","loading-spinner-inner":"Spinner_loading-spinner-inner__o63Dg","loading-spinner-outer":"Spinner_loading-spinner-outer__EFfre","loaderSvg":"Spinner_loader-svg__8RImA","loadingSpinner":"Spinner_loading-spinner__QAyLH","loadingSpinnerInner":"Spinner_loading-spinner-inner__o63Dg","loadingSpinnerOuter":"Spinner_loading-spinner-outer__EFfre"};
var stylesheet$z=".Spinner_loader__Iiay6 {\n  flex-flow: column;\n  margin: 0 auto; }\n  .Spinner_loader__Iiay6 .Spinner_loader-svg__8RImA:not(:last-child) {\n    margin-bottom: 10px; }\n\n.Spinner_loader-svg__8RImA {\n  height: 42px; }\n\n[disabled] > .Spinner_loader__Iiay6 .Spinner_path__bUbFt,\n.disabled > .Spinner_loader__Iiay6 .Spinner_path__bUbFt {\n  stroke: #ffffff;\n  opacity: 0.56; }\n\n.btn-primary-2:not([disabled]):not(.disabled) > .Spinner_loader__Iiay6 .Spinner_path__bUbFt {\n  stroke: #f2f2f2; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .Spinner_loading-spinner__QAyLH {\n    -webkit-animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n            animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n    transform-origin: center center; } }\n\n.Spinner_loading-spinner__QAyLH g {\n  -webkit-animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n          animation: Spinner_loading-spinner__QAyLH 2.25s linear infinite;\n  transform-origin: center center; }\n\n.Spinner_loading-spinner-inner__o63Dg {\n  stroke-width: 3;\n  stroke: #878c94;\n  opacity: 0.25; }\n\n.Spinner_loading-spinner-outer__EFfre {\n  stroke-width: 3;\n  stroke-dasharray: 89, 200;\n  stroke-dashoffset: 0;\n  stroke: #009fdb;\n  -webkit-animation: Spinner_loading-spinner-outer__EFfre 1.6875s ease-in-out infinite;\n          animation: Spinner_loading-spinner-outer__EFfre 1.6875s ease-in-out infinite;\n  stroke-linecap: round; }\n\n@-webkit-keyframes Spinner_loading-spinner__QAyLH {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes Spinner_loading-spinner__QAyLH {\n  100% {\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes Spinner_loading-spinner-outer__EFfre {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n\n@keyframes Spinner_loading-spinner-outer__EFfre {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n";
styleInject(css_248z$E);

var Spinner$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    loader: loader,
    loaderSvg: loaderSvg,
    path: path,
    loadingSpinner: loadingSpinner,
    loadingSpinnerInner: loadingSpinnerInner,
    loadingSpinnerOuter: loadingSpinnerOuter,
    'default': Spinner$1,
    stylesheet: stylesheet$z
});

var styles$u = /*@__PURE__*/getAugmentedNamespace(Spinner$2);

var Spinner_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });



var Spinner = function (_a) {
    var ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className, style = _a.style, onDark = _a.onDark, testId = _a.testId;
    var svg = (React__default.createElement("svg", __assign({ viewBox: "0 0 43 43", className: Join.join([className, styles$u.loadingSpinner, "flex", "flex-items-center"], styles$u.loaderSvg, styles$u.loader), "arial-label": ariaLabel ? ariaLabel : '' }, (!children
        ? {
            style: style,
        }
        : {})),
        React__default.createElement("g", null,
            React__default.createElement("circle", { className: styles$u.loadingSpinnerInner, r: "20", cx: "21.5", cy: "21.5", fill: "none" }),
            React__default.createElement("circle", { className: styles$u.loadingSpinnerOuter, r: "20", cx: "21.5", cy: "21.5", fill: "none" }))));
    return children ? (React__default.createElement("div", { className: Join.join(className, styles$u.loader, "flex", "flex-items-center", "color-ui-dark-gray", onDark && "color-ui-gray"), "data-testid": testId, style: style },
        svg,
        React__default.createElement("span", { className: "type-sm-2 font-medium line-h-lg" }, children))) : (svg);
};
exports.default = Spinner;
});

var SpinnerProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
});

var Spinner = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Spinner_1, exports);
__exportStar(SpinnerProps, exports);
var Spinner_1$1 = Spinner_1;
exports.default = Spinner_1$1.default;
});

var css_248z$D = "[class*=\" btn-\"] svg,\n[class^=\"btn-\"] svg {\n  height: 24px; }\n\n[class*=\" btn-\"] > *:not(.add-margin-right),\n[class^=\"btn-\"] > *:not(.add-margin-right) {\n  margin: 0 !important; }\n\n[class*=\" btn-\"] > .add-margin-right,\n[class^=\"btn-\"] > .add-margin-right {\n  margin: 0 16px 0 0; }\n\n[class*=\" btn-\"].btn-small svg,\n[class^=\"btn-\"].btn-small svg {\n  height: 18px; }\n\n[class*=\" btn-\"].btn-small .add-margin-right,\n[class^=\"btn-\"].btn-small .add-margin-right {\n  margin: 0 12px 0 0; }\n\n@media (max-width: 767px) {\n  [class*=\" btn-\"]:not(.btn-large) svg,\n  [class^=\"btn-\"]:not(.btn-large) svg {\n    height: 18px; }\n  [class*=\" btn-\"]:not(.btn-large) .add-margin-right,\n  [class^=\"btn-\"]:not(.btn-large) .add-margin-right {\n    margin: 0 12px 0 0; } }\n\n[class*=\" btn-\"][disabled] svg, [class*=\" btn-\"].disabled svg,\n[class^=\"btn-\"][disabled] svg,\n[class^=\"btn-\"].disabled svg {\n  fill: #878c94 !important; }\n\n.btn-primary svg,\n.btn-primary-2 svg {\n  fill: #ffffff; }\n\n.btn-secondary svg {\n  fill: #1d2329; }\n\n.btn-secondary:hover svg, .btn-secondary:focus svg {\n  fill: #ffffff; }\n\n.on-dark.btn-primary svg {\n  fill: #1d2329; }\n\n.on-dark.btn-primary-2 svg, .on-dark.btn-secondary svg {\n  fill: #ffffff; }\n\n.on-dark.btn-secondary:hover svg, .on-dark.btn-secondary:focus svg {\n  fill: #1d2329; }\n";
styleInject(css_248z$D);

var ButtonProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Classes = exports.Kind = exports.Size = void 0;
(function (Size) {
    /** Large at all viewport widths. */
    Size["large"] = "btn-large";
    /** Large on desktop and tablet viewport widths; small on mobile viewport widths. */
    Size["responsive"] = "";
    /** Small at all viewport widths. */
    Size["small"] = "btn-small";
})(exports.Size || (exports.Size = {}));
(function (Kind) {
    /** Black on a light background; white on a dark background. */
    Kind["primaryBlack"] = "btn-primary";
    /** Blue on light and dark backgrounds. */
    Kind["primaryBlue"] = "btn-primary-2";
    /** White on a light background; black on a dark background. */
    Kind["secondary"] = "btn-secondary";
})(exports.Kind || (exports.Kind = {}));
(function (Classes) {
    /** Show the rightward arrow. */
    Classes["arrow"] = "btn-arrow";
    /** Span the width of its containing element. */
    Classes["fullWidth"] = "btn-full-width";
    Classes["icon"] = "add-margin-right";
})(exports.Classes || (exports.Classes = {}));
});

var Button_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });






/**
 * A CTA that looks like a button. Will use `<button>` or `<a>` under the hood depending on the functionality needed.
 */
var Button = BaseCta.MakeCtaFromBase(function (allProps) {
    var _a = Simplify.simplify(allProps), _b = _a.arrow, arrow = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.kind, kind = _d === void 0 ? "primaryBlack" : _d, _e = _a.size, size = _e === void 0 ? "responsive" : _e, _f = _a.spinner, spinner = _f === void 0 ? false : _f, props = __rest(_a, ["arrow", "icon", "fullWidth", "kind", "size", "spinner"]);
    var accessoryClass = allProps.children && "add-margin-right";
    return {
        prepend: spinner ? (React__default.createElement(Spinner.default, { "aria-hidden": Boolean(allProps.children), className: accessoryClass })) : (!arrow && icon),
        classes: [
            ButtonProps.Size[size],
            ButtonProps.Kind[kind],
            fullWidth && ButtonProps.Classes.fullWidth,
            !spinner && arrow && ButtonProps.Classes.arrow,
        ],
        props: __assign(__assign({}, props), { role: "button" }),
    };
});
exports.default = Button;
});

var Button = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Button_1, exports);
__exportStar(ButtonProps, exports);
var Button_1$1 = Button_1;
exports.default = Button_1$1.default;
});

var keyPress = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDigitChar = exports.isSpecialChar = exports.isLetterChar = exports.KeyPress = exports.KeyCode = void 0;
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["ALT"] = 18] = "ALT";
    KeyCode[KeyCode["UPARROW"] = 38] = "UPARROW";
    KeyCode[KeyCode["DOWNARROW"] = 40] = "DOWNARROW";
    KeyCode[KeyCode["LEFTARROW"] = 37] = "LEFTARROW";
    KeyCode[KeyCode["RIGHTARROW"] = 39] = "RIGHTARROW";
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["ESC"] = 27] = "ESC";
    KeyCode[KeyCode["FORWARDSLASH"] = 191] = "FORWARDSLASH";
    KeyCode[KeyCode["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
    KeyCode[KeyCode["HOME"] = 36] = "HOME";
    KeyCode[KeyCode["END"] = 35] = "END";
    KeyCode[KeyCode["PAGEUP"] = 33] = "PAGEUP";
    KeyCode[KeyCode["PAGEDOWN"] = 34] = "PAGEDOWN";
    KeyCode[KeyCode["ATRATE"] = 50] = "ATRATE";
    KeyCode[KeyCode["HASH"] = 51] = "HASH";
    KeyCode[KeyCode["DOLLAR"] = 52] = "DOLLAR";
    KeyCode[KeyCode["SHIFT"] = 16] = "SHIFT";
    KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
})(KeyCode = exports.KeyCode || (exports.KeyCode = {}));
var specialChars = new Map();
specialChars.set(192, "`");
specialChars.set(189, "-");
specialChars.set(187, "=");
specialChars.set(219, "[");
specialChars.set(221, "]");
specialChars.set(220, "\\");
specialChars.set(186, ";");
specialChars.set(222, "'");
specialChars.set(223, ",");
specialChars.set(190, ".");
specialChars.set(191, "/");
specialChars.set(-192, "~");
specialChars.set(-49, "!");
specialChars.set(-50, "@");
specialChars.set(-51, "#");
specialChars.set(-52, "$");
specialChars.set(-53, "%");
specialChars.set(-54, "^");
specialChars.set(-55, "&");
specialChars.set(-56, "*");
specialChars.set(-57, "(");
specialChars.set(-48, ")");
specialChars.set(-189, "_");
specialChars.set(-187, "+");
specialChars.set(-219, "{");
specialChars.set(-221, "}");
specialChars.set(-220, "|");
specialChars.set(-186, ":");
specialChars.set(-222, '"');
specialChars.set(-188, "<");
specialChars.set(-190, ">");
specialChars.set(-191, "?");
var KeyPress = /** @class */ (function () {
    function KeyPress() {
    }
    KeyPress.shiftIsPressed = function (e) { return e.keyCode === KeyCode.SHIFT; };
    KeyPress.altIsPressed = function (e) { return e.keyCode === KeyCode.ALT; };
    KeyPress.enterIsPressed = function (e) { return e.keyCode === KeyCode.ENTER; };
    KeyPress.upArrowIsPressed = function (e) { return e.keyCode === KeyCode.UPARROW; };
    KeyPress.downArrowIsPressed = function (e) { return e.keyCode === KeyCode.DOWNARROW; };
    KeyPress.leftArrowIsPressed = function (e) { return e.keyCode === KeyCode.LEFTARROW; };
    KeyPress.rightArrowIsPressed = function (e) { return e.keyCode === KeyCode.RIGHTARROW; };
    KeyPress.tabIsPressed = function (e) { return e.keyCode === KeyCode.TAB; };
    KeyPress.escIsPressed = function (e) { return e.keyCode === KeyCode.ESC; };
    KeyPress.forwardSlashIsPressed = function (e) { return e.keyCode === KeyCode.FORWARDSLASH; };
    KeyPress.backspaceIsPressed = function (e) { return e.keyCode === KeyCode.BACKSPACE; };
    KeyPress.deleteIsPressed = function (e) { return e.keyCode === KeyCode.DELETE; };
    KeyPress.homeIsPressed = function (e) { return e.keyCode === KeyCode.HOME; };
    KeyPress.endIsPressed = function (e) { return e.keyCode === KeyCode.END; };
    KeyPress.pageUpIsPressed = function (e) { return e.keyCode === KeyCode.PAGEUP; };
    KeyPress.pageDownIsPressed = function (e) { return e.keyCode === KeyCode.PAGEDOWN; };
    KeyPress.attherateIsPressed = function (e) { return e.keyCode === KeyCode.ATRATE; };
    KeyPress.hashIsPressed = function (e) { return e.keyCode === KeyCode.HASH; };
    KeyPress.dollarIsPressed = function (e) { return e.keyCode === KeyCode.DOLLAR; };
    KeyPress.spaceIsPressed = function (e) { return e.keyCode === KeyCode.SPACE; };
    return KeyPress;
}());
exports.KeyPress = KeyPress;
exports.isLetterChar = function (e) {
    if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122)) {
        return String.fromCharCode(e.keyCode);
    }
    else {
        return undefined;
    }
};
exports.isSpecialChar = function (e, altPressed) {
    if (altPressed && specialChars.has(e.keyCode * -1)) {
        return specialChars.get(e.keyCode * -1);
    }
    else if (specialChars.has(e.keyCode)) {
        return specialChars.get(e.keyCode);
    }
    else {
        return undefined;
    }
};
exports.isDigitChar = function (e) {
    if (e.keyCode >= 48 && e.keyCode <= 57) {
        return String.fromCharCode(e.keyCode);
    }
    else {
        return undefined;
    }
};
});

var buttonGroup = "ButtonGroup_buttonGroup__pIXDy";
var noBorderRight = "ButtonGroup_noBorderRight__5N11C";
var btn = "ButtonGroup_btn__qSAW3";
var btnBlack = "ButtonGroup_btnBlack__-N1kx";
var btnBlackHover = "ButtonGroup_btnBlackHover__1BipW";
var btnCobalt = "ButtonGroup_btnCobalt__ZpqUI";
var btnCobaltHover = "ButtonGroup_btnCobaltHover__Vh9yi";
var btnWhiteHover = "ButtonGroup_btnWhiteHover__pkSfm";
var btnWhiteUnSelected = "ButtonGroup_btnWhiteUnSelected__qFdQR";
var btnWhite = "ButtonGroup_btnWhite__AAxI2";
var css_248z$C = ".ButtonGroup_buttonGroup__pIXDy {\n  min-width: 272px; }\n  .ButtonGroup_buttonGroup__pIXDy > [class*=\"btn-\"]:focus {\n    outline: 0 !important; }\n  .ButtonGroup_buttonGroup__pIXDy > [class*=\"btn-\"]:first-child {\n    border-bottom-right-radius: 0 !important;\n    border-top-right-radius: 0 !important; }\n  .ButtonGroup_buttonGroup__pIXDy > [class*=\"btn-\"]:last-child {\n    border-bottom-left-radius: 0 !important;\n    border-top-left-radius: 0 !important;\n    border-left-width: 0 !important;\n    padding-left: 1px !important; }\n  .ButtonGroup_buttonGroup__pIXDy > [class*=\"btn-\"]:not(:first-child):not(:last-child) {\n    border-radius: 0 !important;\n    border-left-width: 0 !important;\n    padding-left: 1px !important; }\n\n.ButtonGroup_noBorderRight__5N11C {\n  border-right-width: 0px !important;\n  padding-right: 1px !important; }\n\n.ButtonGroup_btn__qSAW3 {\n  cursor: pointer;\n  min-width: 0 !important;\n  max-width: 100% !important;\n  width: 100% !important; }\n\n.ButtonGroup_btnBlack__-N1kx:focus {\n  background-color: #000000;\n  border-color: #000000;\n  box-shadow: 0px 0px 0px 3px #000000 inset, 0px 0px 0px 4px #878c94 inset; }\n\n.ButtonGroup_btnBlackHover__1BipW:hover {\n  background-color: #454b52;\n  border-color: #454b52;\n  box-shadow: 0px 0px 0px 3px #454b52 inset, 0px 0px 0px 4px #ffffff inset; }\n\n.ButtonGroup_btnCobalt__ZpqUI:focus {\n  background-color: #0057b8;\n  border-color: #0057b8; }\n\n.ButtonGroup_btnCobaltHover__Vh9yi:hover {\n  background-color: #007ae2;\n  border-color: #007ae2;\n  box-shadow: 0px 0px 0px 3px #007ae2 inset, 0px 0px 0px 4px #dcdfe3 inset; }\n\n.ButtonGroup_btnWhiteHover__pkSfm,\n.ButtonGroup_btnWhiteHover__pkSfm:focus:hover,\n.ButtonGroup_btnWhiteUnSelected__qFdQR:focus {\n  background-color: #dcdfe3;\n  border-color: #dcdfe3; }\n\n.ButtonGroup_btnWhite__AAxI2:focus {\n  background-color: #ffffff;\n  border-color: #ffffff;\n  box-shadow: 0px 0px 0px 3px #ffffff inset, 0px 0px 0px 4px #000000 inset !important; }\n\n.ButtonGroup_btnWhiteHover__pkSfm:focus:hover {\n  box-shadow: 0px 0px 0px 3px #dcdfe3 inset, 0px 0px 0px 4px #000000 inset !important; }\n\n.ButtonGroup_btnWhiteUnSelected__qFdQR:focus {\n  box-shadow: 0px 0px 0px 3px #dcdfe3 inset, 0px 0px 0px 4px #000000 inset !important; }\n";
var ButtonGroup$1 = {"buttonGroup":"ButtonGroup_buttonGroup__pIXDy","noBorderRight":"ButtonGroup_noBorderRight__5N11C","btn":"ButtonGroup_btn__qSAW3","btnBlack":"ButtonGroup_btnBlack__-N1kx","btnBlackHover":"ButtonGroup_btnBlackHover__1BipW","btnCobalt":"ButtonGroup_btnCobalt__ZpqUI","btnCobaltHover":"ButtonGroup_btnCobaltHover__Vh9yi","btnWhiteHover":"ButtonGroup_btnWhiteHover__pkSfm","btnWhiteUnSelected":"ButtonGroup_btnWhiteUnSelected__qFdQR","btnWhite":"ButtonGroup_btnWhite__AAxI2"};
var stylesheet$y=".ButtonGroup_buttonGroup__pIXDy {\n  min-width: 272px; }\n  .ButtonGroup_buttonGroup__pIXDy > [class*=\"btn-\"]:focus {\n    outline: 0 !important; }\n  .ButtonGroup_buttonGroup__pIXDy > [class*=\"btn-\"]:first-child {\n    border-bottom-right-radius: 0 !important;\n    border-top-right-radius: 0 !important; }\n  .ButtonGroup_buttonGroup__pIXDy > [class*=\"btn-\"]:last-child {\n    border-bottom-left-radius: 0 !important;\n    border-top-left-radius: 0 !important;\n    border-left-width: 0 !important;\n    padding-left: 1px !important; }\n  .ButtonGroup_buttonGroup__pIXDy > [class*=\"btn-\"]:not(:first-child):not(:last-child) {\n    border-radius: 0 !important;\n    border-left-width: 0 !important;\n    padding-left: 1px !important; }\n\n.ButtonGroup_noBorderRight__5N11C {\n  border-right-width: 0px !important;\n  padding-right: 1px !important; }\n\n.ButtonGroup_btn__qSAW3 {\n  cursor: pointer;\n  min-width: 0 !important;\n  max-width: 100% !important;\n  width: 100% !important; }\n\n.ButtonGroup_btnBlack__-N1kx:focus {\n  background-color: #000000;\n  border-color: #000000;\n  box-shadow: 0px 0px 0px 3px #000000 inset, 0px 0px 0px 4px #878c94 inset; }\n\n.ButtonGroup_btnBlackHover__1BipW:hover {\n  background-color: #454b52;\n  border-color: #454b52;\n  box-shadow: 0px 0px 0px 3px #454b52 inset, 0px 0px 0px 4px #ffffff inset; }\n\n.ButtonGroup_btnCobalt__ZpqUI:focus {\n  background-color: #0057b8;\n  border-color: #0057b8; }\n\n.ButtonGroup_btnCobaltHover__Vh9yi:hover {\n  background-color: #007ae2;\n  border-color: #007ae2;\n  box-shadow: 0px 0px 0px 3px #007ae2 inset, 0px 0px 0px 4px #dcdfe3 inset; }\n\n.ButtonGroup_btnWhiteHover__pkSfm,\n.ButtonGroup_btnWhiteHover__pkSfm:focus:hover,\n.ButtonGroup_btnWhiteUnSelected__qFdQR:focus {\n  background-color: #dcdfe3;\n  border-color: #dcdfe3; }\n\n.ButtonGroup_btnWhite__AAxI2:focus {\n  background-color: #ffffff;\n  border-color: #ffffff;\n  box-shadow: 0px 0px 0px 3px #ffffff inset, 0px 0px 0px 4px #000000 inset !important; }\n\n.ButtonGroup_btnWhiteHover__pkSfm:focus:hover {\n  box-shadow: 0px 0px 0px 3px #dcdfe3 inset, 0px 0px 0px 4px #000000 inset !important; }\n\n.ButtonGroup_btnWhiteUnSelected__qFdQR:focus {\n  box-shadow: 0px 0px 0px 3px #dcdfe3 inset, 0px 0px 0px 4px #000000 inset !important; }\n";
styleInject(css_248z$C);

var ButtonGroup$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    buttonGroup: buttonGroup,
    noBorderRight: noBorderRight,
    btn: btn,
    btnBlack: btnBlack,
    btnBlackHover: btnBlackHover,
    btnCobalt: btnCobalt,
    btnCobaltHover: btnCobaltHover,
    btnWhiteHover: btnWhiteHover,
    btnWhiteUnSelected: btnWhiteUnSelected,
    btnWhite: btnWhite,
    'default': ButtonGroup$1,
    stylesheet: stylesheet$y
});

var styles$t = /*@__PURE__*/getAugmentedNamespace(ButtonGroup$2);

var ButtonGroup_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });



var ButtonGroup = /** @class */ (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.state = {
            hoverArr: props.data.map(function () { return false; }),
            isTouching: false,
            selectedIndex: ((_a = props.options) === null || _a === void 0 ? void 0 : _a.defaultSelected) ? props.options.defaultSelected : 0,
            uniqueId: _this.guid(),
            width: 0,
        };
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        _this.onMouseOver = _this.onMouseOver.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.updateWidth = _this.updateWidth.bind(_this);
        _this.guid = _this.guid.bind(_this);
        _this.S4 = _this.S4.bind(_this);
        return _this;
    }
    ButtonGroup.prototype.componentDidMount = function () {
        this.updateWidth();
        this.setState({ uniqueId: this.guid() });
        window.addEventListener("resize", this.updateWidth);
    };
    ButtonGroup.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.updateWidth);
    };
    ButtonGroup.prototype.onKeyDown = function (e) {
        if (keyPress.KeyPress.enterIsPressed(e) ||
            keyPress.KeyPress.spaceIsPressed(e) ||
            keyPress.KeyPress.leftArrowIsPressed(e) ||
            keyPress.KeyPress.rightArrowIsPressed(e)) {
            e.preventDefault();
        }
    };
    ButtonGroup.prototype.onKeyUp = function (e) {
        var _a = this.props, data = _a.data, events = _a.events;
        var _b = this.state, selectedIndex = _b.selectedIndex, uniqueId = _b.uniqueId;
        var id = e.currentTarget.getAttribute("id");
        var index = parseInt(id.substring(id.length - 1, id.length), 10);
        if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
            if (index !== selectedIndex) {
                this.setState({ selectedIndex: index });
                if (events && events.onSelect) {
                    events.onSelect(data[index].value);
                }
            }
        }
        else if (keyPress.KeyPress.leftArrowIsPressed(e)) {
            var newIndex = (index - 1) % data.length;
            var newId = uniqueId + "-" + newIndex;
            document.getElementById(newId).focus();
        }
        else if (keyPress.KeyPress.rightArrowIsPressed(e)) {
            var newIndex = (index + 1) % data.length;
            var newId = uniqueId + "-" + newIndex;
            document.getElementById(newId).focus();
        }
    };
    ButtonGroup.prototype.onMouseLeave = function (e) {
        var id = e.currentTarget.id;
        var idSplit = id.split("-");
        var index = parseInt(idSplit[idSplit.length - 1], 10);
        var hoverArr = this.state.hoverArr;
        hoverArr[index] = false;
        this.setState({ hoverArr: hoverArr.slice() });
    };
    ButtonGroup.prototype.onMouseOver = function (e) {
        var id = e.currentTarget.id;
        var idSplit = id.split("-");
        var index = parseInt(idSplit[idSplit.length - 1], 10);
        var hoverArr = this.state.hoverArr;
        hoverArr[index] = true;
        this.setState({ hoverArr: hoverArr.slice() });
    };
    ButtonGroup.prototype.onMouseUp = function (e) {
        var id = e.currentTarget.id;
        var idSplit = id.split("-");
        var index = parseInt(idSplit[idSplit.length - 1], 10);
        var _a = this.props, data = _a.data, events = _a.events;
        var selectedIndex = this.state.selectedIndex;
        if (index !== selectedIndex) {
            this.setState({ selectedIndex: index });
            if (events && events.onSelect) {
                events.onSelect(data[index].value);
            }
        }
    };
    ButtonGroup.prototype.onTouchEnd = function () {
        this.setState({ isTouching: true });
    };
    ButtonGroup.prototype.updateWidth = function () {
        this.setState({ width: window.innerWidth });
    };
    ButtonGroup.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    ButtonGroup.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    ButtonGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, options = _a.options, testId = _a.testId;
        var _b = this.state, hoverArr = _b.hoverArr, isTouching = _b.isTouching, selectedIndex = _b.selectedIndex, uniqueId = _b.uniqueId, width = _b.width;
        return (React__default.createElement("div", { className: "flex " + styles$t.buttonGroup, role: "radiogroup" }, data.map(function (item, index) { return (React__default.createElement("button", { "aria-checked": selectedIndex === index, className: "" + (selectedIndex === index
                ? options &&
                    (options.color === "black" || options.color === "white")
                    ? "btn-primary" + (options.color !== "white"
                        ? " " + styles$t.btnBlack + (hoverArr[index] && !isTouching
                            ? " " + styles$t.btnBlackHover
                            : "")
                        : "")
                    : "btn-primary-2 " + styles$t.btnCobalt + (hoverArr[index] && !isTouching
                        ? " " + styles$t.btnCobaltHover
                        : "")
                : "btn-secondary") + (options && options.color === "white"
                ? " on-dark " + styles$t.btnWhite + (hoverArr[index] && !isTouching
                    ? " " + styles$t.btnWhiteHover
                    : "") + (selectedIndex !== index ? " " + styles$t.btnWhiteUnSelected : "")
                : "") + (options && options.size === "large" && width >= 768
                ? " btn-large"
                : " btn-small") + " " + styles$t.btn + " pad-none " + (selectedIndex === index + 1 || hoverArr[index + 1]
                ? styles$t.noBorderRight
                : ""), "data-testid": testId, id: uniqueId + "-" + index, onKeyDown: _this.onKeyDown, onKeyUp: _this.onKeyUp, onMouseLeave: _this.onMouseLeave, onMouseOver: _this.onMouseOver, onMouseUp: _this.onMouseUp, onTouchEnd: _this.onTouchEnd, key: index, role: "radio", tabIndex: 0 }, item.name)); })));
    };
    return ButtonGroup;
}(React__default.PureComponent));
exports.default = ButtonGroup;
});

var ButtonGroup = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = ButtonGroup_1.default;
});

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var require$$1 = propTypes;

var dist = createCommonjsModule(function (module) {
module.exports=function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=2)}([function(e,t){e.exports=React__default;},function(e,t){e.exports=require$$1;},function(e,t,n){n.r(t),n.d(t,"ReCaptcha",(function(){return v})),n.d(t,"loadReCaptcha",(function(){return h}));var r=n(0),o=n.n(r);n(1);function a(e){return (a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}function u(e,t){return (u=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function i(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return !1}}();return function(){var n,r=p(e);if(t){var o=p(this).constructor;n=Reflect.construct(r,arguments,o);}else n=r.apply(this,arguments);return f(this,n)}}function f(e,t){return !t||"object"!==a(t)&&"function"!=typeof t?l(e):t}function l(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e){return (p=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function s(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var d,y=function(){return "undefined"!=typeof window&&void 0!==window.grecaptcha&&void 0!==window.grecaptcha.execute},b=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&u(e,t);}(f,e);var t,n,a=i(f);function f(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,f),s(l(t=a.call(this,e)),"execute",(function(){var e=t.props,n=e.sitekey,r=e.verifyCallback,o=e.action;t.state.ready&&window.grecaptcha.execute(n,{action:o}).then((function(e){void 0!==r&&r(e);}));})),s(l(t),"_updateReadyState",(function(){y()&&(t.setState((function(){return {ready:!0}})),clearInterval(d));})),t.state={ready:y()},t}return t=f,(n=[{key:"componentDidMount",value:function(){this.state.ready?this.execute():d=setInterval(this._updateReadyState,1e3);}},{key:"componentDidUpdate",value:function(e,t){this.state.ready&&!t.ready&&this.execute();}},{key:"componentWillUnmount",value:function(){clearInterval(d);}},{key:"render",value:function(){return this.state.ready?o.a.createElement("div",{id:this.props.elementID,"data-verifycallbackname":this.props.verifyCallbackName}):o.a.createElement("div",{id:this.props.elementID,className:"g-recaptcha"})}}])&&c(t.prototype,n),f}(r.Component);b.defaultProps={elementID:"g-recaptcha",verifyCallbackName:"verifyCallback"};var v=b,h=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){},n=document.createElement("script");!window.onLoadCaptchaV3Callback&&t&&(window.onLoadCaptchaV3Callback=t),n.src="https://www.recaptcha.net/recaptcha/api.js?onload=onLoadCaptchaV3Callback&render=".concat(e),document.body.appendChild(n);};}]);
});

var CaptchaGeneratorV3_config = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaConfigV3 = void 0;
exports.CaptchaConfigV3 = {
    attSiteKeys: {
        siteKey: '6LdMeCIUAAAAAFHYMFkObspfKRx0nomc_jUooKnB',
        siteKeyV3: '6LeZpLgZAAAAANETaW8pbTYkKc9QUU60StgO_5EO',
    },
    personalSitekeys: {
        secretKey: '6LeXfpcUAAAAAMMu6-d3QwsLqSqvQ8KxQfQpIydR',
        siteKey: '6LeXfpcUAAAAALTB0vvp-tRX_3j3Rq56zW8TH6tC',
    },
    scoreUrl: "/msapi/captchams/v1/captcha/verify?version=v3",
};
});

var react_recaptcha_v3_1 = dist;

var CaptchaGeneratorV3$1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });



/**
 *
 * <style>
 * #CaptchaGeneratorV3-container ul[class*="rsg--list-"]{margin:20px 0;padding:0;}
 * #CaptchaGeneratorV3-container li[class*="rsg--li-"]{display:inline;border:1px solid #ccc;border-radius:12px;}
 * #CaptchaGeneratorV3-container li[class*="rsg--li-"]{background:#d12127;padding:4px 8px;color:#fff;margin-right:16px;}
 * #CaptchaGeneratorV3-container li[class*="rsg--li-"]:last-child{background:#007a3e;}
 * #CaptchaGeneratorV3-container li[class*="rsg--li-"] p{display:inline;color:#fff;}
 * </style>
 * <ul style="">
 * <li style="">Phase - Beta Unreleased</li>
 * <li style="">Approval - Pending</li>
 * </ul>
 *
 * @visibleName CaptchaGeneratorV3
 */
var CaptchaGenerator = /** @class */ (function (_super) {
    __extends(CaptchaGenerator, _super);
    function CaptchaGenerator(props) {
        var _this = _super.call(this, props) || this;
        _this.sendMessage = function () {
            _this.reCaptcha.execute();
        };
        _this.verifyCallback = function (recaptchaToken) {
            // Here you will get the final recaptchaToken!!!
            CaptchaGeneratorV3_config.CaptchaConfigV3.scoreUrl;
            if (_this.props.data.callExecute) {
                var reqObj = {
                    "captchaResponse": recaptchaToken,
                };
                fetch(CaptchaGeneratorV3_config.CaptchaConfigV3.scoreUrl, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                    body: JSON.stringify(reqObj),
                })
                    .then(function (response) { return response.json(); })
                    .then(function (resObj) {
                    var _a;
                    if ((_a = _this.props.events) === null || _a === void 0 ? void 0 : _a.verifyCaptcha) {
                        if (resObj.content.success && resObj.content.score > 0.5) {
                            _this.props.events.verifyCaptcha(resObj.content.success);
                        }
                        else {
                            _this.props.events.verifyCaptcha(false);
                        }
                    }
                })
                    .catch(function (error) {
                    var _a;
                    if ((_a = _this.props.events) === null || _a === void 0 ? void 0 : _a.verifyCaptcha) {
                        _this.props.events.verifyCaptcha(false);
                    }
                });
            }
        };
        _this.reCaptcha = {};
        _this.loadHandler = _this.loadHandler.bind(_this);
        _this.unloadRecaptchav3 = _this.unloadRecaptchav3.bind(_this);
        return _this;
    }
    CaptchaGenerator.prototype.componentDidMount = function () {
        if (document.readyState === 'complete') {
            this.loadHandler();
        }
        else {
            window.addEventListener("load", this.loadHandler);
        }
    };
    CaptchaGenerator.prototype.componentDidUpdate = function () {
        if (this.props.data.callExecute) {
            this.sendMessage();
        }
    };
    CaptchaGenerator.prototype.componentWillUnmount = function () {
        this.unloadRecaptchav3();
        window.removeEventListener("load", this.loadHandler);
    };
    CaptchaGenerator.prototype.loadHandler = function () {
        react_recaptcha_v3_1.loadReCaptcha(CaptchaGeneratorV3_config.CaptchaConfigV3.attSiteKeys.siteKeyV3);
    };
    CaptchaGenerator.prototype.unloadRecaptchav3 = function () {
        var nodeBadge = document.querySelector('.grecaptcha-badge');
        if (nodeBadge && nodeBadge.parentNode) {
            document.body.removeChild(nodeBadge.parentNode);
        }
        var scriptSelector = 'script[src=\'https://www.google.com/recaptcha/api.js?render=' +
            CaptchaGeneratorV3_config.CaptchaConfigV3.attSiteKeys.siteKeyV3 + '\']';
        var script = document.querySelector(scriptSelector);
        if (script) {
            script.remove();
        }
    };
    CaptchaGenerator.prototype.render = function () {
        var _this = this;
        var actionName = this.props.data && this.props.data.actionName ?
            this.props.data.actionName : "UserAction";
        return (React__default.createElement(react_recaptcha_v3_1.ReCaptcha, { ref: function (ref) { return _this.reCaptcha = ref; }, sitekey: CaptchaGeneratorV3_config.CaptchaConfigV3.attSiteKeys.siteKeyV3, action: actionName, verifyCallback: this.verifyCallback }));
    };
    return CaptchaGenerator;
}(React__default.Component));
exports.default = CaptchaGenerator;
});

var CaptchaGeneratorV3 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = CaptchaGeneratorV3$1.default;
});

var card$1 = "CardShell_card__02FOu";
var cardPad$1 = "CardShell_card-pad__P3F01";
var selected = "CardShell_selected__1CrSl";
var cardNoBorderRadius = "CardShell_card-no-border-radius__TUSCp";
var willRemoveBgCobalt10 = "CardShell_willRemoveBgCobalt10__lbkO2";
var css_248z$B = ".CardShell_card__02FOu {\n  border-radius: 3px;\n  color: inherit;\n  z-index: 0; }\n  .CardShell_card__02FOu:hover {\n    text-decoration: none; }\n  .CardShell_card__02FOu:focus, .CardShell_card__02FOu:visited {\n    color: inherit;\n    outline: 0; }\n\n.CardShell_card__02FOu[data-is-link=\"true\"],\n.CardShell_card__02FOu[role=\"button\"],\n.CardShell_card__02FOu[role=\"checkbox\"],\n.CardShell_card__02FOu[role=\"radio\"] {\n  cursor: pointer; }\n\n.CardShell_card__02FOu:not([class*=\"bg-\"]) {\n  box-shadow: 0 0 0 1px #dcdfe3 inset; }\n\n.CardShell_card__02FOu:after {\n  border-radius: 3px;\n  content: \"\";\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%; }\n\n.CardShell_card__02FOu[tabindex]:hover:after {\n  box-shadow: 1px 1px 6px 0 #878c94; }\n\n.CardShell_card__02FOu[tabindex][data-focus-method=\"KEY\"]:focus:after {\n  outline: 1px dotted #686e74;\n  outline-offset: -6px; }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /* IE10+ CSS styles go here */\n  .CardShell_card__02FOu[tabindex][data-focus-method=\"KEY\"]:focus:after {\n    border: 1px dotted #686e74; } }\n\n.CardShell_card-pad__P3F01 {\n  padding: 24px; }\n\n.CardShell_card__02FOu[role=\"checkbox\"].CardShell_selected__1CrSl:after,\n.CardShell_card__02FOu[role=\"radio\"].CardShell_selected__1CrSl:after {\n  box-shadow: 0 0 0 2px #0057b8 inset; }\n\n.CardShell_card__02FOu[role=\"checkbox\"].CardShell_selected__1CrSl:hover:after,\n.CardShell_card__02FOu[role=\"radio\"].CardShell_selected__1CrSl:hover:after {\n  box-shadow: 0 0 0 2px #0057b8 inset, 1px 1px 6px 0 #878c94; }\n\n@media (max-width: 767px) {\n  .CardShell_card-pad__P3F01 {\n    padding: 16px; }\n  .CardShell_card-no-border-radius__TUSCp,\n  .CardShell_card-no-border-radius__TUSCp:after {\n    border-radius: 0 !important; } }\n\n.CardShell_willRemoveBgCobalt10__lbkO2 {\n  background-color: rgba(0, 87, 184, 0.1); }\n";
var CardShell$1 = {"card":"CardShell_card__02FOu","card-pad":"CardShell_card-pad__P3F01","selected":"CardShell_selected__1CrSl","card-no-border-radius":"CardShell_card-no-border-radius__TUSCp","willRemoveBgCobalt10":"CardShell_willRemoveBgCobalt10__lbkO2","cardPad":"CardShell_card-pad__P3F01","cardNoBorderRadius":"CardShell_card-no-border-radius__TUSCp"};
var stylesheet$x=".CardShell_card__02FOu {\n  border-radius: 3px;\n  color: inherit;\n  z-index: 0; }\n  .CardShell_card__02FOu:hover {\n    text-decoration: none; }\n  .CardShell_card__02FOu:focus, .CardShell_card__02FOu:visited {\n    color: inherit;\n    outline: 0; }\n\n.CardShell_card__02FOu[data-is-link=\"true\"],\n.CardShell_card__02FOu[role=\"button\"],\n.CardShell_card__02FOu[role=\"checkbox\"],\n.CardShell_card__02FOu[role=\"radio\"] {\n  cursor: pointer; }\n\n.CardShell_card__02FOu:not([class*=\"bg-\"]) {\n  box-shadow: 0 0 0 1px #dcdfe3 inset; }\n\n.CardShell_card__02FOu:after {\n  border-radius: 3px;\n  content: \"\";\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%; }\n\n.CardShell_card__02FOu[tabindex]:hover:after {\n  box-shadow: 1px 1px 6px 0 #878c94; }\n\n.CardShell_card__02FOu[tabindex][data-focus-method=\"KEY\"]:focus:after {\n  outline: 1px dotted #686e74;\n  outline-offset: -6px; }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /* IE10+ CSS styles go here */\n  .CardShell_card__02FOu[tabindex][data-focus-method=\"KEY\"]:focus:after {\n    border: 1px dotted #686e74; } }\n\n.CardShell_card-pad__P3F01 {\n  padding: 24px; }\n\n.CardShell_card__02FOu[role=\"checkbox\"].CardShell_selected__1CrSl:after,\n.CardShell_card__02FOu[role=\"radio\"].CardShell_selected__1CrSl:after {\n  box-shadow: 0 0 0 2px #0057b8 inset; }\n\n.CardShell_card__02FOu[role=\"checkbox\"].CardShell_selected__1CrSl:hover:after,\n.CardShell_card__02FOu[role=\"radio\"].CardShell_selected__1CrSl:hover:after {\n  box-shadow: 0 0 0 2px #0057b8 inset, 1px 1px 6px 0 #878c94; }\n\n@media (max-width: 767px) {\n  .CardShell_card-pad__P3F01 {\n    padding: 16px; }\n  .CardShell_card-no-border-radius__TUSCp,\n  .CardShell_card-no-border-radius__TUSCp:after {\n    border-radius: 0 !important; } }\n\n.CardShell_willRemoveBgCobalt10__lbkO2 {\n  background-color: rgba(0, 87, 184, 0.1); }\n";
styleInject(css_248z$B);

var CardShell$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    card: card$1,
    cardPad: cardPad$1,
    selected: selected,
    cardNoBorderRadius: cardNoBorderRadius,
    willRemoveBgCobalt10: willRemoveBgCobalt10,
    'default': CardShell$1,
    stylesheet: stylesheet$x
});

var styles$s = /*@__PURE__*/getAugmentedNamespace(CardShell$2);

var CardShell_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });



var CardShell = function (_a) {
    var children = _a.children, className = _a.className, classNameElement = _a.classNameElement, classNamePad = _a.classNamePad, href = _a.href, isChecked = _a.isChecked, noPad = _a.noPad, onClick = _a.onClick, onDark = _a.onDark, tabIndex = _a.tabIndex, _b = _a.target, target = _b === void 0 ? "self" : _b, testId = _a.testId, _c = _a.type, type = _c === void 0 ? "default" : _c, withMobileBleed = _a.withMobileBleed, withSelectedBg = _a.withSelectedBg;
    var _d = __read(React__default.useState({
        checked: isChecked ? isChecked : false,
        showFocus: false,
    }), 2), state = _d[0], setState = _d[1];
    var checked = state.checked, showFocus = state.showFocus;
    var onFocus = function () {
        setState(__assign(__assign({}, state), { showFocus: false }));
    };
    var onKeyDown = function (e) {
        if ((keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) && type !== "default") {
            e.preventDefault();
        }
    };
    var onKeyUp = function (e) {
        if ((keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e) || keyPress.KeyPress.tabIsPressed(e)) && type !== "default") {
            setState(__assign(__assign({}, state), { showFocus: true }));
        }
        if ((keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) && type !== "default") {
            e.preventDefault();
            if ((type === "radio" || type === "checkbox") && isChecked === undefined) {
                setState(__assign(__assign({}, state), { checked: type === "checkbox" ? !checked : true }));
            }
            if (type === "link" && href) {
                if (target === "blank") {
                    window.open(href, "_blank");
                }
                else {
                    window.open(href, "_self");
                }
            }
            if (onClick) {
                if (e.target instanceof HTMLAnchorElement) {
                    e.preventDefault();
                }
                else {
                    onClick(type === "radio" || type === "checkbox"
                        ? isChecked !== undefined
                            ? isChecked
                            : checked
                        : undefined);
                }
            }
        }
    };
    var onMouseDown = function (e) {
        setState(__assign(__assign({}, state), { showFocus: false }));
        if (e.button === 0) {
            if ((type === "radio" || type === "checkbox") && isChecked === undefined) {
                setState(__assign(__assign({}, state), { checked: !checked }));
            }
            if (type === "link" && href) {
                if (target === "blank") {
                    window.open(href, "_blank");
                }
                else {
                    window.open(href, "_self");
                }
            }
            if (onClick && type !== "default") {
                if (e.target instanceof HTMLAnchorElement) {
                    e.preventDefault();
                }
                else {
                    onClick(type === "radio" || type === "checkbox"
                        ? isChecked !== undefined
                            ? isChecked
                            : checked
                        : undefined);
                }
            }
        }
    };
    var onMouseUp = function () {
        setState(__assign(__assign({}, state), { showFocus: false }));
    };
    var renderChildren = function () { return React__default.Children.map(children, function (child) { return child; }); };
    var Element = type === "link" ? "a" : "div";
    var innerContent = (React__default.createElement(Element, { "aria-checked": type === "checkbox" || type === "radio"
            ? isChecked === true || (isChecked === undefined && checked)
            : undefined, className: "card height-full inline-block radius-xs rel width-full " + styles$s.card + " " + (onDark ? " bg-ui-white" : "") + ((type === "radio" || type === "checkbox") &&
            (isChecked === true || (isChecked === undefined && checked))
            ? " " + styles$s.selected + " selected" + (withSelectedBg ? " " + styles$s.willRemoveBgCobalt10 : "")
            : "") + (withMobileBleed ? " " + styles$s.cardNoBorderRadius : "") + (classNameElement ? " " + classNameElement : ""), "data-focus-method": showFocus ? "KEY" : undefined, "data-is-link": type === "link", "data-testid": testId, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseUp: onMouseUp, tabIndex: type !== "default" ? 0 : tabIndex ? tabIndex : undefined, role: type !== "default" && type !== "link" ? type : undefined },
        React__default.createElement("div", { className: styles$s.cardPad + " card-pad flex flex-column height-full " + (noPad ? " pad-none" : "") + " " + (classNamePad ? " " + classNamePad : "") }, renderChildren())));
    if (className) {
        return React__default.createElement("div", { className: className }, innerContent);
    }
    return innerContent;
};
exports.default = CardShell;
});

var CardShell = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = CardShell_1.default;
});

var cardPanel = "CardShellRow_card-panel__ELerX";
var card = "CardShellRow_card__1ogmU";
var noHpadSm = "CardShellRow_no-hpad-sm__42Iqb";
var cardPad = "CardShellRow_card-pad__trj7-";
var css_248z$A = ".CardShellRow_card-panel__ELerX {\n  align-items: stretch;\n  padding-top: 16px;\n  padding-bottom: 16px; }\n\n@media (max-width: 666px), (orientation: portrait) and (max-width: 767px) {\n  .CardShellRow_card-panel__ELerX {\n    padding-top: 16px;\n    padding-bottom: 16px; }\n  .CardShellRow_card-panel__ELerX > [class*=\"grid-\"] {\n    padding-top: 8px;\n    padding-bottom: 8px; }\n  .CardShellRow_card__1ogmU:not([class*=\"bg-\"]) {\n    box-shadow: 0 0 0 1px #dcdfe3; }\n  .CardShellRow_card-panel__ELerX.CardShellRow_no-hpad-sm__42Iqb > [class*=\"grid-\"] {\n    padding-top: 8px;\n    padding-bottom: 8px; }\n  .CardShellRow_card-panel__ELerX.CardShellRow_no-hpad-sm__42Iqb .CardShellRow_card-pad__trj7- {\n    padding: 16px 24px; } }\n";
var CardShellRow$1 = {"card-panel":"CardShellRow_card-panel__ELerX","card":"CardShellRow_card__1ogmU","no-hpad-sm":"CardShellRow_no-hpad-sm__42Iqb","card-pad":"CardShellRow_card-pad__trj7-","cardPanel":"CardShellRow_card-panel__ELerX","noHpadSm":"CardShellRow_no-hpad-sm__42Iqb","cardPad":"CardShellRow_card-pad__trj7-"};
var stylesheet$w=".CardShellRow_card-panel__ELerX {\n  align-items: stretch;\n  padding-top: 16px;\n  padding-bottom: 16px; }\n\n@media (max-width: 666px), (orientation: portrait) and (max-width: 767px) {\n  .CardShellRow_card-panel__ELerX {\n    padding-top: 16px;\n    padding-bottom: 16px; }\n  .CardShellRow_card-panel__ELerX > [class*=\"grid-\"] {\n    padding-top: 8px;\n    padding-bottom: 8px; }\n  .CardShellRow_card__1ogmU:not([class*=\"bg-\"]) {\n    box-shadow: 0 0 0 1px #dcdfe3; }\n  .CardShellRow_card-panel__ELerX.CardShellRow_no-hpad-sm__42Iqb > [class*=\"grid-\"] {\n    padding-top: 8px;\n    padding-bottom: 8px; }\n  .CardShellRow_card-panel__ELerX.CardShellRow_no-hpad-sm__42Iqb .CardShellRow_card-pad__trj7- {\n    padding: 16px 24px; } }\n";
styleInject(css_248z$A);

var CardShellRow$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    cardPanel: cardPanel,
    card: card,
    noHpadSm: noHpadSm,
    cardPad: cardPad,
    'default': CardShellRow$1,
    stylesheet: stylesheet$w
});

var styles$r = /*@__PURE__*/getAugmentedNamespace(CardShellRow$2);

var CardShellRow_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


var CardShellRow = function (_a) {
    var children = _a.children, className = _a.className, testId = _a.testId, withMobileBleed = _a.withMobileBleed;
    var renderChildren = function () { return React__default.Children.map(children, function (child) { return child; }); };
    return (React__default.createElement("div", { className: "row flex-wrap flex-items-stretch pad-b-xs pad-t-xs" + (withMobileBleed ? " no-hpad-sm" : "") + " " + styles$r.cardPanel + (className ? " " + className : ""), "data-testid": testId }, renderChildren()));
};
exports.default = CardShellRow;
});

var CardShellRow = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = CardShellRow_1.default;
});

var EventArgs_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
var EventArgs = /** @class */ (function () {
    function EventArgs(payload) {
        this.payload = payload;
    }
    return EventArgs;
}());
exports.default = EventArgs;
});

var Checkbox_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });


var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isChecked: _this.props.data.value ? _this.props.data.value : false,
        };
        _this.componentDidMount = function () {
            var data = _this.props.data;
            var groupValues = data.groupValues, text = data.text; data.value;
            if (data && groupValues) {
                groupValues.includes(text);
            }
        };
        _this.componentWillReceiveProps = function (nextProps) {
            var data = nextProps.data;
            var groupValues = data.groupValues, text = data.text, value = data.value;
            var checked = value;
            if (data && groupValues) {
                checked = groupValues.includes(text);
            }
            var isChecked = _this.state.isChecked;
            if (checked !== isChecked) {
                _this.setState({ isChecked: checked });
            }
        };
        _this.onCheckboxStateChange = function (event) {
            var currentTarget = event.currentTarget;
            var checked = currentTarget.checked;
            var _a = _this.props, data = _a.data, events = _a.events;
            var text = data.text;
            _this.setState({ isChecked: checked }, function () {
                var onCheckboxChange = events.onCheckboxChange;
                onCheckboxChange(new EventArgs_1.default(checked), text);
            });
            if (events.notifyGroup) {
                var notifyGroup = events.notifyGroup;
                notifyGroup(text, checked);
            }
        };
        _this.getCheckBoxClasses = function () {
            var e_1, _a;
            var options = _this.props.options;
            var checkClasses = [
                options.classNames
                    ? options.classNames.customCheckBox
                        ? options.classNames.customCheckBox
                        : ""
                    : "",
                "checkbox",
                "flex-items-top",
            ];
            if (_this.props.globalClasses) {
                try {
                    for (var _b = __values(_this.props.globalClasses), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var globalClasses = _c.value;
                        checkClasses.push(globalClasses);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (options.error) {
                checkClasses.push("error");
            }
            return checkClasses.join(" ");
        };
        _this.getCheckInputClasses = function () {
            var options = _this.props.options;
            var inputClasses = [
                options.classNames
                    ? options.classNames.customCheckboxInput
                        ? options.classNames.customCheckboxInput
                        : ""
                    : "",
            ];
            return inputClasses.join(" ");
        };
        _this.render = function () {
            var isChecked = _this.state.isChecked;
            var _a = _this.props, data = _a.data, options = _a.options, testId = _a.testId;
            var text = data.text;
            return (React__default.createElement("label", { className: _this.getCheckBoxClasses(), "data-testid": testId, htmlFor: _this.labelId },
                React__default.createElement("input", { "aria-invalid": options.disabled || options.error ? true : false, "aria-label": options.accessibility ? options.accessibility : text, checked: isChecked, className: _this.getCheckInputClasses(), disabled: options.disabled, id: _this.labelId, onChange: _this.onCheckboxStateChange, required: options.error, type: "checkbox", name: _this.props.name }),
                React__default.createElement("span", { className: "checkbox-skin" }),
                React__default.createElement("span", { className: options.error ? ["formfield-label", "error"].join(".") : "", dangerouslySetInnerHTML: {
                        __html: text,
                    } })));
        };
        _this.labelId = _this.guid();
        return _this;
    }
    Checkbox.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    Checkbox.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    Checkbox.defaultProps = {
        data: {
            text: "",
            value: false,
        },
        options: {
            classNames: {
                customCheckBox: " ",
                customCheckboxInput: " ",
            },
        },
    };
    return Checkbox;
}(React__default.Component));
exports.default = Checkbox;
});

var Checkbox = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Checkbox_1.default;
});

var colorSelectorLabel = "ColorSelector_color-selector-label__AcgC2";
var colorSelectorGroup = "ColorSelector_color-selector-group__ZeBhz";
var colorSelectorRadioGroup = "ColorSelector_color-selector-radio-group__-NT7b";
var colorSelectorRadioSkin = "ColorSelector_color-selector-radio-skin__hHmZt";
var colorSelectorOutlineA = "ColorSelector_color-selector-outline-a__aJT-a";
var colorSelectorRadioSkinHover = "ColorSelector_color-selector-radio-skin-hover__08kFj";
var colorSelectorStrikeThrough = "ColorSelector_color-selector-strike-through__5AAE4";
var colorSelectorRadioSkinDisabled = "ColorSelector_color-selector-radio-skin-disabled__ZJH7Q";
var noBorder = "ColorSelector_no-border__pKZMk";
var css_248z$z = ".ColorSelector_color-selector-label__AcgC2 {\n  margin-left: 6px; }\n\n.ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b {\n  margin: 8px 6px;\n  z-index: 0; }\n  .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input {\n    border-radius: 100%;\n    height: 44px;\n    left: -2px;\n    opacity: 0.01;\n    top: -2px;\n    width: 44px;\n    z-index: 1; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input + .ColorSelector_color-selector-radio-skin__hHmZt,\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-outline-a__aJT-a {\n      border-radius: 100%;\n      height: 38px;\n      width: 38px;\n      z-index: 0; }\n      .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input + .ColorSelector_color-selector-radio-skin__hHmZt::after,\n      .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-outline-a__aJT-a::after {\n        border-radius: 100%;\n        content: \"\";\n        height: 34px;\n        width: 34px;\n        left: 2px;\n        top: 2px; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input + .ColorSelector_color-selector-radio-skin__hHmZt {\n      transition: box-shadow 0.3s ease-in-out; }\n      .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input + .ColorSelector_color-selector-radio-skin__hHmZt::after {\n        background-color: currentColor;\n        border: 1px solid #878c94;\n        color: currentColor;\n        position: relative;\n        transition: border 0.3s ease-in-out; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-outline-a__aJT-a::after {\n      background-color: transparent;\n      color: transparent;\n      position: absolute; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:checked + .ColorSelector_color-selector-radio-skin__hHmZt {\n      box-shadow: 0 0 0 2px #0057b8 !important; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:checked + .ColorSelector_color-selector-radio-skin__hHmZt::after,\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:checked ~ .ColorSelector_color-selector-outline-a__aJT-a::after {\n      border: 1px solid rgba(0, 0, 0, 0); }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:hover + .ColorSelector_color-selector-radio-skin-hover__08kFj {\n      box-shadow: 0 0 0 1px #878c94; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:focus ~ .ColorSelector_color-selector-outline-a__aJT-a {\n      border: 1px dashed #000000;\n      width: 48px;\n      height: 48px;\n      position: absolute;\n      top: -5px;\n      left: -5px; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-strike-through__5AAE4 {\n      background-color: #454b52;\n      border-radius: 2px;\n      border: 1px solid #ffffff;\n      position: absolute;\n      height: 40px;\n      left: 17px;\n      top: 0;\n      transform: rotate(45deg);\n      width: 4px; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-radio-skin-disabled__ZJH7Q::after {\n      border: 1px solid #878c94 !important; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:disabled {\n      cursor: not-allowed; }\n  .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > .ColorSelector_no-border__pKZMk {\n    border: 0 !important; }\n";
var ColorSelector$1 = {"color-selector-label":"ColorSelector_color-selector-label__AcgC2","color-selector-group":"ColorSelector_color-selector-group__ZeBhz","color-selector-radio-group":"ColorSelector_color-selector-radio-group__-NT7b","color-selector-radio-skin":"ColorSelector_color-selector-radio-skin__hHmZt","color-selector-outline-a":"ColorSelector_color-selector-outline-a__aJT-a","color-selector-radio-skin-hover":"ColorSelector_color-selector-radio-skin-hover__08kFj","color-selector-strike-through":"ColorSelector_color-selector-strike-through__5AAE4","color-selector-radio-skin-disabled":"ColorSelector_color-selector-radio-skin-disabled__ZJH7Q","no-border":"ColorSelector_no-border__pKZMk","colorSelectorLabel":"ColorSelector_color-selector-label__AcgC2","colorSelectorGroup":"ColorSelector_color-selector-group__ZeBhz","colorSelectorRadioGroup":"ColorSelector_color-selector-radio-group__-NT7b","colorSelectorRadioSkin":"ColorSelector_color-selector-radio-skin__hHmZt","colorSelectorOutlineA":"ColorSelector_color-selector-outline-a__aJT-a","colorSelectorRadioSkinHover":"ColorSelector_color-selector-radio-skin-hover__08kFj","colorSelectorStrikeThrough":"ColorSelector_color-selector-strike-through__5AAE4","colorSelectorRadioSkinDisabled":"ColorSelector_color-selector-radio-skin-disabled__ZJH7Q","noBorder":"ColorSelector_no-border__pKZMk"};
var stylesheet$v=".ColorSelector_color-selector-label__AcgC2 {\n  margin-left: 6px; }\n\n.ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b {\n  margin: 8px 6px;\n  z-index: 0; }\n  .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input {\n    border-radius: 100%;\n    height: 44px;\n    left: -2px;\n    opacity: 0.01;\n    top: -2px;\n    width: 44px;\n    z-index: 1; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input + .ColorSelector_color-selector-radio-skin__hHmZt,\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-outline-a__aJT-a {\n      border-radius: 100%;\n      height: 38px;\n      width: 38px;\n      z-index: 0; }\n      .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input + .ColorSelector_color-selector-radio-skin__hHmZt::after,\n      .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-outline-a__aJT-a::after {\n        border-radius: 100%;\n        content: \"\";\n        height: 34px;\n        width: 34px;\n        left: 2px;\n        top: 2px; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input + .ColorSelector_color-selector-radio-skin__hHmZt {\n      transition: box-shadow 0.3s ease-in-out; }\n      .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input + .ColorSelector_color-selector-radio-skin__hHmZt::after {\n        background-color: currentColor;\n        border: 1px solid #878c94;\n        color: currentColor;\n        position: relative;\n        transition: border 0.3s ease-in-out; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-outline-a__aJT-a::after {\n      background-color: transparent;\n      color: transparent;\n      position: absolute; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:checked + .ColorSelector_color-selector-radio-skin__hHmZt {\n      box-shadow: 0 0 0 2px #0057b8 !important; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:checked + .ColorSelector_color-selector-radio-skin__hHmZt::after,\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:checked ~ .ColorSelector_color-selector-outline-a__aJT-a::after {\n      border: 1px solid rgba(0, 0, 0, 0); }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:hover + .ColorSelector_color-selector-radio-skin-hover__08kFj {\n      box-shadow: 0 0 0 1px #878c94; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:focus ~ .ColorSelector_color-selector-outline-a__aJT-a {\n      border: 1px dashed #000000;\n      width: 48px;\n      height: 48px;\n      position: absolute;\n      top: -5px;\n      left: -5px; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-strike-through__5AAE4 {\n      background-color: #454b52;\n      border-radius: 2px;\n      border: 1px solid #ffffff;\n      position: absolute;\n      height: 40px;\n      left: 17px;\n      top: 0;\n      transform: rotate(45deg);\n      width: 4px; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input ~ .ColorSelector_color-selector-radio-skin-disabled__ZJH7Q::after {\n      border: 1px solid #878c94 !important; }\n    .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > input:disabled {\n      cursor: not-allowed; }\n  .ColorSelector_color-selector-group__ZeBhz > .ColorSelector_color-selector-radio-group__-NT7b > .ColorSelector_no-border__pKZMk {\n    border: 0 !important; }\n";
styleInject(css_248z$z);

var ColorSelector$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    colorSelectorLabel: colorSelectorLabel,
    colorSelectorGroup: colorSelectorGroup,
    colorSelectorRadioGroup: colorSelectorRadioGroup,
    colorSelectorRadioSkin: colorSelectorRadioSkin,
    colorSelectorOutlineA: colorSelectorOutlineA,
    colorSelectorRadioSkinHover: colorSelectorRadioSkinHover,
    colorSelectorStrikeThrough: colorSelectorStrikeThrough,
    colorSelectorRadioSkinDisabled: colorSelectorRadioSkinDisabled,
    noBorder: noBorder,
    'default': ColorSelector$1,
    stylesheet: stylesheet$v
});

var styles$q = /*@__PURE__*/getAugmentedNamespace(ColorSelector$2);

var ColorSelector_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });



var ColorSelector = function (_a) {
    var data = _a.data, _b = _a.events, events = _b === void 0 ? { onSelect: function () { return null; } } : _b, name = _a.name, _c = _a.options, options = _c === void 0 ? {} : _c, testId = _a.testId;
    var _d = __read(React__default.useState({
        hideFocus: true,
        selectedIndex: options.defaultIndex ? options.defaultIndex : 0,
    }), 2), state = _d[0], setState = _d[1];
    var hideFocus = state.hideFocus, selectedIndex = state.selectedIndex;
    var colors = data.colors;
    var refOptions = __spread(Array(colors.length)).map(function (_, i) { return i; });
    var onMouseDown = function (e) {
        if (e.button === 0) {
            if (e) {
                e.preventDefault();
            }
            var currentTarget = e.currentTarget;
            var value = currentTarget.value;
            var newSelectedIndex = parseInt(value, 10);
            if (colors[newSelectedIndex].selectable !== false) {
                refOptions[newSelectedIndex].focus();
                setState({ hideFocus: true, selectedIndex: newSelectedIndex });
                if (events &&
                    events.onSelect &&
                    colors[newSelectedIndex].triggerOnSelect !== false) {
                    events.onSelect(colors[newSelectedIndex]);
                }
            }
        }
    };
    var onKeyUp = function (e) {
        var currentTarget = e.currentTarget;
        var value = currentTarget.value;
        var newSelectedIndex = parseInt(value, 10);
        if (colors[newSelectedIndex].selectable !== false) {
            if (keyPress.KeyPress.enterIsPressed(e)) {
                setState({ hideFocus: false, selectedIndex: newSelectedIndex });
                if (events &&
                    events.onSelect &&
                    colors[newSelectedIndex].triggerOnSelect !== false) {
                    events.onSelect(colors[newSelectedIndex]);
                }
            }
            else if (keyPress.KeyPress.tabIsPressed(e) ||
                keyPress.KeyPress.leftArrowIsPressed(e) ||
                keyPress.KeyPress.rightArrowIsPressed(e)) {
                setState(__assign(__assign({}, state), { hideFocus: false }));
            }
        }
    };
    var onChange = function () { };
    var selectedName = colors[selectedIndex].name;
    return (React__default.createElement("div", { "data-testid": testId },
        React__default.createElement("div", { className: styles$q.colorSelectorLabel + " mar-b-none type-sm" },
            React__default.createElement("span", { className: options.labelClassName ? options.labelClassName : "" },
                "Color:",
                " "),
            React__default.createElement("span", { className: options.labelSelectedClassName
                    ? options.labelSelectedClassName
                    : "font-medium" }, colors[selectedIndex].unavailable
                ? colors[selectedIndex].accessibility
                    ? colors[selectedIndex].accessibility
                    : selectedName + " is unavailable"
                : selectedName)),
        React__default.createElement("div", { "aria-label": "Select a color", className: "" + styles$q.colorSelectorGroup + (options.groupClassName ? " " + options.groupClassName : "") }, colors.map(function (item, index) {
            return item.hidden ? null : (React__default.createElement("label", { className: styles$q.colorSelectorRadioGroup + " color-ui-dark-gray flex-items-center inline-flex rel", key: item.name },
                React__default.createElement("input", { "aria-disabled": item.unavailable ? true : undefined, className: "absolute", checked: index === selectedIndex, name: name, onChange: onChange, onKeyUp: onKeyUp, onMouseDown: onMouseDown, ref: function (node) {
                        refOptions[index] = node;
                    }, type: "radio", value: index }),
                React__default.createElement("span", { className: "" + styles$q.colorSelectorRadioSkin + (" " + (item.unavailable
                        ? styles$q.colorSelectorRadioSkinDisabled
                        : styles$q.colorSelectorRadioSkinHover)) + " flex rel", style: { color: item.value } }),
                React__default.createElement("span", { className: "absolute flex " + styles$q.colorSelectorOutlineA + (hideFocus ? " " + styles$q.noBorder : "") }),
                item.unavailable && (React__default.createElement("span", { className: styles$q.colorSelectorStrikeThrough })),
                React__default.createElement("span", { className: "hidden-spoken" }, item.name)));
        }))));
};
exports.default = ColorSelector;
});

var ColorSelector = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = ColorSelector_1.default;
});

var Debounce = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;

/**
 * Debounce the passed function. This means that the function will only fire once while
 * it is being called within the threshold.
 * @param fn The function to be debounced
 * @param threshold How long to wait before allowing the function to be triggered again. Default is `100`.
 * @param immediate Whether to trigger the function at the start instead of after the threshold. Default is `false`.
 * @return A version of this function that will only trigger when it isn't called for the threshold amount of time.
 */
// tslint:disable-next-line: no-any
exports.debounce = utils.makeSsrSafe(function (fn, threshold, immediate) {
    if (threshold === void 0) { threshold = 100; }
    if (immediate === void 0) { immediate = false; }
    var timeout;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var call = function () {
            timeout = undefined;
            if (!immediate) {
                return fn.apply(_this, args);
            }
        };
        if (immediate && !timeout) {
            call();
        }
        clearTimeout(timeout);
        timeout = window.setTimeout(call, threshold);
    };
});
});

var menuItem = "MultiSelectInputList_menu-item__GonjJ";
var activeItem = "MultiSelectInputList_active-item__U56a3";
var menuItemSelected = "MultiSelectInputList_menu-item-selected__LsAyS";
var groupTitle = "MultiSelectInputList_group-title__spW5r";
var checkMark = "MultiSelectInputList_check-mark__lyShk";
var comboHoverColor = "MultiSelectInputList_combo-hover-color__dlbk4";
var comboFocusColor = "MultiSelectInputList_combo-focus-color__LbDgU";
var comboListHeight = "MultiSelectInputList_combo-list-height__BG13W";
var comboLi = "MultiSelectInputList_combo-li__wJ4za";
var css_248z$y = ".MultiSelectInputList_menu-item__GonjJ {\n  cursor: pointer;\n  padding: 10px 16px 10px 24px;\n  line-height: 20px;\n  text-overflow: ellipsis;\n  white-space: wrap;\n  background-color: #ffffff; }\n  .MultiSelectInputList_menu-item__GonjJ .MultiSelectInputList_active-item__U56a3 {\n    font-size: 14px; }\n  .MultiSelectInputList_menu-item__GonjJ:hover {\n    background-color: #f7f8f9 !important; }\n  .MultiSelectInputList_menu-item__GonjJ:focus {\n    background-color: #f2f2f2 !important; }\n  .MultiSelectInputList_menu-item__GonjJ.MultiSelectInputList_menu-item-selected__LsAyS {\n    font: inherit;\n    background-color: #f2f2f2;\n    border: 1px solid #ffff; }\n  @media (max-width: 767px) {\n    .MultiSelectInputList_menu-item__GonjJ {\n      white-space: initial;\n      text-align: justify;\n      word-break: break-word;\n      text-justify: inter-word;\n      display: inline-block;\n      width: 100%; } }\n\n.MultiSelectInputList_group-title__spW5r {\n  padding-top: 10px !important; }\n\n.MultiSelectInputList_check-mark__lyShk {\n  width: 30px;\n  margin-left: auto;\n  margin-top: auto;\n  margin-bottom: auto; }\n\n@media (max-width: 766px) {\n  .MultiSelectInputList_check-mark__lyShk {\n    width: 70px; } }\n\n.MultiSelectInputList_combo-hover-color__dlbk4:hover {\n  color: #0057B8 !important;\n  background-color: #f2f2f2 !important; }\n\n.MultiSelectInputList_combo-focus-color__LbDgU:focus {\n  background-color: #f2f2f2 !important; }\n\n.MultiSelectInputList_combo-list-height__BG13W {\n  font-size: 1.4rem !important; }\n\n.MultiSelectInputList_combo-li__wJ4za {\n  padding: 12px 16px 12px !important;\n  line-height: 16.8px !important; }\n";
var MultiSelectInputList$1 = {"menu-item":"MultiSelectInputList_menu-item__GonjJ","active-item":"MultiSelectInputList_active-item__U56a3","menu-item-selected":"MultiSelectInputList_menu-item-selected__LsAyS","group-title":"MultiSelectInputList_group-title__spW5r","check-mark":"MultiSelectInputList_check-mark__lyShk","combo-hover-color":"MultiSelectInputList_combo-hover-color__dlbk4","combo-focus-color":"MultiSelectInputList_combo-focus-color__LbDgU","combo-list-height":"MultiSelectInputList_combo-list-height__BG13W","combo-li":"MultiSelectInputList_combo-li__wJ4za","menuItem":"MultiSelectInputList_menu-item__GonjJ","activeItem":"MultiSelectInputList_active-item__U56a3","menuItemSelected":"MultiSelectInputList_menu-item-selected__LsAyS","groupTitle":"MultiSelectInputList_group-title__spW5r","checkMark":"MultiSelectInputList_check-mark__lyShk","comboHoverColor":"MultiSelectInputList_combo-hover-color__dlbk4","comboFocusColor":"MultiSelectInputList_combo-focus-color__LbDgU","comboListHeight":"MultiSelectInputList_combo-list-height__BG13W","comboLi":"MultiSelectInputList_combo-li__wJ4za"};
var stylesheet$u=".MultiSelectInputList_menu-item__GonjJ {\n  cursor: pointer;\n  padding: 10px 16px 10px 24px;\n  line-height: 20px;\n  text-overflow: ellipsis;\n  white-space: wrap;\n  background-color: #ffffff; }\n  .MultiSelectInputList_menu-item__GonjJ .MultiSelectInputList_active-item__U56a3 {\n    font-size: 14px; }\n  .MultiSelectInputList_menu-item__GonjJ:hover {\n    background-color: #f7f8f9 !important; }\n  .MultiSelectInputList_menu-item__GonjJ:focus {\n    background-color: #f2f2f2 !important; }\n  .MultiSelectInputList_menu-item__GonjJ.MultiSelectInputList_menu-item-selected__LsAyS {\n    font: inherit;\n    background-color: #f2f2f2;\n    border: 1px solid #ffff; }\n  @media (max-width: 767px) {\n    .MultiSelectInputList_menu-item__GonjJ {\n      white-space: initial;\n      text-align: justify;\n      word-break: break-word;\n      text-justify: inter-word;\n      display: inline-block;\n      width: 100%; } }\n\n.MultiSelectInputList_group-title__spW5r {\n  padding-top: 10px !important; }\n\n.MultiSelectInputList_check-mark__lyShk {\n  width: 30px;\n  margin-left: auto;\n  margin-top: auto;\n  margin-bottom: auto; }\n\n@media (max-width: 766px) {\n  .MultiSelectInputList_check-mark__lyShk {\n    width: 70px; } }\n\n.MultiSelectInputList_combo-hover-color__dlbk4:hover {\n  color: #0057B8 !important;\n  background-color: #f2f2f2 !important; }\n\n.MultiSelectInputList_combo-focus-color__LbDgU:focus {\n  background-color: #f2f2f2 !important; }\n\n.MultiSelectInputList_combo-list-height__BG13W {\n  font-size: 1.4rem !important; }\n\n.MultiSelectInputList_combo-li__wJ4za {\n  padding: 12px 16px 12px !important;\n  line-height: 16.8px !important; }\n";
styleInject(css_248z$y);

var MultiSelectInputList$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    menuItem: menuItem,
    activeItem: activeItem,
    menuItemSelected: menuItemSelected,
    groupTitle: groupTitle,
    checkMark: checkMark,
    comboHoverColor: comboHoverColor,
    comboFocusColor: comboFocusColor,
    comboListHeight: comboListHeight,
    comboLi: comboLi,
    'default': MultiSelectInputList$1,
    stylesheet: stylesheet$u
});

var optionStyles = /*@__PURE__*/getAugmentedNamespace(MultiSelectInputList$2);

var MultiSelectInputList_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });




var enterIsPressed = keyPress.KeyPress.enterIsPressed;
var MultiSelectInputList = /** @class */ (function (_super) {
    __extends(MultiSelectInputList, _super);
    function MultiSelectInputList(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            if (_this.props.onSelect) {
                _this.props.onSelect(_this.props.data.choice, false);
            }
        };
        _this.handleKeyDown = function (e) {
            if (enterIsPressed(e)) {
                var elem = e.target;
                elem.parentElement.parentElement.parentElement.children[0].focus();
                if (_this.props.onSelect) {
                    _this.props.onSelect(_this.props.data.choice, true);
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            else if (_this.props.handelKeyDown) {
                _this.props.handelKeyDown(e);
            }
        };
        _this.setLiRef = function (element) {
            _this.liRef = element;
        };
        return _this;
    }
    MultiSelectInputList.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this.props.data, choice = _h.choice, isSelected = _h.isSelected; _h.textData;
        var isHoverClass = '';
        var isHoverFocusClass = '';
        var isListHeightClass = 'type-sm';
        var isComboLi = '';
        var isComboboxBg = false;
        if (this.props.options && ((_a = this.props.options) === null || _a === void 0 ? void 0 : _a.isCombobox)) {
            isHoverClass = ((_b = this.props.options.isCombobox) === null || _b === void 0 ? void 0 : _b.isHoverColor) ? optionStyles.comboHoverColor : '';
            isHoverFocusClass = ((_c = this.props.options.isCombobox) === null || _c === void 0 ? void 0 : _c.isHoverFocusColor) ? optionStyles.comboFocusColor : '';
            isComboboxBg = ((_d = this.props.options.isCombobox) === null || _d === void 0 ? void 0 : _d.isAddBgColor) === true ? true : false;
            isListHeightClass = optionStyles.comboListHeight;
            isComboLi = optionStyles.comboLi;
        }
        var classes = isSelected
            ? [optionStyles.menuItem, optionStyles.menuItemSelected, !isComboboxBg ? " color-ui-dark-gray flex color-cobalt" : " color-ui-dark-gray", isHoverClass, isHoverFocusClass, isComboLi].join(" ")
            : [optionStyles.menuItem, !isComboLi ? " overflow-hidden" : "", isHoverClass, isHoverFocusClass, isComboLi].join(" ");
        var text = choice.displayText
            ? choice.displayText
            : choice.value
                ? choice.value.toString()
                : "No Suggestion";
        var searchLen = ((_g = (_f = (_e = this.props) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.textData) === null || _g === void 0 ? void 0 : _g.length) || 0;
        var subStrIndex = this.props.data && this.props.data.textData
            ? text.toUpperCase().indexOf(this.props.data.textData.toUpperCase())
            : 0;
        /*
        if (textData && subStrIndex !== textData.length) {
            subStrIndex = 0;
        }*/
        var primary1stText = text.substring(0, subStrIndex);
        var primary2ndText = text.substring(subStrIndex, subStrIndex + searchLen);
        var primary3rdText = text.substring(subStrIndex + searchLen, text.length);
        var optionText = React__default.createElement("span", null, text);
        if (this.props.options && this.props.options.heighlightTextData) {
            optionText = (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("span", { "aria-hidden": "true", className: "" + isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary1stText
                            ? primary1stText.split(" ").join("&nbsp;")
                            : primary1stText,
                    } }),
                React__default.createElement("span", { "aria-hidden": "true", className: !isComboboxBg ? " font-bold " + isListHeightClass : isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary2ndText
                            ? primary2ndText.split(" ").join("&nbsp;")
                            : primary2ndText,
                    } }),
                React__default.createElement("span", { "aria-hidden": "true", className: "" + isListHeightClass, dangerouslySetInnerHTML: {
                        __html: primary3rdText
                            ? primary3rdText.replace(" ", "&nbsp;")
                            : primary3rdText,
                    } })));
        }
        return (React__default.createElement("li", { id: text, "data-test-id": this.props.testId, className: classes, role: "menuitem", title: isSelected ? text + "( is selected)" : text, tabIndex: isHoverFocusClass ? -1 : 0, onClick: this.handleClick, "aria-selected": isSelected, ref: this.setLiRef, onKeyDown: this.handleKeyDown },
            React__default.createElement("div", null, optionText),
            isSelected && !isComboboxBg ? (React__default.createElement("span", { "aria-hidden": "true", className: optionStyles.checkMark + " text-right flex flex-items-center justify-center " },
                React__default.createElement(IconSvg.default, { size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M11.33 26.75l-10-10 1.42-1.42 8.62 8.63 18-18 1.42 1.41z\"/></svg>" }))) : ("")));
    };
    return MultiSelectInputList;
}(React__default.Component));
exports.default = MultiSelectInputList;
});

var MultiSelectInputList = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = MultiSelectInputList_1.default;
});

var dropdown$1 = "ComboBox_dropdown__W9nLG";
var divPosition = "ComboBox_div-position__tHucA";
var closePosition = "ComboBox_close-position__r5l-s";
var resultNotFound = "ComboBox_result-not-found__e9ewg";
var showAllResult = "ComboBox_show-all-result__HAqMt";
var css_248z$x = ".ComboBox_dropdown__W9nLG {\n  top: 74px;\n  z-index: 1;\n  border-radius: 0 0 0.3rem 0.3rem; }\n\n.ComboBox_div-position__tHucA {\n  position: relative; }\n\n.ComboBox_close-position__r5l-s {\n  top: 37px; }\n\n.ComboBox_result-not-found__e9ewg {\n  cursor: default !important;\n  padding-top: 12px !important;\n  padding-bottom: 12px;\n  line-height: 18.8px;\n  padding-left: 16px;\n  background-color: #ffffff;\n  font-size: 1.4rem; }\n  .ComboBox_result-not-found__e9ewg:hover {\n    background-color: #ffffff !important; }\n  .ComboBox_result-not-found__e9ewg:focus {\n    background-color: #ffffff !important; }\n\n.ComboBox_show-all-result__HAqMt {\n  max-height: 128px !important;\n  overflow: auto !important; }\n";
var ComboBox$1 = {"dropdown":"ComboBox_dropdown__W9nLG","div-position":"ComboBox_div-position__tHucA","close-position":"ComboBox_close-position__r5l-s","result-not-found":"ComboBox_result-not-found__e9ewg","show-all-result":"ComboBox_show-all-result__HAqMt","divPosition":"ComboBox_div-position__tHucA","closePosition":"ComboBox_close-position__r5l-s","resultNotFound":"ComboBox_result-not-found__e9ewg","showAllResult":"ComboBox_show-all-result__HAqMt"};
var stylesheet$t=".ComboBox_dropdown__W9nLG {\n  top: 74px;\n  z-index: 1;\n  border-radius: 0 0 0.3rem 0.3rem; }\n\n.ComboBox_div-position__tHucA {\n  position: relative; }\n\n.ComboBox_close-position__r5l-s {\n  top: 37px; }\n\n.ComboBox_result-not-found__e9ewg {\n  cursor: default !important;\n  padding-top: 12px !important;\n  padding-bottom: 12px;\n  line-height: 18.8px;\n  padding-left: 16px;\n  background-color: #ffffff;\n  font-size: 1.4rem; }\n  .ComboBox_result-not-found__e9ewg:hover {\n    background-color: #ffffff !important; }\n  .ComboBox_result-not-found__e9ewg:focus {\n    background-color: #ffffff !important; }\n\n.ComboBox_show-all-result__HAqMt {\n  max-height: 128px !important;\n  overflow: auto !important; }\n";
styleInject(css_248z$x);

var ComboBox$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    dropdown: dropdown$1,
    divPosition: divPosition,
    closePosition: closePosition,
    resultNotFound: resultNotFound,
    showAllResult: showAllResult,
    'default': ComboBox$1,
    stylesheet: stylesheet$t
});

var styles$p = /*@__PURE__*/getAugmentedNamespace(ComboBox$2);

var ComboBox_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });








var enterIsPressed = keyPress.KeyPress.enterIsPressed;
var upArrowIsPressed = keyPress.KeyPress.upArrowIsPressed;
var downArrowIsPressed = keyPress.KeyPress.downArrowIsPressed;
var escIsPressed = keyPress.KeyPress.escIsPressed;
var tabIsPressed = keyPress.KeyPress.tabIsPressed;
var ComboBox = /** @class */ (function (_super) {
    __extends(ComboBox, _super);
    function ComboBox(props) {
        var _a, _b, _c;
        var _this = _super.call(this, props) || this;
        _this.debouncedLog = Debounce.debounce(function (text) {
            _this.filterAndSetData(text, "change");
        }, 300);
        _this.onChange = function (e) {
            var events = _this.props.events;
            var currentValue = e.target.value;
            if (currentValue) {
                _this.setState({ currentText: currentValue, errorText: "", isClickBack: false });
                _this.debouncedLog(currentValue);
            }
            else {
                if (_this.state.isLoadInitialResult) {
                    _this.setState({
                        isOpen: true,
                        currentText: currentValue,
                        errorText: "",
                        isClickBack: false,
                    });
                    _this.filterAndSetData("", "focus");
                }
                else {
                    _this.setState({ isOpen: false, currentText: currentValue, errorText: "" });
                }
            }
            if (events && events.onChange) {
                events.onChange(e);
            }
        };
        _this.filterAndSetData = function (txtValue, from) {
            var filteredData = _this.props.data.choices;
            if (txtValue) {
                filteredData = _this.props.data.choices.filter(function (choice) {
                    var searchText = txtValue.toUpperCase();
                    var displayText = choice.displayText.toUpperCase();
                    return displayText.includes(searchText);
                });
                // tslint:disable-next-line:no-console
                var noSuggestionText = filteredData.length === 0 && txtValue ? true : false;
                _this.setState({ isOpen: true, showClose: true, filteredData: filteredData, noSuggestionText: noSuggestionText });
            }
            else {
                if (from === "focus") {
                    filteredData = _this.props.data.choices.filter(function (choice) {
                        var displayText = choice.displayText.toUpperCase();
                        return displayText;
                    });
                    _this.setState({
                        isOpen: true,
                        showClose: true,
                        filteredData: filteredData,
                        noSuggestionText: true,
                    });
                }
                else {
                    _this.setState({ filteredData: [], noSuggestionText: false });
                }
            }
        };
        _this.handleInputKeyDown = function (e) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (e.shiftKey && e.keyCode === 9) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            if (tabIsPressed(e) && currentText.length === 0) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
            }
            else if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
            }
            else if (_this.state.isOpen && downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var firstLi = el.querySelector("." + optionStyles.menuItem);
                if (firstLi) {
                    firstLi.focus();
                }
            }
            if (events && events.onKeyUp) {
                events.onKeyUp(e);
            }
            if (downArrowIsPressed(e) || upArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                e.preventDefault();
                if (liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                }
                return;
            }
        };
        _this.handleKeyDown = function (e) {
            var _a, _b;
            var events = _this.props.events;
            if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
                (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            else if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
                var elm = e.currentTarget.parentElement;
                var liElementMain = elm.querySelector("." + optionStyles.menuItem + ":focus");
                _this.setState({ currentText: liElementMain.innerHTML });
            }
            else if (downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                var firstLi = el.querySelectorAll("." + optionStyles.menuItem);
                if (liElement && liElement.nextElementSibling) {
                    liElement.nextElementSibling.focus();
                }
                else {
                    if (firstLi && firstLi.length) {
                        firstLi[0].focus();
                    }
                }
                e.preventDefault();
                if (!UserAgent.isIE()) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                    return;
                }
            }
            else if (upArrowIsPressed(e)) {
                var elUp = e.currentTarget.parentElement;
                var liUpElement = elUp.querySelector("." + optionStyles.menuItem + ":focus");
                var lastLi = elUp.querySelectorAll("." + optionStyles.menuItem);
                if (liUpElement && liUpElement.previousElementSibling) {
                    liUpElement.previousElementSibling.focus();
                }
                else {
                    if (lastLi && lastLi.length > 1) {
                        lastLi[lastLi.length - 1].focus();
                    }
                }
                e.preventDefault();
            }
            else if (keyPress.KeyPress.tabIsPressed(e)) {
                if (_this.state.isOpen) {
                    _this.setState({
                        showClose: true,
                    }, function () {
                        var _a, _b;
                        (_b = (_a = _this.closeRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
                    });
                    e.preventDefault();
                }
            }
            if (events && events.handleKeyDown) {
                events.handleKeyDown(e);
            }
        };
        _this.onFocus = function (event) {
            var events = _this.props.events;
            _this.setState({ isOnFocus: true });
            if (events && events.onFocus) {
                events.onFocus(event);
            }
            if (_this.state.isLoadInitialResult && _this.state.currentText.length === 0) {
                _this.filterAndSetData("", "focus");
                _this.setState({ errorText: "" });
            }
            if (_this.state.isLoadInitialResult && _this.state.currentText.length > 0) {
                _this.showAllList();
            }
            if (!_this.state.isLoadInitialResult) {
                _this.setState({ showClose: true });
            }
        };
        _this.showAllList = function () {
            var currentTxt = _this.state.currentText;
            var filteredData = _this.props.data.choices;
            var checkRecord = _this.props.data.choices.filter(function (choice) {
                var searchText = currentTxt.toUpperCase();
                var displayText = choice.displayText.toUpperCase();
                return displayText === searchText;
            });
            // tslint:disable-next-line:no-console
            if (checkRecord.length === 0) {
                _this.filterAndSetData(currentTxt, "change");
            }
            else {
                _this.setState({
                    isOpen: true,
                    showClose: true,
                    filteredData: filteredData,
                    noSuggestionText: false,
                    isClickBack: true,
                });
            }
        };
        _this.handleClickOutside = function (event) {
            var domNode = react_dom_1.findDOMNode(_this);
            if (!domNode || !domNode.contains(event.target)) {
                _this.setState({
                    isOpen: false,
                    showClose: false,
                });
            }
        };
        _this.onBlur = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (_this.state.isLoadInitialResult && _this.state.isOpen && currentText.length > 0) {
                _this.setState({ isOnFocus: false, showClose: true });
            }
            else if (_this.state.isLoadInitialResult) {
                _this.setState({ isOnFocus: false, showClose: false });
            }
            else {
                _this.setState({ isOnFocus: false, showClose: false });
            }
            if (events && events.onBlur) {
                events.onBlur(currentText);
            }
        };
        _this.onSelect = function (choice, enter) {
            var events = _this.props.events;
            _this.setState({
                isOpen: false,
                currentText: choice.displayText ? choice.displayText : "",
                showClose: false,
            });
            if (events && events.onSelect) {
                var response = { dropdown: false, focus: false };
                response = events.onSelect(choice);
                if (response && response.dropdown) {
                    _this.setState({ isOpen: true,
                        isOnFocus: true,
                        currentText: "" });
                }
            }
        };
        _this.clearInput = function (e) {
            var _a, _b;
            e.preventDefault();
            _this.setState({ currentText: "", isOpen: false, isOnFocus: true });
            (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            if (_this.state.isLoadInitialResult) {
                _this.filterAndSetData("", "focus");
                _this.setState({ errorText: "" });
            }
        };
        _this.closeOnBlur = function (e) {
            _this.setState({ isOpen: false, showClose: false });
        };
        _this.onNoSuggestionSelect = function () {
            _this.setState({ isOpen: false });
        };
        _this.closeIcon = function () {
            return (React__default.createElement(React__default.Fragment, null, _this.state.currentText.length && _this.state.showClose ? (React__default.createElement("button", { className: styles$p.closePosition + " right mar-r-xxs icon-close absolute", onMouseDown: _this.clearInput, onBlur: _this.closeOnBlur, ref: _this.closeRef, "aria-label": "Clear Input field" })) : ("")));
        };
        _this.getFindIndex = function (inputText, listText) {
            if (inputText === listText && _this.state.isClickBack === true) {
                return true;
            }
            return false;
        };
        _this.closeRef = React__default.createRef();
        _this.inputRef = React__default.createRef();
        _this.state = {
            isOpen: false,
            currentData: props.data,
            currentText: ((_a = props.data) === null || _a === void 0 ? void 0 : _a.value) ? props.data.value : "",
            currentValue: null,
            filteredData: [],
            isOnFocus: false,
            errorText: ((_b = props.options) === null || _b === void 0 ? void 0 : _b.errorText) ? props.options.errorText : "",
            showClose: false,
            alertText: "",
            isLoadInitialResult: ((_c = props.options) === null || _c === void 0 ? void 0 : _c.isLoadInitialResult) === false ? false : true,
        };
        return _this;
    }
    ComboBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (JSON.stringify(nextProps.data.choices) !== JSON.stringify(this.props.data.choices)) {
            var filtereddata = nextProps.data.choices;
            this.setState(__assign(__assign({}, this.state), { filteredData: filtereddata }));
        }
    };
    ComboBox.prototype.componentDidMount = function () {
        document.addEventListener("click", this.handleClickOutside, true);
    };
    ComboBox.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.handleClickOutside, true);
    };
    ComboBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, options = _a.options, testId = _a.testId;
        var id = "input-" + testId;
        var ariaControlId = "aria-control-" + testId;
        var _b = this.state, isOpen = _b.isOpen, filteredData = _b.filteredData, currentText = _b.currentText, noSuggestionText = _b.noSuggestionText, errorText = _b.errorText;
        var dropdownCls = isOpen
            ? [
                styles$p.dropdown,
                "block pad-none left right absolute overflow-hidden bg-ui-white border border-medium-gray",
            ].join(" ")
            : [styles$p.dropdown, "absolute left right overflow-hidden hide"].join(" ");
        var choices = this.props.data.choices;
        var noDataFound = false;
        if (choices && choices.length === 0) {
            noDataFound = true;
        }
        var labelClass = errorText && errorText.length > 0 ? "error" : "";
        return (React__default.createElement("div", { "data-test-id": testId, className: styles$p.divPosition },
            React__default.createElement("div", { className: "inline-flex" }, data.labelText && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("label", { className: labelClass + " formfield-label", htmlFor: id }, data.labelText),
                React__default.createElement("span", { className: "hidden-spoken" }, errorText && errorText.length > 0 ? errorText : null),
                (options === null || options === void 0 ? void 0 : options.tooltip) !== undefined && options.tooltip))),
            React__default.createElement("div", null,
                React__default.createElement("div", { id: "multi-select-container" },
                    React__default.createElement("input", { id: id, "aria-describedby": errorText && errorText.length > 0 ? "msg_" + id : undefined, className: "textfield pad-r-lg rel", autoComplete: "off", "aria-autocomplete": "list", "aria-controls": ariaControlId, value: currentText, type: "text", placeholder: data.placeHolder, "aria-invalid": errorText && errorText.length > 0 ? true : undefined, onChange: this.onChange, onKeyDown: this.handleInputKeyDown, onFocus: this.onFocus, onBlur: this.onBlur, tabIndex: 0, ref: this.inputRef }),
                    errorText && errorText.length > 0 && (React__default.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: { __html: errorText }, id: "msg_" + id, role: "alert" })),
                    React__default.createElement("div", { id: ariaControlId, className: dropdownCls },
                        React__default.createElement("div", { className: styles$p.showAllResult },
                            currentText.length > 0 && (React__default.createElement("div", { className: "hidden-spoken", "aria-live": "polite", dangerouslySetInnerHTML: {
                                    __html: filteredData.length + "\n                            suggestions shown, use your arrow keys to navigate through them and Enter to select",
                                } })),
                            React__default.createElement("ul", { role: "menu" },
                                noSuggestionText &&
                                    currentText &&
                                    filteredData.length === 0 ? (React__default.createElement("li", { className: optionStyles.menuItem +
                                        " " +
                                        " pad-t-xs " +
                                        styles$p.resultNotFound, "aria-label": options === null || options === void 0 ? void 0 : options.noSuggestionsText, tabIndex: -1, role: "option", onKeyDown: this.handleKeyDown },
                                    React__default.createElement("span", null, options === null || options === void 0 ? void 0 : options.noSuggestionsText))) : (""),
                                filteredData.map(function (choice, index) { return (React__default.createElement(MultiSelectInputList.default, { testId: _this.props.testId + " \"_Option_\" " + index + ")", key: choice.value, data: {
                                        choice: choice,
                                        isSelected: _this.getFindIndex(currentText, choice.displayText)
                                            ? true
                                            : false,
                                        textData: currentText || "",
                                    }, onSelect: noDataFound
                                        ? _this.onNoSuggestionSelect
                                        : _this.onSelect, options: {
                                        heighlightTextData: true,
                                        isCombobox: {
                                            isHoverColor: true,
                                            isHoverFocusColor: true,
                                            isAddBgColor: _this.state.isClickBack
                                                ? true
                                                : false,
                                        },
                                    }, handelKeyDown: _this.handleKeyDown })); })))),
                    this.closeIcon())),
            React__default.createElement("div", { "aria-live": "assertive", role: "status" },
                React__default.createElement("span", { className: "hidden-spoken" },
                    " ",
                    this.state.alertText))));
    };
    return ComboBox;
}(React__default.Component));
exports.default = ComboBox;
});

var ComboBox = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = ComboBox_1.default;
});

var css_248z$w = ".link-icon-left,\n.link-icon-right {\n  display: inline-flex;\n  align-items: center; }\n\n.link-icon-left span,\n.link-icon-right span {\n  border-bottom: 1px solid transparent; }\n\n.link-icon-left svg,\n.link-icon-right svg {\n  flex-shrink: 0; }\n\n.link-icon-left:hover,\n.link-icon-right:hover {\n  color: #0057b8;\n  text-decoration: none; }\n\n.link-icon-left:hover span,\n.link-icon-right:hover span {\n  border-bottom: 1px solid #0057b8; }\n\n.link-icon-left.type-base svg,\n.link-icon-right.type-base svg {\n  width: 20px;\n  height: 20px; }\n\n.link-icon-left.type-sm svg,\n.link-icon-right.type-sm svg {\n  width: 16px;\n  height: 16px; }\n\n.link-icon-left.type-xs svg,\n.link-icon-right.type-xs svg {\n  width: 16px;\n  height: 16px; }\n\n.link-icon-left.type-base svg {\n  margin-right: 6px; }\n\n.link-icon-right.type-base svg {\n  margin-left: 6px; }\n\n.link-icon-left.type-sm svg,\n.link-icon-left.type-xs svg {\n  margin-right: 5px; }\n\n.link-icon-right.type-sm svg,\n.link-icon-right.type-xs svg {\n  margin-left: 5px; }\n\n.link-icon-left.color-ui-white:hover,\n.link-icon-right.color-ui-white:hover {\n  color: #ffffff; }\n\n.link-icon-left.color-ui-white:hover span,\n.link-icon-right.color-ui-white:hover span {\n  border-color: #ffffff; }\n\n.row-reverse {\n  flex-direction: row-reverse; }\n\n.link-tertiary-large.row-reverse:after {\n  margin: 0 16px 1px 0; }\n\n.link-tertiary-small.row-reverse:after {\n  margin: 0 8px 0 0;\n  min-width: 21px; }\n\n.rotate180-after:after {\n  transform: rotate(180deg); }\n\n.link-utility-primary,\n.link-utility-secondary {\n  align-items: center;\n  display: inline-flex;\n  text-decoration: underline; }\n\n.link-utility-primary.solo,\n.link-utility-secondary.solo {\n  font-family: font-medium, sans-serif;\n  font-size: 1.5rem;\n  text-decoration: none; }\n\n.link-text,\n.link-text3 {\n  text-decoration: underline; }\n\n.link-text3.solo:not(.on-dark) {\n  text-decoration: none; }\n\n.link-text3.solo:not(.on-dark):hover {\n  text-decoration: underline; }\n\n.link-utility-primary:not(.solo):hover,\n.link-utility-secondary:not(.solo):hover {\n  text-decoration: underline; }\n";
styleInject(css_248z$w);

var LinkProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kind = void 0;
(function (Kind) {
    /** A link that is blue on light backgrounds or white on dark backgrounds, with a rightward caret. */
    Kind["utilityPrimary"] = "link-utility-primary";
    /** A link that is dark gray on light backgrounds or white on dark backgrounds, with a rightward caret. */
    Kind["utilitySecondary"] = "link-utility-secondary";
    /** A small link with a rightward arrow. */
    Kind["tertiarySmall"] = "link-tertiary-small";
    /** A large link with a rightward arrow. */
    Kind["tertiaryLarge"] = "link-tertiary-large";
    /** A text link with an underline. */
    Kind["textUnderline"] = "link-text";
    /** A text link with medium font. */
    Kind["textMedium"] = "link-text2";
    /** A text link without any distinguishing features. Use this very sparingly. As in almost never. */
    Kind["textPlain"] = "link-text3";
    /** A link with Icon prepended before text. */
    Kind["withPrependIcon"] = "link-icon-left";
    /** A link with Icon appended after text. */
    Kind["withAppendIcon"] = "link-icon-right";
    /** A link no default classes */
    Kind["none"] = "";
})(exports.Kind || (exports.Kind = {}));
});

var Link_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });




/**
 * A CTA that looks like a link. Will use `<a>` or `<button>` under the hood depending on the functionality needed.
 */
var Link = BaseCta.MakeCtaFromBase(function (allProps) {
    var _a = Simplify.simplify(allProps), _b = _a.kind, kind = _b === void 0 ? "utilityPrimary" : _b, icon = _a.icon, props = __rest(_a, ["kind", "icon"]);
    return {
        prepend: kind === "withPrependIcon" ? icon : "",
        append: kind === "withAppendIcon" ? icon : "",
        classes: [
            LinkProps.Kind[kind],
            kind === "withPrependIcon" || kind === "withAppendIcon"
                ? allProps.onDark
                    ? "line-h-md color-ui-white font-medium"
                    : "line-h-md color-cobalt font-medium"
                : "",
        ],
        props: __assign(__assign({}, props), { className: allProps.className, overrideLink: true, role: allProps.role ? allProps.role : undefined }),
    };
});
exports.default = Link;
});

var Link = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Link_1.default;
});

var svgSize = "ContextualMessage_svgSize__H5W-9";
var marginTop1 = "ContextualMessage_marginTop1__R-O-M";
var marginTop2 = "ContextualMessage_marginTop2__atHQZ";
var marginTop3 = "ContextualMessage_marginTop3__5ehq0";
var msgPadding = "ContextualMessage_msgPadding__MBR2T";
var msgMaxWidth = "ContextualMessage_msgMaxWidth__QGSVF";
var linkColor = "ContextualMessage_linkColor__WkJDO";
var css_248z$v = ".ContextualMessage_svgSize__H5W-9 svg {\n  height: 24px;\n  min-height: 24px;\n  min-width: 24px;\n  width: 24px;\n  margin-right: 8px; }\n\n.ContextualMessage_marginTop1__R-O-M {\n  margin-top: 0; }\n\n.ContextualMessage_marginTop2__atHQZ {\n  margin-top: 1px; }\n\n.ContextualMessage_marginTop3__5ehq0 {\n  margin-top: -2px; }\n\n.ContextualMessage_msgPadding__MBR2T {\n  padding: 8px 0; }\n\n.ContextualMessage_msgMaxWidth__QGSVF {\n  max-width: 300px; }\n\n.ContextualMessage_linkColor__WkJDO {\n  color: #0057b8; }\n\n@media (max-width: 767px) {\n  .ContextualMessage_marginTop1__R-O-M {\n    margin-top: 1px; }\n  .ContextualMessage_marginTop2__atHQZ {\n    margin-top: 2px; }\n  .ContextualMessage_marginTop3__5ehq0 {\n    margin-top: -1px; } }\n";
var ContextualMessage$1 = {"svgSize":"ContextualMessage_svgSize__H5W-9","marginTop1":"ContextualMessage_marginTop1__R-O-M","marginTop2":"ContextualMessage_marginTop2__atHQZ","marginTop3":"ContextualMessage_marginTop3__5ehq0","msgPadding":"ContextualMessage_msgPadding__MBR2T","msgMaxWidth":"ContextualMessage_msgMaxWidth__QGSVF","linkColor":"ContextualMessage_linkColor__WkJDO"};
var stylesheet$s=".ContextualMessage_svgSize__H5W-9 svg {\n  height: 24px;\n  min-height: 24px;\n  min-width: 24px;\n  width: 24px;\n  margin-right: 8px; }\n\n.ContextualMessage_marginTop1__R-O-M {\n  margin-top: 0; }\n\n.ContextualMessage_marginTop2__atHQZ {\n  margin-top: 1px; }\n\n.ContextualMessage_marginTop3__5ehq0 {\n  margin-top: -2px; }\n\n.ContextualMessage_msgPadding__MBR2T {\n  padding: 8px 0; }\n\n.ContextualMessage_msgMaxWidth__QGSVF {\n  max-width: 300px; }\n\n.ContextualMessage_linkColor__WkJDO {\n  color: #0057b8; }\n\n@media (max-width: 767px) {\n  .ContextualMessage_marginTop1__R-O-M {\n    margin-top: 1px; }\n  .ContextualMessage_marginTop2__atHQZ {\n    margin-top: 2px; }\n  .ContextualMessage_marginTop3__5ehq0 {\n    margin-top: -1px; } }\n";
styleInject(css_248z$v);

var ContextualMessage$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    svgSize: svgSize,
    marginTop1: marginTop1,
    marginTop2: marginTop2,
    marginTop3: marginTop3,
    msgPadding: msgPadding,
    msgMaxWidth: msgMaxWidth,
    linkColor: linkColor,
    'default': ContextualMessage$1,
    stylesheet: stylesheet$s
});

var styles$o = /*@__PURE__*/getAugmentedNamespace(ContextualMessage$2);

var ContextualMessage_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



/**
 * Note: For user-initiated alerts which occur most frequently at the top of page or section, please use the <a href="#/Atoms/Alert" class="rsg--link-45">Alert</a> component in the library.<br /><br />
 * Contextual messages occur on page load and are not user-initiated. They can be placed anywhere on the page but must be in close proximity to the relevant content and are usually placed inside a component, such as a card or a table. Contextual messages span the width of the container they are placed within.
 */
var ContextualMessage = function (_a) {
    var data = _a.data, _b = _a.options, options = _b === void 0 ? {} : _b, testId = _a.testId;
    return (React__default.createElement("div", { className: "flex flex-wrap justify-between rel", "data-testid": testId },
        React__default.createElement("div", { className: "flex flex-items-stretch " + styles$o.msgPadding },
            data.icon && React__default.createElement("span", { className: styles$o.svgSize }, data.icon),
            (data.text || options.showLink) && (React__default.createElement("span", { className: "color-ui-dark-gray mar-b-none " + (options.type === 2
                    ? " " + styles$o.marginTop2
                    : options.type === 3
                        ? " " + styles$o.marginTop3
                        : " " + styles$o.marginTop1) + (data.className ? " " + data.className : "") },
                React__default.createElement("span", { dangerouslySetInnerHTML: { __html: data.text } }),
                options.showLink && (React__default.createElement(Link.default, { className: styles$o.linkColor, kind: "textMedium", url: options.linkUrl }, options.link)))))));
};
exports.default = ContextualMessage;
});

var ContextualMessage = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = ContextualMessage_1.default;
});

var dropdownOpen = "DropdownButton_dropdown-open__iRw-J";
var iconChevronWhite = "DropdownButton_icon-chevron-white__ifYCq";
var iconChevronGray = "DropdownButton_icon-chevron-gray__A1Vll";
var dropdownClose = "DropdownButton_dropdown-close__DZVl7";
var animate = "DropdownButton_animate__yRGsV";
var css_248z$u = ".is-tabbing .DropdownButton_dropdown-open__iRw-J li:focus {\n  outline: 1px dotted #1d2329 !important;\n  outline-offset: -6px !important; }\n\n.is-tabbing .DropdownButton_dropdown-open__iRw-J th:focus {\n  outline-offset: -2px; }\n\n.DropdownButton_dropdown-open__iRw-J {\n  opacity: 1;\n  margin-top: 4px;\n  position: absolute;\n  transition: margin-top .25s linear, opacity .25s linear, z-index 0s linear 0s;\n  box-shadow: 3px 3px 4px 0px rgba(0, 0, 0, 0.1);\n  border-radius: .3rem;\n  z-index: 1; }\n\n.DropdownButton_icon-chevron-white__ifYCq {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0nI2ZmZic+PHBhdGggY2xhc3M9InN2Zy1iYXNlIiBkPSJNMTYgMjJMNS4yOSAxMS4yOGwxLjQyLTEuNDFMMTYgMTkuMTZsOS4yOS05LjI5IDEuNDIgMS40MXoiLz48L3N2Zz4=\"); }\n\n.DropdownButton_icon-chevron-gray__A1Vll {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0nIzg3OGM5NCc+PHBhdGggY2xhc3M9InN2Zy1iYXNlIiBkPSJNMTYgMjJMNS4yOSAxMS4yOGwxLjQyLTEuNDFMMTYgMTkuMTZsOS4yOS05LjI5IDEuNDIgMS40MXoiLz48L3N2Zz4=\"); }\n\n.DropdownButton_dropdown-close__DZVl7 {\n  margin-top: 0;\n  opacity: 0;\n  position: absolute;\n  transition: margin-top .25s linear, opacity .25s linear, z-index 0s linear .25s;\n  z-index: -9999; }\n\n.DropdownButton_animate__yRGsV {\n  margin-left: 8px !important;\n  transition: 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n";
var DropdownButton$1 = {"dropdown-open":"DropdownButton_dropdown-open__iRw-J","icon-chevron-white":"DropdownButton_icon-chevron-white__ifYCq","icon-chevron-gray":"DropdownButton_icon-chevron-gray__A1Vll","dropdown-close":"DropdownButton_dropdown-close__DZVl7","animate":"DropdownButton_animate__yRGsV","dropdownOpen":"DropdownButton_dropdown-open__iRw-J","iconChevronWhite":"DropdownButton_icon-chevron-white__ifYCq","iconChevronGray":"DropdownButton_icon-chevron-gray__A1Vll","dropdownClose":"DropdownButton_dropdown-close__DZVl7"};
var stylesheet$r=".is-tabbing .DropdownButton_dropdown-open__iRw-J li:focus {\n  outline: 1px dotted #1d2329 !important;\n  outline-offset: -6px !important; }\n\n.is-tabbing .DropdownButton_dropdown-open__iRw-J th:focus {\n  outline-offset: -2px; }\n\n.DropdownButton_dropdown-open__iRw-J {\n  opacity: 1;\n  margin-top: 4px;\n  position: absolute;\n  transition: margin-top .25s linear, opacity .25s linear, z-index 0s linear 0s;\n  box-shadow: 3px 3px 4px 0px rgba(0, 0, 0, 0.1);\n  border-radius: .3rem;\n  z-index: 1; }\n\n.DropdownButton_icon-chevron-white__ifYCq {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0nI2ZmZic+PHBhdGggY2xhc3M9InN2Zy1iYXNlIiBkPSJNMTYgMjJMNS4yOSAxMS4yOGwxLjQyLTEuNDFMMTYgMTkuMTZsOS4yOS05LjI5IDEuNDIgMS40MXoiLz48L3N2Zz4=\"); }\n\n.DropdownButton_icon-chevron-gray__A1Vll {\n  background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0nIzg3OGM5NCc+PHBhdGggY2xhc3M9InN2Zy1iYXNlIiBkPSJNMTYgMjJMNS4yOSAxMS4yOGwxLjQyLTEuNDFMMTYgMTkuMTZsOS4yOS05LjI5IDEuNDIgMS40MXoiLz48L3N2Zz4=\"); }\n\n.DropdownButton_dropdown-close__DZVl7 {\n  margin-top: 0;\n  opacity: 0;\n  position: absolute;\n  transition: margin-top .25s linear, opacity .25s linear, z-index 0s linear .25s;\n  z-index: -9999; }\n\n.DropdownButton_animate__yRGsV {\n  margin-left: 8px !important;\n  transition: 0.25s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n";
styleInject(css_248z$u);

var DropdownButton$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    dropdownOpen: dropdownOpen,
    iconChevronWhite: iconChevronWhite,
    iconChevronGray: iconChevronGray,
    dropdownClose: dropdownClose,
    animate: animate,
    'default': DropdownButton$1,
    stylesheet: stylesheet$r
});

var styles$n = /*@__PURE__*/getAugmentedNamespace(DropdownButton$2);

var DropdownButton_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });



var DropdownButton = React__default.forwardRef(function (_a, ref) {
    var data = _a.data, _b = _a.events, events = _b === void 0 ? {} : _b, options = _a.options, testId = _a.testId, uniqueId = _a.uniqueId;
    var menuOptions = options.menuOptions;
    var onBlur = events.onBlur, onChange = events.onChange, onFocus = events.onFocus, onKeyDown = events.onKeyDown;
    var dataOptionsRef = __spread(Array(menuOptions.length)).map(function (_, i) { return i; });
    var buttonRef = React__default.createRef();
    var buttonSize = data.buttonSize, buttonTitle = data.buttonTitle, disabled = data.disabled;
    var _c = __read(React__default.useState({
        openList: false,
        buttonString: '',
        selected: -1,
        current: -1,
    }), 2), state = _c[0], setState = _c[1];
    var openList = state.openList, buttonString = state.buttonString, selected = state.selected, current = state.current;
    React__default.useEffect(function () {
        var _a;
        if (openList) {
            if (current === -1) {
                return;
            }
            if (process.browser) {
                document.addEventListener("mouseup", handleMouseUp, false);
            }
            (_a = dataOptionsRef[current]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        return function cleanup() {
            if (process.browser) {
                document.removeEventListener("mouseup", handleMouseUp, false);
            }
        };
    });
    var handleOpenList = function () {
        if (!state.openList) {
            setState(__assign(__assign({}, state), { openList: true, current: 0 }));
        }
    };
    var closeList = function () {
        var _a;
        if (state.openList) {
            setState(__assign(__assign({}, state), { openList: false }));
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var handleMouseUp = function (e) {
        var _a;
        if ((buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) !== null && ((_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            return;
        }
        else {
            closeList();
        }
    };
    var handleFocus = function () {
        if (onFocus) {
            onFocus(selected, buttonString);
        }
    };
    var handleBlur = function () {
        if (onBlur) {
            onBlur(selected, buttonString);
        }
    };
    var handleClick = function () {
        if (state.openList) {
            closeList();
        }
        else {
            handleOpenList();
        }
    };
    var handleSelect = function (index, item) {
        var _a;
        if (onChange) {
            onChange(index, item);
        }
        setState(__assign(__assign({}, state), { buttonString: item, openList: false, selected: index, current: index }));
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var keyDownSelect = function (e) {
        if (onKeyDown) {
            onKeyDown(e);
        }
        e.preventDefault();
        if (keyPress.KeyPress.tabIsPressed(e)) {
            closeList();
        }
        else if (keyPress.KeyPress.downArrowIsPressed(e)) {
            if (current < menuOptions.length - 1) {
                setState(__assign(__assign({}, state), { current: current + 1 }));
            }
        }
        else if (keyPress.KeyPress.upArrowIsPressed(e)) {
            if (current > 0) {
                setState(__assign(__assign({}, state), { current: current - 1 }));
            }
        }
        else if (keyPress.KeyPress.homeIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: 0 }));
        }
        else if (keyPress.KeyPress.endIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: menuOptions.length - 1 }));
        }
        else if (keyPress.KeyPress.pageUpIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current - 3 >= 0 ? current - 3 : 0 }));
        }
        else if (keyPress.KeyPress.pageDownIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current + 3 < menuOptions.length ? current + 3 : menuOptions.length - 1 }));
        }
        else if (keyPress.KeyPress.escIsPressed(e)) {
            closeList();
        }
        else if (keyPress.KeyPress.enterIsPressed(e)) {
            handleSelect(current, menuOptions[current].optionItem);
        }
    };
    return (React__default.createElement("div", { "data-testid": testId, ref: ref },
        React__default.createElement("button", { "data-dropdown-target": "demo-dropdown-" + uniqueId, className: "btn-primary-2 btn-dropdown " + (buttonSize === 'small' ? 'btn-small' : ''), type: "button", "aria-pressed": "false", onClick: handleClick, onFocus: handleFocus, onBlur: handleBlur, ref: buttonRef, disabled: disabled === true },
            buttonTitle,
            React__default.createElement("span", { ref: function (element) {
                    if (element) {
                        element.style.setProperty('margin-left', '8px', 'important');
                    }
                }, className: (disabled === true ? styles$n.iconChevronGray : styles$n.iconChevronWhite) + " " + styles$n.animate + " height-sm-all width-sm-all .mar-l-xxs-sm " + (openList ? 'rotate180' : '') })),
        React__default.createElement("div", { className: "rel", style: { zIndex: openList ? 3 : -1 } },
            React__default.createElement("div", { id: "demo-dropdown-" + uniqueId, className: ["absolute z1 bg-ui-white border border-dark-gray radius-xs",
                    openList ? styles$n.dropdownOpen : styles$n.dropdownClose].join(' '), style: { 'minWidth': '200px' }, onKeyDown: keyDownSelect },
                React__default.createElement("ul", { role: "listbox" }, options === null || options === void 0 ? void 0 : options.menuOptions.map(function (item, index) {
                    return (React__default.createElement("li", { key: index, className: "option-list-item", role: "option", tabIndex: !openList ? -1 : current === index ? 0 : -1, "aria-selected": current === index, "aria-posinset": 1, ref: function (node) {
                            dataOptionsRef[index] = node;
                        }, onClick: handleSelect.bind(null, index, item.optionItem) }, item.optionItem));
                }))))));
});
exports.default = DropdownButton;
});

var DropdownButton = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = DropdownButton_1.default;
});

var hrule = "HorizontalRule_hrule__rnQux";
var css_248z$t = ".HorizontalRule_hrule__rnQux {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  padding: 0;\n  border: none;\n  position: relative;\n  min-height: 1px; }\n\n.HorizontalRule_hrule__rnQux:before {\n  align-self: center;\n  background-color: #dcdfe3;\n  content: \"\";\n  display: flex;\n  height: 1px;\n  width: 100%;\n  position: absolute; }\n\n.HorizontalRule_hrule__rnQux:after {\n  align-self: center;\n  background-color: #ffffff;\n  content: attr(aria-label);\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n  padding-left: 8px;\n  padding-right: 8px;\n  text-align: center;\n  z-index: 1; }\n\nhr.on-dark:before {\n  background-color: #454b52; }\n\nhr.on-dark:after {\n  background-color: #1d2329; }\n";
var HorizontalRule$1 = {"hrule":"HorizontalRule_hrule__rnQux"};
var stylesheet$q=".HorizontalRule_hrule__rnQux {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  padding: 0;\n  border: none;\n  position: relative;\n  min-height: 1px; }\n\n.HorizontalRule_hrule__rnQux:before {\n  align-self: center;\n  background-color: #dcdfe3;\n  content: \"\";\n  display: flex;\n  height: 1px;\n  width: 100%;\n  position: absolute; }\n\n.HorizontalRule_hrule__rnQux:after {\n  align-self: center;\n  background-color: #ffffff;\n  content: attr(aria-label);\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n  padding-left: 8px;\n  padding-right: 8px;\n  text-align: center;\n  z-index: 1; }\n\nhr.on-dark:before {\n  background-color: #454b52; }\n\nhr.on-dark:after {\n  background-color: #1d2329; }\n";
styleInject(css_248z$t);

var HorizontalRule$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    hrule: hrule,
    'default': HorizontalRule$1,
    stylesheet: stylesheet$q
});

var styles$m = /*@__PURE__*/getAugmentedNamespace(HorizontalRule$2);

var HorizontalRule_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



var HorizontalRule = function (_a) {
    var centerWord = _a.centerWord, testId = _a.testId, onDark = _a.onDark, className = _a.className, ariaHidden = _a.ariaHidden;
    className = className ? className : "type-xs font-medium";
    var classes = onDark
        ? Join.join("on-dark", "color-ui-gray", className, styles$m.hrule)
        : Join.join("color-ui-black", className, styles$m.hrule);
    return (React__default.createElement("hr", { className: classes, "data-testid": testId, "aria-label": centerWord ? centerWord : undefined, "aria-hidden": ariaHidden ? ariaHidden : undefined }));
};
exports.default = HorizontalRule;
});

var HorizontalRule = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = HorizontalRule_1.default;
});

var borderRadiusIcon = "IconButton_border-radius-icon__r2JP3";
var curOnly = "IconButton_cur-only__BTksh";
var nfGrayBgColor = "IconButton_nf-gray-bg-color__yM2-2";
var wfCobaltBgColor = "IconButton_wf-cobalt-bg-color__LngB8";
var toltipbtn = "IconButton_toltipbtn__eEwSo";
var cirDisabled = "IconButton_cir-disabled__QNGRh";
var smtabarea = "IconButton_smtabarea__JWmhp";
var mdtabarea = "IconButton_mdtabarea__LQvzD";
var css_248z$s = ".IconButton_border-radius-icon__r2JP3 {\n  border-radius: 50%; }\n\n.is-tabbing .IconButton_cur-only__BTksh {\n  outline-offset: 3px !important; }\n  .is-tabbing .IconButton_cur-only__BTksh:hover .IconButton_nf-gray-bg-color__yM2-2 {\n    background-color: #f2f2f2 !important; }\n  .is-tabbing .IconButton_cur-only__BTksh:hover .IconButton_wf-cobalt-bg-color__LngB8 {\n    background-color: #007AE2 !important; }\n\n.is-tabbing .IconButton_toltipbtn__eEwSo:focus {\n  color: #0057b8;\n  outline: 1px dotted currentColor !important;\n  outline-offset: 3px; }\n\n.IconButton_cur-only__BTksh:hover .IconButton_nf-gray-bg-color__yM2-2 {\n  background-color: #f2f2f2 !important; }\n\n.IconButton_cur-only__BTksh:hover .IconButton_wf-cobalt-bg-color__LngB8 {\n  background-color: #007AE2 !important; }\n\n.IconButton_cir-disabled__QNGRh {\n  cursor: not-allowed !important;\n  outline: none !important; }\n\n.IconButton_toltipbtn__eEwSo:focus {\n  outline: none !important; }\n\n@media (max-width: 767px) {\n  .IconButton_smtabarea__JWmhp {\n    padding: 10px; }\n  .IconButton_mdtabarea__LQvzD {\n    padding: 6px; } }\n";
var IconButton$1 = {"border-radius-icon":"IconButton_border-radius-icon__r2JP3","cur-only":"IconButton_cur-only__BTksh","nf-gray-bg-color":"IconButton_nf-gray-bg-color__yM2-2","wf-cobalt-bg-color":"IconButton_wf-cobalt-bg-color__LngB8","toltipbtn":"IconButton_toltipbtn__eEwSo","cir-disabled":"IconButton_cir-disabled__QNGRh","smtabarea":"IconButton_smtabarea__JWmhp","mdtabarea":"IconButton_mdtabarea__LQvzD","borderRadiusIcon":"IconButton_border-radius-icon__r2JP3","curOnly":"IconButton_cur-only__BTksh","nfGrayBgColor":"IconButton_nf-gray-bg-color__yM2-2","wfCobaltBgColor":"IconButton_wf-cobalt-bg-color__LngB8","cirDisabled":"IconButton_cir-disabled__QNGRh"};
var stylesheet$p=".IconButton_border-radius-icon__r2JP3 {\n  border-radius: 50%; }\n\n.is-tabbing .IconButton_cur-only__BTksh {\n  outline-offset: 3px !important; }\n  .is-tabbing .IconButton_cur-only__BTksh:hover .IconButton_nf-gray-bg-color__yM2-2 {\n    background-color: #f2f2f2 !important; }\n  .is-tabbing .IconButton_cur-only__BTksh:hover .IconButton_wf-cobalt-bg-color__LngB8 {\n    background-color: #007AE2 !important; }\n\n.is-tabbing .IconButton_toltipbtn__eEwSo:focus {\n  color: #0057b8;\n  outline: 1px dotted currentColor !important;\n  outline-offset: 3px; }\n\n.IconButton_cur-only__BTksh:hover .IconButton_nf-gray-bg-color__yM2-2 {\n  background-color: #f2f2f2 !important; }\n\n.IconButton_cur-only__BTksh:hover .IconButton_wf-cobalt-bg-color__LngB8 {\n  background-color: #007AE2 !important; }\n\n.IconButton_cir-disabled__QNGRh {\n  cursor: not-allowed !important;\n  outline: none !important; }\n\n.IconButton_toltipbtn__eEwSo:focus {\n  outline: none !important; }\n\n@media (max-width: 767px) {\n  .IconButton_smtabarea__JWmhp {\n    padding: 10px; }\n  .IconButton_mdtabarea__LQvzD {\n    padding: 6px; } }\n";
styleInject(css_248z$s);

var IconButton$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    borderRadiusIcon: borderRadiusIcon,
    curOnly: curOnly,
    nfGrayBgColor: nfGrayBgColor,
    wfCobaltBgColor: wfCobaltBgColor,
    toltipbtn: toltipbtn,
    cirDisabled: cirDisabled,
    smtabarea: smtabarea,
    mdtabarea: mdtabarea,
    'default': IconButton$1,
    stylesheet: stylesheet$p
});

var styles$l = /*@__PURE__*/getAugmentedNamespace(IconButton$2);

var IconButton_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });




var enterIsPressed = keyPress.KeyPress.enterIsPressed;
var IconButton = function (_a) {
    var data = _a.data, testId = _a.testId, options = _a.options, events = _a.events;
    var sizeClass;
    var size = (data === null || data === void 0 ? void 0 : data.size) ? data === null || data === void 0 ? void 0 : data.size : '';
    var url = (data === null || data === void 0 ? void 0 : data.url) ? data === null || data === void 0 ? void 0 : data.url : '';
    var icon = (data === null || data === void 0 ? void 0 : data.icon) ? data === null || data === void 0 ? void 0 : data.icon : '';
    var labelText = (data === null || data === void 0 ? void 0 : data.labelText) ? data === null || data === void 0 ? void 0 : data.labelText : '';
    var disabled = (options === null || options === void 0 ? void 0 : options.disabled) ? options === null || options === void 0 ? void 0 : options.disabled : false;
    var isButtonFace = (options === null || options === void 0 ? void 0 : options.isButtonFace) === false ? false : true;
    var optClass = (options === null || options === void 0 ? void 0 : options.className) ? options === null || options === void 0 ? void 0 : options.className : '';
    var btnRole = (options === null || options === void 0 ? void 0 : options.role) ? options === null || options === void 0 ? void 0 : options.role : undefined;
    var isTooltip = (options === null || options === void 0 ? void 0 : options.isTooltip) ? true : false;
    var ariaLabel = (options === null || options === void 0 ? void 0 : options.ariaLabel) ? options === null || options === void 0 ? void 0 : options.ariaLabel : '';
    switch (size) {
        case 'extraLarge':
            sizeClass = 'width-xl-all height-xl-all';
            break;
        case 'large':
            sizeClass = 'width-lg-all height-lg-all';
            break;
        case 'medium':
            sizeClass = 'width-md-all height-md-all';
            break;
        case 'small':
            sizeClass = 'width-sm-all height-sm-all';
            break;
    }
    var backColor = (options === null || options === void 0 ? void 0 : options.bgIconColor) ? options === null || options === void 0 ? void 0 : options.bgIconColor : '';
    var btnWithoutLable = '';
    var focusBorderClass = '';
    var lableColorClass = 'color-functional-blue';
    var disabledClass = '';
    var anchorClass = '';
    var iconDivClass = '';
    if (!labelText) {
        if (disabled) {
            disabledClass = styles$l.cirDisabled;
            btnWithoutLable = '';
            if (!isButtonFace) {
                backColor = '';
            }
        }
        else {
            btnWithoutLable = styles$l.curOnly;
            if (!isButtonFace) {
                focusBorderClass = backColor === 'bg-ui-background-gray' ? styles$l.nfGrayBgColor : '';
                backColor = '';
            }
            else {
                focusBorderClass = backColor === 'bg-ui-background-gray' ? '' : styles$l.wfCobaltBgColor;
            }
        }
        var tabareaClass = '';
        if (!disabled && (size === 'small' || size === 'medium')) {
            tabareaClass = size === 'small' ? styles$l.smtabarea : styles$l.mdtabarea;
        }
        anchorClass = ["inline-flex flex-column flex-items-center", disabledClass, tabareaClass, btnWithoutLable].join(" ");
        iconDivClass = ["text-center", styles$l.borderRadiusIcon, focusBorderClass, backColor, sizeClass].join(" ");
    }
    else {
        if (!isButtonFace) {
            btnWithoutLable = styles$l.curOnly;
            focusBorderClass = backColor === 'bg-ui-background-gray' ? [styles$l.nfGrayBgColor].join(" ") : '';
            backColor = '';
        }
        else {
            btnWithoutLable = styles$l.curOnly;
            focusBorderClass = backColor === 'bg-ui-background-gray' ? '' : [styles$l.wfCobaltBgColor].join(" ");
        }
        if (disabled) {
            disabledClass = styles$l.cirDisabled;
            lableColorClass = 'color-ui-gray';
            btnWithoutLable = '';
        }
        anchorClass = ["inline-flex flex-column flex-items-center", disabledClass, btnWithoutLable, 'no-hover'].join(" ");
        iconDivClass = ["text-center", styles$l.borderRadiusIcon, focusBorderClass, backColor, sizeClass].join(" ");
    }
    var handleClick = function (e) {
        if (disabled) {
            return false;
        }
        if (e.type === 'click' && !url) {
            if (events.onClick) {
                events.onClick(e);
            }
        }
    };
    var handleKeyPress = function (e) {
        if (disabled) {
            return false;
        }
        if (enterIsPressed(e) || e.keyCode === 32) {
            e.stopPropagation();
            e.preventDefault();
            if (url) {
                window.location.href = url;
            }
            else {
                if (events.onClick) {
                    events.onClick(e);
                }
            }
        }
    };
    return ((!isTooltip) ? (React__default.createElement("a", __assign({ "data-testid": testId, className: anchorClass + " " + optClass }, { "aria-label": ariaLabel ? ariaLabel : undefined }, { tabIndex: !disabled ? 0 : -1 }, { href: !url ? 'javascript:void(0)' : url }, { role: !btnRole ? undefined : btnRole }, { onClick: url ? undefined : handleClick }, { onKeyDown: handleKeyPress }),
        React__default.createElement("div", { className: iconDivClass }, icon),
        labelText ? React__default.createElement("span", { className: "line-h-md type-sm " + lableColorClass }, labelText) : '')) :
        (React__default.createElement(BaseCta$1.BaseCta, __assign({ className: "" + styles$l.toltipbtn }, { "aria-label": ariaLabel ? ariaLabel : undefined }),
            React__default.createElement("div", { className: iconDivClass }, icon),
            labelText ? React__default.createElement("span", { className: "line-h-md type-sm " + lableColorClass }, labelText) : '')));
};
exports.default = IconButton;
});

var IconButton = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = IconButton_1.default;
});

var Legal_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });


var Legal = function (_a) {
    var data = _a.data, _b = _a.options, options = _b === void 0 ? {} : _b, testId = _a.testId;
    return (React__default.createElement("div", { "data-testid": testId, className: (options === null || options === void 0 ? void 0 : options.onDark) ? "color-ui-white" : "color-ui-black" },
        React__default.createElement("div", { className: (options.className || "") + " type-legal" },
            data.legalText,
            (options === null || options === void 0 ? void 0 : options.linkProps) && (React__default.createElement("span", null,
                React__default.createElement(Link.default, __assign({}, options === null || options === void 0 ? void 0 : options.linkProps), options.legalLinkText))))));
};
exports.default = Legal;
});

var Legal = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Legal_1.default;
});

var LinkList_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });





/**
 * A list of utility links, styled according to global styles.
 */
var LinkList = function (props) {
    var _a = Simplify.simplify(props), links = _a.links, _b = _a.kind, kind = _b === void 0 ? "utilitySecondary" : _b, _c = _a.onDark, onDark = _c === void 0 ? false : _c, position = _a.position, style = _a.style, className = _a.className, testId = _a.testId;
    var linkElements = FlatFilter.flatfilter(links).map(function (link, index) { return (React__default.createElement("li", { className: "border-bottom border-light-gray", "data-testid": testId, key: link.children || "link " + index },
        React__default.createElement(Link.default, __assign({ onDark: onDark, position: position, className: Join.join("flex", "justify-between", "solo", link.className), kind: kind }, link)))); });
    return linkElements.length > 0 ? (React__default.createElement("ul", { className: Join.join("link-utility-list", className), "data-testid": testId, style: style }, linkElements)) : null;
};
exports.default = LinkList;
});

var LinkList = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = LinkList_1.default;
});

var bullet = "Lists_bullet__L0XMc";
var bulletSvg = "Lists_bullet-svg__iM-oh";
var bulletSvgSm = "Lists_bullet-svg-sm__EyURn";
var bulletSvgLg = "Lists_bullet-svg-lg__iUuOc";
var typeBase = "Lists_type-base__9ga9P";
var typeSm = "Lists_type-sm__RY3Ec";
var typeXs = "Lists_type-xs__sK8Wx";
var typeXxs = "Lists_type-xxs__daU90";
var typeXxxs = "Lists_type-xxxs__31iGK";
var white = "Lists_white__xd9AQ";
var typeMd = "Lists_type-md__O2HOb";
var css_248z$r = ".Lists_bullet__L0XMc,\n.Lists_bullet-svg__iM-oh,\n.Lists_bullet-svg-sm__EyURn,\n.Lists_bullet-svg-lg__iUuOc,\nol {\n  margin-left: 8px; }\n\n.Lists_bullet__L0XMc .Lists_bullet__L0XMc,\n.Lists_bullet-svg__iM-oh .Lists_bullet-svg__iM-oh,\n.Lists_bullet-svg-sm__EyURn .Lists_bullet-svg-sm__EyURn,\n.Lists_bullet-svg-lg__iUuOc .Lists_bullet-svg-lg__iUuOc,\nol ol {\n  margin-left: 0 !important; }\n\n.Lists_bullet__L0XMc > li,\n.Lists_bullet-svg__iM-oh > li,\n.Lists_bullet-svg-sm__EyURn > li,\n.Lists_bullet-svg-lg__iUuOc > li {\n  padding-left: 28px;\n  position: relative; }\n\n.Lists_bullet__L0XMc .Lists_bullet__L0XMc,\n.Lists_bullet__L0XMc > li + li,\nol ol,\nol > li + li {\n  margin-top: 8px; }\n\nol li {\n  margin-left: 24px;\n  padding-left: 4px; }\n\nol ol li {\n  list-style-type: lower-alpha; }\n\nol ol.Lists_bullet__L0XMc li {\n  list-style-type: none;\n  margin-left: 0; }\n\n.Lists_bullet__L0XMc > li:before {\n  background-color: #1d2329;\n  border: 1px solid #1d2329;\n  border-radius: 100%;\n  content: \"\";\n  display: block;\n  height: 6px;\n  left: 9px;\n  position: absolute;\n  width: 6px;\n  line-height: 1em; }\n\n.Lists_bullet__L0XMc .Lists_bullet__L0XMc > li:before,\nol ol.Lists_bullet__L0XMc li:before {\n  background-color: transparent; }\n\n.Lists_bullet__L0XMc,\n.Lists_bullet__L0XMc.Lists_type-base__9ga9P {\n  line-height: 28px; }\n\n.Lists_bullet__L0XMc.Lists_type-sm__RY3Ec {\n  line-height: 24px; }\n\n.Lists_bullet__L0XMc.Lists_type-xs__sK8Wx {\n  line-height: 14px; }\n\n.Lists_bullet__L0XMc.Lists_type-xxs__daU90 {\n  line-height: 14px; }\n\n.Lists_bullet__L0XMc.Lists_type-xxxs__31iGK {\n  line-height: 12px; }\n\n.Lists_bullet__L0XMc li:before,\n.Lists_bullet__L0XMc.Lists_type-base__9ga9P li:before {\n  top: calc(((1em * 1.6) / 2) - 2.5px); }\n\n.Lists_bullet__L0XMc.Lists_type-sm__RY3Ec li:before {\n  top: calc(((1em * 1.6) / 2) - 2px); }\n\n.Lists_bullet__L0XMc.Lists_type-xs__sK8Wx li:before {\n  top: calc(((1em * 1.2) / 2) - 2.5px); }\n\n.Lists_bullet__L0XMc.Lists_type-xxs__daU90 li:before {\n  top: calc(((1em * 1.2) / 2) - 2px); }\n\n.Lists_bullet__L0XMc.Lists_type-xxxs__31iGK li:before {\n  top: calc(((1em * 1.2) / 2) - 1.5px); }\n\n.Lists_bullet__L0XMc.Lists_type-xs__sK8Wx li,\n.Lists_bullet__L0XMc.Lists_type-xxs__daU90 li,\n.Lists_bullet__L0XMc.Lists_type-xxxs__31iGK li {\n  padding-left: 24px; }\n\n.Lists_bullet__L0XMc.Lists_type-xs__sK8Wx li:before,\n.Lists_bullet__L0XMc.Lists_type-xxs__daU90 li:before,\n.Lists_bullet__L0XMc.Lists_type-xxxs__31iGK li:before {\n  height: 4px;\n  width: 4px; }\n\n.Lists_bullet__L0XMc.Lists_white__xd9AQ > li:before {\n  background-color: #fff;\n  border: 3px solid #fff; }\n\n.Lists_bullet-svg__iM-oh li + li,\n.Lists_bullet-svg-sm__EyURn li + li,\n.Lists_bullet-svg-lg__iUuOc li + li {\n  margin-top: 8px; }\n\n.Lists_bullet-svg__iM-oh li svg,\n.Lists_bullet-svg-sm__EyURn li svg,\n.Lists_bullet-svg-lg__iUuOc li svg {\n  left: 0;\n  position: absolute; }\n\n.Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb li + li,\n.Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec li + li {\n  margin-top: 16px; }\n\n.Lists_bullet-svg__iM-oh:not(.Lists_type-md__O2HOb) li + li {\n  margin-top: 8px; }\n\n@media (min-width: 1025px) {\n  .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li {\n    padding-left: 56px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li svg {\n      top: -8px;\n      height: 48px;\n      width: 48px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li {\n    padding-left: 40px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li svg {\n      top: -2px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P > li {\n    padding-left: 32px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P > li svg {\n      top: 3px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec > li {\n    padding-left: 40px; }\n    .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec > li svg {\n      top: -2px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec > li {\n    padding-left: 32px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec > li svg {\n      top: 1px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec > li {\n    padding-left: 20px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec > li svg {\n      top: 5px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx > li {\n    padding-left: 20px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx > li svg {\n      top: -1px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 > li {\n    padding-left: 20px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 > li svg {\n      top: -2px;\n      height: 16px;\n      width: 16px; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li {\n    padding-left: 40px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb li svg {\n    top: -1px;\n    height: 32px;\n    width: 32px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li {\n    padding-left: 40px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li svg {\n      top: -3px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P li {\n    padding-left: 32px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P li svg {\n      top: 2px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec > li {\n    padding-left: 40px; }\n    .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec > li svg {\n      top: -2px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec > li {\n    padding-left: 32px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec > li svg {\n      top: 0;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec > li {\n    padding-left: 24px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec > li svg {\n      top: 4px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx li {\n    padding-left: 24px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx li svg {\n      top: -1px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 li {\n    padding-left: 24px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 li svg {\n      top: -3px;\n      height: 16px;\n      width: 16px; } }\n\n@media (max-width: 767px) {\n  .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li,\n  .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li,\n  .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P li {\n    padding-left: 32px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li svg,\n    .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li svg,\n    .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P li svg {\n      top: 1px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec li {\n    padding-left: 40px; }\n    .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec li svg {\n      top: -5px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec li {\n    padding-left: 32px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec li svg {\n      top: -1px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec li {\n    padding-left: 24px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec li svg {\n      top: 3px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx li,\n  .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 li {\n    padding-left: 20px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx li svg,\n    .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 li svg {\n      top: 0px;\n      height: 16px;\n      width: 16px; } }\n";
var Lists$1 = {"bullet":"Lists_bullet__L0XMc","bullet-svg":"Lists_bullet-svg__iM-oh","bullet-svg-sm":"Lists_bullet-svg-sm__EyURn","bullet-svg-lg":"Lists_bullet-svg-lg__iUuOc","type-base":"Lists_type-base__9ga9P","type-sm":"Lists_type-sm__RY3Ec","type-xs":"Lists_type-xs__sK8Wx","type-xxs":"Lists_type-xxs__daU90","type-xxxs":"Lists_type-xxxs__31iGK","white":"Lists_white__xd9AQ","type-md":"Lists_type-md__O2HOb","bulletSvg":"Lists_bullet-svg__iM-oh","bulletSvgSm":"Lists_bullet-svg-sm__EyURn","bulletSvgLg":"Lists_bullet-svg-lg__iUuOc","typeBase":"Lists_type-base__9ga9P","typeSm":"Lists_type-sm__RY3Ec","typeXs":"Lists_type-xs__sK8Wx","typeXxs":"Lists_type-xxs__daU90","typeXxxs":"Lists_type-xxxs__31iGK","typeMd":"Lists_type-md__O2HOb"};
var stylesheet$o=".Lists_bullet__L0XMc,\n.Lists_bullet-svg__iM-oh,\n.Lists_bullet-svg-sm__EyURn,\n.Lists_bullet-svg-lg__iUuOc,\nol {\n  margin-left: 8px; }\n\n.Lists_bullet__L0XMc .Lists_bullet__L0XMc,\n.Lists_bullet-svg__iM-oh .Lists_bullet-svg__iM-oh,\n.Lists_bullet-svg-sm__EyURn .Lists_bullet-svg-sm__EyURn,\n.Lists_bullet-svg-lg__iUuOc .Lists_bullet-svg-lg__iUuOc,\nol ol {\n  margin-left: 0 !important; }\n\n.Lists_bullet__L0XMc > li,\n.Lists_bullet-svg__iM-oh > li,\n.Lists_bullet-svg-sm__EyURn > li,\n.Lists_bullet-svg-lg__iUuOc > li {\n  padding-left: 28px;\n  position: relative; }\n\n.Lists_bullet__L0XMc .Lists_bullet__L0XMc,\n.Lists_bullet__L0XMc > li + li,\nol ol,\nol > li + li {\n  margin-top: 8px; }\n\nol li {\n  margin-left: 24px;\n  padding-left: 4px; }\n\nol ol li {\n  list-style-type: lower-alpha; }\n\nol ol.Lists_bullet__L0XMc li {\n  list-style-type: none;\n  margin-left: 0; }\n\n.Lists_bullet__L0XMc > li:before {\n  background-color: #1d2329;\n  border: 1px solid #1d2329;\n  border-radius: 100%;\n  content: \"\";\n  display: block;\n  height: 6px;\n  left: 9px;\n  position: absolute;\n  width: 6px;\n  line-height: 1em; }\n\n.Lists_bullet__L0XMc .Lists_bullet__L0XMc > li:before,\nol ol.Lists_bullet__L0XMc li:before {\n  background-color: transparent; }\n\n.Lists_bullet__L0XMc,\n.Lists_bullet__L0XMc.Lists_type-base__9ga9P {\n  line-height: 28px; }\n\n.Lists_bullet__L0XMc.Lists_type-sm__RY3Ec {\n  line-height: 24px; }\n\n.Lists_bullet__L0XMc.Lists_type-xs__sK8Wx {\n  line-height: 14px; }\n\n.Lists_bullet__L0XMc.Lists_type-xxs__daU90 {\n  line-height: 14px; }\n\n.Lists_bullet__L0XMc.Lists_type-xxxs__31iGK {\n  line-height: 12px; }\n\n.Lists_bullet__L0XMc li:before,\n.Lists_bullet__L0XMc.Lists_type-base__9ga9P li:before {\n  top: calc(((1em * 1.6) / 2) - 2.5px); }\n\n.Lists_bullet__L0XMc.Lists_type-sm__RY3Ec li:before {\n  top: calc(((1em * 1.6) / 2) - 2px); }\n\n.Lists_bullet__L0XMc.Lists_type-xs__sK8Wx li:before {\n  top: calc(((1em * 1.2) / 2) - 2.5px); }\n\n.Lists_bullet__L0XMc.Lists_type-xxs__daU90 li:before {\n  top: calc(((1em * 1.2) / 2) - 2px); }\n\n.Lists_bullet__L0XMc.Lists_type-xxxs__31iGK li:before {\n  top: calc(((1em * 1.2) / 2) - 1.5px); }\n\n.Lists_bullet__L0XMc.Lists_type-xs__sK8Wx li,\n.Lists_bullet__L0XMc.Lists_type-xxs__daU90 li,\n.Lists_bullet__L0XMc.Lists_type-xxxs__31iGK li {\n  padding-left: 24px; }\n\n.Lists_bullet__L0XMc.Lists_type-xs__sK8Wx li:before,\n.Lists_bullet__L0XMc.Lists_type-xxs__daU90 li:before,\n.Lists_bullet__L0XMc.Lists_type-xxxs__31iGK li:before {\n  height: 4px;\n  width: 4px; }\n\n.Lists_bullet__L0XMc.Lists_white__xd9AQ > li:before {\n  background-color: #fff;\n  border: 3px solid #fff; }\n\n.Lists_bullet-svg__iM-oh li + li,\n.Lists_bullet-svg-sm__EyURn li + li,\n.Lists_bullet-svg-lg__iUuOc li + li {\n  margin-top: 8px; }\n\n.Lists_bullet-svg__iM-oh li svg,\n.Lists_bullet-svg-sm__EyURn li svg,\n.Lists_bullet-svg-lg__iUuOc li svg {\n  left: 0;\n  position: absolute; }\n\n.Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb li + li,\n.Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec li + li {\n  margin-top: 16px; }\n\n.Lists_bullet-svg__iM-oh:not(.Lists_type-md__O2HOb) li + li {\n  margin-top: 8px; }\n\n@media (min-width: 1025px) {\n  .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li {\n    padding-left: 56px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li svg {\n      top: -8px;\n      height: 48px;\n      width: 48px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li {\n    padding-left: 40px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li svg {\n      top: -2px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P > li {\n    padding-left: 32px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P > li svg {\n      top: 3px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec > li {\n    padding-left: 40px; }\n    .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec > li svg {\n      top: -2px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec > li {\n    padding-left: 32px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec > li svg {\n      top: 1px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec > li {\n    padding-left: 20px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec > li svg {\n      top: 5px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx > li {\n    padding-left: 20px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx > li svg {\n      top: -1px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 > li {\n    padding-left: 20px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 > li svg {\n      top: -2px;\n      height: 16px;\n      width: 16px; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li {\n    padding-left: 40px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb li svg {\n    top: -1px;\n    height: 32px;\n    width: 32px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li {\n    padding-left: 40px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li svg {\n      top: -3px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P li {\n    padding-left: 32px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P li svg {\n      top: 2px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec > li {\n    padding-left: 40px; }\n    .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec > li svg {\n      top: -2px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec > li {\n    padding-left: 32px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec > li svg {\n      top: 0;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec > li {\n    padding-left: 24px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec > li svg {\n      top: 4px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx li {\n    padding-left: 24px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx li svg {\n      top: -1px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 li {\n    padding-left: 24px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 li svg {\n      top: -3px;\n      height: 16px;\n      width: 16px; } }\n\n@media (max-width: 767px) {\n  .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li,\n  .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li,\n  .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P li {\n    padding-left: 32px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-md__O2HOb > li svg,\n    .Lists_bullet-svg__iM-oh.Lists_type-base__9ga9P > li svg,\n    .Lists_bullet-svg-sm__EyURn.Lists_type-base__9ga9P li svg {\n      top: 1px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec li {\n    padding-left: 40px; }\n    .Lists_bullet-svg-lg__iUuOc.Lists_type-sm__RY3Ec li svg {\n      top: -5px;\n      height: 32px;\n      width: 32px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec li {\n    padding-left: 32px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-sm__RY3Ec li svg {\n      top: -1px;\n      height: 24px;\n      width: 24px; }\n  .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec li {\n    padding-left: 24px; }\n    .Lists_bullet-svg-sm__EyURn.Lists_type-sm__RY3Ec li svg {\n      top: 3px;\n      height: 16px;\n      width: 16px; }\n  .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx li,\n  .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 li {\n    padding-left: 20px; }\n    .Lists_bullet-svg__iM-oh.Lists_type-xs__sK8Wx li svg,\n    .Lists_bullet-svg__iM-oh.Lists_type-xxs__daU90 li svg {\n      top: 0px;\n      height: 16px;\n      width: 16px; } }\n";
styleInject(css_248z$r);

var Lists$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    bullet: bullet,
    bulletSvg: bulletSvg,
    bulletSvgSm: bulletSvgSm,
    bulletSvgLg: bulletSvgLg,
    typeBase: typeBase,
    typeSm: typeSm,
    typeXs: typeXs,
    typeXxs: typeXxs,
    typeXxxs: typeXxxs,
    white: white,
    typeMd: typeMd,
    'default': Lists$1,
    stylesheet: stylesheet$o
});

var styles$k = /*@__PURE__*/getAugmentedNamespace(Lists$2);

var Lists_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


var Lists = function (_a) {
    var data = _a.data, testId = _a.testId;
    var ListType = data.type === "unordered" ||
        data.type === "unordered-svg" ||
        data.type === "unordered-svg-lg" ||
        data.type === "unordered-svg-sm"
        ? "ul"
        : "ol";
    /* Created variable to check the icon class and font class given as iput follow rules */
    var bulletClass = data.type === "unordered"
        ? "" + styles$k.bullet
        : data.type === "unordered-svg"
            ? "" + styles$k.bulletSvg
            : data.type === "unordered-svg-sm" &&
                data.fontClassName !== "type-xs" &&
                data.fontClassName !== "type-xxs"
                ? "" + styles$k.bulletSvgSm
                : data.type === "unordered-svg-lg" && data.fontClassName === "type-sm"
                    ? "" + styles$k.bulletSvgLg
                    : "";
    return (React__default.createElement(ListType, { className: data.fontClassName + " " + (data.paddingClassName ? data.paddingClassName + " " : "") + (data.marginClassName ? data.marginClassName + " " : "") + bulletClass + " " + (data.fontClassName === "type-md"
            ? "" + styles$k.typeMd
            : data.fontClassName === "type-sm"
                ? "" + styles$k.typeSm
                : data.fontClassName === "type-xs"
                    ? "" + styles$k.typeXs
                    : data.fontClassName === "type-xxs"
                        ? "" + styles$k.typeXxs
                        : data.fontClassName === "type-xxxs"
                            ? "" + styles$k.typeXxxs
                            : "" + styles$k.typeBase), "data-testid": testId }, data.lists.map(function (item, i) { return (React__default.createElement("li", { key: i },
        bulletClass.length > 1 && item.icon ? item.icon : null,
        item.text,
        item.textChild ? (React__default.createElement(ListType, { className: data.fontClassName + " " + (data.childPaddingClassName ? data.childPaddingClassName + " " : "") + (data.childMarginClassName ? data.childMarginClassName + " " : "") + (data.type === "unordered"
                ? "" + styles$k.bullet
                : data.type === "ordered-alt"
                    ? "" + styles$k.bullet
                    : "") + " " + (data.fontClassName === "type-md"
                ? "" + styles$k.typeMd
                : data.fontClassName === "type-sm"
                    ? "" + styles$k.typeSm
                    : data.fontClassName === "type-xs"
                        ? "" + styles$k.typeXs
                        : data.fontClassName === "type-xxs"
                            ? "" + styles$k.typeXxs
                            : data.fontClassName === "type-xxxs"
                                ? "" + styles$k.typeXxxs
                                : "" + styles$k.typeBase) }, item.textChild.map(function (childItem, index) { return (React__default.createElement("li", { key: index }, childItem)); }))) : null)); })));
};
exports.default = Lists;
});

var Lists = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Lists_1.default;
});

var tagsCont = "Tag_tagsCont__aRPc-";
var tagsButton = "Tag_tagsButton__mUHXr";
var tagsButtonOutline = "Tag_tagsButtonOutline__vi-9U";
var tagsButtonSelected = "Tag_tagsButtonSelected__bzCx2";
var tagsButtonUnSelected = "Tag_tagsButtonUnSelected__urbta";
var tagsButtonDisabled = "Tag_tagsButtonDisabled__D7Nc0";
var tagsButtonRemovable = "Tag_tagsButtonRemovable__ynCx2";
var tagsButtonRemoved = "Tag_tagsButtonRemoved__-A6pk";
var css_248z$q = ".Tag_tagsCont__aRPc- {\n  transition: margin-bottom 0s 0.3s, margin-right 0s 0.3s; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButton__mUHXr {\n    border-radius: 3px;\n    cursor: pointer;\n    min-height: 24px;\n    min-width: 48px;\n    max-width: 100%;\n    opacity: 1;\n    padding: 3.5px 8px;\n    transition: background-color 0.3s ease-in; }\n    .Tag_tagsCont__aRPc- .Tag_tagsButton__mUHXr:focus ~ .Tag_tagsButtonOutline__vi-9U {\n      display: block !important;\n      visibility: visible !important; }\n    .Tag_tagsCont__aRPc- .Tag_tagsButton__mUHXr svg {\n      height: 14px; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonSelected__bzCx2 {\n    border-color: #0057b8; }\n    .Tag_tagsCont__aRPc- .Tag_tagsButtonSelected__bzCx2:hover {\n      background-color: #007ae2 !important;\n      border-color: #007ae2 !important; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonUnSelected__urbta:hover {\n    border-color: #0057b8;\n    color: #0057b8; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonDisabled__D7Nc0,\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonDisabled__D7Nc0:hover {\n    border-color: #878c94;\n    color: #878c94;\n    cursor: not-allowed; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonRemovable__ynCx2 {\n    transition: margin 0s 0.3s, margin-right 0s 0.3s, min-width 0s 0.3s, max-width 0s 0.3s, opacity 0.3s 0s, padding 0s 0.3s, visibility 0s 0.3s !important; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonRemoved__-A6pk {\n    height: 0;\n    min-width: 0;\n    max-width: 0;\n    opacity: 0;\n    pointer-events: none;\n    visibility: hidden; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonOutline__vi-9U {\n    visibility: hidden;\n    top: -5px;\n    left: -5px;\n    border: 1px dotted #000000;\n    border-radius: 5px;\n    height: calc(100% + 10px);\n    width: calc(100% + 10px);\n    z-index: -1; }\n";
var Tag$1 = {"tagsCont":"Tag_tagsCont__aRPc-","tagsButton":"Tag_tagsButton__mUHXr","tagsButtonOutline":"Tag_tagsButtonOutline__vi-9U","tagsButtonSelected":"Tag_tagsButtonSelected__bzCx2","tagsButtonUnSelected":"Tag_tagsButtonUnSelected__urbta","tagsButtonDisabled":"Tag_tagsButtonDisabled__D7Nc0","tagsButtonRemovable":"Tag_tagsButtonRemovable__ynCx2","tagsButtonRemoved":"Tag_tagsButtonRemoved__-A6pk"};
var stylesheet$n=".Tag_tagsCont__aRPc- {\n  transition: margin-bottom 0s 0.3s, margin-right 0s 0.3s; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButton__mUHXr {\n    border-radius: 3px;\n    cursor: pointer;\n    min-height: 24px;\n    min-width: 48px;\n    max-width: 100%;\n    opacity: 1;\n    padding: 3.5px 8px;\n    transition: background-color 0.3s ease-in; }\n    .Tag_tagsCont__aRPc- .Tag_tagsButton__mUHXr:focus ~ .Tag_tagsButtonOutline__vi-9U {\n      display: block !important;\n      visibility: visible !important; }\n    .Tag_tagsCont__aRPc- .Tag_tagsButton__mUHXr svg {\n      height: 14px; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonSelected__bzCx2 {\n    border-color: #0057b8; }\n    .Tag_tagsCont__aRPc- .Tag_tagsButtonSelected__bzCx2:hover {\n      background-color: #007ae2 !important;\n      border-color: #007ae2 !important; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonUnSelected__urbta:hover {\n    border-color: #0057b8;\n    color: #0057b8; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonDisabled__D7Nc0,\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonDisabled__D7Nc0:hover {\n    border-color: #878c94;\n    color: #878c94;\n    cursor: not-allowed; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonRemovable__ynCx2 {\n    transition: margin 0s 0.3s, margin-right 0s 0.3s, min-width 0s 0.3s, max-width 0s 0.3s, opacity 0.3s 0s, padding 0s 0.3s, visibility 0s 0.3s !important; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonRemoved__-A6pk {\n    height: 0;\n    min-width: 0;\n    max-width: 0;\n    opacity: 0;\n    pointer-events: none;\n    visibility: hidden; }\n  .Tag_tagsCont__aRPc- .Tag_tagsButtonOutline__vi-9U {\n    visibility: hidden;\n    top: -5px;\n    left: -5px;\n    border: 1px dotted #000000;\n    border-radius: 5px;\n    height: calc(100% + 10px);\n    width: calc(100% + 10px);\n    z-index: -1; }\n";
styleInject(css_248z$q);

var Tag$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    tagsCont: tagsCont,
    tagsButton: tagsButton,
    tagsButtonOutline: tagsButtonOutline,
    tagsButtonSelected: tagsButtonSelected,
    tagsButtonUnSelected: tagsButtonUnSelected,
    tagsButtonDisabled: tagsButtonDisabled,
    tagsButtonRemovable: tagsButtonRemovable,
    tagsButtonRemoved: tagsButtonRemoved,
    'default': Tag$1,
    stylesheet: stylesheet$n
});

var styles$j = /*@__PURE__*/getAugmentedNamespace(Tag$2);

var Tag_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });



var Tag = function (_a) {
    var children = _a.children, _b = _a.events, events = _b === void 0 ? { onClick: function () { return null; } } : _b, _c = _a.options, options = _c === void 0 ? { type: "default" } : _c, hideFocus = _a.hideFocus, isLast = _a.isLast, setHideFocus = _a.setHideFocus, tagsType = _a.tagsType, testId = _a.testId, total = _a.total, overrideRemovableAccessibility = _a.overrideRemovableAccessibility;
    var _d = __read(React__default.useState({
        isRemoved: false,
        isSelected: options.defaultSelected ? options.defaultSelected : false,
    }), 2), state = _d[0], setState = _d[1];
    var isRemoved = state.isRemoved, isSelected = state.isSelected;
    var componentRef = React__default.createRef();
    var handleRemove = function () {
        if (testId && total) {
            var index = parseInt(testId.substring(testId.length - 1, testId.length), 10);
            if (total === index + 1) {
                var el = document.getElementById(testId.substring(0, testId.length - 1) + (index - 1));
                if (el) {
                    el.focus();
                }
            }
        }
    };
    var onClick = function () {
        if (options.type === "removable") {
            if (tagsType) {
                handleRemove();
            }
        }
        else if (options.selected === undefined) {
            setState(__assign(__assign({}, state), { isSelected: !isSelected }));
        }
        if (events.onClick) {
            events.onClick(options.type === "default"
                ? options.selected
                    ? options.selected
                    : isSelected
                : undefined);
        }
    };
    var onKeyDown = function (e) {
        if (setHideFocus) {
            setHideFocus(false);
        }
        if (options.type !== "disabled" && !isRemoved) {
            if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
                onClick();
            }
        }
    };
    var onKeyUp = function () {
        if (options.type !== "disabled" && !isRemoved) {
            if (setHideFocus) {
                setHideFocus(false);
            }
        }
    };
    return (React__default.createElement("div", { className: "" + styles$j.tagsCont + (" mar-b-xs " + (!isLast ? "mar-r-xs" : "")), "data-testid": testId },
        React__default.createElement("div", { className: "rel" },
            React__default.createElement("div", { "aria-checked": options.type !== "removable"
                    ? options.selected !== undefined
                        ? options.selected
                        : isSelected
                    : undefined, "aria-disabled": options.type === "disabled" ? true : undefined, className: "tag-button " + styles$j.tagsButton + " " + ((total && total < 1) ||
                    (options.type !== "disabled" &&
                        ((options.selected !== undefined ? options.selected : isSelected) ||
                            options.type === "removable"))
                    ? "bg-cobalt color-ui-white " + styles$j.tagsButtonSelected
                    : "bg-ui-white border-black " + styles$j.tagsButtonUnSelected) + (options.type === "disabled" ? " " + styles$j.tagsButtonDisabled : "") + (options.className ? " " + options.className : "") + (options.type === "removable" ? " " + styles$j.tagsButtonRemovable : "") + " border flex flex-1 flex-self-center flex-items-center font-medium justify-center rel type-xs mar-b-none", id: testId, ref: componentRef, role: tagsType === "default" ? "checkbox" : "button", onKeyDown: onKeyDown, onKeyUp: onKeyUp, onClick: onClick, tabIndex: 0 },
                children,
                options.type === "removable" ? (React__default.createElement("span", { className: "hidden-spoken" }, overrideRemovableAccessibility
                    ? overrideRemovableAccessibility
                    : " (press to remove)")) : null,
                options.type === "removable" ? React__default.createElement(CloseIcon, null) : null),
            !hideFocus && (React__default.createElement("span", { "aria-hidden": "true", className: "absolute hide " + styles$j.tagsButtonOutline })))));
};
var CloseIcon = function () { return (React__default.createElement("svg", { height: "14px", width: "14px", className: "mar-l-xxxs", style: { minHeight: 14, minWidth: 14 }, viewBox: "-18 32 36 36", "aria-hidden": "true", focusable: "false" },
    React__default.createElement("path", { fill: "#fff", d: "M-9.3 61.1c-.5 0-.9-.2-1.3-.5-.7-.7-.7-1.8 0-2.6L7.9 39.5c.7-.7 1.8-.7 2.6 0 .7.7.7 1.8 0 2.6L-8 60.5c-.4.4-.8.6-1.3.6zm18.5 0c-.5 0-.9-.2-1.3-.5l-18.5-18.5c-.7-.7-.7-1.8 0-2.6.7-.7 1.8-.7 2.6 0L10.5 58c.7.7.7 1.8 0 2.6-.4.3-.8.5-1.3.5z" }))); };
exports.default = Tag;
});

var Tag = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Tag_1.default;
});

var Tags_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });


var Tags = function (_a) {
    var data = _a.data, propEvents = _a.events, propOptions = _a.options, tagsType = _a.tagsType, propsTestId = _a.testId, overrideRemovableAccessibility = _a.overrideRemovableAccessibility, tagsGroupAriaLabel = _a.tagsGroupAriaLabel;
    var _b = __read(React__default.useState({
        hideFocus: true,
        removedArr: [],
        selectedArr: propOptions && propOptions.defaultSelected ? propOptions.defaultSelected : [],
    }), 2), state = _b[0], setState = _b[1];
    var setHideFocus = function (value) { return setState(__assign(__assign({}, state), { hideFocus: value })); };
    var removedArr = state.removedArr, selectedArr = state.selectedArr;
    var guid = function () { return "" + S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4(); };
    var S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    var uniqueId = guid();
    var updatedDataArr = data;
    var removalHandledExternally = propOptions && propOptions.isHandledExternally ? propOptions.isHandledExternally : false;
    return (React__default.createElement("div", { "aria-live": "polite", "aria-label": tagsGroupAriaLabel ? tagsGroupAriaLabel : undefined, className: "flex flex-wrap" + (propOptions && propOptions.className ? " " + propOptions.className : "") + " ", "data-testid": propsTestId, role: tagsType === "default" ? undefined : "group" }, updatedDataArr.map(function (item, index) {
        var children = item.children, events = item.events, options = item.options, testId = item.testId;
        var loc = selectedArr.indexOf(index);
        var isSelected = loc !== -1;
        var realOptions = __assign(__assign({}, options), { tagsType: tagsType });
        var onClick = function () {
            if (tagsType === "default") {
                isSelected
                    ? setState(__assign(__assign({}, state), { selectedArr: selectedArr
                            .slice(0, loc)
                            .concat(selectedArr.slice(loc + 1, selectedArr.length)) }))
                    : setState(__assign(__assign({}, state), { selectedArr: selectedArr.concat([index]) }));
            }
            else {
                setState(__assign(__assign({}, state), { removedArr: removedArr.concat([index]) }));
                if (!removalHandledExternally) {
                    data.splice(index, 1);
                }
            }
            if (propEvents && propEvents.onClick) {
                propEvents.onClick(children);
            }
            if (events && events.onClick) {
                events.onClick(true);
            }
        };
        var realEvents = __assign(__assign({}, events), { onClick: onClick });
        return (React__default.createElement(Tag.default, { events: realEvents, hideFocus: state.hideFocus, isHandledExternally: propOptions && propOptions.isHandledExternally === true, key: index, options: realOptions, isLast: index + 1 === data.length, setHideFocus: setHideFocus, tagsType: tagsType, testId: tagsType === "removable" ? uniqueId + "-" + index : testId, total: data.length, overrideRemovableAccessibility: overrideRemovableAccessibility }, children));
    })));
};
exports.default = Tags;
});

var Tags = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Tags_1.default;
});

var link = "MultiSelectInput_link__7mA3P";
var positionClose = "MultiSelectInput_position-close__XjbLw";
var inputClasses = "MultiSelectInput_input-classes__nNG-a";
var inputFocusCss = "MultiSelectInput_input-focus-css__J-Vpp";
var tags = "MultiSelectInput_tags__CWo0G";
var dropdown = "MultiSelectInput_dropdown__BiMab";
var icons = "MultiSelectInput_icons__8-V6W";
var recordNotFound = "MultiSelectInput_record-not-found__I8eCQ";
var css_248z$p = "/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.MultiSelectInput_link__7mA3P {\n  line-height: 24px; }\n\n.MultiSelectInput_position-close__XjbLw {\n  top: 40px;\n  right: 12px; }\n\n.MultiSelectInput_input-classes__nNG-a {\n  border-radius: 3px;\n  border: 1px solid #91939c;\n  box-shadow: none;\n  box-sizing: border-box;\n  outline: 0 none;\n  width: 100%;\n  padding-right: 16px;\n  padding-left: 24px;\n  padding-bottom: 10px;\n  padding-top: 11px;\n  height: 48px; }\n  .MultiSelectInput_input-classes__nNG-a > input {\n    display: inline-block;\n    border: none !important;\n    font-family: font-regular;\n    width: calc(100% - 30px) !important; }\n\n.MultiSelectInput_input-focus-css__J-Vpp {\n  border: 1px solid #0057b8;\n  outline: none; }\n\n.MultiSelectInput_tags__CWo0G {\n  padding-top: 11.41px; }\n  .MultiSelectInput_tags__CWo0G > div > div {\n    margin-right: 8px !important;\n    margin-bottom: 8px !important; }\n\n.MultiSelectInput_dropdown__BiMab {\n  top: 78px;\n  left: 0px;\n  right: 0px;\n  box-sizing: border-box;\n  outline: none;\n  z-index: 1050;\n  border-top: 0px; }\n  .MultiSelectInput_dropdown__BiMab > ul {\n    margin: 0;\n    padding: 0;\n    overflow: auto;\n    background: #ffffff;\n    border: 1px solid #686e74;\n    border-radius: 0px 0px 4px 4px; }\n\n.MultiSelectInput_icons__8-V6W {\n  max-width: 30px; }\n  .MultiSelectInput_icons__8-V6W:focus {\n    border: 1px solid #0057b8;\n    outline: 0 none; }\n\n.MultiSelectInput_record-not-found__I8eCQ {\n  cursor: default !important; }\n  .MultiSelectInput_record-not-found__I8eCQ:hover {\n    background-color: #ffffff !important; }\n  .MultiSelectInput_record-not-found__I8eCQ:focus {\n    background-color: #ffffff !important; }\n";
var MultiSelectInput$1 = {"link":"MultiSelectInput_link__7mA3P","position-close":"MultiSelectInput_position-close__XjbLw","input-classes":"MultiSelectInput_input-classes__nNG-a","input-focus-css":"MultiSelectInput_input-focus-css__J-Vpp","tags":"MultiSelectInput_tags__CWo0G","dropdown":"MultiSelectInput_dropdown__BiMab","icons":"MultiSelectInput_icons__8-V6W","record-not-found":"MultiSelectInput_record-not-found__I8eCQ","positionClose":"MultiSelectInput_position-close__XjbLw","inputClasses":"MultiSelectInput_input-classes__nNG-a","inputFocusCss":"MultiSelectInput_input-focus-css__J-Vpp","recordNotFound":"MultiSelectInput_record-not-found__I8eCQ"};
var stylesheet$m="/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.MultiSelectInput_link__7mA3P {\n  line-height: 24px; }\n\n.MultiSelectInput_position-close__XjbLw {\n  top: 40px;\n  right: 12px; }\n\n.MultiSelectInput_input-classes__nNG-a {\n  border-radius: 3px;\n  border: 1px solid #91939c;\n  box-shadow: none;\n  box-sizing: border-box;\n  outline: 0 none;\n  width: 100%;\n  padding-right: 16px;\n  padding-left: 24px;\n  padding-bottom: 10px;\n  padding-top: 11px;\n  height: 48px; }\n  .MultiSelectInput_input-classes__nNG-a > input {\n    display: inline-block;\n    border: none !important;\n    font-family: font-regular;\n    width: calc(100% - 30px) !important; }\n\n.MultiSelectInput_input-focus-css__J-Vpp {\n  border: 1px solid #0057b8;\n  outline: none; }\n\n.MultiSelectInput_tags__CWo0G {\n  padding-top: 11.41px; }\n  .MultiSelectInput_tags__CWo0G > div > div {\n    margin-right: 8px !important;\n    margin-bottom: 8px !important; }\n\n.MultiSelectInput_dropdown__BiMab {\n  top: 78px;\n  left: 0px;\n  right: 0px;\n  box-sizing: border-box;\n  outline: none;\n  z-index: 1050;\n  border-top: 0px; }\n  .MultiSelectInput_dropdown__BiMab > ul {\n    margin: 0;\n    padding: 0;\n    overflow: auto;\n    background: #ffffff;\n    border: 1px solid #686e74;\n    border-radius: 0px 0px 4px 4px; }\n\n.MultiSelectInput_icons__8-V6W {\n  max-width: 30px; }\n  .MultiSelectInput_icons__8-V6W:focus {\n    border: 1px solid #0057b8;\n    outline: 0 none; }\n\n.MultiSelectInput_record-not-found__I8eCQ {\n  cursor: default !important; }\n  .MultiSelectInput_record-not-found__I8eCQ:hover {\n    background-color: #ffffff !important; }\n  .MultiSelectInput_record-not-found__I8eCQ:focus {\n    background-color: #ffffff !important; }\n";
styleInject(css_248z$p);

var MultiSelectInput$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    link: link,
    positionClose: positionClose,
    inputClasses: inputClasses,
    inputFocusCss: inputFocusCss,
    tags: tags,
    dropdown: dropdown,
    icons: icons,
    recordNotFound: recordNotFound,
    'default': MultiSelectInput$1,
    stylesheet: stylesheet$m
});

var styles$i = /*@__PURE__*/getAugmentedNamespace(MultiSelectInput$2);

var MultiSelectInput_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });













var enterIsPressed = keyPress.KeyPress.enterIsPressed;
var upArrowIsPressed = keyPress.KeyPress.upArrowIsPressed;
var downArrowIsPressed = keyPress.KeyPress.downArrowIsPressed;
var escIsPressed = keyPress.KeyPress.escIsPressed;
var MultiSelectInput = /** @class */ (function (_super) {
    __extends(MultiSelectInput, _super);
    function MultiSelectInput(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.debouncedLog = Debounce.debounce(function (text) {
            _this.filterAndSetData(text);
        }, 300);
        _this.onChange = function (e) {
            var events = _this.props.events;
            var currentValue = e.target.value;
            if (currentValue) {
                _this.setState({ currentText: currentValue });
            }
            else {
                _this.setState({ isOpen: false, currentText: currentValue });
            }
            if (events && events.onChange) {
                events.onChange(e);
            }
            _this.debouncedLog(currentValue);
        };
        _this.filterAndSetData = function (txtValue) {
            var filteredData = _this.props.data.choices;
            if (txtValue) {
                filteredData = _this.props.data.choices.filter(function (choice) {
                    var searchText = txtValue.toUpperCase();
                    var displayText = choice.displayText.toUpperCase();
                    return displayText.includes(searchText);
                });
                // tslint:disable-next-line:no-console
                var isErrorText = filteredData.length === 0 && txtValue ? true : false;
                _this.setState({ isOpen: true, showClose: false, filteredData: filteredData, isErrorText: isErrorText });
            }
            else {
                _this.setState({ filteredData: [], isErrorText: false });
            }
        };
        _this.handleInputKeyDown = function (e) {
            var events = _this.props.events;
            if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
                if (_this.state.currentText) {
                    _this.selectGroupFilterTags();
                }
            }
            else if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
            }
            else if (_this.state.isOpen && downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var firstLi = el.querySelector("." + optionStyles.menuItem);
                if (firstLi) {
                    firstLi.focus();
                }
            }
            if (events && events.onKeyUp) {
                events.onKeyUp(e);
            }
            if (downArrowIsPressed(e) || upArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                e.preventDefault();
                if (liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                }
                return;
            }
        };
        _this.handleKeyDown = function (e) {
            var _a, _b;
            var events = _this.props.events;
            if (escIsPressed(e)) {
                _this.setState({ isOpen: false, currentText: "" });
                (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            else if (enterIsPressed(e)) {
                _this.setState(function (prevState) { return ({
                    isOpen: false,
                }); });
                var elm = e.currentTarget.parentElement;
                var liElementMain = elm.querySelector("." + optionStyles.menuItem + ":focus");
                if (liElementMain && !liElementMain.prevElementSibling) {
                    _this.selectGroupFilterTags();
                }
            }
            else if (downArrowIsPressed(e)) {
                var el = e.currentTarget.parentElement;
                var liElement = el.querySelector("." + optionStyles.menuItem + ":focus");
                var firstLi = el.querySelectorAll("." + optionStyles.menuItem);
                if (liElement && liElement.nextElementSibling) {
                    liElement.nextElementSibling.focus();
                }
                else {
                    if (firstLi && firstLi.length) {
                        firstLi[0].focus();
                    }
                }
                e.preventDefault();
                if (!UserAgent.isIE()) {
                    liElement === null || liElement === void 0 ? void 0 : liElement.scrollTo(0, liElement === null || liElement === void 0 ? void 0 : liElement.offsetTop);
                    return;
                }
            }
            else if (upArrowIsPressed(e)) {
                var elUp = e.currentTarget.parentElement;
                var liUpElement = elUp.querySelector("." + optionStyles.menuItem + ":focus");
                var lastLi = elUp.querySelectorAll("." + optionStyles.menuItem);
                if (liUpElement && liUpElement.previousElementSibling) {
                    liUpElement.previousElementSibling.focus();
                }
                else {
                    if (lastLi && lastLi.length > 1) {
                        lastLi[lastLi.length - 1].focus();
                    }
                }
                e.preventDefault();
            }
            else if (keyPress.KeyPress.tabIsPressed(e)) {
                if (_this.state.isOpen) {
                    _this.setState({
                        showClose: true,
                    }, function () {
                        var _a, _b;
                        (_b = (_a = _this.closeRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
                    });
                    e.preventDefault();
                }
            }
            if (events && events.handleKeyDown) {
                events.handleKeyDown(e);
            }
        };
        _this.onFocus = function (event) {
            var events = _this.props.events;
            _this.setState({ isOnFocus: true });
            if (events && events.onFocus) {
                events.onFocus(event);
            }
        };
        _this.handleClickOutside = function (event) {
            var domNode = react_dom_1.findDOMNode(_this);
            if (!domNode || !domNode.contains(event.target)) {
                _this.setState({
                    isOpen: false,
                });
            }
        };
        _this.onBlur = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            _this.setState({ isOnFocus: false });
            if (events && events.onBlur) {
                events.onBlur(currentText);
            }
        };
        _this.closeDropDown = function () {
            var _a, _b;
            _this.setState({
                isOpen: false,
                showClose: false,
                currentText: "",
            });
            (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        };
        _this.onSearchClick = function (event) {
            var elUp = event.currentTarget.parentElement;
            var liUpElement = elUp.querySelector("input");
            if (liUpElement) {
                liUpElement.focus();
                _this.setState({ isOnFocus: true });
            }
        };
        _this.onSelect = function (choice, enter) {
            var selectedTags = _this.state.selectedTags;
            var events = _this.props.events;
            selectedTags.push(choice);
            var unqSelectedTags = _this.getUniqueArray(selectedTags);
            var tagArray = unqSelectedTags.map(function (tag, index) {
                return {
                    children: tag.displayText,
                    options: {
                        type: "removable",
                    },
                    testId: "tag" + index,
                    events: {
                        onClick: function (e) {
                            _this.handleRemoveTag(e, tag);
                        },
                    },
                };
            });
            _this.setState({ selectedTags: unqSelectedTags, isOpen: false, currentText: "", tagArray: tagArray }, _this.handleTagsChange);
            if (events && events.onSelect) {
                events.onSelect(choice);
            }
        };
        _this.getUniqueArray = function (arr) {
            var e_1, _a;
            var result = [];
            var map = new Map();
            try {
                for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                    var item = arr_1_1.value;
                    if (!map.has(item.displayText)) {
                        map.set(item.displayText, true); // set any value to Map
                        result.push(item);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return result;
        };
        _this.selectGroupFilterTags = function () {
            var _a = _this.state, filteredData = _a.filteredData, selectedTags = _a.selectedTags;
            var updatedSelectedTags = __spread(filteredData, selectedTags);
            var unqSelectedTags = _this.getUniqueArray(updatedSelectedTags);
            var tagArray = unqSelectedTags.map(function (tag, index) {
                return {
                    children: tag.displayText,
                    options: {
                        type: "removable",
                    },
                    testId: "tag" + index,
                    events: {
                        onClick: function (e) {
                            _this.handleRemoveTag(e, tag);
                        },
                    },
                };
            });
            _this.setState({
                alertText: filteredData.length + " Channels Selected starting with " + _this.state.currentText,
            });
            _this.setState({
                selectedTags: unqSelectedTags,
                isOpen: false,
                currentText: "",
                tagArray: tagArray,
            }, _this.handleTagsChange);
            setTimeout(function () {
                _this.setState({ alertText: "" });
            }, 1000);
        };
        _this.handleRemoveTag = function (t, tag) {
            _this.removeSelectedTags(tag);
        };
        _this.removeSelectedTags = function (tag) {
            var _a, _b;
            var _c = _this.state, selectedTags = _c.selectedTags, tagArray = _c.tagArray;
            selectedTags = selectedTags.filter(function (tagItem) {
                return tag.displayText !== tagItem.displayText;
            });
            tagArray = tagArray.filter(function (tagItem) {
                return tag.displayText !== tagItem.children;
            });
            _this.setState({ selectedTags: selectedTags, isOpen: false, tagArray: tagArray }, _this.handleTagsChange);
            if (selectedTags.length === 0) {
                (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        };
        _this.handleTagsChange = function () {
            var events = _this.props.events;
            var selectedTags = _this.state.selectedTags;
            if (events && events.handleTagsChange) {
                events.handleTagsChange(selectedTags);
            }
        };
        _this.clearInput = function () {
            _this.setState({ currentText: "", isOpen: false, isOnFocus: true });
        };
        _this.onClearAll = function (event) {
            var _a, _b;
            var events = _this.props.events;
            event.stopPropagation();
            var elUp = event.currentTarget.parentElement;
            var inputElement = elUp.querySelector("input");
            if (inputElement) {
                inputElement.focus();
            }
            _this.setState({ isOpen: false, currentText: "", isOnFocus: true, selectedTags: [], tagArray: [] }, _this.handleTagsChange);
            if (events && events.onClearAll) {
                events.onClearAll();
            }
            (_b = (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        };
        _this.onNoSuggestionSelect = function () {
            _this.setState({ isOpen: false });
        };
        _this.searchIcon = function () {
            var _a, _b;
            return (React__default.createElement(React__default.Fragment, null,
                !_this.state.currentText.length ? (React__default.createElement("button", { "aria-label": (_a = _this.props.options) === null || _a === void 0 ? void 0 : _a.searchAriaLabelText, className: styles$i.icons + " pull-right border-none bg-transparent height-sm-all", onClick: _this.onSearchClick },
                    React__default.createElement(IconSvg.default, { size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M21.45 20A11 11 0 1020 21.45l8.26 8.26 1.42-1.42zM13 22a9 9 0 119-9 9 9 0 01-9 9z\"/></svg>" }))) : (""),
                _this.state.currentText.length ? (React__default.createElement(BaseCta.BaseCta, { className: styles$i.positionClose + " icon-close absolute color-ui-black", onClick: _this.clearInput, "aria-label": (_b = _this.props.options) === null || _b === void 0 ? void 0 : _b.closeAriaLabelText })) : ("")));
        };
        _this.getFindIndex = function (arr, displayText) {
            var _a;
            var index = -1;
            for (var i = 0; i < arr.length; i++) {
                if (((_a = arr[i]) === null || _a === void 0 ? void 0 : _a.displayText) === displayText) {
                    return i;
                }
            }
            return index;
        };
        _this.closeRef = React__default.createRef();
        _this.inputRef = React__default.createRef();
        _this.state = {
            selectedTags: [],
            isOpen: false,
            currentData: props.data,
            currentText: ((_a = props.data) === null || _a === void 0 ? void 0 : _a.value) ? props.data.value : "",
            currentValue: null,
            filteredData: [],
            isOnFocus: false,
            tagArray: [],
            isErrorText: false,
            showClose: false,
            alertText: "",
        };
        return _this;
    }
    MultiSelectInput.prototype.componentDidMount = function () {
        document.addEventListener("click", this.handleClickOutside, true);
    };
    MultiSelectInput.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.handleClickOutside, true);
    };
    MultiSelectInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, options = _a.options, testId = _a.testId, id = _a.id, spi = _a.spi;
        var _b = this.state, selectedTags = _b.selectedTags, isOpen = _b.isOpen, filteredData = _b.filteredData, isOnFocus = _b.isOnFocus, currentText = _b.currentText, tagArray = _b.tagArray, isErrorText = _b.isErrorText, showClose = _b.showClose;
        var dropdownCls = isOpen
            ? [
                styles$i.dropdown,
                "block pad-none absolute overflow-hidden bg-transparent color-ui-dark-gray",
            ].join(" ")
            : [
                styles$i.dropdown,
                "absolute overflow-hidden hide bg-transparent  color-ui-dark-gray",
            ].join(" ");
        var choices = this.props.data.choices;
        var noDataFound = false;
        if (choices && choices.length === 0 && this.props.data.noSuggestionData) {
            choices = [this.props.data.noSuggestionData];
            noDataFound = true;
        }
        var grouptitleName = (options === null || options === void 0 ? void 0 : options.groupTitle) ? (options === null || options === void 0 ? void 0 : options.groupTitle) + " " : "";
        var groupTitle = function () {
            return (React__default.createElement(React__default.Fragment, null,
                grouptitleName,
                React__default.createElement("span", { className: "font-bold type-sm" }, currentText)));
        };
        return (React__default.createElement("div", { "data-test-id": testId, className: "rel font-regular color-ui-black flex-column flex" },
            React__default.createElement("div", { className: "mar-b-xxs" }, data.labelText && (React__default.createElement("label", { className: "font-medium type-sm", htmlFor: id }, data.labelText))),
            React__default.createElement("div", { className: "width-full" },
                React__default.createElement("div", { id: "multi-select-container", className: styles$i.inputClasses + " " + (isOnFocus ? "" + styles$i.inputFocusCss : " ") + " color-ui-dark-gray" },
                    React__default.createElement("input", { id: id, name: data.name, value: currentText, type: options === null || options === void 0 ? void 0 : options.inputType, placeholder: data.placeHolder, "aria-label": options.ariaLabelForInput ? options.ariaLabelForInput : undefined, "data-spi": spi, onChange: this.onChange, onKeyDown: this.handleInputKeyDown, onFocus: this.onFocus, onBlur: this.onBlur, tabIndex: 0, ref: this.inputRef }),
                    React__default.createElement("div", { id: "multi-select-list", className: dropdownCls },
                        React__default.createElement("ul", { role: "menu" },
                            currentText.length > 1 && filteredData.length > 0 ? (React__default.createElement("li", { "aria-hidden": "true", onKeyDown: this.handleKeyDown, className: optionStyles.menuItem +
                                    " " +
                                    " color-ui-dark-gray type-sm pad-t-xs" +
                                    " " +
                                    optionStyles.activeItem, tabIndex: 0, title: grouptitleName + currentText, onClick: this.selectGroupFilterTags, role: "menuitem" },
                                React__default.createElement("span", { "aria-hidden": "true" }, groupTitle()))) : (""),
                            (isErrorText && currentText && filteredData.length === 0) ||
                                currentText.length === 1 ? (React__default.createElement("li", { className: optionStyles.menuItem +
                                    " " +
                                    " type-sm pad-t-xs" +
                                    " " +
                                    optionStyles.activeItem +
                                    " " +
                                    styles$i.recordNotFound, title: options === null || options === void 0 ? void 0 : options.errorText, tabIndex: 0, role: "menuitem", onKeyDown: this.handleKeyDown },
                                React__default.createElement("span", null, options === null || options === void 0 ? void 0 : options.errorText))) : (""),
                            currentText.length > 1 &&
                                filteredData.map(function (choice, index) { return (React__default.createElement(MultiSelectInputList.default, { testId: utils.default(_this.props.testId, "Option"), key: choice.value, data: {
                                        choice: choice,
                                        isSelected: _this.getFindIndex(selectedTags, choice.displayText) !== -1
                                            ? true
                                            : false,
                                        textData: currentText || "",
                                    }, onSelect: noDataFound
                                        ? _this.onNoSuggestionSelect
                                        : _this.onSelect, options: { heighlightTextData: true }, handelKeyDown: _this.handleKeyDown })); })),
                        showClose && (React__default.createElement("button", { "aria-hidden": !isOpen, "aria-label": "Close dropdown", role: "button", className: "btn-small btn-primary-2", tabIndex: isOpen ? 0 : -1, ref: this.closeRef, onClick: this.closeDropDown }, "Close"))),
                    this.searchIcon())),
            React__default.createElement("div", { className: "mar-b-xxs" }, data.linkProps && (React__default.createElement(Link.default, __assign({}, data.linkProps, { className: "absolute top right solo pull-right" + " " + styles$i.link, onClick: this.onClearAll }), options === null || options === void 0 ? void 0 : options.linkText))),
            React__default.createElement("div", { className: styles$i.tags, id: "MultiSelectInputTags" },
                React__default.createElement(Tags.default, { data: tagArray, tagsType: "removable" })),
            React__default.createElement("div", { "aria-live": "assertive", role: "status" },
                React__default.createElement("span", { className: "hidden-spoken" },
                    " ",
                    this.state.alertText))));
    };
    return MultiSelectInput;
}(React__default.Component));
exports.default = MultiSelectInput;
});

var MultiSelectInput = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = MultiSelectInput_1.default;
});

var notificationBox = "NotificationTimed_notificationBox__eHDKX";
var notificationText = "NotificationTimed_notificationText__GNzur";
var notificationButton = "NotificationTimed_notificationButton__sl47R";
var notificationIcon = "NotificationTimed_notificationIcon__3KPlb";
var css_248z$o = ".NotificationTimed_notificationBox__eHDKX {\n  border-radius: 2px;\n  box-shadow: 0 -2px 4px 0 #dcdfe3;\n  min-height: 48px;\n  padding-bottom: 11px;\n  padding-top: 13px; }\n  @media (max-width: 767px) {\n    .NotificationTimed_notificationBox__eHDKX {\n      min-height: 40px;\n      padding-bottom: 9px;\n      padding-top: 11px; } }\n\n.NotificationTimed_notificationText__GNzur {\n  font-size: 15px;\n  padding-right: 33px; }\n  @media (max-width: 767px) {\n    .NotificationTimed_notificationText__GNzur {\n      font-size: 14px; } }\n\n.NotificationTimed_notificationButton__sl47R {\n  background: none;\n  border: none;\n  height: 22px;\n  margin-top: 13px;\n  width: 42px; }\n  @media (max-width: 767px) {\n    .NotificationTimed_notificationButton__sl47R {\n      margin-top: 9px; } }\n\n.NotificationTimed_notificationIcon__3KPlb {\n  fill: #878c94;\n  font-size: 12px;\n  padding-right: 5px; }\n";
var NotificationTimed$1 = {"notificationBox":"NotificationTimed_notificationBox__eHDKX","notificationText":"NotificationTimed_notificationText__GNzur","notificationButton":"NotificationTimed_notificationButton__sl47R","notificationIcon":"NotificationTimed_notificationIcon__3KPlb"};
var stylesheet$l=".NotificationTimed_notificationBox__eHDKX {\n  border-radius: 2px;\n  box-shadow: 0 -2px 4px 0 #dcdfe3;\n  min-height: 48px;\n  padding-bottom: 11px;\n  padding-top: 13px; }\n  @media (max-width: 767px) {\n    .NotificationTimed_notificationBox__eHDKX {\n      min-height: 40px;\n      padding-bottom: 9px;\n      padding-top: 11px; } }\n\n.NotificationTimed_notificationText__GNzur {\n  font-size: 15px;\n  padding-right: 33px; }\n  @media (max-width: 767px) {\n    .NotificationTimed_notificationText__GNzur {\n      font-size: 14px; } }\n\n.NotificationTimed_notificationButton__sl47R {\n  background: none;\n  border: none;\n  height: 22px;\n  margin-top: 13px;\n  width: 42px; }\n  @media (max-width: 767px) {\n    .NotificationTimed_notificationButton__sl47R {\n      margin-top: 9px; } }\n\n.NotificationTimed_notificationIcon__3KPlb {\n  fill: #878c94;\n  font-size: 12px;\n  padding-right: 5px; }\n";
styleInject(css_248z$o);

var NotificationTimed$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    notificationBox: notificationBox,
    notificationText: notificationText,
    notificationButton: notificationButton,
    notificationIcon: notificationIcon,
    'default': NotificationTimed$1,
    stylesheet: stylesheet$l
});

var NotificationTimed_scss_1 = /*@__PURE__*/getAugmentedNamespace(NotificationTimed$2);

var NotificationTimed_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });




var NotificationTimed = function (_a) {
    var children = _a.children, onClick = _a.onClick, style = _a.style, testId = _a.testId, className = _a.className, hide = _a.hide, _b = _a.timeout, timeout = _b === void 0 ? 30000 : _b, _c = _a.shown, shown = _c === void 0 ? true : _c;
    React__default.useEffect(function () {
        if (shown && isFinite(timeout)) {
            setTimeout(hide, timeout);
        }
    }, [shown]);
    return shown ? (React__default.createElement("div", { role: "alert", className: Join.join(NotificationTimed_scss_1.notificationBox, "bg-ui-dark-gray", "flex", "flex-items-center", "justify-between", "rel", className), style: style, onClick: onClick, "data-testid": testId },
        React__default.createElement("span", { className: "hidden-spoken" }, children),
        React__default.createElement("span", { "aria-hidden": true, className: Join.join(NotificationTimed_scss_1.notificationText, "section-text-3", "color-ui-white", "pad-l-xs") }, children),
        React__default.createElement("button", { role: "button", className: Join.join(NotificationTimed_scss_1.notificationButton, "absolute", "right", "top"), onClick: hide },
            React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Close Notification", className: NotificationTimed_scss_1.notificationIcon, colorClass: "color-ui-gray", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path class=\"svg-base\" d=\"M11.33 6.38L9.21 8.5l2.12 2.12-.71.71L8.5 9.21l-2.12 2.12-.71-.71L7.79 8.5 5.67 6.38l.71-.71L8.5 7.79l2.12-2.12z\"/></svg>" })))) : null;
};
exports.default = NotificationTimed;
});

var NotificationTimed = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = NotificationTimed_1.default;
});

var numberBadge = "NumberBadge_numberBadge__PuHea";
var label$2 = "NumberBadge_label__4-4gE";
var css_248z$n = ".NumberBadge_numberBadge__PuHea {\n  border-radius: 1em;\n  height: 2rem;\n  font-size: 1.4rem;\n  line-height: 0 !important;\n  min-width: 2rem;\n  padding: 0 0.59rem; }\n\n.NumberBadge_label__4-4gE {\n  font-size: 1.5rem; }\n\n@supports (-moz-appearance: meterbar) and (cursor: zoom-in) {\n  .NumberBadge_numberBadge__PuHea {\n    padding: 0 0.59rem 0.1rem; } }\n";
var NumberBadge$1 = {"numberBadge":"NumberBadge_numberBadge__PuHea","label":"NumberBadge_label__4-4gE"};
var stylesheet$k=".NumberBadge_numberBadge__PuHea {\n  border-radius: 1em;\n  height: 2rem;\n  font-size: 1.4rem;\n  line-height: 0 !important;\n  min-width: 2rem;\n  padding: 0 0.59rem; }\n\n.NumberBadge_label__4-4gE {\n  font-size: 1.5rem; }\n\n@supports (-moz-appearance: meterbar) and (cursor: zoom-in) {\n  .NumberBadge_numberBadge__PuHea {\n    padding: 0 0.59rem 0.1rem; } }\n";
styleInject(css_248z$n);

var NumberBadge$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    numberBadge: numberBadge,
    label: label$2,
    'default': NumberBadge$1,
    stylesheet: stylesheet$k
});

var NumberBadgeProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberBadgeColors = void 0;
(function (NumberBadgeColors) {
    NumberBadgeColors["black"] = "color-ui-black";
    NumberBadgeColors["blue"] = "color-cobalt";
    NumberBadgeColors["darkgray"] = "color-ui-dark-gray";
})(exports.NumberBadgeColors || (exports.NumberBadgeColors = {}));
});

var styles$h = /*@__PURE__*/getAugmentedNamespace(NumberBadge$2);

var NumberBadge_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



var NumberBadge = function (_a) {
    var accessibilityText = _a.accessibilityText, children = _a.children, className = _a.className, count = _a.count, labelColor = _a.labelColor, testId = _a.testId, urgent = _a.urgent;
    var renderCount = function () {
        if (count > 99) {
            return "99+";
        }
        else {
            return count.toString();
        }
    };
    var badgeClasses = [
        className,
        styles$h.numberBadge,
        urgent ? "bg-functional-dk-red" : count > 0 ? "bg-cobalt" : "bg-ui-dark-gray",
        "font-medium inline-flex flex-items-center justify-center color-ui-white",
    ];
    var accessibility = children && typeof children === "string" ? children + " " + renderCount() : renderCount();
    var labelClasses = [styles$h.label, NumberBadgeProps.NumberBadgeColors[labelColor], "font-medium mar-r-xxs"];
    return (React__default.createElement("div", { "data-testid": testId },
        children && React__default.createElement("span", { className: labelClasses.join(" ") }, children),
        React__default.createElement("span", { className: badgeClasses.join(" ") },
            " ",
            renderCount(),
            React__default.createElement("span", { className: "hidden-spoken" }, accessibilityText ? accessibilityText : accessibility))));
};
exports.default = NumberBadge;
});

var NumberBadge = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = NumberBadge_1.default;
});

var z1 = "Popover_z1__Admok";
var zOne = "Popover_z-one__yHJV8";
var childContainer$1 = "Popover_childContainer__tyc0j";
var popoverHeading = "Popover_popover-heading__hDdEU";
var closeHide = "Popover_close-hide__sYQxu";
var show$1 = "Popover_show__RVjhD";
var arrow$1 = "Popover_arrow__2rlKw";
var arrowBottom = "Popover_arrowBottom__LZfjv";
var arrowTop = "Popover_arrowTop__T2Ntr";
var popoverWrapper = "Popover_popover-wrapper__Tj7Vi";
var popover = "Popover_popover__Y3zCC";
var closeButton = "Popover_close-button__8e66l";
var root = "Popover_root__tqMSW";
var relPmt$1 = "Popover_rel-pmt__LI-Za";
var infoBox$1 = "Popover_infoBox__WxNCd";
var popoverFull = "Popover_popover-full__OZ2MD";
var infoboxOpen = "Popover_infobox-open__IdZx7";
var closeButtonFull = "Popover_closeButtonFull__B2W4h";
var arrowshowFull = "Popover_arrowshow-full__nmf2e";
var popoverWrapperRight = "Popover_popover-wrapper-right__uYhG-";
var css_248z$m = ".Popover_z1__Admok {\n  z-index: 3 !important; }\n\n.Popover_z-one__yHJV8 {\n  z-index: -1 !important; }\n\n.Popover_childContainer__tyc0j {\n  line-height: 1.4; }\n  .Popover_childContainer__tyc0j > * {\n    position: relative !important; }\n  .Popover_childContainer__tyc0j svg {\n    vertical-align: baseline; }\n\n.Popover_popover-heading__hDdEU {\n  color: #1d2329; }\n\n.Popover_close-hide__sYQxu {\n  visibility: hidden; }\n\n.Popover_show__RVjhD {\n  display: block !important; }\n\n.Popover_arrow__2rlKw {\n  display: none;\n  border-radius: 0 2px 0 2px;\n  background-color: #ffffff;\n  width: 9px;\n  height: 9px;\n  z-index: 1000;\n  position: absolute; }\n\n.Popover_arrowBottom__LZfjv {\n  left: calc(50% - 4.2px);\n  transform: translateY(3px) rotate(-45deg);\n  box-shadow: -2px 2px 0 0px #dcdfe3;\n  bottom: -2px; }\n\n.Popover_arrowTop__T2Ntr {\n  left: calc(50% - 4.2px);\n  box-shadow: 1px -1px 0 0px #dcdfe3;\n  top: 0;\n  transform: translateY(-5px) rotate(-45deg);\n  bottom: 100%; }\n\n.Popover_popover-wrapper__Tj7Vi {\n  position: relative; }\n\n.Popover_popover__Y3zCC {\n  min-width: 150px;\n  max-width: 400px;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  background: #ffffff;\n  border-radius: 3px;\n  z-index: 1;\n  filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.2)); }\n\n.Popover_close-button__8e66l {\n  top: -6px;\n  right: -6px;\n  min-height: 44px;\n  min-width: 44px;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none; }\n\n.Popover_close-button__8e66l:focus {\n  outline: 1px dotted #1d2329; }\n\n.Popover_root__tqMSW {\n  --left: auto; }\n\n@media (max-width: 428px) {\n  .Popover_popover__Y3zCC {\n    min-width: 150px;\n    max-width: 300px; } }\n\n.Popover_rel-pmt__LI-Za {\n  position: relative !important; }\n\n.form-row.rel {\n  z-index: auto; }\n\n.is-tabbing .trigger:focus {\n  outline: 1px dotted currentColor;\n  outline-offset: 1px; }\n\n@media (max-width: 767px) {\n  .Popover_infoBox__WxNCd {\n    z-index: -1; }\n  .Popover_popover-full__OZ2MD {\n    position: fixed !important;\n    height: 100% !important;\n    width: 100% !important;\n    border-radius: 0px;\n    max-width: 100% !important;\n    top: -8px;\n    left: 0px !important;\n    border: none;\n    z-index: 1;\n    margin-top: 0px;\n    padding-top: 32px !important; }\n  .Popover_infobox-open__IdZx7 {\n    z-index: 1; }\n  .Popover_closeButtonFull__B2W4h {\n    top: 12px !important;\n    right: 12px !important;\n    min-height: 32px;\n    min-width: 32px;\n    visibility: visible !important; }\n  .Popover_popover-full__OZ2MD:before, .Popover_popover-full__OZ2MD:after {\n    display: none; }\n  .Popover_arrowshow-full__nmf2e {\n    display: none !important; } }\n\n@media (max-width: 320px) {\n  .Popover_popover-wrapper__Tj7Vi {\n    right: 10px;\n    left: 10px;\n    position: absolute; }\n  .Popover_popover-wrapper-right__uYhG- {\n    right: -7px;\n    left: 10px;\n    position: absolute; } }\n";
var Popover$1 = {"z1":"Popover_z1__Admok","z-one":"Popover_z-one__yHJV8","childContainer":"Popover_childContainer__tyc0j","popover-heading":"Popover_popover-heading__hDdEU","close-hide":"Popover_close-hide__sYQxu","show":"Popover_show__RVjhD","arrow":"Popover_arrow__2rlKw","arrowBottom":"Popover_arrowBottom__LZfjv","arrowTop":"Popover_arrowTop__T2Ntr","popover-wrapper":"Popover_popover-wrapper__Tj7Vi","popover":"Popover_popover__Y3zCC","close-button":"Popover_close-button__8e66l","root":"Popover_root__tqMSW","rel-pmt":"Popover_rel-pmt__LI-Za","infoBox":"Popover_infoBox__WxNCd","popover-full":"Popover_popover-full__OZ2MD","infobox-open":"Popover_infobox-open__IdZx7","closeButtonFull":"Popover_closeButtonFull__B2W4h","arrowshow-full":"Popover_arrowshow-full__nmf2e","popover-wrapper-right":"Popover_popover-wrapper-right__uYhG-","zOne":"Popover_z-one__yHJV8","popoverHeading":"Popover_popover-heading__hDdEU","closeHide":"Popover_close-hide__sYQxu","popoverWrapper":"Popover_popover-wrapper__Tj7Vi","closeButton":"Popover_close-button__8e66l","relPmt":"Popover_rel-pmt__LI-Za","popoverFull":"Popover_popover-full__OZ2MD","infoboxOpen":"Popover_infobox-open__IdZx7","arrowshowFull":"Popover_arrowshow-full__nmf2e","popoverWrapperRight":"Popover_popover-wrapper-right__uYhG-"};
var stylesheet$j=".Popover_z1__Admok {\n  z-index: 3 !important; }\n\n.Popover_z-one__yHJV8 {\n  z-index: -1 !important; }\n\n.Popover_childContainer__tyc0j {\n  line-height: 1.4; }\n  .Popover_childContainer__tyc0j > * {\n    position: relative !important; }\n  .Popover_childContainer__tyc0j svg {\n    vertical-align: baseline; }\n\n.Popover_popover-heading__hDdEU {\n  color: #1d2329; }\n\n.Popover_close-hide__sYQxu {\n  visibility: hidden; }\n\n.Popover_show__RVjhD {\n  display: block !important; }\n\n.Popover_arrow__2rlKw {\n  display: none;\n  border-radius: 0 2px 0 2px;\n  background-color: #ffffff;\n  width: 9px;\n  height: 9px;\n  z-index: 1000;\n  position: absolute; }\n\n.Popover_arrowBottom__LZfjv {\n  left: calc(50% - 4.2px);\n  transform: translateY(3px) rotate(-45deg);\n  box-shadow: -2px 2px 0 0px #dcdfe3;\n  bottom: -2px; }\n\n.Popover_arrowTop__T2Ntr {\n  left: calc(50% - 4.2px);\n  box-shadow: 1px -1px 0 0px #dcdfe3;\n  top: 0;\n  transform: translateY(-5px) rotate(-45deg);\n  bottom: 100%; }\n\n.Popover_popover-wrapper__Tj7Vi {\n  position: relative; }\n\n.Popover_popover__Y3zCC {\n  min-width: 150px;\n  max-width: 400px;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  background: #ffffff;\n  border-radius: 3px;\n  z-index: 1;\n  filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.2)); }\n\n.Popover_close-button__8e66l {\n  top: -6px;\n  right: -6px;\n  min-height: 44px;\n  min-width: 44px;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none; }\n\n.Popover_close-button__8e66l:focus {\n  outline: 1px dotted #1d2329; }\n\n.Popover_root__tqMSW {\n  --left: auto; }\n\n@media (max-width: 428px) {\n  .Popover_popover__Y3zCC {\n    min-width: 150px;\n    max-width: 300px; } }\n\n.Popover_rel-pmt__LI-Za {\n  position: relative !important; }\n\n.form-row.rel {\n  z-index: auto; }\n\n.is-tabbing .trigger:focus {\n  outline: 1px dotted currentColor;\n  outline-offset: 1px; }\n\n@media (max-width: 767px) {\n  .Popover_infoBox__WxNCd {\n    z-index: -1; }\n  .Popover_popover-full__OZ2MD {\n    position: fixed !important;\n    height: 100% !important;\n    width: 100% !important;\n    border-radius: 0px;\n    max-width: 100% !important;\n    top: -8px;\n    left: 0px !important;\n    border: none;\n    z-index: 1;\n    margin-top: 0px;\n    padding-top: 32px !important; }\n  .Popover_infobox-open__IdZx7 {\n    z-index: 1; }\n  .Popover_closeButtonFull__B2W4h {\n    top: 12px !important;\n    right: 12px !important;\n    min-height: 32px;\n    min-width: 32px;\n    visibility: visible !important; }\n  .Popover_popover-full__OZ2MD:before, .Popover_popover-full__OZ2MD:after {\n    display: none; }\n  .Popover_arrowshow-full__nmf2e {\n    display: none !important; } }\n\n@media (max-width: 320px) {\n  .Popover_popover-wrapper__Tj7Vi {\n    right: 10px;\n    left: 10px;\n    position: absolute; }\n  .Popover_popover-wrapper-right__uYhG- {\n    right: -7px;\n    left: 10px;\n    position: absolute; } }\n";
styleInject(css_248z$m);

var Popover$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    z1: z1,
    zOne: zOne,
    childContainer: childContainer$1,
    popoverHeading: popoverHeading,
    closeHide: closeHide,
    show: show$1,
    arrow: arrow$1,
    arrowBottom: arrowBottom,
    arrowTop: arrowTop,
    popoverWrapper: popoverWrapper,
    popover: popover,
    closeButton: closeButton,
    root: root,
    relPmt: relPmt$1,
    infoBox: infoBox$1,
    popoverFull: popoverFull,
    infoboxOpen: infoboxOpen,
    closeButtonFull: closeButtonFull,
    arrowshowFull: arrowshowFull,
    popoverWrapperRight: popoverWrapperRight,
    'default': Popover$1,
    stylesheet: stylesheet$j
});

var styles$g = /*@__PURE__*/getAugmentedNamespace(Popover$2);

var Popover_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });




/**
 *
 * <style>
 * #Popover-container ul[class*="rsg--list-"]{margin:20px 0;padding:0;}
 * #Popover-container li[class*="rsg--li-"]{display:inline;border:1px solid #ccc;border-radius:12px;}
 * #Popover-container li[class*="rsg--li-"]{background:#d12127;padding:4px 8px;color:#fff;margin-right:16px;}
 * #Popover-container li[class*="rsg--li-"] p{display:inline;color:#fff;}
 * </style>
 * <ul style="">
 * <li style="">UX Approval - Pending</li>
 * <li style="">Approval - Pending</li>
 * </ul>
 *
 */
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover(props) {
        var _this = _super.call(this, props) || this;
        _this.setResize = function () {
            if (!_this.boxRef2.current) {
                return;
            }
            var currentBox = _this.boxRef2.current;
            var sc = currentBox.style;
            sc.removeProperty('left');
            sc.removeProperty('right');
            _this.setState({
                resize: window.innerWidth,
            });
        };
        _this.handleClickOutside = function (event) {
            var domNode = document.getElementById('popover-outer-' + _this.props.uniqueId);
            if (!(domNode === null || domNode === void 0 ? void 0 : domNode.contains(event.target))) {
                _this.hidePopover();
            }
        };
        _this.onFocus = function (e) {
            var _a, _b, _c, _d;
            // const domNode = document.getElementById('popover-outer-' + this.props.uniqueId);
            if (((_a = _this.triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                return;
            }
            var c = false;
            if (_this.tabElements) {
                _this.tabElements.forEach(function (item) {
                    if (item === e.target) {
                        item.focus();
                        _this.previousEl = item;
                        c = true;
                        return;
                    }
                });
                if (!c && e.target !== _this.boxRef && !((_b = _this.boxRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
                    if (_this.previousEl === _this.firstEl) {
                        (_c = _this.lastEl) === null || _c === void 0 ? void 0 : _c.focus();
                    }
                    else {
                        (_d = _this.firstEl) === null || _d === void 0 ? void 0 : _d.focus();
                    }
                }
            }
        };
        _this.KeyDownHandler = function (e) {
            if (keyPress.KeyPress.escIsPressed(e)) {
                _this.hidePopover();
            }
            else {
                if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
                    e.preventDefault();
                    if (!_this.state.showState) {
                        _this.showPopover();
                    }
                    else {
                        _this.hidePopover();
                    }
                }
            }
        };
        _this.popoverKeyDown = function (e) {
            if (keyPress.KeyPress.escIsPressed(e)) {
                _this.hidePopover();
            }
        };
        var _a = props.show, show = _a === void 0 ? false : _a;
        _this.state = {
            showState: show,
            resize: 0,
        };
        _this.boxRef = React__default.createRef();
        _this.boxRef2 = React__default.createRef();
        _this.triggerRef = React__default.createRef();
        _this.headingRef = React__default.createRef();
        _this.arrowRef = React__default.createRef();
        _this.tabElements = [];
        _this.firstEl = '';
        _this.lastEl = '';
        _this.previousEl = '';
        _this.isAutoAligned = false;
        _this.onClick = _this.onClick.bind(_this);
        _this.showPopover = _this.showPopover.bind(_this);
        _this.hidePopover = _this.hidePopover.bind(_this);
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.KeyDownHandler = _this.KeyDownHandler.bind(_this);
        _this.popoverKeyDown = _this.popoverKeyDown.bind(_this);
        _this.autoAlignPopover = _this.autoAlignPopover.bind(_this);
        return _this;
    }
    Popover.prototype.componentDidMount = function () {
        var _a, _b;
        document.addEventListener("click", this.handleClickOutside, true);
        window.addEventListener("resize", this.setResize);
        if (this.props.show) {
            document.addEventListener("focus", this.onFocus, true);
            this.tabElements = (_a = this.boxRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input, button, a, select, textarea, div[tabindex="0"], div[role="button"]:not([aria-hidden=true]), div[role="checkbox"]:not([aria-hidden=true]), div[role="radio"]:not([aria-hidden=true])');
            if (this.tabElements) {
                this.firstEl = this.tabElements[0];
                this.lastEl = this.tabElements[this.tabElements.length - 1];
            }
            this.autoAlignPopover();
            (_b = this.firstEl) === null || _b === void 0 ? void 0 : _b.focus();
        }
    };
    Popover.prototype.autoAlignPopover = function () {
        var _a = this.props.align, align = _a === void 0 ? 'left' : _a;
        if (!this.boxRef.current || !this.boxRef2.current || !this.arrowRef.current || !this.triggerRef.current) {
            return;
        }
        var currentBox2 = this.boxRef.current;
        var bounds2 = currentBox2.getBoundingClientRect();
        var currentBox = this.boxRef2.current;
        var bounds = currentBox.getBoundingClientRect();
        var currentArrow = this.arrowRef.current;
        currentArrow.getBoundingClientRect();
        var currentTrigger = this.triggerRef.current;
        var triggerBounds = currentTrigger.getBoundingClientRect();
        if (document.documentElement.clientWidth <= 320) {
            if (align === 'center') {
                currentArrow.style.left = triggerBounds.left + (triggerBounds.width / 2) + 'px';
            }
            else if (align === 'left') {
                var res = triggerBounds.left + (triggerBounds.width / 2);
                res = res - bounds2.left;
                currentArrow.style.left = res + 'px';
            }
            else if (align === 'right') {
                var ab = bounds.width - (triggerBounds.width / 2);
                currentArrow.style.left = ab + 'px';
            }
        }
        else {
            if (align === 'center') {
                var sc = currentArrow.style;
                sc.removeProperty('left');
                // currentArrow.style.left = triggerBounds.left + (triggerBounds.width/2) + 'px';
            }
            else if (align === 'left') {
                currentArrow.style.left = (triggerBounds.width / 2) + 'px';
            }
            else if (align === 'right') {
                var ab = bounds.width - (triggerBounds.width / 2);
                currentArrow.style.left = ab + 'px';
            }
        }
        if (bounds.left < 0) {
            currentBox.style.left = 0 + 'px';
            currentArrow.style.left = (triggerBounds.width / 2) + 'px';
            this.isAutoAligned = true;
        }
        else if (bounds.right > document.documentElement.clientWidth) {
            currentBox.style.right = -20 + 'px';
            currentArrow.style.left = bounds.width - (triggerBounds.width / 2) - 20 + 'px';
        }
    };
    Popover.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        if (this.props.show !== undefined && prevProps.show !== this.props.show) {
            this.setState({
                showState: this.props.show,
            });
            return;
        }
        if (this.state.showState) {
            // getting tab Element
            document.addEventListener("focus", this.onFocus, true);
            this.tabElements = (_a = this.boxRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('input, button, a, select, textarea, div[tabindex="0"], div[role="button"]:not([aria-hidden=true]), div[role="checkbox"]:not([aria-hidden=true]), div[role="radio"]:not([aria-hidden=true])');
            if (this.tabElements) {
                this.firstEl = this.tabElements[0];
                this.lastEl = this.tabElements[this.tabElements.length - 1];
            }
            if (!this.boxRef2.current || !this.triggerRef.current) {
                return;
            }
            var currentBox = this.boxRef2.current;
            var bounds = currentBox === null || currentBox === void 0 ? void 0 : currentBox.getBoundingClientRect();
            var triggerPoint = this.triggerRef.current;
            triggerPoint.getBoundingClientRect();
            // autoscroll
            if (((_b = this.boxRef2) === null || _b === void 0 ? void 0 : _b.current) !== null && ((_d = (_c = this.boxRef2) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.scrollTo)) {
                var isVisible = bounds.top + bounds.height - 1 >= window.innerHeight;
                if (this.props.sizing && window.innerWidth <= 767) ;
                else {
                    if (isVisible) {
                        window.scrollTo({
                            top: window.pageYOffset + 5 + (bounds.top + bounds.height - window.innerHeight),
                            left: 0,
                            behavior: 'smooth',
                        });
                        setTimeout(function () {
                            var _a;
                            (_a = _this.firstEl) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 300);
                    }
                    else {
                        (_e = this.firstEl) === null || _e === void 0 ? void 0 : _e.focus();
                    }
                }
            }
            this.autoAlignPopover();
        }
        if (prevState.showState === true && this.state.showState === false) {
            this.triggerRef.current.focus();
        }
    };
    Popover.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.handleClickOutside, true);
        document.removeEventListener("focus", this.onFocus, true);
        window.removeEventListener("resize", this.setResize);
    };
    Popover.prototype.showPopover = function () {
        if (!this.boxRef2.current) {
            return;
        }
        var currentBox = this.boxRef2.current;
        var sc = currentBox.style;
        sc.removeProperty('left');
        sc.removeProperty('right');
        if (this.props.onOpen) {
            this.props.onOpen();
        }
        else {
            this.setState({
                showState: true,
            });
        }
    };
    Popover.prototype.hidePopover = function () {
        if (this.props.onClose) {
            this.props.onClose();
        }
        else {
            this.setState({
                showState: false,
            });
        }
    };
    Popover.prototype.onClick = function (e) {
        e.stopPropagation();
        if (this.state.showState) {
            this.hidePopover();
        }
        else {
            this.showPopover();
        }
    };
    Popover.prototype.render = function () {
        var _a = this.props, testId = _a.testId, uniqueId = _a.uniqueId, sizing = _a.sizing, smallPadding = _a.smallPadding, _b = _a.align, align = _b === void 0 ? 'left' : _b, showClose = _a.showClose, title = _a.title; _a.ariaHidden; var _c = _a.content, content = _c === void 0 ? "stuff" : _c; _a.show; var boxWidth = _a.boxWidth, children = _a.children, _e = _a.position, position = _e === void 0 ? "bottom" : _e, className = _a.className;
        var showState = this.state.showState;
        var styleObj;
        if (position === "top") {
            styleObj = {
                bottom: '25px',
            };
        }
        else {
            styleObj = {};
        }
        var sizingVal = sizing ? true : false;
        return (React__default.createElement("div", { className: "inline-block", style: { verticalAlign: "middle" }, "data-testid": testId },
            React__default.createElement("div", { className: Join.join(["outerContainer"]), "data-testid": testId, id: 'popover-outer-' + uniqueId },
                React__default.createElement("div", { ref: this.triggerRef, className: Join.join("rel", "trigger", styles$g.childContainer, className), onClick: this.onClick, onKeyDown: this.KeyDownHandler, "aria-expanded": showState ? true : false }, children),
                React__default.createElement("div", { ref: this.boxRef, onKeyDown: this.popoverKeyDown, className: Join.join(align === 'right' ? styles$g.popoverWrapperRight : styles$g.popoverWrapper, "text-left", align === 'right' ? 'flex justify-end' : align === 'center' ? 'flex justify-center' : '') },
                    React__default.createElement("div", { ref: this.boxRef2, id: uniqueId + '-popoverBox', className: Join.join(styles$g.popover, "absolute mar-t-xxs bg-white border border-gray-300 pad-sm-all opacity0 text-left fadein", smallPadding ? 'pad-xs-lg' : '', showState ? styles$g.z1 : "fadeout " + styles$g.zOne, showState && sizingVal ? styles$g.popoverFull : ''), style: __assign({ width: boxWidth + 'px' }, styleObj), tabIndex: showState ? 0 : -1, "aria-hidden": false },
                        position === "top" ? React__default.createElement("div", { ref: this.arrowRef, className: Join.join("arrow", showState && styles$g.show, styles$g.arrow, styles$g.arrowBottom, showState && sizingVal ? styles$g.arrowshowFull : '') }) : null,
                        showState ?
                            React__default.createElement(React__default.Fragment, null,
                                React__default.createElement("h3", { tabIndex: 0, ref: this.headingRef, className: [
                                        styles$g.popoverHeading,
                                        'heading-md mar-b-xs',
                                    ].join(' ') }, title),
                                content,
                                React__default.createElement("button", { onClick: this.hidePopover, name: "close", className: [
                                        styles$g.closeButton,
                                        "flex absolute",
                                        showClose ? '' : styles$g.closeHide,
                                        sizingVal ? styles$g.closeButtonFull : '',
                                    ].join(" "), "aria-label": "Close popup" },
                                    React__default.createElement("span", { className: "flex icon-close height-md-all width-md-all" }))) : null,
                        position === "bottom" ? React__default.createElement("div", { ref: this.arrowRef, className: Join.join("arrow", showState && styles$g.show, styles$g.arrow, styles$g.arrowTop, showState && sizingVal ? styles$g.arrowshowFull : '') }) : null)))));
    };
    return Popover;
}(React__default.Component));
exports.default = Popover;
});

var Popover = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Popover_1.default;
});

var progressIndicatorContainer = "ProgressIndicator_progress-indicator-container__9UXpm";
var infoContainer = "ProgressIndicator_info-container__RmV5M";
var title = "ProgressIndicator_title__EDuKH";
var pagination = "ProgressIndicator_pagination__uut4n";
var outerBar = "ProgressIndicator_outer-bar__Y4QkL";
var innerBar = "ProgressIndicator_inner-bar__LI4fE";
var css_248z$l = ".ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n  font-size: 34px;\n  bottom: 0;\n  width: 85%; }\n  @media (max-width: 1023px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n      font-size: 28px; } }\n  @media (max-width: 767px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n      font-size: 22px; } }\n\n.ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_pagination__uut4n {\n  font-size: 12px;\n  padding-top: 10px;\n  bottom: 3px; }\n  @media (max-width: 767px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_pagination__uut4n {\n      font-size: 11px; } }\n\n.ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_outer-bar__Y4QkL {\n  width: 100%;\n  border-radius: 2px; }\n  .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_outer-bar__Y4QkL .ProgressIndicator_inner-bar__LI4fE {\n    padding: 1.5px;\n    border-radius: 2px; }\n";
var ProgressIndicator$1 = {"progress-indicator-container":"ProgressIndicator_progress-indicator-container__9UXpm","info-container":"ProgressIndicator_info-container__RmV5M","title":"ProgressIndicator_title__EDuKH","pagination":"ProgressIndicator_pagination__uut4n","outer-bar":"ProgressIndicator_outer-bar__Y4QkL","inner-bar":"ProgressIndicator_inner-bar__LI4fE","progressIndicatorContainer":"ProgressIndicator_progress-indicator-container__9UXpm","infoContainer":"ProgressIndicator_info-container__RmV5M","outerBar":"ProgressIndicator_outer-bar__Y4QkL","innerBar":"ProgressIndicator_inner-bar__LI4fE"};
var stylesheet$i=".ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n  font-size: 34px;\n  bottom: 0;\n  width: 85%; }\n  @media (max-width: 1023px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n      font-size: 28px; } }\n  @media (max-width: 767px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_title__EDuKH {\n      font-size: 22px; } }\n\n.ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_pagination__uut4n {\n  font-size: 12px;\n  padding-top: 10px;\n  bottom: 3px; }\n  @media (max-width: 767px) {\n    .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_info-container__RmV5M .ProgressIndicator_pagination__uut4n {\n      font-size: 11px; } }\n\n.ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_outer-bar__Y4QkL {\n  width: 100%;\n  border-radius: 2px; }\n  .ProgressIndicator_progress-indicator-container__9UXpm .ProgressIndicator_outer-bar__Y4QkL .ProgressIndicator_inner-bar__LI4fE {\n    padding: 1.5px;\n    border-radius: 2px; }\n";
styleInject(css_248z$l);

var ProgressIndicator$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    progressIndicatorContainer: progressIndicatorContainer,
    infoContainer: infoContainer,
    title: title,
    pagination: pagination,
    outerBar: outerBar,
    innerBar: innerBar,
    'default': ProgressIndicator$1,
    stylesheet: stylesheet$i
});

var styles$f = /*@__PURE__*/getAugmentedNamespace(ProgressIndicator$2);

var ProgressIndicator_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



var ProgressIndicator = function (_a) {
    var testId = _a.testId, title = _a.title, numPages = _a.numPages, currentPageNum = _a.currentPageNum, className = _a.className, accessibility = _a.accessibility, isFirstElement = _a.isFirstElement;
    return (React__default.createElement("div", { "data-testid": testId, className: Join.join(styles$f.progressIndicatorContainer, className) },
        React__default.createElement("div", { role: "alert", "aria-label": accessibility, className: Join.join(styles$f.infoContainer, "flex", "rel", "text-left") },
            isFirstElement ? (React__default.createElement("h1", { className: Join.join(styles$f.title, "pull-left", "color-ui-black", "font-medium") }, title)) : (React__default.createElement("h2", { className: Join.join(styles$f.title, "pull-left", "color-ui-black", "font-medium") }, title)),
            React__default.createElement("span", { className: Join.join(styles$f.pagination, "absolute", "pull-right", "color-ui-dark-gray", "pad-l-xxs", "right"), "aria-label": "progress is on step " },
                currentPageNum,
                " of ",
                numPages)),
        React__default.createElement("div", { className: Join.join(styles$f.outerBar, "height-xxxs", "bg-ui-light-gray", "mar-t-xs") },
            React__default.createElement("div", { className: Join.join(styles$f.innerBar, "height-xxxs", "bg-att-blue"), style: { width: (currentPageNum / numPages) * 100 + "%" } }))));
};
exports.default = ProgressIndicator;
});

var ProgressIndicator = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = ProgressIndicator_1.default;
});

var css_248z$k = " {\n  /* reward card badge colors */ }\n  .rcb-berry-lt-black {\n    background-color: rgba(255, 133, 129, 0.95);\n    color: #1d2329 !important; }\n  .rcb-berry-black {\n    background-color: rgba(255, 88, 93, 0.95);\n    color: #1d2329 !important; }\n  .rcb-berry-white {\n    background-color: rgba(255, 88, 93, 0.95);\n    color: #ffffff !important;\n    text-shadow: 0.5px 0.5px 0.5px #c70032; }\n  .rcb-berry-dk-white {\n    background-color: rgba(209, 34, 59, 0.95);\n    color: #ffffff !important; }\n  .rcb-mint-lt-black {\n    background-color: rgba(120, 255, 255, 0.95);\n    color: #1d2329 !important; }\n  .rcb-mint-black {\n    background-color: rgba(73, 238, 220, 0.95);\n    color: #1d2329 !important; }\n  .rcb-mint-dk-white {\n    background-color: rgba(0, 193, 178, 0.95);\n    color: #ffffff !important;\n    text-shadow: 0.5px 0.5px 0.5px rgba(1, 88, 82, 0.5); }\n  .rcb-lime-lt-black {\n    background-color: rgba(188, 255, 68, 0.95);\n    color: #1d2329 !important; }\n  .rcb-lime-black {\n    background-color: rgba(145, 220, 0, 0.95);\n    color: #1d2329 !important; }\n  .rcb-lime-dk-white {\n    background-color: rgba(106, 178, 0, 0.95);\n    color: #ffffff !important;\n    text-shadow: 0.5px 0.5px 0.5px rgba(50, 84, 0, 0.5); }\n  .rcb-tangerine-lt-black {\n    background-color: rgba(255, 216, 66, 0.95);\n    color: #1d2329 !important; }\n  .rcb-tangerine-black {\n    background-color: rgba(255, 176, 0, 0.95);\n    color: #1d2329 !important; }\n  .rcb-tangerine-dk-white {\n    background-color: rgba(208, 135, 0, 0.95);\n    color: #ffffff !important;\n    text-shadow: 0.5px 0.5px 0.5px rgba(100, 65, 0, 0.5); }\n  .rcb-purple-lt-black {\n    background-color: rgba(231, 92, 229, 0.95);\n    color: #1d2329 !important; }\n  .rcb-purple-white {\n    background-color: rgba(175, 41, 187, 0.95);\n    color: #ffffff !important; }\n  .rcb-pruple-dk-white {\n    background-color: rgba(146, 0, 146, 0.95);\n    color: #ffffff !important; }\n  .rcb-white-black {\n    background-color: rgba(255, 255, 255, 0.95);\n    color: #1d2329 !important; }\n  .rcb-ui-black-white {\n    background-color: rgba(29, 35, 41, 0.95);\n    color: #ffffff !important; }\n  .rcb-cobalt-white {\n    background-color: rgba(0, 87, 184, 0.95);\n    color: #ffffff !important; }\n  .rcb-ui-grey-ui-black {\n    background-color: rgba(242, 242, 242, 0.95);\n    color: #1d2329 !important; }\n  .rcb-black-white {\n    background-color: rgba(0, 0, 0, 0.95);\n    color: #ffffff !important; }\n";
styleInject(css_248z$k);

var dataDemoFocus = "PromoBadge_dataDemoFocus__RNMXw";
var rewardCard = "PromoBadge_reward-card__53Nh3";
var rewardCardCopy = "PromoBadge_reward-card-copy__VDBY7";
var rewardCardImg = "PromoBadge_reward-card-img__JQahX";
var rewardCardLegal = "PromoBadge_reward-card-legal__-DZDN";
var css_248z$j = ".PromoBadge_dataDemoFocus__RNMXw:focus {\n  outline: 2px dotted #ffffff;\n  outline-offset: 3px; }\n\n.PromoBadge_reward-card__53Nh3 {\n  min-width: 140px;\n  max-width: 140px;\n  max-height: 23.4rem; }\n\n.PromoBadge_reward-card-copy__VDBY7 {\n  font-size: 1.4rem;\n  line-height: 1.2;\n  padding: 16px 8px; }\n\n.PromoBadge_reward-card-copy__VDBY7 b {\n  font-family: font-regular;\n  font-weight: bold; }\n\n.PromoBadge_reward-card-img__JQahX {\n  text-align: center;\n  padding: 0 16px; }\n\n.PromoBadge_reward-card-img__JQahX img {\n  max-height: 100px; }\n\n.PromoBadge_reward-card-legal__-DZDN {\n  font-size: 1.1rem; }\n\na.PromoBadge_reward-card__53Nh3,\na.PromoBadge_reward-card__53Nh3:hover {\n  text-decoration: none;\n  z-index: 1; }\n\nbody.is-tabbing a.PromoBadge_reward-card__53Nh3:focus {\n  box-shadow: 0 0 0 1px #000000 inset, 0 0 0 2px #ffffff inset;\n  outline: none; }\n\n@media (max-width: 767px) {\n  .PromoBadge_reward-card__53Nh3 {\n    font-size: 1rem;\n    min-width: 90px;\n    max-width: 90px;\n    max-height: 15.4rem; }\n  .PromoBadge_reward-card-copy__VDBY7 {\n    font-size: 1rem;\n    padding: 4px; }\n  .PromoBadge_reward-card-img__JQahX {\n    padding: 0 8px; }\n  .PromoBadge_reward-card-img__JQahX img {\n    max-height: 60px; }\n  .PromoBadge_reward-card-legal__-DZDN {\n    font-size: 0.9rem; } }\n";
var PromoBadge$1 = {"dataDemoFocus":"PromoBadge_dataDemoFocus__RNMXw","reward-card":"PromoBadge_reward-card__53Nh3","reward-card-copy":"PromoBadge_reward-card-copy__VDBY7","reward-card-img":"PromoBadge_reward-card-img__JQahX","reward-card-legal":"PromoBadge_reward-card-legal__-DZDN","rewardCard":"PromoBadge_reward-card__53Nh3","rewardCardCopy":"PromoBadge_reward-card-copy__VDBY7","rewardCardImg":"PromoBadge_reward-card-img__JQahX","rewardCardLegal":"PromoBadge_reward-card-legal__-DZDN"};
var stylesheet$h=".PromoBadge_dataDemoFocus__RNMXw:focus {\n  outline: 2px dotted #ffffff;\n  outline-offset: 3px; }\n\n.PromoBadge_reward-card__53Nh3 {\n  min-width: 140px;\n  max-width: 140px;\n  max-height: 23.4rem; }\n\n.PromoBadge_reward-card-copy__VDBY7 {\n  font-size: 1.4rem;\n  line-height: 1.2;\n  padding: 16px 8px; }\n\n.PromoBadge_reward-card-copy__VDBY7 b {\n  font-family: font-regular;\n  font-weight: bold; }\n\n.PromoBadge_reward-card-img__JQahX {\n  text-align: center;\n  padding: 0 16px; }\n\n.PromoBadge_reward-card-img__JQahX img {\n  max-height: 100px; }\n\n.PromoBadge_reward-card-legal__-DZDN {\n  font-size: 1.1rem; }\n\na.PromoBadge_reward-card__53Nh3,\na.PromoBadge_reward-card__53Nh3:hover {\n  text-decoration: none;\n  z-index: 1; }\n\nbody.is-tabbing a.PromoBadge_reward-card__53Nh3:focus {\n  box-shadow: 0 0 0 1px #000000 inset, 0 0 0 2px #ffffff inset;\n  outline: none; }\n\n@media (max-width: 767px) {\n  .PromoBadge_reward-card__53Nh3 {\n    font-size: 1rem;\n    min-width: 90px;\n    max-width: 90px;\n    max-height: 15.4rem; }\n  .PromoBadge_reward-card-copy__VDBY7 {\n    font-size: 1rem;\n    padding: 4px; }\n  .PromoBadge_reward-card-img__JQahX {\n    padding: 0 8px; }\n  .PromoBadge_reward-card-img__JQahX img {\n    max-height: 60px; }\n  .PromoBadge_reward-card-legal__-DZDN {\n    font-size: 0.9rem; } }\n";
styleInject(css_248z$j);

var PromoBadge$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    dataDemoFocus: dataDemoFocus,
    rewardCard: rewardCard,
    rewardCardCopy: rewardCardCopy,
    rewardCardImg: rewardCardImg,
    rewardCardLegal: rewardCardLegal,
    'default': PromoBadge$1,
    stylesheet: stylesheet$h
});

var styles$e = /*@__PURE__*/getAugmentedNamespace(PromoBadge$2);

var PromoBadge_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



var PromoBadge = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
    var offSetClass = ((_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.offSet) === null || _b === void 0 ? void 0 : _b.phone) ? " offset" + ((_c = props.options) === null || _c === void 0 ? void 0 : _c.offSet.phone) + "-sm"
        : "";
    offSetClass =
        offSetClass +
            (((_e = (_d = props.options) === null || _d === void 0 ? void 0 : _d.offSet) === null || _e === void 0 ? void 0 : _e.tablet) ? " offset" + ((_f = props.options) === null || _f === void 0 ? void 0 : _f.offSet.tablet) + "-md" : "");
    offSetClass =
        offSetClass +
            (((_h = (_g = props.options) === null || _g === void 0 ? void 0 : _g.offSet) === null || _h === void 0 ? void 0 : _h.desktop) ? " offset" + ((_j = props.options) === null || _j === void 0 ? void 0 : _j.offSet.desktop) : "");
    var gridCols = ((_l = (_k = props.options) === null || _k === void 0 ? void 0 : _k.gridCols) === null || _l === void 0 ? void 0 : _l.phone) ? " grid-col-" + ((_m = props.options) === null || _m === void 0 ? void 0 : _m.gridCols.phone) + "-sm"
        : "";
    gridCols =
        gridCols +
            (((_p = (_o = props.options) === null || _o === void 0 ? void 0 : _o.gridCols) === null || _p === void 0 ? void 0 : _p.tablet) ? " grid-col-" + ((_q = props.options) === null || _q === void 0 ? void 0 : _q.gridCols.tablet) + "-md"
                : "");
    gridCols =
        gridCols +
            (((_s = (_r = props.options) === null || _r === void 0 ? void 0 : _r.gridCols) === null || _s === void 0 ? void 0 : _s.desktop) ? " grid-col-" + ((_t = props.options) === null || _t === void 0 ? void 0 : _t.gridCols.desktop) : "");
    gridCols = gridCols === "" ? " grid-" : gridCols;
    var verticalPos = ((_v = (_u = props.options) === null || _u === void 0 ? void 0 : _u.verticalPosition) === null || _v === void 0 ? void 0 : _v.phone) ? " flex-self-" + ((_w = props.options) === null || _w === void 0 ? void 0 : _w.verticalPosition.phone.toLowerCase()) + "-sm"
        : "";
    verticalPos =
        verticalPos +
            (((_y = (_x = props.options) === null || _x === void 0 ? void 0 : _x.verticalPosition) === null || _y === void 0 ? void 0 : _y.tablet) ? " flex-self-" + ((_z = props.options) === null || _z === void 0 ? void 0 : _z.verticalPosition.tablet.toLowerCase()) + "-md"
                : "");
    verticalPos =
        verticalPos +
            (((_1 = (_0 = props.options) === null || _0 === void 0 ? void 0 : _0.verticalPosition) === null || _1 === void 0 ? void 0 : _1.desktop) ? " flex-self-" + ((_2 = props.options) === null || _2 === void 0 ? void 0 : _2.verticalPosition.desktop.toLowerCase())
                : "");
    verticalPos =
        verticalPos === ""
            ? ((_4 = (_3 = props.options) === null || _3 === void 0 ? void 0 : _3.verticalPosition) === null || _4 === void 0 ? void 0 : _4.all) ? " flex-self-" + ((_6 = (_5 = props.options) === null || _5 === void 0 ? void 0 : _5.verticalPosition) === null || _6 === void 0 ? void 0 : _6.all.toLowerCase())
                : " flex-self-top"
            : verticalPos;
    return (
    /* begin reward-card-badge-container */
    React__default.createElement("div", { "data-testid": props.testId, className: (props.options && props.options.customClass ? props.options.customClass + " " : "") + "absolute top right bottom left pad-l-xs pad-r-xs" },
        React__default.createElement("div", { className: "row-nowrap height-full" },
            React__default.createElement("div", { className: offSetClass +
                    gridCols +
                    " justify-" +
                    (((_7 = props.options) === null || _7 === void 0 ? void 0 : _7.horizontalPosition) ? props.options.horizontalPosition.toLowerCase() === "right"
                        ? "end"
                        : props.options.horizontalPosition.toLowerCase()
                        : "center") +
                    " " +
                    " pad-b-none pad-t-none flex" +
                    (verticalPos ? verticalPos : " ") },
                !((_8 = props.options) === null || _8 === void 0 ? void 0 : _8.clickable) && (React__default.createElement("span", { className: styles$e.rewardCard + " reward-card rel " + (((_9 = props.options) === null || _9 === void 0 ? void 0 : _9.cardColor) ? props.options.cardColor : "") },
                    React__default.createElement("div", { "aria-hidden": "true" },
                        React__default.createElement("div", { className: styles$e.rewardCardCopy + " mar-b-none block text-center " + styles$e.dataDemoFocus, "tab-index": "0", dangerouslySetInnerHTML: {
                                __html: props.data.message ? props.data.message : "",
                            } }),
                        React__default.createElement("div", { className: styles$e.rewardCardImg + " block" },
                            React__default.createElement("img", { src: props.data.cardImage, alt: "" })),
                        React__default.createElement("div", { className: styles$e.rewardCardLegal + " text-center pad-t-xs pad-t-xxs-sm pad-b-xxs pad-l-xxs pad-r-xxs pad-l-xxxs-sm pad-r-xxxs-sm" }, props.data.cardLabel)),
                    React__default.createElement("div", { className: "hidden-spoken cta-overlay", role: "option" }, props.data.ariaMessage))),
                ((_10 = props.options) === null || _10 === void 0 ? void 0 : _10.clickable) && (React__default.createElement("a", { href: ((_11 = props.options) === null || _11 === void 0 ? void 0 : _11.url) ? (_12 = props.options) === null || _12 === void 0 ? void 0 : _12.url : undefined, target: ((_13 = props.options) === null || _13 === void 0 ? void 0 : _13.targetWindow) ? (_14 = props.options) === null || _14 === void 0 ? void 0 : _14.targetWindow : "_self", className: styles$e.rewardCard + " reward-card rel " + (((_15 = props.options) === null || _15 === void 0 ? void 0 : _15.cardColor) ? props.options.cardColor : "") },
                    React__default.createElement("div", { "aria-hidden": "true" },
                        React__default.createElement("div", { className: styles$e.rewardCardCopy + " mar-b-none block text-center " + styles$e.dataDemoFocus, "tab-index": "0", dangerouslySetInnerHTML: {
                                __html: props.data.message ? props.data.message : "",
                            } }),
                        React__default.createElement("div", { className: styles$e.rewardCardImg + " block" },
                            React__default.createElement("img", { src: props.data.cardImage, alt: "" })),
                        React__default.createElement("div", { className: styles$e.rewardCardLegal + " text-center pad-t-xs pad-t-xxs-sm pad-b-xxs pad-l-xxs pad-r-xxs pad-l-xxxs-sm pad-r-xxxs-sm" }, props.data.cardLabel)),
                    React__default.createElement("div", { className: "hidden-spoken cta-overlay", role: "option" }, props.data.ariaMessage))))))
    /* end reward-card-badge-container */
    );
};
exports.default = PromoBadge;
});

var PromoBadge = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = PromoBadge_1.default;
});

var radioGroupError = "RadioGroup_radioGroupError__X14ZQ";
var css_248z$i = ".RadioGroup_radioGroupError__X14ZQ {\n  height: auto !important;\n  min-height: 2rem; }\n";
var RadioGroup$1 = {"radioGroupError":"RadioGroup_radioGroupError__X14ZQ"};
var stylesheet$g=".RadioGroup_radioGroupError__X14ZQ {\n  height: auto !important;\n  min-height: 2rem; }\n";
styleInject(css_248z$i);

var RadioGroup$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    radioGroupError: radioGroupError,
    'default': RadioGroup$1,
    stylesheet: stylesheet$g
});

var groupStyles = /*@__PURE__*/getAugmentedNamespace(RadioGroup$2);

var RadioGroup_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });


var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.renderChildren = function () {
            var _a = _this.props, children = _a.children, options = _a.options;
            return React__default.Children.map(children, function (child) {
                return React__default.cloneElement(child, __assign(__assign({}, _this.radioItemProps), { error: child.props.error ? child.props.error : _this.radioItemProps.error, selected: _this.state.selected === child.props.value, spacing: child.props.last
                        ? 0
                        : options
                            ? options.spacing
                                ? options.spacing
                                : 8
                            : 8 }));
            });
        };
        _this.handleChange = function (event) {
            _this.setState({ selected: event.currentTarget.value }, function () {
                var onChange = _this.props.onChange;
                var selected = _this.state.selected;
                if (onChange) {
                    onChange(selected);
                }
            });
        };
        _this.handleKeyPress = function (value) {
            _this.setState({ selected: value }, function () {
                var onChange = _this.props.onChange;
                var selected = _this.state.selected;
                if (onChange) {
                    onChange(selected);
                }
            });
        };
        _this.render = function () {
            var _a = _this.props, error = _a.error, errorMessage = _a.errorMessage, options = _a.options, testId = _a.testId, title = _a.title;
            var elementsDirection = options && options.elementsDirection && options.elementsDirection === "column"
                ? "flex-column"
                : "";
            return (React__default.createElement("div", { "data-testid": testId, className: ["flex", elementsDirection].join(" ") },
                React__default.createElement("fieldset", { className: error ? "error" : undefined },
                    errorMessage && (React__default.createElement("div", { id: _this.hintId, className: [groupStyles.radioGroupError, "formfield-msg", "mar-b-xs"].join(" "), "aria-live": "polite", "aria-atomic": error ? true : false, "aria-hidden": error ? false : true, tabIndex: -1 }, errorMessage)),
                    title && (React__default.createElement("legend", { className: "type-sm font-medium color-ui-black" },
                        React__default.createElement("span", null, title))),
                    _this.renderChildren())));
        };
        _this.getInitialRadioItemProps = function () {
            var _a = _this.props, className = _a.className, error = _a.error, errorMessage = _a.errorMessage, options = _a.options;
            var elementsDirection = options && options.elementsDirection;
            return {
                className: className,
                error: error,
                errorMessage: errorMessage,
                elementsDirection: elementsDirection,
                events: {
                    onChange: _this.handleChange.bind(_this),
                    onKeyPress: _this.handleKeyPress.bind(_this),
                },
                name: _this.props.name,
                hintId: _this.hintId,
            };
        };
        _this.guid = function () {
            return "" + _this.S4() + _this.S4() + "-" + _this.S4() + "-" + _this.S4() + "-" + _this.S4() + "-" + _this.S4() + _this.S4() + _this.S4();
        };
        _this.S4 = function () {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        };
        _this.state = {
            selected: props.defaultChecked || "",
        };
        _this.hintId = _this.guid();
        _this.radioItemProps = _this.getInitialRadioItemProps();
        return _this;
    }
    RadioGroup.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, defaultChecked = _a.defaultChecked, persistentDefaultChecked = _a.persistentDefaultChecked;
        if (prevState.selected !== defaultChecked && persistentDefaultChecked) {
            this.setState({
                selected: defaultChecked ? defaultChecked : "",
            });
        }
    };
    return RadioGroup;
}(React__default.Component));
exports.default = RadioGroup;
});

var RadioGroup = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = RadioGroup_1.default;
});

var radioCardDefault = "RadioButton_radio-card-default__pHqmf";
var radioCardActive = "RadioButton_radio-card-active__jSfHA";
var error = "RadioButton_error__g6DAi";
var disabled = "RadioButton_disabled__VQVju";
var radio = "RadioButton_radio__YO25-";
var radioSkin = "RadioButton_radio-skin__oD6Ke";
var css_248z$h = ".RadioButton_radio-card-default__pHqmf::after {\n  content: \"\";\n  border-radius: 3px;\n  border: solid 1px #dcdfe3;\n  overflow: hidden;\n  transition: border 0.15s ease;\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.RadioButton_radio-card-active__jSfHA::after {\n  content: \"\";\n  border-radius: 3px;\n  border: solid 2px #0057b8;\n  overflow: hidden;\n  transition: border 0.15s ease;\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.RadioButton_radio-card-active__jSfHA:focus-within::after {\n  border: 2px solid #a6c4e6; }\n\n.RadioButton_error__g6DAi.RadioButton_radio-card-active__jSfHA::after,\n.RadioButton_error__g6DAi.RadioButton_radio-card-default__pHqmf::after {\n  border: solid 2px #c70032; }\n\n.RadioButton_disabled__VQVju.RadioButton_radio-card-active__jSfHA::after {\n  border: solid 1px #dcdfe3; }\n\n.RadioButton_disabled__VQVju.RadioButton_radio-card-active__jSfHA,\n.RadioButton_disabled__VQVju.RadioButton_radio-card-default__pHqmf {\n  cursor: not-allowed !important; }\n\n.RadioButton_radio-card-default__pHqmf:hover:not(.RadioButton_error__g6DAi):not(.RadioButton_disabled__VQVju)::after {\n  border-color: #454b52; }\n\n.RadioButton_radio__YO25- input:focus + .RadioButton_radio-skin__oD6Ke {\n  border: none;\n  outline: none; }\n";
var RadioButton$1 = {"radio-card-default":"RadioButton_radio-card-default__pHqmf","radio-card-active":"RadioButton_radio-card-active__jSfHA","error":"RadioButton_error__g6DAi","disabled":"RadioButton_disabled__VQVju","radio":"RadioButton_radio__YO25-","radio-skin":"RadioButton_radio-skin__oD6Ke","radioCardDefault":"RadioButton_radio-card-default__pHqmf","radioCardActive":"RadioButton_radio-card-active__jSfHA","radioSkin":"RadioButton_radio-skin__oD6Ke"};
var stylesheet$f=".RadioButton_radio-card-default__pHqmf::after {\n  content: \"\";\n  border-radius: 3px;\n  border: solid 1px #dcdfe3;\n  overflow: hidden;\n  transition: border 0.15s ease;\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.RadioButton_radio-card-active__jSfHA::after {\n  content: \"\";\n  border-radius: 3px;\n  border: solid 2px #0057b8;\n  overflow: hidden;\n  transition: border 0.15s ease;\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.RadioButton_radio-card-active__jSfHA:focus-within::after {\n  border: 2px solid #a6c4e6; }\n\n.RadioButton_error__g6DAi.RadioButton_radio-card-active__jSfHA::after,\n.RadioButton_error__g6DAi.RadioButton_radio-card-default__pHqmf::after {\n  border: solid 2px #c70032; }\n\n.RadioButton_disabled__VQVju.RadioButton_radio-card-active__jSfHA::after {\n  border: solid 1px #dcdfe3; }\n\n.RadioButton_disabled__VQVju.RadioButton_radio-card-active__jSfHA,\n.RadioButton_disabled__VQVju.RadioButton_radio-card-default__pHqmf {\n  cursor: not-allowed !important; }\n\n.RadioButton_radio-card-default__pHqmf:hover:not(.RadioButton_error__g6DAi):not(.RadioButton_disabled__VQVju)::after {\n  border-color: #454b52; }\n\n.RadioButton_radio__YO25- input:focus + .RadioButton_radio-skin__oD6Ke {\n  border: none;\n  outline: none; }\n";
styleInject(css_248z$h);

var RadioButton$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    radioCardDefault: radioCardDefault,
    radioCardActive: radioCardActive,
    error: error,
    disabled: disabled,
    radio: radio,
    radioSkin: radioSkin,
    'default': RadioButton$1,
    stylesheet: stylesheet$f
});

var styles$d = /*@__PURE__*/getAugmentedNamespace(RadioButton$2);

var RadioButton_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



var RadioButton = function (props) {
    var inputRef = React__default.useRef(null);
    var labelRef = React__default.useRef(null);
    var guid = function () {
        return "" + S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
    };
    var S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    var handleClick = function (e) {
        var elem = e.target;
        if (e.screenX === 0 && e.screenY === 0) {
            elem.setAttribute("event-type", "keyboard");
        }
        else {
            elem.setAttribute("event-type", "mouse");
        }
    };
    var onKeyUp = function (e) {
        if (props.events && props.events.onKeyPress) {
            props.events.onKeyPress(e.currentTarget.value);
        }
    };
    var getBottomMargin = function () {
        return { marginBottom: props.last ? "0px" : props.spacing + "px" };
    };
    var renderChildren = function () {
        if (props.children) {
            return React__default.createElement("div", null, props.children);
        }
        return null;
    };
    var classes = [
        props.classes ? props.classes.join(" ") : "",
        props.className,
        props.disabled ? styles$d.disabled : "",
        props.card
            ? (props.selected ? styles$d.radioCardActive : styles$d.radioCardDefault) + " pad-xs"
            : "",
        props.error ? styles$d.error + " error" : "",
        props.elementsDirection === "column" ? "flex" : "inline-flex",
        "radio flex-items-top",
    ];
    var inputId = guid();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("label", { style: props.card ? getBottomMargin() : undefined, ref: labelRef, htmlFor: inputId, "data-testid": props.testId, className: classes.join(" ").trim() },
            React__default.createElement("input", { id: inputId, "aria-label": props.accessibilityText ? props.accessibilityText : props.value, "aria-describedby": props.errorMessage ? props.hintId : undefined, type: "radio", name: props.name, checked: props.selected, onClick: handleClick, onChange: props.events ? props.events.onChange : undefined, onKeyUp: onKeyUp, "event-type": "keyboard", ref: inputRef, value: props.value, "aria-invalid": props.error, disabled: props.disabled }),
            React__default.createElement("div", { className: "radio-skin" }),
            React__default.createElement("span", { className: "rad-chk-txt", "aria-hidden": true }, props.customLabel ? renderChildren() : props.value),
            props.customLabel ? null : renderChildren()),
        props.errorMessage && (React__default.createElement("div", { className: ["formfield-msg", groupStyles.radioGroupError].join(" "), "aria-live": "polite", "aria-atomic": false, "aria-hidden": false, tabIndex: -1 }, props.errorMessage))));
};
exports.default = RadioButton;
});

var RadioButton = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = RadioButton_1.default;
});

var optionHidden = "Select_option-hidden__O5lIb";
var requiredError$1 = "Select_required-error__Lm35s";
var label$1 = "Select_label__LTks9";
var group = "Select_group__h-bOy";
var dropdownButton$1 = "Select_dropdown-button__iPJOw";
var dropdownButtonMultiline = "Select_dropdown-button-multiline__CU3GJ";
var dropdownButtonNotSelected = "Select_dropdown-button-not-selected__L7-56";
var dropdownButtonSelected = "Select_dropdown-button-selected__bciTz";
var dropdownButtonFocus$1 = "Select_dropdown-button-focus__8vHGQ";
var optionListItem$1 = "Select_option-list-item__YlYUX";
var optionListItemPad = "Select_option-list-item-pad__qfRNT";
var optionWrapper$1 = "Select_optionWrapper__5zzhr";
var optionWrapperOpen$1 = "Select_optionWrapper-open__wgMSM";
var awdSelect = "Select_awd-select__eoqw-";
var selectSkin = "Select_select-skin__Mel3q";
var selectSkinOpen = "Select_select-skin-open__ZGKOg";
var css_248z$g = "/*Select specific styles*/\n.Select_option-hidden__O5lIb {\n  max-height: 0px; }\n\n.Select_required-error__Lm35s {\n  display: initial;\n  padding-left: 2px; }\n\n.Select_label__LTks9 {\n  line-height: 1.2; }\n\n.Select_group__h-bOy {\n  cursor: text;\n  padding: 10px 24px; }\n\n.Select_dropdown-button__iPJOw {\n  display: table;\n  height: auto !important;\n  min-height: 48px;\n  outline: 0 !important;\n  padding: 10px 43px 10px 23px;\n  white-space: normal; }\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .Select_dropdown-button__iPJOw {\n      display: inline;\n      vertical-align: middle; } }\n  .Select_dropdown-button-multiline__CU3GJ {\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .Select_dropdown-button-not-selected__L7-56 {\n    color: #686e74 !important; }\n  .Select_dropdown-button-selected__bciTz {\n    color: #1d2329 !important; }\n  .Select_dropdown-button__iPJOw[aria-expanded=\"true\"] {\n    border-color: #0057b8;\n    z-index: 3; }\n    .Select_dropdown-button__iPJOw[aria-expanded=\"true\"]:after {\n      transform: rotate(-90deg); }\n\n.Select_dropdown-button-focus__8vHGQ:focus {\n  outline: 1px dotted #686e74 !important;\n  outline-offset: -6px !important; }\n\n.Select_option-list-item__YlYUX {\n  background-color: #ffffff;\n  border: none;\n  color: #454b52 !important;\n  cursor: pointer;\n  line-height: 20px;\n  min-height: 40px;\n  padding: 10px 24px;\n  text-indent: 0;\n  white-space: normal;\n  width: 100%; }\n  .Select_option-list-item__YlYUX:focus {\n    background-color: rgba(121, 126, 133, 0.05); }\n  .Select_option-list-item__YlYUX:hover {\n    background-color: rgba(121, 126, 133, 0.1);\n    color: #0057b8 !important; }\n\n.Select_option-list-item-pad__qfRNT {\n  padding: 10px 24px 10px 48px; }\n\n.Select_optionWrapper__5zzhr {\n  margin-top: -1px;\n  top: auto;\n  transform: none !important; }\n\n.Select_optionWrapper-open__wgMSM {\n  z-index: 2; }\n\n.Select_awd-select__eoqw- {\n  line-height: normal;\n  word-break: break-all;\n  z-index: 1; }\n\n.Select_select-skin__Mel3q {\n  height: 100%;\n  min-width: 120px; }\n  .Select_select-skin__Mel3q[aria-pressed=\"true\"]:after {\n    transform: rotate(-90deg); }\n\n.Select_select-skin-open__ZGKOg:after {\n  transform: rotate(-90deg) !important; }\n";
var Select$1 = {"option-hidden":"Select_option-hidden__O5lIb","required-error":"Select_required-error__Lm35s","label":"Select_label__LTks9","group":"Select_group__h-bOy","dropdown-button":"Select_dropdown-button__iPJOw","dropdown-button-multiline":"Select_dropdown-button-multiline__CU3GJ","dropdown-button-not-selected":"Select_dropdown-button-not-selected__L7-56","dropdown-button-selected":"Select_dropdown-button-selected__bciTz","dropdown-button-focus":"Select_dropdown-button-focus__8vHGQ","option-list-item":"Select_option-list-item__YlYUX","option-list-item-pad":"Select_option-list-item-pad__qfRNT","optionWrapper":"Select_optionWrapper__5zzhr","optionWrapper-open":"Select_optionWrapper-open__wgMSM","awd-select":"Select_awd-select__eoqw-","select-skin":"Select_select-skin__Mel3q","select-skin-open":"Select_select-skin-open__ZGKOg","optionHidden":"Select_option-hidden__O5lIb","requiredError":"Select_required-error__Lm35s","dropdownButton":"Select_dropdown-button__iPJOw","dropdownButtonMultiline":"Select_dropdown-button-multiline__CU3GJ","dropdownButtonNotSelected":"Select_dropdown-button-not-selected__L7-56","dropdownButtonSelected":"Select_dropdown-button-selected__bciTz","dropdownButtonFocus":"Select_dropdown-button-focus__8vHGQ","optionListItem":"Select_option-list-item__YlYUX","optionListItemPad":"Select_option-list-item-pad__qfRNT","optionWrapperOpen":"Select_optionWrapper-open__wgMSM","awdSelect":"Select_awd-select__eoqw-","selectSkin":"Select_select-skin__Mel3q","selectSkinOpen":"Select_select-skin-open__ZGKOg"};
var stylesheet$e="/*Select specific styles*/\n.Select_option-hidden__O5lIb {\n  max-height: 0px; }\n\n.Select_required-error__Lm35s {\n  display: initial;\n  padding-left: 2px; }\n\n.Select_label__LTks9 {\n  line-height: 1.2; }\n\n.Select_group__h-bOy {\n  cursor: text;\n  padding: 10px 24px; }\n\n.Select_dropdown-button__iPJOw {\n  display: table;\n  height: auto !important;\n  min-height: 48px;\n  outline: 0 !important;\n  padding: 10px 43px 10px 23px;\n  white-space: normal; }\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .Select_dropdown-button__iPJOw {\n      display: inline;\n      vertical-align: middle; } }\n  .Select_dropdown-button-multiline__CU3GJ {\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .Select_dropdown-button-not-selected__L7-56 {\n    color: #686e74 !important; }\n  .Select_dropdown-button-selected__bciTz {\n    color: #1d2329 !important; }\n  .Select_dropdown-button__iPJOw[aria-expanded=\"true\"] {\n    border-color: #0057b8;\n    z-index: 3; }\n    .Select_dropdown-button__iPJOw[aria-expanded=\"true\"]:after {\n      transform: rotate(-90deg); }\n\n.Select_dropdown-button-focus__8vHGQ:focus {\n  outline: 1px dotted #686e74 !important;\n  outline-offset: -6px !important; }\n\n.Select_option-list-item__YlYUX {\n  background-color: #ffffff;\n  border: none;\n  color: #454b52 !important;\n  cursor: pointer;\n  line-height: 20px;\n  min-height: 40px;\n  padding: 10px 24px;\n  text-indent: 0;\n  white-space: normal;\n  width: 100%; }\n  .Select_option-list-item__YlYUX:focus {\n    background-color: rgba(121, 126, 133, 0.05); }\n  .Select_option-list-item__YlYUX:hover {\n    background-color: rgba(121, 126, 133, 0.1);\n    color: #0057b8 !important; }\n\n.Select_option-list-item-pad__qfRNT {\n  padding: 10px 24px 10px 48px; }\n\n.Select_optionWrapper__5zzhr {\n  margin-top: -1px;\n  top: auto;\n  transform: none !important; }\n\n.Select_optionWrapper-open__wgMSM {\n  z-index: 2; }\n\n.Select_awd-select__eoqw- {\n  line-height: normal;\n  word-break: break-all;\n  z-index: 1; }\n\n.Select_select-skin__Mel3q {\n  height: 100%;\n  min-width: 120px; }\n  .Select_select-skin__Mel3q[aria-pressed=\"true\"]:after {\n    transform: rotate(-90deg); }\n\n.Select_select-skin-open__ZGKOg:after {\n  transform: rotate(-90deg) !important; }\n";
styleInject(css_248z$g);

var Select$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    optionHidden: optionHidden,
    requiredError: requiredError$1,
    label: label$1,
    group: group,
    dropdownButton: dropdownButton$1,
    dropdownButtonMultiline: dropdownButtonMultiline,
    dropdownButtonNotSelected: dropdownButtonNotSelected,
    dropdownButtonSelected: dropdownButtonSelected,
    dropdownButtonFocus: dropdownButtonFocus$1,
    optionListItem: optionListItem$1,
    optionListItemPad: optionListItemPad,
    optionWrapper: optionWrapper$1,
    optionWrapperOpen: optionWrapperOpen$1,
    awdSelect: awdSelect,
    selectSkin: selectSkin,
    selectSkinOpen: selectSkinOpen,
    'default': Select$1,
    stylesheet: stylesheet$e
});

var styles$c = /*@__PURE__*/getAugmentedNamespace(Select$2);

var Select_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });





var Select = React__default.forwardRef(function (props, ref) {
    var className = props.className, _a = props.defaultValue, defaultValue = _a === void 0 ? -1 : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.errorMsg, errorMsg = _c === void 0 ? "" : _c, _d = props.errorState, errorState = _d === void 0 ? false : _d, _e = props.label, label = _e === void 0 ? "Select an Option" : _e, _f = props.multiline, multiline = _f === void 0 ? false : _f, _g = props.native, native = _g === void 0 ? UserAgent.isAndroid() || UserAgent.isIos() : _g, _h = props.nativePlaceHolder, nativePlaceHolder = _h === void 0 ? false : _h, onChange = props.onChange, onBlur = props.onBlur, onKeyPress = props.onKeyPress, onError = props.onError, onClick = props.onClick, onFocus = props.onFocus, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, onHover = props.onHover, options = props.options, placeholder = props.placeholder, style = props.style, testId = props.testId, _j = props.useOnlyErrorState, useOnlyErrorState = _j === void 0 ? false : _j, _k = props.resetOption, resetOption = _k === void 0 ? false : _k;
    var buttonRef = React__default.createRef();
    var containerRef = React__default.createRef();
    var dropdownRef = React__default.createRef();
    var refOptions = __spread(Array(options.length)).map(function (_, i) { return i; });
    var group;
    var setSearchResults = function () {
        var obj = [];
        options.forEach(function (option, i) {
            obj.push({ index: i, value: option.value });
        });
        return obj;
    };
    var _l = __read(React__default.useState({
        altPressed: false,
        clicked: false,
        current: 0,
        error: false,
        nativeArrowOpen: false,
        searchResults: setSearchResults(),
        selected: defaultValue,
        show: false,
        showFocus: true,
    }), 2), state = _l[0], setState = _l[1];
    var firstUpdate = React__default.useRef(true);
    var _m = __read(React__default.useState(false), 2), refresh = _m[0], setRefresh = _m[1];
    var _o = __read(React__default.useState(null), 2), timer = _o[0], setTimer = _o[1];
    var altPressed = state.altPressed, clicked = state.clicked, current = state.current, error = state.error, searchResults = state.searchResults, selected = state.selected, show = state.show, showFocus = state.showFocus;
    var setFocus = function (value) {
        if (value !== showFocus) {
            setState(__assign(__assign({}, state), { showFocus: value }));
        }
    };
    var setFocusFalse = function () {
        setFocus(false);
    };
    var setFocusTrue = function () {
        setFocus(true);
    };
    React__default.useEffect(function () {
        if (!native) {
            if (process.browser) {
                document.addEventListener("mousedown", setFocusFalse, false);
                document.addEventListener("keydown", setFocusTrue, false);
            }
            if (show) {
                if (process.browser) {
                    document.addEventListener("mouseup", handleMouseUp, false);
                }
                refOptions[current].focus();
                if (!UserAgent.isIE() && dropdownRef.current !== null) {
                    dropdownRef.current.scrollTo(0, refOptions[current].offsetTop);
                }
                if (current === 0) {
                    setTimeout(function () {
                        if (dropdownRef.current !== null) {
                            dropdownRef.current.scrollTop = 0;
                        }
                    }, 0);
                }
            }
            if (refresh) {
                setRefresh(false);
                setTimer(null);
                setState(__assign(__assign({}, state), { searchResults: setSearchResults() }));
            }
            return function cleanup() {
                if (process.browser) {
                    document.removeEventListener("mouseup", handleMouseUp, false);
                    if (!native) {
                        document.removeEventListener("mousedown", setFocusFalse, false);
                        document.removeEventListener("keydown", setFocusTrue, false);
                    }
                }
            };
        }
    });
    React__default.useEffect(function () {
        onChangeEvent();
    }, [state.selected]);
    React__default.useEffect(function () {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        setState(__assign(__assign({}, state), { selected: -1, current: 0 }));
    }, [resetOption]);
    /* Event Handlers */
    var onChangeEvent = function () {
        if (onChange) {
            onChange(state);
        }
    };
    var onBlurEvent = function () {
        if (onBlur) {
            onBlur(state);
        }
    };
    var onErrorEvent = function () {
        if (onError) {
            onError(state);
        }
    };
    var onClickEvent = function () {
        if (onClick) {
            onClick(state);
        }
    };
    var onFocusEvent = function () {
        if (onFocus) {
            onFocus(state);
        }
    };
    var onMouseDownEvent = function () {
        if (onMouseDown) {
            onMouseDown(state);
        }
    };
    var onMouseUpEvent = function () {
        if (onMouseUp) {
            onMouseUp(state);
        }
    };
    var onHoverEvent = function () {
        if (onHover) {
            onHover(state);
        }
    };
    var onKeyPressEvent = function (k) {
        if (onKeyPress) {
            onKeyPress(k, state);
        }
    };
    var getId = function () {
        var temp = label
            .replace(/ /g, "-")
            .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
            .toLowerCase();
        while (process.browser && document.getElementById(temp)) {
            temp = temp.concat(Math.floor(Math.random() * 100 + 1).toString());
        }
        return temp;
    };
    var showDropdown = function () {
        setState(__assign(__assign({}, state), { clicked: true, nativeArrowOpen: true, show: !state.show }));
        onClickEvent();
    };
    var hideDropdown = function () {
        if (!native && buttonRef.current !== null) {
            buttonRef.current.focus();
        }
        setState(__assign(__assign({}, state), { current: selected === -1 ? 0 : selected, searchResults: setSearchResults(), show: false }));
        clearTimeout(timer);
    };
    var handleSelection = function (i) {
        if (!native && buttonRef.current !== null) {
            buttonRef.current.focus();
        }
        setState(__assign(__assign({}, state), { current: i, error: false, nativeArrowOpen: false, selected: i, show: native }));
    };
    var handleNativeSelection = function (e) {
        var temp = parseInt(e.target.value, 10);
        handleSelection(temp);
    };
    var handleOnBlur = function () {
        onBlurEvent();
        if ((!show && clicked && selected === -1) || (selected === -1 && clicked && native)) {
            onErrorEvent();
            setState(__assign(__assign({}, state), { error: true, nativeArrowOpen: false }));
        }
        else {
            setState(__assign(__assign({}, state), { nativeArrowOpen: false }));
        }
    };
    var searchOptions = function (e) {
        clearTimeout(timer);
        var letterChar = keyPress.isLetterChar(e);
        var specialChar = keyPress.isSpecialChar(e, altPressed);
        var digitChar = keyPress.isDigitChar(e);
        var keyChar = letterChar
            ? letterChar
            : specialChar
                ? specialChar
                : digitChar
                    ? digitChar
                    : undefined;
        if (!keyChar) {
            return;
        }
        var temp = [];
        searchResults.forEach(function (item) {
            var value = item.value;
            var optionChar = value.charAt(0).toUpperCase();
            if (optionChar.localeCompare(keyChar) === 0) {
                item.value = value.substring(1);
                temp.push(item);
            }
        });
        temp.forEach(function (singleItem, indexInner) {
            temp[indexInner]["next"] = temp[indexInner + 1]
                ? temp[indexInner + 1].index
                : temp[0].index;
        });
        var handleNextSelect = function (tempObj, currentPos) {
            var tempData = 0;
            if (tempObj.length) {
                tempObj.forEach(function (item) {
                    if (item.index === current) {
                        tempData = item;
                    }
                });
                tempData = searchResults[tempData.next] ? searchResults[tempData.next] : tempObj[0];
            }
            return tempData.index;
        };
        setState(__assign(__assign({}, state), { current: temp.length === 0 ? current : handleNextSelect(temp), searchResults: temp }));
        setTimer(setTimeout(function () { return setRefresh(true); }, 1000));
    };
    var handleMouseUp = function (e) {
        if (containerRef.current !== null && containerRef.current.contains(e.target)) {
            return;
        }
        else {
            hideDropdown();
        }
    };
    var keyUpDropDown = function (e) {
        if (keyPress.KeyPress.altIsPressed(e) || keyPress.KeyPress.shiftIsPressed(e)) {
            setState(__assign(__assign({}, state), { altPressed: false }));
        }
    };
    var keyPressedDropDown = function (e) {
        onKeyPressEvent(e);
        if (keyPress.KeyPress.tabIsPressed(e)) {
            hideDropdown();
            return;
        }
        e.preventDefault();
        if (keyPress.KeyPress.downArrowIsPressed(e)) {
            if (current < options.length - 1) {
                setState(__assign(__assign({}, state), { current: current + 1 }));
            }
            else {
                setState(__assign(__assign({}, state), { current: 0 }));
            }
        }
        else if (keyPress.KeyPress.upArrowIsPressed(e)) {
            if (current > 0) {
                setState(__assign(__assign({}, state), { current: current - 1 }));
            }
            else {
                setState(__assign(__assign({}, state), { current: options.length - 1 }));
            }
        }
        else if (keyPress.KeyPress.homeIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: 0 }));
        }
        else if (keyPress.KeyPress.endIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: options.length - 1 }));
        }
        else if (keyPress.KeyPress.pageUpIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current - 3 >= 0 ? current - 3 : 0 }));
        }
        else if (keyPress.KeyPress.pageDownIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current + 3 < options.length ? current + 3 : options.length - 1 }));
        }
        else if (keyPress.KeyPress.escIsPressed(e)) {
            hideDropdown();
        }
        else if (keyPress.KeyPress.enterIsPressed(e)) {
            handleSelection(current);
        }
        else if (keyPress.KeyPress.altIsPressed(e) || keyPress.KeyPress.shiftIsPressed(e)) {
            if (!altPressed) {
                setState(__assign(__assign({}, state), { altPressed: true }));
            }
        }
        else {
            searchOptions(e);
        }
    };
    var labelId = getId();
    var hasGroup = options.filter(function (option) { return option.group !== undefined; }).length > 0;
    return (React__default.createElement("div", { className: Join.join([
            className,
            (error || useOnlyErrorState) && errorState ? "error" : "",
            show ? "active" : "",
        ]), "data-testid": testId, ref: ref, style: style },
        React__default.createElement("label", { className: Join.join([
                "formfield-label",
                styles$c.label,
                disabled ? "disabled" : "",
                (error || useOnlyErrorState) && errorState ? "error" : "",
            ]), htmlFor: labelId, id: "msg-" + labelId }, label),
        React__default.createElement("div", { className: Join.join([
                "selectWrap",
                (error || useOnlyErrorState) && errorState ? "error" : "",
            ]), ref: containerRef }, native ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("select", { "aria-invalid": (error || useOnlyErrorState) && errorState, className: Join.join([
                    "awd-select",
                    "dropdown-button",
                    "color-ui-black",
                    "text-left",
                    styles$c.dropdownButton,
                    styles$c.awdSelect,
                    !multiline
                        ? Join.join([styles$c.dropdownButtonMultiline, "overflow-hidden"])
                        : "",
                    selected === -1
                        ? styles$c.dropdownButtonNotSelected
                        : styles$c.dropdownButtonSelected,
                ]), "aria-expanded": show, disabled: disabled, id: labelId, onBlur: handleOnBlur, onChange: handleNativeSelection, onClick: showDropdown, onFocus: onFocusEvent, onMouseDown: onMouseDownEvent, onMouseOver: onHoverEvent, onMouseUp: onMouseUpEvent, value: selected === -1 ? -1 : selected },
                !nativePlaceHolder ? (Boolean(placeholder) ? (React__default.createElement("option", { dangerouslySetInnerHTML: {
                        __html: placeholder ? placeholder : "",
                    }, disabled: true, value: -1 })) : (React__default.createElement("option", { disabled: true, value: -1 }, "Select"))) : (""),
                options.map(function (option, i) {
                    if ("group" in option &&
                        (i === 0 || options[i].group !== options[i - 1].group)) {
                        group = [
                            React__default.createElement("option", { "aria-selected": selected === i, key: i, value: i }, option.value),
                        ];
                    }
                    else {
                        if ("group" in option) {
                            group.push(React__default.createElement("option", { "aria-selected": selected === i, dangerouslySetInnerHTML: {
                                    __html: option.value,
                                }, key: i, value: i }));
                            if (i === options.length - 1 ||
                                options[i].group !== options[i + 1].group) {
                                return (React__default.createElement("optgroup", { key: Join.join(["Group-Label", i.toString()]), label: option.group }, group.map(function (innerOption, key) {
                                    return innerOption;
                                })));
                            }
                        }
                        else {
                            return (React__default.createElement("option", { dangerouslySetInnerHTML: {
                                    __html: option.value,
                                }, key: i, value: i }));
                        }
                    }
                })),
            React__default.createElement("span", { className: Join.join([
                    "select-skin",
                    styles$c.selectSkin,
                    show ? styles$c.selectSkinOpen : "",
                ]) }))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("button", { "aria-describedby": "msg-" + labelId, "aria-expanded": show, "aria-invalid": (error || useOnlyErrorState) && errorState, "aria-label": options[selected] && options[selected].value
                    ? options[selected].value + "( is selected)"
                    : label, className: Join.join([
                    "dropdown-button",
                    styles$c.dropdownButton,
                    "text-left",
                    !multiline
                        ? Join.join([styles$c.dropdownButtonMultiline, "overflow-hidden"])
                        : "",
                    selected === -1
                        ? styles$c.dropdownButtonNotSelected
                        : styles$c.dropdownButtonSelected,
                    showFocus ? styles$c.dropdownButtonFocus : "",
                ]), dangerouslySetInnerHTML: {
                    __html: Boolean(placeholder)
                        ? selected === -1
                            ? placeholder
                                ? placeholder
                                : "Select"
                            : options[selected].value
                        : selected === -1
                            ? "Select"
                            : options[selected] ? options[selected].value : "",
                }, disabled: disabled, id: labelId, "aria-controls": labelId + "-select", role: "combobox", ref: buttonRef, onBlur: handleOnBlur, onClick: show ? hideDropdown : showDropdown, onFocus: onFocusEvent, onMouseDown: onMouseDownEvent, onMouseOver: onHoverEvent, onMouseUp: onMouseUpEvent }),
            React__default.createElement("div", { className: Join.join([
                    "optionWrapper",
                    "overflow-y-scroll",
                    styles$c.optionWrapper,
                    show ? Join.join([styles$c.optionWrapperOpen, "open"]) : "",
                ]), onKeyDown: keyPressedDropDown, onKeyUp: keyUpDropDown, ref: dropdownRef, id: labelId + "-select" }, show &&
                options.map(function (option, i) {
                    if ("group" in option &&
                        (i === 0 || options[i].group !== options[i - 1].group)) {
                        return [
                            React__default.createElement("label", { className: Join.join([
                                    "formfield-label",
                                    "color-ui-dark-gray",
                                    styles$c.group,
                                ]), key: Join.join(["Group-Label", i.toString()]) }, option.group),
                            React__default.createElement("button", { "aria-label": selected === i
                                    ? "Group " +
                                        option.group +
                                        " " +
                                        option.value +
                                        "( is selected)"
                                    : "Group " +
                                        option.group +
                                        " " +
                                        option.value, "aria-posinset": i + 1, "aria-selected": selected === i, "aria-setsize": options.length, ref: function (node) {
                                    refOptions[i] = node;
                                }, className: Join.join([
                                    "optgroup-wrapper",
                                    "option-list-item",
                                    "text-left",
                                    hasGroup ? styles$c.optionListItemPad : "",
                                    styles$c.optionListItem,
                                ]), dangerouslySetInnerHTML: {
                                    __html: option.value,
                                }, key: i, name: option.value, onClick: handleSelection.bind(null, i), role: "option", type: "button" }),
                        ];
                    }
                    else {
                        return (React__default.createElement("button", { "aria-label": "group" in option
                                ? selected === i
                                    ? "Group " +
                                        option.group +
                                        " " +
                                        option.value +
                                        "( is selected)"
                                    : "Group " +
                                        option.group +
                                        " " +
                                        option.value
                                : selected === i
                                    ? option.value + "( is selected)"
                                    : option.value, "aria-posinset": i + 1, "aria-selected": selected === i, "aria-setsize": options.length, className: Join.join([
                                "optgroup-wrapper",
                                "option-list-item",
                                "text-left",
                                styles$c.optionListItem,
                                hasGroup ? styles$c.optionListItemPad : "",
                            ]), dangerouslySetInnerHTML: {
                                __html: option.value,
                            }, key: i, onClick: handleSelection.bind(null, i), ref: function (node) {
                                refOptions[i] = node;
                            }, role: "option" }));
                    }
                }))))),
        errorState && (error || useOnlyErrorState) && errorMsg && (React__default.createElement("span", { "aria-live": "polite", className: Join.join(["formfield-msg", styles$c.requiredError]), id: labelId.concat("-error") }, errorMsg))));
});
exports.default = Select;
});

var Select = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });

__exportStar(Select_1, exports);
exports.default = Select_1.default;
});

var label = "SelectionMenu_label__MW6dk";
var requiredError = "SelectionMenu_required-error__sI-7F";
var dropdownButton = "SelectionMenu_dropdown-button__BNDKX";
var dropdownButtonFocus = "SelectionMenu_dropdown-button-focus__G3CHi";
var optionListItem = "SelectionMenu_option-list-item__nfWrK";
var optionWrapper = "SelectionMenu_optionWrapper__6q44O";
var optionWrapperOpen = "SelectionMenu_optionWrapper-open__A6BDx";
var selectionMenuWithLink = "SelectionMenu_selection-menu-with-Link__BzB-4";
var selectionMenuIcon = "SelectionMenu_selection-menu-icon__fr5F5";
var selectionMenuCheck = "SelectionMenu_selection-menu-check__6Y-qB";
var selectionMenuInnerHover = "SelectionMenu_selection-menu-inner-hover__lh0uP";
var selectionMenuInnerText = "SelectionMenu_selection-menu-inner-text__dBwu-";
var selectionMenuLink = "SelectionMenu_selection-menu-link__h1cH9";
var selectionMenuLinkInner = "SelectionMenu_selection-menu-link-inner__wZaED";
var selectionMenuHide = "SelectionMenu_selection-menu-hide__5Qker";
var selectionMenuCloseHide = "SelectionMenu_selection-menu-close-hide__oazuU";
var selectionMenuClose = "SelectionMenu_selection-menu-close__7FhZY";
var css_248z$f = ".SelectionMenu_label__MW6dk {\n  line-height: 1.2; }\n\n.SelectionMenu_required-error__sI-7F {\n  display: initial;\n  padding-left: 2px; }\n\n.SelectionMenu_dropdown-button__BNDKX {\n  outline: 0 !important;\n  min-height: 64px !important; }\n  .SelectionMenu_dropdown-button__BNDKX[aria-disabled=\"true\"] {\n    cursor: not-allowed; }\n  .SelectionMenu_dropdown-button__BNDKX[aria-expanded=\"true\"] {\n    border-color: #0057b8;\n    z-index: 3; }\n\n.SelectionMenu_dropdown-button-focus__G3CHi:focus {\n  outline: 1px dotted #686e74 !important;\n  outline-offset: -6px !important; }\n\n.SelectionMenu_option-list-item__nfWrK {\n  border: 0 !important;\n  text-indent: 0; }\n  .SelectionMenu_option-list-item__nfWrK:focus {\n    background-color: #f2f2f2 !important; }\n  .SelectionMenu_option-list-item__nfWrK[aria-selected=\"true\"] {\n    background-color: #ffffff; }\n    .SelectionMenu_option-list-item__nfWrK[aria-selected=\"true\"]:focus {\n      background-color: #f2f2f2 !important; }\n\n.SelectionMenu_optionWrapper__6q44O {\n  margin-top: -1px;\n  max-height: 360px !important;\n  top: auto;\n  transform: none !important; }\n\n.SelectionMenu_optionWrapper-open__A6BDx {\n  z-index: 2; }\n\n.SelectionMenu_selection-menu-with-Link__BzB-4 {\n  max-height: 403px !important; }\n\n.SelectionMenu_selection-menu-icon__fr5F5,\n.SelectionMenu_selection-menu-check__6Y-qB {\n  height: 64px;\n  width: 64px; }\n\n.SelectionMenu_selection-menu-inner-hover__lh0uP:hover .SelectionMenu_selection-menu-inner-text__dBwu- {\n  color: #0057b8 !important; }\n\n.SelectionMenu_selection-menu-inner-text__dBwu- > span {\n  text-overflow: ellipsis; }\n\n.SelectionMenu_selection-menu-link__h1cH9 {\n  border: 1px solid #dedede;\n  border-radius: 0 0 3px 3px;\n  cursor: default;\n  margin: -2px -1px -1px -1px; }\n\n.SelectionMenu_selection-menu-link__h1cH9:hover {\n  background-color: #ffffff; }\n\n.SelectionMenu_selection-menu-link-inner__wZaED {\n  margin-left: -8px; }\n\n.SelectionMenu_selection-menu-link-inner__wZaED:focus {\n  outline: 1px dotted currentColor;\n  outline-offset: -2px; }\n\n.SelectionMenu_selection-menu-hide__5Qker {\n  visibility: hidden !important; }\n\n.SelectionMenu_selection-menu-close-hide__oazuU {\n  background-color: transparent !important;\n  color: transparent !important;\n  max-height: 1px !important;\n  max-width: 1px !important;\n  opacity: 0 !important;\n  outline: 0 !important;\n  overflow: hidden !important; }\n\n.SelectionMenu_selection-menu-close__7FhZY:focus {\n  outline: 2px solid #0057b8 !important; }\n";
var SelectionMenu$1 = {"label":"SelectionMenu_label__MW6dk","required-error":"SelectionMenu_required-error__sI-7F","dropdown-button":"SelectionMenu_dropdown-button__BNDKX","dropdown-button-focus":"SelectionMenu_dropdown-button-focus__G3CHi","option-list-item":"SelectionMenu_option-list-item__nfWrK","optionWrapper":"SelectionMenu_optionWrapper__6q44O","optionWrapper-open":"SelectionMenu_optionWrapper-open__A6BDx","selection-menu-with-Link":"SelectionMenu_selection-menu-with-Link__BzB-4","selection-menu-icon":"SelectionMenu_selection-menu-icon__fr5F5","selection-menu-check":"SelectionMenu_selection-menu-check__6Y-qB","selection-menu-inner-hover":"SelectionMenu_selection-menu-inner-hover__lh0uP","selection-menu-inner-text":"SelectionMenu_selection-menu-inner-text__dBwu-","selection-menu-link":"SelectionMenu_selection-menu-link__h1cH9","selection-menu-link-inner":"SelectionMenu_selection-menu-link-inner__wZaED","selection-menu-hide":"SelectionMenu_selection-menu-hide__5Qker","selection-menu-close-hide":"SelectionMenu_selection-menu-close-hide__oazuU","selection-menu-close":"SelectionMenu_selection-menu-close__7FhZY","requiredError":"SelectionMenu_required-error__sI-7F","dropdownButton":"SelectionMenu_dropdown-button__BNDKX","dropdownButtonFocus":"SelectionMenu_dropdown-button-focus__G3CHi","optionListItem":"SelectionMenu_option-list-item__nfWrK","optionWrapperOpen":"SelectionMenu_optionWrapper-open__A6BDx","selectionMenuWithLink":"SelectionMenu_selection-menu-with-Link__BzB-4","selectionMenuIcon":"SelectionMenu_selection-menu-icon__fr5F5","selectionMenuCheck":"SelectionMenu_selection-menu-check__6Y-qB","selectionMenuInnerHover":"SelectionMenu_selection-menu-inner-hover__lh0uP","selectionMenuInnerText":"SelectionMenu_selection-menu-inner-text__dBwu-","selectionMenuLink":"SelectionMenu_selection-menu-link__h1cH9","selectionMenuLinkInner":"SelectionMenu_selection-menu-link-inner__wZaED","selectionMenuHide":"SelectionMenu_selection-menu-hide__5Qker","selectionMenuCloseHide":"SelectionMenu_selection-menu-close-hide__oazuU","selectionMenuClose":"SelectionMenu_selection-menu-close__7FhZY"};
var stylesheet$d=".SelectionMenu_label__MW6dk {\n  line-height: 1.2; }\n\n.SelectionMenu_required-error__sI-7F {\n  display: initial;\n  padding-left: 2px; }\n\n.SelectionMenu_dropdown-button__BNDKX {\n  outline: 0 !important;\n  min-height: 64px !important; }\n  .SelectionMenu_dropdown-button__BNDKX[aria-disabled=\"true\"] {\n    cursor: not-allowed; }\n  .SelectionMenu_dropdown-button__BNDKX[aria-expanded=\"true\"] {\n    border-color: #0057b8;\n    z-index: 3; }\n\n.SelectionMenu_dropdown-button-focus__G3CHi:focus {\n  outline: 1px dotted #686e74 !important;\n  outline-offset: -6px !important; }\n\n.SelectionMenu_option-list-item__nfWrK {\n  border: 0 !important;\n  text-indent: 0; }\n  .SelectionMenu_option-list-item__nfWrK:focus {\n    background-color: #f2f2f2 !important; }\n  .SelectionMenu_option-list-item__nfWrK[aria-selected=\"true\"] {\n    background-color: #ffffff; }\n    .SelectionMenu_option-list-item__nfWrK[aria-selected=\"true\"]:focus {\n      background-color: #f2f2f2 !important; }\n\n.SelectionMenu_optionWrapper__6q44O {\n  margin-top: -1px;\n  max-height: 360px !important;\n  top: auto;\n  transform: none !important; }\n\n.SelectionMenu_optionWrapper-open__A6BDx {\n  z-index: 2; }\n\n.SelectionMenu_selection-menu-with-Link__BzB-4 {\n  max-height: 403px !important; }\n\n.SelectionMenu_selection-menu-icon__fr5F5,\n.SelectionMenu_selection-menu-check__6Y-qB {\n  height: 64px;\n  width: 64px; }\n\n.SelectionMenu_selection-menu-inner-hover__lh0uP:hover .SelectionMenu_selection-menu-inner-text__dBwu- {\n  color: #0057b8 !important; }\n\n.SelectionMenu_selection-menu-inner-text__dBwu- > span {\n  text-overflow: ellipsis; }\n\n.SelectionMenu_selection-menu-link__h1cH9 {\n  border: 1px solid #dedede;\n  border-radius: 0 0 3px 3px;\n  cursor: default;\n  margin: -2px -1px -1px -1px; }\n\n.SelectionMenu_selection-menu-link__h1cH9:hover {\n  background-color: #ffffff; }\n\n.SelectionMenu_selection-menu-link-inner__wZaED {\n  margin-left: -8px; }\n\n.SelectionMenu_selection-menu-link-inner__wZaED:focus {\n  outline: 1px dotted currentColor;\n  outline-offset: -2px; }\n\n.SelectionMenu_selection-menu-hide__5Qker {\n  visibility: hidden !important; }\n\n.SelectionMenu_selection-menu-close-hide__oazuU {\n  background-color: transparent !important;\n  color: transparent !important;\n  max-height: 1px !important;\n  max-width: 1px !important;\n  opacity: 0 !important;\n  outline: 0 !important;\n  overflow: hidden !important; }\n\n.SelectionMenu_selection-menu-close__7FhZY:focus {\n  outline: 2px solid #0057b8 !important; }\n";
styleInject(css_248z$f);

var SelectionMenu$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    label: label,
    requiredError: requiredError,
    dropdownButton: dropdownButton,
    dropdownButtonFocus: dropdownButtonFocus,
    optionListItem: optionListItem,
    optionWrapper: optionWrapper,
    optionWrapperOpen: optionWrapperOpen,
    selectionMenuWithLink: selectionMenuWithLink,
    selectionMenuIcon: selectionMenuIcon,
    selectionMenuCheck: selectionMenuCheck,
    selectionMenuInnerHover: selectionMenuInnerHover,
    selectionMenuInnerText: selectionMenuInnerText,
    selectionMenuLink: selectionMenuLink,
    selectionMenuLinkInner: selectionMenuLinkInner,
    selectionMenuHide: selectionMenuHide,
    selectionMenuCloseHide: selectionMenuCloseHide,
    selectionMenuClose: selectionMenuClose,
    'default': SelectionMenu$1,
    stylesheet: stylesheet$d
});

var styles$b = /*@__PURE__*/getAugmentedNamespace(SelectionMenu$2);

var SelectionMenu_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });





var SelectionMenu = React__default.forwardRef(function (_a, ref) {
    var _b;
    var data = _a.data, _c = _a.events, events = _c === void 0 ? {} : _c, _d = _a.options, options = _d === void 0 ? {} : _d, testId = _a.testId, uniqueId = _a.uniqueId;
    var dataOptions = data.options;
    var className = options.className, _e = options.defaultValue, defaultValue = _e === void 0 ? 0 : _e, disabled = options.disabled, label = options.label, linkHref = options.linkHref, linkOnClick = options.linkOnClick, linkText = options.linkText, style = options.style, _f = options.zIndex, zIndex = _f === void 0 ? 10 : _f;
    var onBlur = events.onBlur, onChange = events.onChange, onClick = events.onClick, onFocus = events.onFocus, onHover = events.onHover, onKeyPress = events.onKeyPress, onMouseDown = events.onMouseDown, onMouseUp = events.onMouseUp;
    var buttonRef = React__default.createRef();
    var closeRef = React__default.createRef();
    var containerRef = React__default.createRef();
    var dataOptionsRef = __spread(Array(dataOptions.length)).map(function (_, i) { return i; });
    var dropdownRef = React__default.createRef();
    var linkRef = React__default.createRef();
    var isMobile = true;
    if (typeof navigator !== "undefined") {
        isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i);
    }
    var _g = __read(React__default.useState({
        altPressed: false,
        current: defaultValue,
        prevCurrent: defaultValue,
        searchResults: "",
        selected: defaultValue,
        show: false,
        showClose: false,
        showFocus: true,
        willShow: false,
    }), 2), state = _g[0], setState = _g[1];
    var _h = __read(React__default.useState(null), 2), timer = _h[0], setTimer = _h[1];
    var altPressed = state.altPressed, current = state.current, prevCurrent = state.prevCurrent, selected = state.selected, show = state.show, showClose = state.showClose, showFocus = state.showFocus, willShow = state.willShow;
    var setFocus = function (value) {
        if (value !== showFocus) {
            setState(__assign(__assign({}, state), { showFocus: value }));
        }
    };
    var setFocusFalse = function () {
        setFocus(false);
    };
    var setFocusTrue = function () {
        setFocus(true);
    };
    React__default.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (process.browser) {
            document.addEventListener("mousedown", setFocusFalse, false);
            document.addEventListener("keydown", setFocusTrue, false);
        }
        if (show) {
            if (showClose) {
                (_a = closeRef === null || closeRef === void 0 ? void 0 : closeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            if (current === -1) {
                return;
            }
            if (process.browser) {
                document.addEventListener("mouseup", handleMouseUp, false);
            }
            (_b = dataOptionsRef[current]) === null || _b === void 0 ? void 0 : _b.focus();
            if (!UserAgent.isIE() && (dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) !== null && ((_c = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _c === void 0 ? void 0 : _c.scrollTo)) {
                (_d = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _d === void 0 ? void 0 : _d.scrollTo(0, (_e = dataOptionsRef[current]) === null || _e === void 0 ? void 0 : _e.offsetTop);
            }
            if (current === 0) {
                setTimeout(function () {
                    if ((dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) !== null) {
                        dropdownRef.current.scrollTop = 0;
                    }
                }, 0);
            }
            if (willShow && (dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) && (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current)) {
                var el = document.getElementById(uniqueId + "-listbox");
                if (el) {
                    var rect = el.getBoundingClientRect();
                    if (window.pageYOffset >
                        window.pageYOffset + rect.top - ((_f = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _f === void 0 ? void 0 : _f.offsetHeight) &&
                        window.pageYOffset < window.pageYOffset + rect.top) {
                        window.scrollTo(window.pageXOffset, window.pageYOffset + rect.top - ((_g = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _g === void 0 ? void 0 : _g.offsetHeight));
                    }
                    else if (window.pageYOffset + rect.top - ((_h = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _h === void 0 ? void 0 : _h.offsetHeight) >
                        window.pageYOffset +
                            rect.top -
                            window.innerHeight + ((_j = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _j === void 0 ? void 0 : _j.offsetHeight) &&
                        window.pageYOffset - ((_k = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _k === void 0 ? void 0 : _k.offsetHeight) <
                            window.pageYOffset +
                                rect.top -
                                window.innerHeight + ((_l = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _l === void 0 ? void 0 : _l.offsetHeight) +
                                32) {
                        window.scrollTo(window.pageXOffset, window.pageYOffset +
                            rect.top -
                            window.innerHeight + ((_m = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _m === void 0 ? void 0 : _m.offsetHeight) +
                            32);
                    }
                    setState(__assign(__assign({}, state), { willShow: false }));
                }
            }
        }
        return function cleanup() {
            if (process.browser) {
                document.removeEventListener("mouseup", handleMouseUp, false);
                document.removeEventListener("mousedown", setFocusFalse, false);
                document.removeEventListener("keydown", setFocusTrue, false);
            }
        };
    });
    React__default.useEffect(function () {
        onChangeEvent();
    }, [state.selected]);
    React__default.useEffect(function () {
        setState(__assign(__assign({}, state), { selected: defaultValue }));
    }, [defaultValue]);
    /* Event Handlers */
    var onChangeEvent = function () {
        if (onChange) {
            onChange(state);
        }
    };
    var onBlurEvent = function () {
        if (onBlur) {
            onBlur(state);
        }
    };
    var onClickEvent = function () {
        if (onClick) {
            onClick(state);
        }
    };
    var onFocusEvent = function () {
        if (onFocus) {
            onFocus(state);
        }
    };
    var onMouseDownEvent = function () {
        if (onMouseDown) {
            onMouseDown(state);
        }
    };
    var onMouseUpEvent = function () {
        if (onMouseUp) {
            onMouseUp(state);
        }
    };
    var onHoverEvent = function () {
        if (onHover) {
            onHover(state);
        }
    };
    var onKeyPressEvent = function (k) {
        if (onKeyPress) {
            onKeyPress(k, state);
        }
    };
    var showDropdown = function () {
        if (!disabled) {
            setState(__assign(__assign({}, state), { show: true, willShow: true }));
            onClickEvent();
        }
    };
    var hideDropdown = function () {
        var _a;
        if ((buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) !== null) {
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        setState(__assign(__assign({}, state), { current: selected === -1 ? 0 : selected, prevCurrent: current, show: false, showClose: false }));
    };
    var toggleDropdown = function () {
        var func = function () {
            if (show) {
                hideDropdown();
            }
            else {
                showDropdown();
            }
        };
        if (isMobile) {
            clearTimeout(timer);
            setTimer(setTimeout(func, 75));
        }
        else {
            func();
        }
    };
    var handleSelection = function (i) {
        var _a;
        if ((buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) !== null) {
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        setState(__assign(__assign({}, state), { current: i, prevCurrent: current, selected: i, show: false, showClose: false }));
    };
    var handleMouseUp = function (e) {
        var _a;
        if ((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) !== null && ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            return;
        }
        else {
            hideDropdown();
        }
    };
    var searchOptions = function (e) {
        var letterChar = keyPress.isLetterChar(e);
        var specialChar = keyPress.isSpecialChar(e, state.altPressed);
        var digitChar = keyPress.isDigitChar(e);
        var keyChar = letterChar
            ? letterChar
            : specialChar
                ? specialChar
                : digitChar
                    ? digitChar
                    : undefined;
        if (!keyChar) {
            setState(__assign(__assign({}, state), { current: state.selected, prevCurrent: current, searchResults: "" }));
            return;
        }
        var temp = (state.searchResults + keyChar).toLowerCase();
        for (var i = 0; i < dataOptions.length; i++) {
            if (dataOptions[i].label.substring(0, temp.length).toLowerCase() === temp) {
                setState(__assign(__assign({}, state), { current: i, prevCurrent: current, searchResults: temp }));
                return;
            }
        }
        temp = keyChar.toLowerCase();
        for (var i = 0; i < dataOptions.length; i++) {
            if (dataOptions[i].label.substring(0, temp.length).toLowerCase() === temp) {
                setState(__assign(__assign({}, state), { current: i, prevCurrent: current, searchResults: temp }));
                return;
            }
        }
        setState(__assign(__assign({}, state), { current: state.selected, prevCurrent: current, searchResults: "" }));
    };
    var keyDownDropdown = function (e) {
        var _a, _b;
        onKeyPressEvent(e);
        if (keyPress.KeyPress.tabIsPressed(e)) {
            if ((options === null || options === void 0 ? void 0 : options.linkText) && (linkRef === null || linkRef === void 0 ? void 0 : linkRef.current) &&
                document.getElementById(uniqueId + "-link") !== document.activeElement &&
                !e.shiftKey) {
                (_a = linkRef === null || linkRef === void 0 ? void 0 : linkRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                setState(__assign(__assign({}, state), { current: -1, prevCurrent: current !== -1 ? current : prevCurrent }));
            }
            else if (!e.shiftKey) {
                setState(__assign(__assign({}, state), { current: -1, prevCurrent: current !== -1 ? current : prevCurrent, showClose: true }));
            }
            else if (e.shiftKey &&
                (document.getElementById(uniqueId + "-link") !== document.activeElement ||
                    document.getElementById(uniqueId + "-close") !== document.activeElement) && (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current)) {
                (_b = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            e.preventDefault();
            return;
        }
        e.preventDefault();
        if (keyPress.KeyPress.downArrowIsPressed(e)) {
            if (current < dataOptions.length - 1) {
                setState(__assign(__assign({}, state), { current: current + 1, prevCurrent: current }));
            }
            else {
                setState(__assign(__assign({}, state), { current: 0, prevCurrent: current }));
            }
        }
        else if (keyPress.KeyPress.upArrowIsPressed(e)) {
            if (current > 0) {
                setState(__assign(__assign({}, state), { current: current - 1, prevCurrent: current }));
            }
            else {
                setState(__assign(__assign({}, state), { current: dataOptions.length - 1, prevCurrent: current }));
            }
        }
        else if (keyPress.KeyPress.homeIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: 0, prevCurrent: current }));
        }
        else if (keyPress.KeyPress.endIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: dataOptions.length - 1, prevCurrent: current }));
        }
        else if (keyPress.KeyPress.pageUpIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current - 3 >= 0 ? current - 3 : 0, prevCurrent: current }));
        }
        else if (keyPress.KeyPress.pageDownIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current + 3 < dataOptions.length ? current + 3 : dataOptions.length - 1, prevCurrent: current }));
        }
        else if (keyPress.KeyPress.escIsPressed(e)) {
            hideDropdown();
        }
        else if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
            handleSelection(current !== -1 ? current : selected);
        }
        else if (keyPress.KeyPress.altIsPressed(e) || keyPress.KeyPress.shiftIsPressed(e)) {
            if (!altPressed) {
                setState(__assign(__assign({}, state), { altPressed: true }));
            }
        }
        else {
            searchOptions(e);
        }
    };
    var onBlurClose = function () {
        setState(__assign(__assign({}, state), { showClose: false }));
    };
    var keyDownClose = function (e) {
        var _a;
        if (keyPress.KeyPress.tabIsPressed(e) && !e.shiftKey) {
            hideDropdown();
        }
        else if (keyPress.KeyPress.tabIsPressed(e) && e.shiftKey && !options.linkText) {
            (_a = dataOptionsRef[prevCurrent]) === null || _a === void 0 ? void 0 : _a.focus();
            setState(__assign(__assign({}, state), { current: prevCurrent, showClose: false }));
        }
    };
    var keyDownLink = function (e) {
        var _a;
        if (keyPress.KeyPress.tabIsPressed(e) && e.shiftKey) {
            (_a = dataOptionsRef[prevCurrent]) === null || _a === void 0 ? void 0 : _a.focus();
            setState(__assign(__assign({}, state), { current: prevCurrent, showClose: false }));
        }
    };
    var onMouseLeaveDropdown = function () {
        setState(__assign(__assign({}, state), { current: current !== -1 ? current : selected, prevCurrent: current }));
    };
    var onClickLink = function (e) {
        hideDropdown();
        if (linkOnClick) {
            linkOnClick(e);
        }
    };
    var ariaActiveDescendant = !UserAgent.isIE() ? uniqueId + "-selection-" + selected : "";
    return (React__default.createElement("div", { className: Join.join([className, show ? "active" : ""]), "data-testid": testId, ref: ref, style: style ? style : {} },
        label && (React__default.createElement("label", { className: Join.join([
                "formfield-label",
                styles$b.label,
                disabled ? "disabled" : "",
            ]), htmlFor: uniqueId }, label)),
        React__default.createElement("div", { className: "rel" + (className ? " " + className : ""), "data-test-id": testId, ref: containerRef, style: { zIndex: state.show ? zIndex : undefined } },
            React__default.createElement(React__default.Fragment, null,
                React__default.createElement("button", { "aria-activedescendant": ariaActiveDescendant, "aria-autocomplete": "list", "aria-disabled": disabled, "aria-expanded": show, "aria-controls": uniqueId + "-listbox", "aria-haspopup": "listbox", "aria-label": "" + (dataOptions[state.selected].group
                        ? "Group " + dataOptions[state.selected].group + ": "
                        : "") + (dataOptions[state.selected].ariaLabel
                        ? dataOptions[state.selected].ariaLabel
                        : dataOptions[state.selected].label) + " " + (dataOptions[state.selected].ariaDescription
                        ? dataOptions[state.selected].ariaDescription
                        : dataOptions[state.selected].description) + (dataOptions[state.selected].ariaSubDescription
                        ? " " + dataOptions[state.selected].ariaSubDescription
                        : dataOptions[state.selected].subDescription
                            ? " " + dataOptions[state.selected].subDescription
                            : "") + " is selected", "aria-owns": uniqueId + "-listbox", className: "dropdown-button " + styles$b.dropdownButton + " inline-block nowrap text-left" + (state.selected === -1 ? "" : " pad-none") + (disabled ? " border-ui-gray" : "") + (showFocus ? " " + styles$b.dropdownButtonFocus : ""), disabled: disabled, id: uniqueId, onBlur: onBlurEvent, onClick: toggleDropdown, onFocus: onFocusEvent, onMouseDown: onMouseDownEvent, onMouseOver: onHoverEvent, onMouseUp: onMouseUpEvent, ref: buttonRef }, state.selected === -1 ? ("Select Menu Option") : (React__default.createElement(SelectionInner, { description: dataOptions[state.selected].description, icon: dataOptions[state.selected].icon, innerCustomClass: dataOptions[state.selected].innerCustomClass, isDisabled: disabled, isDisplayed: true, label: dataOptions[state.selected].label, subDescription: dataOptions[state.selected].subDescription }))),
                React__default.createElement("div", { className: "rel" + (show ? " " + styles$b.optionWrapperOpen : "") },
                    React__default.createElement("div", { "aria-expanded": show, "aria-label": "Select from menu:", className: "optionWrapper" + (state.show ? " open" : "") + " " + styles$b.optionWrapper + (linkText ? " " + styles$b.selectionMenuWithLink : "") + " overflow-hidden", id: uniqueId + "-listbox", onKeyDown: keyDownDropdown, onMouseLeave: onMouseLeaveDropdown, ref: dropdownRef, role: "listbox" },
                        dataOptions.map(function (option, i) {
                            if ("group" in option &&
                                (i === 0 ||
                                    dataOptions[i].group !== dataOptions[i - 1].group)) {
                                return [
                                    React__default.createElement("label", { "aria-hidden": true, className: "block color-ui-dark-gray font-medium pad-b-xxs pad-l-xs pad-t-xxs mar-b-none type-sm uppercase" + (state.show
                                            ? ""
                                            : " hide " + styles$b.selectionMenuHide), key: "Group-Label" + i }, option.group),
                                    React__default.createElement("button", { "aria-label": "Group " + option.group + ": " + (option.ariaLabel
                                            ? option.ariaLabel
                                            : option.label) + " " + (option.ariaDescription
                                            ? option.ariaDescription
                                            : option.description) + (option.ariaSubDescription
                                            ? " " + option.ariaSubDescription
                                            : option.subDescription
                                                ? " " + option.subDescription
                                                : "") + (state.selected === i ? " selected" : ""), "aria-posinset": i + 1, "aria-selected": selected === i ? true : false, "aria-setsize": dataOptions.length, className: "optgroup-wrapper option-list-item bg-ui-white pad-none no-border " + styles$b.optionListItem + (state.show
                                            ? ""
                                            : " hide " + styles$b.selectionMenuHide), id: uniqueId + "-selection-" + i, key: i, name: option.value, onClick: handleSelection.bind(null, i), ref: function (node) {
                                            dataOptionsRef[i] = node;
                                        }, role: "option", type: "button" },
                                        React__default.createElement(SelectionInner, { description: option.description, icon: option.icon, innerCustomClass: option.innerCustomClass, label: option.label, selected: state.selected === i ? true : false, subDescription: option.subDescription })),
                                ];
                            }
                            else {
                                return (React__default.createElement("button", { "aria-label": "" + (option.group ? "Group " + option.group + ": " : "") + (option.ariaLabel
                                        ? option.ariaLabel
                                        : option.label) + " " + (option.ariaDescription
                                        ? option.ariaDescription
                                        : option.description) + (option.ariaSubDescription
                                        ? " " + option.ariaSubDescription
                                        : option.subDescription
                                            ? " " + option.subDescription
                                            : "") + (state.selected === i ? " selected" : ""), "aria-posinset": i + 1, "aria-selected": selected === i, "aria-setsize": dataOptions.length, className: "optgroup-wrapper option-list-item bg-ui-white pad-none no-border " + styles$b.optionListItem + (state.show
                                        ? ""
                                        : " hide " + styles$b.selectionMenuHide), id: uniqueId + "-selection-" + i, key: i, onClick: handleSelection.bind(null, i), ref: function (node) {
                                        dataOptionsRef[i] = node;
                                    }, role: "option" },
                                    React__default.createElement(SelectionInner, { description: option.description, icon: option.icon, innerCustomClass: option.innerCustomClass, label: option.label, selected: state.selected === i ? true : false, subDescription: option.subDescription })));
                            }
                        }),
                        linkText && (React__default.createElement("div", { className: "rel bottom" + (state.show ? "" : " hide " + styles$b.selectionMenuHide) },
                            React__default.createElement("div", { className: "optgroup-wrapper option-list-item bg-ui-white " + styles$b.selectionMenuLink },
                                React__default.createElement("span", { style: { cursor: "pointer" } },
                                    React__default.createElement("a", { className: "link-utility-primary solo pad-l-xxs " + styles$b.selectionMenuLinkInner, href: linkHref, id: uniqueId + "-link", onClick: onClickLink, onKeyDown: keyDownLink, ref: linkRef, role: linkHref === undefined
                                            ? "button"
                                            : undefined, tabIndex: 0 }, linkText)))))),
                    React__default.createElement("button", { "aria-hidden": !show, "aria-label": "Close dropdown", className: "btn-small btn-primary-2 absolute " + (showClose ? "" : " " + styles$b.selectionMenuCloseHide) + (options && options.closeBtnClass
                            ? " " + options.closeBtnClass
                            : ""), id: uniqueId + "-close", onBlur: onBlurClose, onClick: hideDropdown, onKeyDown: keyDownClose, ref: closeRef, role: "button", style: {
                            top: show
                                ? (_b = document.getElementById(uniqueId + "-listbox")) === null || _b === void 0 ? void 0 : _b.offsetHeight : 0,
                        }, tabIndex: show ? 0 : -1 }, "Close"))))));
});
var SelectionInner = function (_a) {
    var description = _a.description, icon = _a.icon, innerCustomClass = _a.innerCustomClass, isDisabled = _a.isDisabled, _b = _a.isDisplayed, isDisplayed = _b === void 0 ? false : _b, label = _a.label, subDescription = _a.subDescription, _c = _a.selected, selected = _c === void 0 ? false : _c;
    return (React__default.createElement("div", { "aria-hidden": true, className: "flex flex-1 flex-items-center " + (innerCustomClass ? "" + innerCustomClass : "") + (isDisplayed ? "" : " " + styles$b.selectionMenuInnerHover) + " " },
        React__default.createElement("div", { className: "flex flex-items-center justify-center " + styles$b.selectionMenuIcon }, React__default.cloneElement(icon, { "aria-label": label, role: "img" })),
        React__default.createElement("div", { className: (isDisabled ? "color-ui-gray" : isDisplayed ? "color-ui-black" : "color-ui-dark-gray") + " flex flex-1 flex-column overflow-hidden pad-b-xxs pad-t-xxs " + styles$b.selectionMenuInnerText + (isDisplayed ? " pad-r-md-all" : "") },
            React__default.createElement("span", { className: "font-medium line-h-md mar-b-none overflow-hidden text-left type-sm" + (selected ? " color-cobalt" : " pad-r-xs") }, label),
            React__default.createElement("span", { className: "mar-b-none line-h-md overflow-hidden text-left type-sm" + (selected ? " color-cobalt" : " pad-r-xs") }, description),
            subDescription && (React__default.createElement("span", { className: "mar-b-none line-h-md overflow-hidden text-left type-sm" + (selected ? " color-cobalt" : " pad-r-xs") }, subDescription))),
        selected && (React__default.createElement("div", { className: "flex flex-items-center justify-center " + styles$b.selectionMenuCheck },
            React__default.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32" },
                React__default.createElement("path", { d: "m24.8653297 9.83653941c.6397776.65715569.6213088 1.70525139-.0354372 2.33385609-1.3803706 1.3709-2.3707788 2.3864303-5.2188499 5.3321191-.1018422.1053303-.1018422.1053303-.2036954.2106578-2.1334052 2.2060798-3.3511506 3.4512388-4.6352461 4.7263618-.6067873.5996701-1.5724289.6441499-2.2314955.1037156l-5.14881946-4.2043013c-.08021331-.0542355-.1554941-.1155381-.22471175-.1828924-.657779-.6390358-.66850157-1.6875444-.02363594-2.3398245.64301794-.6499908 1.6938697-.6605458 2.32094764-.0490073l4.00221941 3.2654768c1.0466469-1.0549369 1.9099826-1.942317 4.1650259-4.2704945.109358-.1129018.109358-.1129018.2187283-.2258001 2.116577-2.1847497 3.3358628-3.4298026 4.6147267-4.6998686.3005861-.30816229.7094537-.48799264 1.1405702-.50198738.4723161-.01799646.930024.16418824 1.2596731.50198889z", fill: "#0057b8", fillRule: "evenodd" }))))));
};
exports.default = SelectionMenu;
});

var SelectionMenu = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = SelectionMenu_1.default;
});

var starRatingStar = "Star_star-rating-star__UBcfb";
var css_248z$e = ".Star_star-rating-star__UBcfb {\n  height: 10px; }\n  @media (min-width: 768px) {\n    .Star_star-rating-star__UBcfb {\n      height: 12px; } }\n";
var Star$1 = {"star-rating-star":"Star_star-rating-star__UBcfb","starRatingStar":"Star_star-rating-star__UBcfb"};
var stylesheet$c=".Star_star-rating-star__UBcfb {\n  height: 10px; }\n  @media (min-width: 768px) {\n    .Star_star-rating-star__UBcfb {\n      height: 12px; } }\n";
styleInject(css_248z$e);

var Star$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    starRatingStar: starRatingStar,
    'default': Star$1,
    stylesheet: stylesheet$c
});

var styles$a = /*@__PURE__*/getAugmentedNamespace(Star$2);

var Star_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


var Star = function (_a) {
    var isLast = _a.isLast, onDark = _a.onDark, value = _a.value;
    return (React__default.createElement("div", { className: styles$a.starRatingStar + " flex-items-center rel", style: { marginRight: isLast ? 4 : 2 } },
        React__default.createElement("div", { className: styles$a.starRatingStar + " absolute left overflow-hidden top", style: {
                maxWidth: value * 100 + "%",
            } },
            React__default.createElement(StarFilled, { onDark: onDark })),
        React__default.createElement(StarEmpty, { onDark: onDark })));
};
var StarFilled = function (_a) {
    var onDark = _a.onDark;
    return (React__default.createElement("svg", { "aria-hidden": "true", focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26" },
        React__default.createElement("title", null, "Star Filled"),
        React__default.createElement("path", { d: "M11.859 1.31L9.451 6.37c-.375.792-1.425 1.583-2.267 1.71l-5.385.81c-1.39.209-1.773 1.427-.77 2.447l3.897 3.94c.613.617 1.014 1.894.869 2.765l-.92 5.561c-.238 1.435.761 2.19 2.005 1.514l4.818-2.627c.755-.414 2.048-.414 2.803 0l4.82 2.626c1.24.677 2.241-.078 2.006-1.512l-.92-5.56c-.145-.874.254-2.152.864-2.768l3.898-3.938c1.004-1.021.622-2.24-.769-2.447l-5.384-.812c-.842-.126-1.89-.916-2.27-1.71L14.34 1.31c-.622-1.308-1.858-1.308-2.48 0z", fill: !onDark ? "#454b52" : "#fff" })));
};
var StarEmpty = function (_a) {
    var onDark = _a.onDark;
    return (React__default.createElement("svg", { "aria-hidden": "true", focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26" },
        React__default.createElement("title", null, "Star Un-filled"),
        React__default.createElement("path", { d: "M11.859 1.31L9.451 6.37c-.375.792-1.425 1.583-2.267 1.71l-5.385.81c-1.39.209-1.773 1.427-.77 2.447l3.897 3.94c.613.617 1.014 1.894.869 2.765l-.92 5.561c-.238 1.435.761 2.19 2.005 1.514l4.818-2.627c.755-.414 2.048-.414 2.803 0l4.82 2.626c1.24.677 2.241-.078 2.006-1.512l-.92-5.56c-.145-.874.254-2.152.864-2.768l3.898-3.938c1.004-1.021.622-2.24-.769-2.447l-5.384-.812c-.842-.126-1.89-.916-2.27-1.71L14.34 1.31c-.622-1.308-1.858-1.308-2.48 0zm1.624.437l2.408 5.06c.52 1.086 1.836 2.078 2.988 2.25l5.385.812c.608.09.678.313.238.761l-3.896 3.937c-.835.844-1.337 2.45-1.139 3.643l.92 5.56c.102.626-.081.765-.622.47l-4.819-2.626c-1.033-.567-2.66-.567-3.693 0L6.437 24.24c-.544.295-.726.158-.621-.47l.919-5.56c.199-1.193-.306-2.8-1.143-3.644L1.696 10.63c-.439-.446-.369-.67.24-.76l5.385-.812c1.153-.173 2.472-1.167 2.986-2.251l2.407-5.058c.272-.573.497-.573.77 0z", fill: !onDark ? "#454b52" : "#fff" })));
};
exports.default = Star;
});

var Star = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Star_1.default;
});

var starRating = "StarRating_star-rating__MJSwN";
var starRatingElements = "StarRating_star-rating-elements__jTmUz";
var spanB = "StarRating_span-b__0sUxD";
var spanA = "StarRating_span-a__iiJxE";
var spanC = "StarRating_span-c__UBwCj";
var starRatingFocusA = "StarRating_star-rating-focus-a__8EtVN";
var starRatingFocusB = "StarRating_star-rating-focus-b__lU6dt";
var css_248z$d = ".StarRating_star-rating__MJSwN {\n  cursor: pointer;\n  outline: 1px dotted transparent;\n  outline-offset: 2px; }\n\n.StarRating_star-rating-elements__jTmUz .StarRating_span-b__0sUxD {\n  margin: 0 2px 2px 2px; }\n\n.StarRating_star-rating-elements__jTmUz svg {\n  max-height: 10px;\n  min-height: 10px;\n  max-width: 10px;\n  min-width: 10px; }\n  @media (min-width: 768px) {\n    .StarRating_star-rating-elements__jTmUz svg {\n      max-height: 12px;\n      min-height: 12px;\n      max-width: 12px;\n      min-width: 12px; } }\n\n.StarRating_star-rating__MJSwN:hover .StarRating_span-a__iiJxE,\n.StarRating_star-rating__MJSwN:hover .StarRating_span-c__UBwCj,\n.StarRating_star-rating-focus-a__8EtVN:focus .StarRating_span-a__iiJxE,\n.StarRating_star-rating-focus-a__8EtVN:focus .StarRating_span-c__UBwCj,\n.StarRating_star-rating-focus-b__lU6dt:focus .StarRating_span-a__iiJxE,\n.StarRating_star-rating-focus-b__lU6dt:focus .StarRating_span-c__UBwCj {\n  text-decoration: underline !important; }\n\n.StarRating_star-rating-focus-a__8EtVN:focus {\n  outline-color: #1d2329; }\n\n.StarRating_star-rating-focus-b__lU6dt:focus {\n  outline-color: #ffffff; }\n";
var StarRating$1 = {"star-rating":"StarRating_star-rating__MJSwN","star-rating-elements":"StarRating_star-rating-elements__jTmUz","span-b":"StarRating_span-b__0sUxD","span-a":"StarRating_span-a__iiJxE","span-c":"StarRating_span-c__UBwCj","star-rating-focus-a":"StarRating_star-rating-focus-a__8EtVN","star-rating-focus-b":"StarRating_star-rating-focus-b__lU6dt","starRating":"StarRating_star-rating__MJSwN","starRatingElements":"StarRating_star-rating-elements__jTmUz","spanB":"StarRating_span-b__0sUxD","spanA":"StarRating_span-a__iiJxE","spanC":"StarRating_span-c__UBwCj","starRatingFocusA":"StarRating_star-rating-focus-a__8EtVN","starRatingFocusB":"StarRating_star-rating-focus-b__lU6dt"};
var stylesheet$b=".StarRating_star-rating__MJSwN {\n  cursor: pointer;\n  outline: 1px dotted transparent;\n  outline-offset: 2px; }\n\n.StarRating_star-rating-elements__jTmUz .StarRating_span-b__0sUxD {\n  margin: 0 2px 2px 2px; }\n\n.StarRating_star-rating-elements__jTmUz svg {\n  max-height: 10px;\n  min-height: 10px;\n  max-width: 10px;\n  min-width: 10px; }\n  @media (min-width: 768px) {\n    .StarRating_star-rating-elements__jTmUz svg {\n      max-height: 12px;\n      min-height: 12px;\n      max-width: 12px;\n      min-width: 12px; } }\n\n.StarRating_star-rating__MJSwN:hover .StarRating_span-a__iiJxE,\n.StarRating_star-rating__MJSwN:hover .StarRating_span-c__UBwCj,\n.StarRating_star-rating-focus-a__8EtVN:focus .StarRating_span-a__iiJxE,\n.StarRating_star-rating-focus-a__8EtVN:focus .StarRating_span-c__UBwCj,\n.StarRating_star-rating-focus-b__lU6dt:focus .StarRating_span-a__iiJxE,\n.StarRating_star-rating-focus-b__lU6dt:focus .StarRating_span-c__UBwCj {\n  text-decoration: underline !important; }\n\n.StarRating_star-rating-focus-a__8EtVN:focus {\n  outline-color: #1d2329; }\n\n.StarRating_star-rating-focus-b__lU6dt:focus {\n  outline-color: #ffffff; }\n";
styleInject(css_248z$d);

var StarRating$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    starRating: starRating,
    starRatingElements: starRatingElements,
    spanB: spanB,
    spanA: spanA,
    spanC: spanC,
    starRatingFocusA: starRatingFocusA,
    starRatingFocusB: starRatingFocusB,
    'default': StarRating$1,
    stylesheet: stylesheet$b
});

var styles$9 = /*@__PURE__*/getAugmentedNamespace(StarRating$2);

var StarRating_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });




var StarRating = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.options, options = _c === void 0 ? {} : _c, _d = _a.events, events = _d === void 0 ? {} : _d, testId = _a.testId;
    var _e = __read(React__default.useState(true), 2), hideFocus = _e[0], setHideFocus = _e[1];
    var rating = data && data.rating ? data.rating : 0;
    var ratingsArr = [];
    var remainder = Math.floor(rating);
    var ratingTimesTen = Math.floor(rating * 10);
    var modulus = (ratingTimesTen % 10) / 10;
    var isInteractive = options && options.isInteractive === false ? false : true;
    var reviews = data.reviews;
    if (typeof reviews === "number") {
        reviews = reviews.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    for (var i = 0; i < remainder; i++) {
        ratingsArr[i] = 1;
    }
    for (var i = remainder; i < 5; i++) {
        if (i === remainder) {
            ratingsArr[i] = modulus;
        }
        else {
            ratingsArr[i] = 0;
        }
    }
    if (options && options.showWriteAReview) {
        return (React__default.createElement("div", { className: "flex flex-items-center" + (options.className ? " " + options.className : ""), "data-testid": testId, id: testId },
            React__default.createElement("a", { className: "font-medium link-text" + (options.onDark ? "" : "3") + " type-xs", href: options.linkHref ? options.linkHref : undefined, onClick: events && events.linkOnClick ? events.linkOnClick : undefined, style: __assign({ cursor: "pointer" }, (options.onDark ? { color: "#fff" } : {})), tabIndex: 0 }, "Write a review")));
    }
    var onFocus = function () {
        setHideFocus(true);
    };
    var onKeyDown = function (e) {
        if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
            e.preventDefault();
        }
    };
    var onKeyUp = function (e) {
        if (keyPress.KeyPress.tabIsPressed(e) || keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
            setHideFocus(false);
        }
        if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
            e.preventDefault();
            if (events && events.onClick) {
                events.onClick();
            }
        }
    };
    var onMouseDown = function (e) {
        e.preventDefault();
        setHideFocus(true);
    };
    var onMouseUp = function (e) {
        e.preventDefault();
        if (events && events.onClick) {
            events.onClick();
        }
    };
    if (isInteractive) {
        return (React__default.createElement("div", { "aria-label": options && options.ariaLabel
                ? options.ariaLabel
                : "Rated " + ratingTimesTen / 10 + " out of 5 stars" + (data && data.reviews ? " with " + data.reviews + " reviews" : ""), className: "inline-flex flex-items-center line-h-sm type-xs " + styles$9.starRating + " " + styles$9.starRatingElements + " " + (hideFocus
                ? ""
                : !(options && options.onDark)
                    ? " " + styles$9.starRatingFocusA
                    : " " + styles$9.starRatingFocusB) + (options && options.className ? " " + options.className : ""), id: testId, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseUp: onMouseUp, role: "button", tabIndex: 0 },
            ratingsArr.map(function (item, index) { return (React__default.createElement(Star.default, { isLast: index === 4, key: index, onDark: options && options.onDark ? options.onDark : false, value: item })); }),
            React__default.createElement("span", { className: styles$9.spanA + " " + (!(options && options.onDark) ? "color-ui-dark-gray" : "color-ui-white") }, Math.floor(ratingTimesTen / 10) + "." + ratingTimesTen % 10),
            data && data.reviews && (React__default.createElement("span", { className: styles$9.spanB + " " + (!(options && options.onDark) ? "color-ui-gray" : "color-ui-medium-gray") }, "|")),
            data && data.reviews && (React__default.createElement("span", { className: styles$9.spanC + " " + (!(options && options.onDark) ? "color-ui-dark-gray" : "color-ui-white") }, reviews))));
    }
    else {
        return (React__default.createElement("div", { className: "inline-flex flex-items-center line-h-sm type-xs " + styles$9.starRatingElements + "\n                    " + (options && options.className ? " " + options.className : ""), id: testId, tabIndex: -1 },
            React__default.createElement("span", { className: "hidden-spoken" }, options && options.ariaLabel
                ? options.ariaLabel
                : "Rated " + ratingTimesTen / 10 + " out of 5 stars" + (data && data.reviews ? " with " + data.reviews + " reviews" : "")),
            ratingsArr.map(function (item, index) { return (React__default.createElement(Star.default, { isLast: index === 4, key: index, onDark: options && options.onDark ? options.onDark : false, value: item })); }),
            React__default.createElement("span", { className: styles$9.spanA + " " + (!(options && options.onDark) ? "color-ui-dark-gray" : "color-ui-white"), "aria-hidden": true }, Math.floor(ratingTimesTen / 10) + "." + ratingTimesTen % 10),
            data && data.reviews && (React__default.createElement("span", { className: styles$9.spanB + " " + (!(options && options.onDark) ? "color-ui-gray" : "color-ui-medium-gray"), "aria-hidden": true }, "|")),
            data && data.reviews && (React__default.createElement("span", { className: styles$9.spanC + " " + (!(options && options.onDark) ? "color-ui-dark-gray" : "color-ui-white"), "aria-hidden": true }, reviews))));
    }
};
exports.default = StarRating;
});

var StarRating = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = StarRating_1.default;
});

var tag = "StatusTag_tag__1rg0U";
var css_248z$c = ".StatusTag_tag__1rg0U {\n  height: 2.3rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  line-height: 2.3rem; }\n\n@media (max-width: 767px) {\n  .StatusTag_tag__1rg0U {\n    height: 2rem;\n    line-height: 2rem; } }\n";
var StatusTag$1 = {"tag":"StatusTag_tag__1rg0U"};
var stylesheet$a=".StatusTag_tag__1rg0U {\n  height: 2.3rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  line-height: 2.3rem; }\n\n@media (max-width: 767px) {\n  .StatusTag_tag__1rg0U {\n    height: 2rem;\n    line-height: 2rem; } }\n";
styleInject(css_248z$c);

var StatusTag$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    tag: tag,
    'default': StatusTag$1,
    stylesheet: stylesheet$a
});

var StatusTagProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTagType = void 0;
(function (StatusTagType) {
    StatusTagType["VERIFIED"] = "VERIFIED";
    StatusTagType["PENDING"] = "PENDING";
    StatusTagType["EXPIRED"] = "EXPIRED";
})(exports.StatusTagType || (exports.StatusTagType = {}));
});

var StatusTagsStylesMaps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeMap = void 0;

exports.typeMap = new Map([
    [StatusTagProps.StatusTagType.EXPIRED, "bg-functional-dk-red"],
    [StatusTagProps.StatusTagType.PENDING, "bg-ui-medium-gray"],
    [StatusTagProps.StatusTagType.VERIFIED, "bg-functional-dk-green"],
]);
});

var styles$8 = /*@__PURE__*/getAugmentedNamespace(StatusTag$2);

var StatusTag_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });




var StatusTag = function (props) {
    var getTypeStyle = function (type) {
        if (type) {
            return StatusTagsStylesMaps.typeMap.get(type);
        }
        return null;
    };
    var tagClasses = [
        styles$8.tag,
        getTypeStyle(StatusTagProps.StatusTagType[props.type]),
        "inline-flex flex-items-center pill-radius type-sm color-ui-white text-center font-medium pad-l-xxs pad-r-xxs",
    ];
    var accessibilityText = props.accessibilityText, className = props.className, testId = props.testId;
    return (React__default.createElement("div", { "data-testid": testId, className: [className, tagClasses.join(" ")].join(" ") },
        React__default.createElement("span", { className: "hidden-spoken" }, accessibilityText ? accessibilityText : props.type),
        React__default.createElement("span", { "aria-hidden": true }, props.type)));
};
exports.default = StatusTag;
});

var StatusTag = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = StatusTag_1.default;
});

var charCounter = "TextArea_char-counter__P5ehN";
var textareaLabel = "TextArea_textarea-label__yGrzv";
var css_248z$b = ".TextArea_char-counter__P5ehN {\n  font-size: 13px;\n  float: right; }\n\n.TextArea_textarea-label__yGrzv {\n  width: auto; }\n";
var TextArea$1 = {"char-counter":"TextArea_char-counter__P5ehN","textarea-label":"TextArea_textarea-label__yGrzv","charCounter":"TextArea_char-counter__P5ehN","textareaLabel":"TextArea_textarea-label__yGrzv"};
var stylesheet$9=".TextArea_char-counter__P5ehN {\n  font-size: 13px;\n  float: right; }\n\n.TextArea_textarea-label__yGrzv {\n  width: auto; }\n";
styleInject(css_248z$b);

var TextArea$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    charCounter: charCounter,
    textareaLabel: textareaLabel,
    'default': TextArea$1,
    stylesheet: stylesheet$9
});

var styles$7 = /*@__PURE__*/getAugmentedNamespace(TextArea$2);

var TextArea_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });


var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.hintId = _this.guid();
        _this.counterId = _this.guid();
        _this.textAreaId = _this.guid();
        _this.shouldComponentUpdate = function (newProps) {
            var currentText = _this.state.currentText;
            if (newProps.input !== currentText) {
                _this.state.currentText = newProps.input;
            }
            if (newProps.options && newProps.options.disabled !== _this.state.disabled) {
                _this.state.disabled = newProps.options.disabled;
            }
            return true;
        };
        _this.onChange = function (event) {
            _this.setState({ currentText: event.currentTarget.value });
            var _a = _this.props, events = _a.events, options = _a.options;
            if (events && events.onChange) {
                events.onChange(event);
            }
            if (options && options.maxLength && event.target.value.length > options.maxLength) {
                event.preventDefault();
            }
        };
        _this.onKeyPress = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (events && events.onKeyPress) {
                events.onKeyPress(currentText, event);
            }
        };
        _this.onBlur = function () {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (events && events.onBlur) {
                events.onBlur(currentText);
            }
            _this.setState({ focused: false });
        };
        _this.onFocus = function (event) {
            var events = _this.props.events;
            var currentText = _this.state.currentText;
            if (events && events.onFocus) {
                events.onFocus(currentText, event);
            }
            _this.setState({ focused: true });
        };
        _this.render = function () {
            var _a = _this.props, error = _a.error, errorText = _a.errorText, hintText = _a.hintText, options = _a.options, placeHolder = _a.placeHolder, testId = _a.testId, title = _a.title;
            var _b = _this.state, currentText = _b.currentText, focused = _b.focused;
            var descIds = [];
            if (options && options.maxLength) {
                descIds.push(_this.counterId);
            }
            if (hintText && error) {
                descIds.push(_this.hintId);
            }
            return (React__default.createElement("div", { className: [options ? options.className : "", "rel"].join(" "), "data-testid": testId },
                _this.props.title && (React__default.createElement("label", { htmlFor: _this.textAreaId, className: [
                        styles$7.textareaLabel,
                        options && options.disabled ? "disabled" : "",
                        "formfield-label inline-flex",
                        error ? "error" : "",
                    ].join(" ") },
                    title,
                    hintText && !error && (React__default.createElement("span", { className: "hidden-spoken" }, ": " + hintText)))),
                options && options.maxLength && (React__default.createElement("span", { id: _this.counterId, className: ["color-ui-gray", styles$7.charCounter, "pad-b-xxs"].join(" "), "aria-live": options.maxLength - currentText.length <= 20 ? "assertive" : "polite", "aria-atomic": false, "aria-label": currentText.length + " out of " + options.maxLength + " characters" }, currentText.length + "/" + options.maxLength)),
                React__default.createElement("textarea", { id: _this.textAreaId, className: "line-h-md", placeholder: placeHolder, "aria-invalid": _this.props.error ? true : undefined, "aria-describedby": descIds.length === 0 ? undefined : descIds.join(" "), maxLength: options ? options.maxLength : undefined, value: currentText, onChange: _this.onChange, onKeyPress: _this.onKeyPress, onBlur: _this.onBlur, onFocus: _this.onFocus, disabled: options ? options.disabled : undefined, "aria-label": options ? options.accessibility : undefined }),
                !error && _this.props.hintText && (React__default.createElement("div", { className: ["formfield-msg"].join(" "), role: "tooltip", tabIndex: focused ? 0 : -1 }, hintText)),
                error && _this.props.errorText && (React__default.createElement("div", { id: _this.hintId, className: ["formfield-msg"].join(" "), "aria-atomic": true, tabIndex: focused ? 0 : -1, "aria-live": focused && error ? "assertive" : undefined }, errorText))));
        };
        _this.state = {
            currentText: props.input ? props.input : "",
            disabled: props.options.disabled || false,
        };
        _this.onKeyPress = _this.onKeyPress.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    TextArea.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    TextArea.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    TextArea.defaultProps = {
        options: {},
    };
    return TextArea;
}(React__default.Component));
exports.default = TextArea;
});

var TextArea = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = TextArea_1.default;
});

var showHidePasswordButton = "TextField_showHidePasswordButton__FLsaf";
var showHideEyePasswordButton = "TextField_showHideEyePasswordButton__1fjk4";
var css_248z$a = ".TextField_showHidePasswordButton__FLsaf {\n  top: 35px;\n  background-color: transparent;\n  border: none;\n  right: 8px;\n  font-size: 14px;\n  font-weight: 500; }\n\n.TextField_showHideEyePasswordButton__1fjk4 {\n  top: 32px;\n  background-color: transparent;\n  border: none;\n  right: 0;\n  font-size: 30px;\n  height: 41px;\n  line-height: 0; }\n\nbody.is-tabbing .TextField_showHidePasswordButton__FLsaf:focus {\n  text-decoration: underline; }\n\ninput::-ms-reveal {\n  display: none; }\n";
var TextField$1 = {"showHidePasswordButton":"TextField_showHidePasswordButton__FLsaf","showHideEyePasswordButton":"TextField_showHideEyePasswordButton__1fjk4"};
var stylesheet$8=".TextField_showHidePasswordButton__FLsaf {\n  top: 35px;\n  background-color: transparent;\n  border: none;\n  right: 8px;\n  font-size: 14px;\n  font-weight: 500; }\n\n.TextField_showHideEyePasswordButton__1fjk4 {\n  top: 32px;\n  background-color: transparent;\n  border: none;\n  right: 0;\n  font-size: 30px;\n  height: 41px;\n  line-height: 0; }\n\nbody.is-tabbing .TextField_showHidePasswordButton__FLsaf:focus {\n  text-decoration: underline; }\n\ninput::-ms-reveal {\n  display: none; }\n";
styleInject(css_248z$a);

var TextField$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    showHidePasswordButton: showHidePasswordButton,
    showHideEyePasswordButton: showHideEyePasswordButton,
    'default': TextField$1,
    stylesheet: stylesheet$8
});

var TextFieldProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.MASK_CHARACTER = exports.TextFieldType = void 0;
(function (TextFieldType) {
    TextFieldType["DATE"] = "date";
    TextFieldType["EMAIL"] = "email";
    TextFieldType["HIDDEN"] = "hidden";
    TextFieldType["INTEGER"] = "integer";
    TextFieldType["NUMBER"] = "number";
    TextFieldType["NUMERIC_PASSWORD"] = "numeric";
    TextFieldType["PASSWORD"] = "password";
    TextFieldType["TEL"] = "tel";
    TextFieldType["TEXT"] = "text";
})(exports.TextFieldType || (exports.TextFieldType = {}));
(function (MASK_CHARACTER) {
    MASK_CHARACTER["DEFAULT"] = "\u2022";
})(exports.MASK_CHARACTER || (exports.MASK_CHARACTER = {}));
});

var textfieldStyles = /*@__PURE__*/getAugmentedNamespace(TextField$2);

var TextField_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });




var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentTextValue: _this.props.data.input ? _this.props.data.input : "",
            disabled: _this.props.options.disabled || false,
            maskedValue: _this.props.data.input ? _this.mask(_this.props.data.input) : "",
            showHint: false,
            showPassword: false,
        };
        _this.onChange = function (event) {
            var events = _this.props.events;
            var value = _this.evaluateValue(event);
            _this.setState({
                currentTextValue: value,
                maskedValue: _this.mask(event.currentTarget.value),
            });
            event.currentTarget.value = value;
            if (events && events.onChange) {
                events.onChange(event);
            }
        };
        _this.onMouseDown = function (event) {
            var _a = _this.props; _a.events; var options = _a.options;
            if (options.disableCopyPaste) {
                event.preventDefault();
            }
        };
        _this.onKeyPress = function (event) {
            var _a = _this.props, events = _a.events, options = _a.options;
            if (options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD &&
                (event.charCode <= 47 || event.charCode >= 58) &&
                event.which !== 8 &&
                event.which !== 9
                && (event.which <= 95 || event.which >= 106 && event.which !== 37 && event.which !== 39 && event.which !== 46)) {
                event.preventDefault();
            }
            else if (events && events.onKeyPress) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyPress(currentTextValue, event);
            }
        };
        _this.onKeyDown = function (event) {
            var _a = _this.props, events = _a.events, options = _a.options;
            if ((options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD &&
                (event.which <= 47 || event.which >= 58) &&
                event.which !== 8 &&
                event.which !== 9
                && (event.which <= 95 || event.which >= 106) && event.which !== 37 && event.which !== 39 && event.which !== 46) ||
                (options.disableCopyPaste &&
                    event.ctrlKey &&
                    (event.keyCode === 88 || event.keyCode === 67 || event.keyCode === 86))) {
                event.preventDefault();
            }
            else if (events && events.onKeyDown) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyDown(currentTextValue, event);
            }
        };
        _this.onKeyUp = function (event) {
            var events = _this.props.events;
            if (events && events.onKeyUp) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyUp(currentTextValue, event);
            }
        };
        _this.onBlur = function () {
            var _a = _this.props, data = _a.data, events = _a.events;
            if (data.hintText) {
                _this.setState({ showHint: false });
            }
            if (events && events.onBlur) {
                var currentTextValue = _this.state.currentTextValue;
                events.onBlur(currentTextValue);
            }
        };
        _this.onFocus = function (event) {
            var _a = _this.props, data = _a.data, events = _a.events;
            if (data.hintText) {
                _this.setState({ showHint: true });
            }
            if (events && events.onFocus) {
                var currentTextValue = _this.state.currentTextValue;
                events.onFocus(currentTextValue, event);
            }
        };
        _this.prevent = function (event) {
            var _a = _this.props; _a.events; var options = _a.options;
            if (options.disableCopyPaste) {
                event.preventDefault();
            }
        };
        _this.getContainerClass = function () {
            var options = _this.props.options;
            return options.withTooltip
                ? ["rel", options.type === TextFieldProps.TextFieldType.PASSWORD].join(" ")
                : "rel";
        };
        _this.handleShowHidePassword = function () {
            _this.setState(function (_a) {
                var showPassword = _a.showPassword;
                return ({ showPassword: !showPassword });
            });
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, id = _a.id, options = _a.options, spi = _a.spi, testId = _a.testId;
            var _b = _this.state, disabled = _b.disabled, showHint = _b.showHint, showPassword = _b.showPassword;
            var inputClasses = ["textfield", _this.props.options.className];
            if (options.error) {
                inputClasses.push("error");
            }
            var showHidePassword = options && options.showHidePassword;
            var showHideEyePassword = options && options.hasEye;
            var errorInlineText = options.error
                ? options.errorText
                : data.hintText;
            if (errorInlineText && _this.props.options.inLineHtmlParse) {
                errorInlineText = errorInlineText.replace(/ /g, "&nbsp;");
            }
            return (React__default.createElement("div", { className: "form-row " + _this.getContainerClass(), "data-testid": testId },
                data.labelText && (React__default.createElement("div", { className: "inline-flex" },
                    React__default.createElement("label", { className: "formfield-label " +
                            (options.error ? "error" : "") +
                            (disabled ? "disabled" : ""), dangerouslySetInnerHTML: { __html: data.labelText }, htmlFor: id }),
                    React__default.createElement("span", { className: "hidden-spoken" }, options.error ? options.errorText : data.hintText),
                    options.tooltip !== undefined && options.tooltip)),
                React__default.createElement("input", { "aria-label": _this.props.options.accessibility ?
                        _this.props.options.accessibility : undefined, "aria-describedby": _this.props.data.ariaDescribedBy ?
                        _this.props.data.ariaDescribedBy :
                        ((_this.props.data.hintText && !_this.props.options.error) ||
                            (_this.props.options.error && _this.props.options.errorText)
                            ? "msg_" + id
                            : undefined), "aria-invalid": options.error === true ? options.error : undefined, autoComplete: options.autocompleteOption, className: inputClasses.join(" "), "data-spi": spi, disabled: disabled, id: id, maxLength: options.maxLength, name: data.name, onBlur: _this.onBlur, onChange: _this.onChange, onFocus: _this.onFocus, onKeyDown: _this.onKeyDown, onKeyPress: _this.onKeyPress, onKeyUp: _this.onKeyUp, onPaste: _this.prevent, placeholder: data.placeHolder, ref: function (el) { return (_this.inputEl = el); }, type: _this.decideInputType(), value: _this.referenceState(), inputMode: options.inputMode ? options.inputMode : undefined, min: (options.type === "number" && options.minValue !== undefined) ? options.minValue : undefined, max: (options.type === "number" && options.maxValue !== undefined) ? options.maxValue : undefined }),
                _this.props.options.error && _this.props.options.errorText && (React__default.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: _this.props.options.inLineHtmlParse === true
                        ? { __html: errorInlineText }
                        : undefined, id: "msg_" + id, role: "alert", tabIndex: showHint ? 0 : -1 }, _this.props.options.inLineHtmlParse === true ? null : errorInlineText)),
                showHidePassword && (React__default.createElement("button", { "aria-label": showPassword ? "Hide Text" : "Show Text", className: [
                        textfieldStyles.showHidePasswordButton,
                        "absolute",
                        "pad-xxs",
                        "font-regular",
                        "color-ui-black",
                    ].join(" "), onClick: _this.handleShowHidePassword, tabIndex: 0, type: "button" }, !showPassword ? "Show" : "Hide")),
                showHideEyePassword && (React__default.createElement("button", { "aria-label": showPassword ? "Hide Text" : "Show Text", className: [
                        textfieldStyles.showHideEyePasswordButton,
                        "absolute",
                        "pad-xxs",
                    ].join(" "), onClick: _this.handleShowHidePassword, tabIndex: 0, style: { width: "2em" }, type: "button" },
                    showPassword === true && (React__default.createElement(IconSvg.default, { colorClass: "color-ui-black", size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M11.77 8.94l-1.5-1.5a12.28 12.28 0 0114.35 2.14L31 16l-6 6.13-1.41-1.42 4.6-4.71-5-5A10.08 10.08 0 0016 8a10.27 10.27 0 00-4.23.94zm9.64 9.64a6 6 0 00-8-8L15 12.15a3.81 3.81 0 011-.15 4 4 0 014 4 3.81 3.81 0 01-.15 1zm7.24 10.07l-1.42 1.41-5.47-5.47a12.21 12.21 0 01-14.41-2.16L1 16l6.07-6.1-5.13-5.13 1.41-1.42 5.21 5.21L10 10l1.77 1.77 1.41 1.41 5.66 5.66 1.41 1.41L22 22l1.43 1.43zM12 16a4 4 0 004 4 3.81 3.81 0 001-.15L12.15 15a3.81 3.81 0 00-.15 1zm8.26 7.09l-1.68-1.68a6 6 0 01-8-8l-2.1-2.1L3.81 16l5 5a10.17 10.17 0 0011.49 2.07z\"/></svg>" })),
                    showPassword === false && (React__default.createElement(IconSvg.default, { colorClass: "color-ui-black", size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M24.62 9.58a12.24 12.24 0 00-17.24 0L1 16l6.36 6.43a12.19 12.19 0 0017.3 0L31 16zM23.23 21a10.19 10.19 0 01-14.46 0l-5-5 5-5a10.21 10.21 0 0114.4 0l5 5zM16 10a6 6 0 106 6 6 6 0 00-6-6zm0 10a4 4 0 114-4 4 4 0 01-4 4z\"/></svg>" })))),
                _this.props.data.hintText && !_this.props.options.error && (React__default.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: _this.props.options.inLineHtmlParse === true
                        ? { __html: data.hintText ? data.hintText : "" }
                        : undefined, id: "msg_" + id, tabIndex: showHint ? 0 : -1 }, _this.props.options.inLineHtmlParse === true ? null : data.hintText))));
        };
        return _this;
    }
    TextField.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        var options = this.props.options;
        var _a = this.state, currentTextValue = _a.currentTextValue, disabled = _a.disabled;
        if (newProps.data.input !== currentTextValue) {
            if (options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD) {
                this.setState({
                    currentTextValue: newProps.data.input,
                    maskedValue: this.mask(newProps.data.input),
                });
            }
            else {
                this.setState({
                    currentTextValue: newProps.data.input,
                });
            }
        }
        if (newProps.options.disabled !== disabled) {
            this.setState({ disabled: newProps.options.disabled });
        }
    };
    TextField.prototype.evaluateValue = function (event) {
        var options = this.props.options;
        var currentTextValue = this.state.currentTextValue;
        var stateValue = currentTextValue ? currentTextValue : "";
        var evaluatedResult = event.currentTarget.value;
        if (options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD && !this.state.showPassword) {
            var value = event.currentTarget.value;
            var charAt = event.currentTarget.selectionStart;
            // delete key handling
            if (value.length < stateValue.length && charAt) {
                evaluatedResult = stateValue.replace(stateValue.charAt(charAt), '');
            }
            else {
                if (charAt && value.length === charAt) {
                    evaluatedResult = stateValue + value.charAt(value.length - 1);
                }
                else if (charAt) {
                    evaluatedResult = stateValue.slice(0, charAt - 1) + value.charAt(value.length - (value.length - charAt) - 1) +
                        stateValue.slice(charAt - 1);
                }
                else {
                    evaluatedResult = stateValue;
                }
            }
        }
        return evaluatedResult;
    };
    TextField.prototype.decideInputType = function () {
        var options = this.props.options;
        var showPassword = this.state.showPassword;
        var inputType = this.props.options.type;
        switch (options.type) {
            case TextFieldProps.TextFieldType.NUMERIC_PASSWORD:
                if (showPassword && options.showHidePassword) {
                    inputType = TextFieldProps.TextFieldType.TEL;
                }
                else {
                    inputType = TextFieldProps.TextFieldType.PASSWORD;
                }
                break;
            case TextFieldProps.TextFieldType.PASSWORD:
                if ((showPassword && options.showHidePassword) ||
                    (showPassword && options.hasEye)) {
                    inputType = TextFieldProps.TextFieldType.TEXT;
                }
                break;
        }
        return inputType;
    };
    TextField.prototype.mask = function (value) {
        var maskedValue = "";
        if (value && value !== "") {
            maskedValue = value.replace(/[0-9]/g, TextFieldProps.MASK_CHARACTER.DEFAULT);
        }
        return maskedValue;
    };
    TextField.prototype.referenceState = function () {
        var options = this.props.options;
        var _a = this.state, currentTextValue = _a.currentTextValue, maskedValue = _a.maskedValue, showPassword = _a.showPassword;
        return options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD && showPassword === false
            ? maskedValue
            : currentTextValue;
    };
    TextField.defaultProps = {
        options: {
            autocompleteOption: "on",
            className: "",
            type: TextFieldProps.TextFieldType.TEXT,
        },
        spi: false,
    };
    return TextField;
}(React__default.Component));
exports.default = TextField;
});

var TextField = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = TextField_1.default;
});

var Timer_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });

var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            tempShowTimer: true,
        };
        _this.count = function () {
            var now = new Date().getTime();
            var timeLeft = _this.deadline - now;
            var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
            _this.setState({ days: days, minutes: minutes, hours: hours, seconds: seconds });
            if (timeLeft < 0) {
                clearInterval(_this.x);
                _this.setState({ days: 0, minutes: 0, hours: 0, seconds: 0, tempShowTimer: false }, function () {
                    var _a;
                    if ((_a = _this.props.options) === null || _a === void 0 ? void 0 : _a.onTimerEnd) {
                        _this.props.options.onTimerEnd();
                    }
                });
            }
        };
        return _this;
    }
    Timer.prototype.componentDidMount = function () {
        var dater = this.props.date;
        this.deadline = new Date(dater).getTime();
        this.count();
        this.x = setInterval(this.count, 1000);
    };
    Timer.prototype.render = function () {
        var _a = this.state, days = _a.days, seconds = _a.seconds, hours = _a.hours, minutes = _a.minutes, tempShowTimer = _a.tempShowTimer;
        var options = this.props.options || {};
        var introTextposition = options && options.introTextposition ? options.introTextposition : "left";
        var customClassWithColor = options.customClass || "";
        if (customClassWithColor.indexOf("color-") < 0) {
            customClassWithColor +=
                (options === null || options === void 0 ? void 0 : options.onDark) === true ? " color-ui-white" : " color-ui-black";
        }
        return (React__default.createElement("div", { className: "inline-block", "data-testid": this.props.testId }, this.props.showTimer && tempShowTimer ? (React__default.createElement("div", { "data-testid": this.props.testId, className: " " + customClassWithColor },
            React__default.createElement("p", { className: "font-medium mar-b-xxs type-base text-" + introTextposition, "aria-describedby": "spoken-timer" }, (options === null || options === void 0 ? void 0 : options.timerIntroText) && (options === null || options === void 0 ? void 0 : options.timerIntroText.slice(0, options === null || options === void 0 ? void 0 : options.maxCharLimit))),
            React__default.createElement("div", { className: "flex mar-b-xs rel" },
                React__default.createElement("div", { className: "hidden-spoken", id: "spoken-timer" },
                    days,
                    " days ",
                    hours,
                    " hours ",
                    minutes,
                    " minutes ",
                    seconds,
                    " seconds"),
                React__default.createElement("div", { className: "flex flex-column text-center width-xl mar-r-xxs", "aria-hidden": true },
                    React__default.createElement("div", { className: "type-xl font-medium line-h-sm mar-b-xxxs" }, days),
                    React__default.createElement("div", { className: "type-xs" }, "DAYS")),
                React__default.createElement("div", { className: "flex flex-column text-center width-xl mar-r-xxs", "aria-hidden": true },
                    React__default.createElement("div", { className: "type-xl font-medium line-h-sm mar-b-xxxs" }, hours),
                    React__default.createElement("div", { className: "type-xs" }, "HRS")),
                React__default.createElement("div", { className: "flex flex-column text-center width-xl mar-r-xxs", "aria-hidden": true },
                    React__default.createElement("div", { className: "type-xl font-medium line-h-sm mar-b-xxxs" }, minutes),
                    React__default.createElement("div", { className: "type-xs" }, "MIN")),
                React__default.createElement("div", { className: "flex flex-column text-center width-xl mar-r-xxs", "aria-hidden": true },
                    React__default.createElement("div", { className: "type-xl font-medium line-h-sm mar-b-xxxs" }, seconds),
                    React__default.createElement("div", { className: "type-xs" }, "SEC"))))) : null));
    };
    return Timer;
}(React__default.Component));
exports.default = Timer;
});

var Timer = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Timer_1.default;
});

var toggleLabel = "Toggle_toggle-label__y-Ain";
var toggleCheckbox = "Toggle_toggle-checkbox__TjDsq";
var toggleSwitch = "Toggle_toggle-switch__Ihv7c";
var toggleHandle = "Toggle_toggle-handle__9LxPo";
var toggleMsgOn = "Toggle_toggle-msg-on__1GRJs";
var toggleMsgOff = "Toggle_toggle-msg-off__2pNt-";
var css_248z$9 = "/* ********** UTILITIES *********** */\n.Toggle_toggle-label__y-Ain {\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n  position: relative; }\n\n.Toggle_toggle-checkbox__TjDsq {\n  height: 100%;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  z-index: 1; }\n\n.is-tabbing .Toggle_toggle-checkbox__TjDsq:focus ~ .Toggle_toggle-switch__Ihv7c {\n  outline: 1px dotted #1d2329;\n  outline-offset: 3px; }\n\n.Toggle_toggle-switch__Ihv7c {\n  border-radius: 20px;\n  cursor: pointer;\n  display: inline-flex;\n  height: 21px;\n  margin-left: 8px;\n  position: relative;\n  width: 34px; }\n\n.Toggle_toggle-handle__9LxPo {\n  background: #ffffff;\n  border-radius: 20px;\n  height: 17px;\n  margin-left: 2px;\n  margin-top: 2px;\n  position: absolute;\n  transition: transform 0.2s ease-in;\n  width: 17px; }\n\n.Toggle_toggle-msg-on__1GRJs,\n.Toggle_toggle-msg-off__2pNt- {\n  align-items: center;\n  color: #686e74;\n  font-family: font-medium, sans-serif;\n  font-size: 1.4rem;\n  line-height: normal;\n  margin-left: 8px;\n  min-width: 2.8rem;\n  text-transform: uppercase; }\n\n.Toggle_toggle-checkbox__TjDsq:not(:checked) ~ .Toggle_toggle-msg-on__1GRJs,\n.Toggle_toggle-checkbox__TjDsq:checked ~ .Toggle_toggle-msg-off__2pNt- {\n  display: none; }\n\n.Toggle_toggle-checkbox__TjDsq:checked ~ .Toggle_toggle-msg-on__1GRJs,\n.Toggle_toggle-checkbox__TjDsq:not(:checked) ~ .Toggle_toggle-msg-off__2pNt- {\n  display: flex; }\n\n.Toggle_toggle-checkbox__TjDsq:not(:checked):not(:disabled) ~ .Toggle_toggle-switch__Ihv7c {\n  background-color: #878c94; }\n\n.Toggle_toggle-checkbox__TjDsq[disabled] {\n  cursor: not-allowed; }\n\n.Toggle_toggle-checkbox__TjDsq[disabled] ~ .Toggle_toggle-switch__Ihv7c {\n  background-color: #dcdfe3; }\n\n.Toggle_toggle-checkbox__TjDsq:checked ~ .Toggle_toggle-switch__Ihv7c .Toggle_toggle-handle__9LxPo {\n  transform: translateX(13px);\n  transition: transform 0.2s ease-in; }\n\n/* ********** END UTILITIES *********** */\n";
var Toggle$1 = {"toggle-label":"Toggle_toggle-label__y-Ain","toggle-checkbox":"Toggle_toggle-checkbox__TjDsq","toggle-switch":"Toggle_toggle-switch__Ihv7c","toggle-handle":"Toggle_toggle-handle__9LxPo","toggle-msg-on":"Toggle_toggle-msg-on__1GRJs","toggle-msg-off":"Toggle_toggle-msg-off__2pNt-","toggleLabel":"Toggle_toggle-label__y-Ain","toggleCheckbox":"Toggle_toggle-checkbox__TjDsq","toggleSwitch":"Toggle_toggle-switch__Ihv7c","toggleHandle":"Toggle_toggle-handle__9LxPo","toggleMsgOn":"Toggle_toggle-msg-on__1GRJs","toggleMsgOff":"Toggle_toggle-msg-off__2pNt-"};
var stylesheet$7="/* ********** UTILITIES *********** */\n.Toggle_toggle-label__y-Ain {\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n  position: relative; }\n\n.Toggle_toggle-checkbox__TjDsq {\n  height: 100%;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  z-index: 1; }\n\n.is-tabbing .Toggle_toggle-checkbox__TjDsq:focus ~ .Toggle_toggle-switch__Ihv7c {\n  outline: 1px dotted #1d2329;\n  outline-offset: 3px; }\n\n.Toggle_toggle-switch__Ihv7c {\n  border-radius: 20px;\n  cursor: pointer;\n  display: inline-flex;\n  height: 21px;\n  margin-left: 8px;\n  position: relative;\n  width: 34px; }\n\n.Toggle_toggle-handle__9LxPo {\n  background: #ffffff;\n  border-radius: 20px;\n  height: 17px;\n  margin-left: 2px;\n  margin-top: 2px;\n  position: absolute;\n  transition: transform 0.2s ease-in;\n  width: 17px; }\n\n.Toggle_toggle-msg-on__1GRJs,\n.Toggle_toggle-msg-off__2pNt- {\n  align-items: center;\n  color: #686e74;\n  font-family: font-medium, sans-serif;\n  font-size: 1.4rem;\n  line-height: normal;\n  margin-left: 8px;\n  min-width: 2.8rem;\n  text-transform: uppercase; }\n\n.Toggle_toggle-checkbox__TjDsq:not(:checked) ~ .Toggle_toggle-msg-on__1GRJs,\n.Toggle_toggle-checkbox__TjDsq:checked ~ .Toggle_toggle-msg-off__2pNt- {\n  display: none; }\n\n.Toggle_toggle-checkbox__TjDsq:checked ~ .Toggle_toggle-msg-on__1GRJs,\n.Toggle_toggle-checkbox__TjDsq:not(:checked) ~ .Toggle_toggle-msg-off__2pNt- {\n  display: flex; }\n\n.Toggle_toggle-checkbox__TjDsq:not(:checked):not(:disabled) ~ .Toggle_toggle-switch__Ihv7c {\n  background-color: #878c94; }\n\n.Toggle_toggle-checkbox__TjDsq[disabled] {\n  cursor: not-allowed; }\n\n.Toggle_toggle-checkbox__TjDsq[disabled] ~ .Toggle_toggle-switch__Ihv7c {\n  background-color: #dcdfe3; }\n\n.Toggle_toggle-checkbox__TjDsq:checked ~ .Toggle_toggle-switch__Ihv7c .Toggle_toggle-handle__9LxPo {\n  transform: translateX(13px);\n  transition: transform 0.2s ease-in; }\n\n/* ********** END UTILITIES *********** */\n";
styleInject(css_248z$9);

var Toggle$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    toggleLabel: toggleLabel,
    toggleCheckbox: toggleCheckbox,
    toggleSwitch: toggleSwitch,
    toggleHandle: toggleHandle,
    toggleMsgOn: toggleMsgOn,
    toggleMsgOff: toggleMsgOff,
    'default': Toggle$1,
    stylesheet: stylesheet$7
});

var styles$6 = /*@__PURE__*/getAugmentedNamespace(Toggle$2);

var Toggle_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });



var enterIsPressed = keyPress.KeyPress.enterIsPressed;
var Toggle = /** @class */ (function (_super) {
    __extends(Toggle, _super);
    function Toggle(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyPress = function (e) {
            if (enterIsPressed(e)) {
                _this.handleClick(e);
                _this.onChange(e);
            }
        };
        _this.handleClick = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.data.value, e);
            }
        };
        _this.onChange = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(_this.props.data.value, e);
            }
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, options = _a.options, testId = _a.testId;
            return (React__default.createElement("label", { "data-testid": testId, className: styles$6.toggleLabel + " " + _this.props.className },
                React__default.createElement("input", { id: _this.labelId, "aria-label": data.text, ref: function (inputElement) { return (_this.inputEl = inputElement); }, checked: _this.props.data.value, "aria-checked": _this.props.data.value ? true : false, className: styles$6.toggleCheckbox, onChange: _this.onChange, onClick: _this.handleClick, disabled: options.disabled ? true : undefined, onKeyDown: _this.handleKeyPress, role: "switch", type: "checkbox" }),
                React__default.createElement("span", { "aria-hidden": true, className: _this.props.data.value
                        ? styles$6.toggleMsgOn +
                            " " +
                            (data.rightAlign ? " text-right" : " text-left")
                        : styles$6.toggleMsgOff + (data.rightAlign ? " text-right" : " text-left") }, _this.props.data.value ? "ON" : "OFF"),
                React__default.createElement("div", { className: _this.props.data.value
                        ? styles$6.toggleSwitch + " " + data.type
                        : styles$6.toggleSwitch },
                    React__default.createElement("span", { className: styles$6.toggleHandle }))));
        };
        _this.labelId = _this.guid();
        return _this;
    }
    Toggle.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    Toggle.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    Toggle.defaultProps = {
        data: {
            text: "",
            type: "",
            value: false,
            rightAlign: true,
        },
        options: {
            disabled: false,
        },
    };
    return Toggle;
}(React__default.PureComponent));
exports.default = Toggle;
});

var Toggle = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Toggle_1.default;
});

var childContainer = "Tooltip_childContainer__gB0w-";
var textInfo = "Tooltip_textInfo__rRpKx";
var bgwhite = "Tooltip_bgwhite__UfvBO";
var infoBox = "Tooltip_infoBox__fQoZn";
var arrow = "Tooltip_arrow__V-Vpz";
var show = "Tooltip_show__r7ZoV";
var positionBottom = "Tooltip_positionBottom__8QOgP";
var positionTop = "Tooltip_positionTop__bifT8";
var relPmt = "Tooltip_rel-pmt__upNa3";
var css_248z$8 = ".Tooltip_childContainer__gB0w- {\n  line-height: 0.8;\n  top: -1px; }\n  .Tooltip_childContainer__gB0w- > * {\n    position: relative !important; }\n  .Tooltip_childContainer__gB0w- svg {\n    vertical-align: baseline; }\n\n.Tooltip_textInfo__rRpKx {\n  color: #ffffff;\n  font-size: 1.2rem; }\n  .Tooltip_textInfo__rRpKx.Tooltip_bgwhite__UfvBO {\n    color: #454b52 !important; }\n\n.Tooltip_infoBox__fQoZn {\n  border-radius: 2px;\n  visibility: hidden;\n  background-color: #454b52;\n  position: absolute;\n  z-index: 1000;\n  max-width: 320px;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content; }\n\n.Tooltip_bgwhite__UfvBO {\n  background-color: #ffffff !important; }\n\n.Tooltip_arrow__V-Vpz {\n  visibility: hidden;\n  border-radius: 0 2px 0 2px;\n  background-color: #454b52;\n  width: 8px;\n  height: 8px;\n  z-index: 1000;\n  position: absolute; }\n\n.Tooltip_show__r7ZoV {\n  visibility: visible !important; }\n\n.Tooltip_positionBottom__8QOgP.Tooltip_arrow__V-Vpz {\n  left: calc(50% - 4.2px);\n  transform: translateY(3px) rotate(-45deg);\n  top: 100%; }\n\n.Tooltip_positionBottom__8QOgP.Tooltip_infoBox__fQoZn {\n  transform: translate(-50%, 7px);\n  left: 50%; }\n\n.Tooltip_positionTop__bifT8.Tooltip_arrow__V-Vpz {\n  left: calc(50% - 4.2px);\n  transform: translateY(-5px) rotate(-45deg);\n  bottom: 100%; }\n\n.Tooltip_positionTop__bifT8.Tooltip_infoBox__fQoZn {\n  transform: translate(-50%, -9px);\n  bottom: 100%;\n  left: 50%; }\n\n.Tooltip_rel-pmt__upNa3 {\n  position: relative !important; }\n\n.form-row.rel {\n  z-index: auto; }\n\n.is-tabbing .trigger:focus {\n  outline: 1px dotted currentColor;\n  outline-offset: 1px; }\n";
var Tooltip$1 = {"childContainer":"Tooltip_childContainer__gB0w-","textInfo":"Tooltip_textInfo__rRpKx","bgwhite":"Tooltip_bgwhite__UfvBO","infoBox":"Tooltip_infoBox__fQoZn","arrow":"Tooltip_arrow__V-Vpz","show":"Tooltip_show__r7ZoV","positionBottom":"Tooltip_positionBottom__8QOgP","positionTop":"Tooltip_positionTop__bifT8","rel-pmt":"Tooltip_rel-pmt__upNa3","relPmt":"Tooltip_rel-pmt__upNa3"};
var stylesheet$6=".Tooltip_childContainer__gB0w- {\n  line-height: 0.8;\n  top: -1px; }\n  .Tooltip_childContainer__gB0w- > * {\n    position: relative !important; }\n  .Tooltip_childContainer__gB0w- svg {\n    vertical-align: baseline; }\n\n.Tooltip_textInfo__rRpKx {\n  color: #ffffff;\n  font-size: 1.2rem; }\n  .Tooltip_textInfo__rRpKx.Tooltip_bgwhite__UfvBO {\n    color: #454b52 !important; }\n\n.Tooltip_infoBox__fQoZn {\n  border-radius: 2px;\n  visibility: hidden;\n  background-color: #454b52;\n  position: absolute;\n  z-index: 1000;\n  max-width: 320px;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content; }\n\n.Tooltip_bgwhite__UfvBO {\n  background-color: #ffffff !important; }\n\n.Tooltip_arrow__V-Vpz {\n  visibility: hidden;\n  border-radius: 0 2px 0 2px;\n  background-color: #454b52;\n  width: 8px;\n  height: 8px;\n  z-index: 1000;\n  position: absolute; }\n\n.Tooltip_show__r7ZoV {\n  visibility: visible !important; }\n\n.Tooltip_positionBottom__8QOgP.Tooltip_arrow__V-Vpz {\n  left: calc(50% - 4.2px);\n  transform: translateY(3px) rotate(-45deg);\n  top: 100%; }\n\n.Tooltip_positionBottom__8QOgP.Tooltip_infoBox__fQoZn {\n  transform: translate(-50%, 7px);\n  left: 50%; }\n\n.Tooltip_positionTop__bifT8.Tooltip_arrow__V-Vpz {\n  left: calc(50% - 4.2px);\n  transform: translateY(-5px) rotate(-45deg);\n  bottom: 100%; }\n\n.Tooltip_positionTop__bifT8.Tooltip_infoBox__fQoZn {\n  transform: translate(-50%, -9px);\n  bottom: 100%;\n  left: 50%; }\n\n.Tooltip_rel-pmt__upNa3 {\n  position: relative !important; }\n\n.form-row.rel {\n  z-index: auto; }\n\n.is-tabbing .trigger:focus {\n  outline: 1px dotted currentColor;\n  outline-offset: 1px; }\n";
styleInject(css_248z$8);

var Tooltip$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    childContainer: childContainer,
    textInfo: textInfo,
    bgwhite: bgwhite,
    infoBox: infoBox,
    arrow: arrow,
    show: show,
    positionBottom: positionBottom,
    positionTop: positionTop,
    relPmt: relPmt,
    'default': Tooltip$1,
    stylesheet: stylesheet$6
});

var styles$5 = /*@__PURE__*/getAugmentedNamespace(Tooltip$2);

var TooltipProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionType = void 0;

exports.PositionType = {
    top: styles$5.positionTop,
    bottom: styles$5.positionBottom,
};
});

var Tooltip_1 = createCommonjsModule(function (module, exports) {
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });





var Tooltip = function (_a) {
    var infoTxt = _a.infoTxt, boxWidth = _a.boxWidth, _b = _a.position, position = _b === void 0 ? "top" : _b, children = _a.children, style = _a.style, className = _a.className, offset = _a.offset, _c = _a.show, show = _c === void 0 ? false : _c, _d = _a.content, content = _d === void 0 ? "stuff" : _d, testId = _a.testId, zIndex = _a.zIndex, _e = _a.type, type = _e === void 0 ? "dark" : _e;
    var _f = __read(React__default.useState(show), 2), showState = _f[0], setShowState = _f[1];
    var _g = __read(React__default.useState(position), 2), positionState = _g[0], setPositionState = _g[1];
    var _h = __read(React__default.useState(false), 2), isClick = _h[0], setIsClick = _h[1];
    var _j = __read(React__default.useState(false), 2), isHover = _j[0], setIsHover = _j[1];
    var _k = __read(React__default.useState(true), 2), isFocusable = _k[0], setIsFocusable = _k[1];
    var arrowRef = React__default.useRef(null);
    var boxRef = React__default.useRef(null);
    var triggerRef = React__default.useRef(null);
    var noWrap = false;
    React__default.useEffect(function () {
        if (process.browser && window) {
            suppressFocus();
            checkPosition();
            window.addEventListener("resize", checkPosition);
        }
        return function () {
            if (process.browser && window) {
                suppressFocus();
                window.removeEventListener("resize", checkPosition);
            }
        };
    }, []);
    var checkPosition = React__default.useCallback(function () {
        if (process.browser && window) {
            // if width of box exceeds screen size, set it responsively to the size of the screen
            if (!boxRef.current || !arrowRef.current || !triggerRef.current) {
                return;
            }
            var currentBox = boxRef.current;
            var bounds = currentBox.getBoundingClientRect();
            var currentArrow = arrowRef.current;
            var arrowBounds = currentArrow.getBoundingClientRect();
            var currentTrigger = triggerRef.current;
            var triggerBounds = currentTrigger.getBoundingClientRect();
            // if it is the size of the screen
            var sidePadding = window.innerWidth > 600 ? 32 : 16;
            // vertical positioning
            if (position === "top" && bounds.top < sidePadding) {
                setPositionState("bottom");
            }
            else if (position === "bottom" && bounds.bottom > window.innerHeight - sidePadding) {
                setPositionState("top");
            }
            if (bounds.width >= document.documentElement.clientWidth - sidePadding * 2) {
                currentBox.style.width =
                    document.documentElement.clientWidth - (sidePadding + 10) * 2 + "px";
            }
            else {
                currentBox.style.width = bounds.width + "px";
            }
            if (bounds.left < sidePadding) {
                currentBox.style.left =
                    sidePadding +
                        Math.abs(arrowBounds.left +
                            8 -
                            parseInt(currentBox.style.width.slice(0, -2), 10) / 2) +
                        triggerBounds.width / 2 +
                        "px";
                if (currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width >=
                    document.documentElement.clientWidth - sidePadding) {
                    var tmpLeft = parseInt(currentBox.style.left.slice(0, -2), 10);
                    currentBox.style.left =
                        tmpLeft -
                            (currentBox.getBoundingClientRect().right -
                                (document.documentElement.clientWidth - sidePadding)) +
                            "px";
                }
            }
            if (bounds.right > document.documentElement.clientWidth - sidePadding) {
                var extra = arrowBounds.left +
                    6 +
                    parseInt(currentBox.style.width.slice(0, -2), 10) / 2 -
                    (document.documentElement.clientWidth - sidePadding);
                currentBox.style.left = -extra + "px";
                if (currentBox.getBoundingClientRect().left < sidePadding) {
                    var tmpLeft = parseInt(currentBox.style.left.slice(0, -2), 10);
                    currentBox.style.left =
                        tmpLeft + (sidePadding - currentBox.getBoundingClientRect().left) + "px";
                }
            }
            if (
            // is there an offset? Is that offset less than half the width of the box? If I relocate it, will the offset push me off the page?
            offset &&
                Math.abs(offset) < currentBox.getBoundingClientRect().width / 2 - 15 &&
                currentBox.getBoundingClientRect().left + offset > sidePadding &&
                currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width +
                    offset <
                    window.innerWidth - sidePadding) {
                currentBox.style.left = "calc(50% + " + offset + "px)";
                // make sure its not pushhing off screen
                if (currentBox.getBoundingClientRect().left +
                    currentBox.getBoundingClientRect().width >=
                    window.innerWidth - sidePadding) {
                    var extra = arrowBounds.left +
                        6 +
                        parseInt(currentBox.style.width.slice(0, -2), 10) / 2 -
                        (document.documentElement.clientWidth - sidePadding);
                    currentBox.style.left = -extra + "px";
                }
                else if (currentBox.getBoundingClientRect().left < sidePadding) {
                    currentBox.style.left =
                        sidePadding +
                            Math.abs(arrowBounds.left +
                                6 -
                                parseInt(currentBox.style.width.slice(0, -2), 10) / 2) +
                            triggerBounds.width / 2 +
                            "px";
                }
            }
        }
    }, []);
    function suppressFocus() {
        if (triggerRef.current) {
            var items = triggerRef.current.querySelectorAll("input, button, a, select, textarea");
            if (items.length > 0) {
                setIsFocusable(false);
            }
            else {
                setIsFocusable(true);
            }
        }
        else {
            setIsFocusable(true);
        }
    }
    var tooltipLabel = "tooltip";
    var tooltipId = getId();
    var msgid = "msg-" + tooltipId;
    if (!boxWidth &&
        boxRef &&
        boxRef.current &&
        boxRef.current.getBoundingClientRect().width < 320) {
        noWrap = true;
    }
    function getId() {
        if (typeof document !== "undefined") {
            var temp = tooltipLabel
                .replace(/ /g, "-")
                .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
                .toLowerCase();
            while (document.getElementById(temp)) {
                temp = temp.concat(Math.floor(Math.random() * 100 + 1).toString());
            }
            return temp;
        }
        else {
            return tooltipLabel;
        }
    }
    var KeyDownHandler = function (e) {
        if (keyPress.KeyPress.escIsPressed(e)) {
            hideTooltip();
            setIsClick(false);
            setIsHover(false);
        }
        else {
            if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
                e.preventDefault();
                if (!showState) {
                    showTooltip();
                    setIsClick(true);
                    setIsHover(false);
                }
                else {
                    hideTooltip();
                    setIsClick(false);
                    setIsHover(false);
                }
            }
        }
    };
    return (React__default.createElement("div", { className: "inline-block", style: { verticalAlign: "middle" }, "data-testid": testId },
        React__default.createElement("div", { className: Join.join(["outerContainer", className]), style: style, "data-testid": testId, id: tooltipId },
            positionState === "top" && positionTop(),
            React__default.createElement("span", { className: "hidden-spoken", id: msgid }, content),
            React__default.createElement("div", { tabIndex: isFocusable ? 0 : -1, ref: triggerRef, className: Join.join("rel", "trigger", styles$5.childContainer), onClick: onClick, onMouseEnter: onHoverIn, onMouseLeave: onHoverOut, onBlur: onBlur, onKeyDown: KeyDownHandler, role: "button", "aria-describedby": msgid, "aria-label": infoTxt ? infoTxt : "Help", "aria-expanded": showState ? true : false }, children),
            positionState === "bottom" && positionBottom())));
    function positionTop() {
        return (React__default.createElement("div", { className: zIndex === undefined || zIndex === false ? "rel" : styles$5.relPmt },
            React__default.createElement("div", { ref: boxRef, style: { width: boxWidth }, className: Join.join("infoBox", showState && styles$5.show, styles$5.infoBox, type === "light" ? styles$5.bgwhite : "", TooltipProps.PositionType[positionState], noWrap ? "nowrap" : "") },
                React__default.createElement("div", { className: Join.join("mar-b-none infoText pad-t-xxs pad-b-xxs pad-l-xs pad-r-xs line-h-md", styles$5.textInfo, type === "light" ? styles$5.bgwhite : "") }, content)),
            React__default.createElement("div", { ref: arrowRef, className: Join.join("arrow", showState && styles$5.show, styles$5.arrow, type === "light" ? styles$5.bgwhite : "", TooltipProps.PositionType[positionState]) })));
    }
    function positionBottom() {
        return (React__default.createElement("div", { className: zIndex === undefined || zIndex === false ? "rel" : styles$5.relPmt },
            React__default.createElement("div", { ref: arrowRef, className: Join.join("arrow", showState && styles$5.show, styles$5.arrow, type === "light" ? styles$5.bgwhite : "", TooltipProps.PositionType[positionState]) }),
            React__default.createElement("div", { ref: boxRef, style: { width: boxWidth }, className: Join.join("infoBox", showState && styles$5.show, styles$5.infoBox, type === "light" ? styles$5.bgwhite : "", TooltipProps.PositionType[positionState], noWrap ? "nowrap" : "") },
                React__default.createElement("div", { className: Join.join("mar-b-none infoText pad-t-xxs pad-b-xxs pad-l-xs pad-r-xs line-h-md", styles$5.textInfo, type === "light" ? styles$5.bgwhite : "") }, content))));
    }
    function onHoverOut() {
        if (isClick) {
            return;
        }
        else {
            hideTooltip();
            setIsHover(false);
        }
    }
    function onHoverIn() {
        setIsHover(true);
        showTooltip();
    }
    function onBlur() {
        setIsClick(false);
        setIsHover(false);
        hideTooltip();
    }
    function onClick(e) {
        e.stopPropagation();
        if (isHover) {
            showTooltip();
            setIsClick(true);
            setIsHover(false);
        }
        else if (showState) {
            hideTooltip();
            setIsClick(false);
        }
        else {
            showTooltip();
            setIsClick(true);
            setIsHover(false);
        }
    }
    function showTooltip() {
        checkPosition();
        setShowState(true);
    }
    function hideTooltip() {
        setShowState(false);
        setPositionState(position);
    }
};
exports.default = Tooltip;
});

var Tooltip = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Tooltip_1.default;
});

var tracker = "Tracker_tracker__hSYp5";
var css_248z$7 = ".Tracker_tracker__hSYp5 div {\n  border-radius: 1.5px;\n  height: 3px;\n  margin-right: 4px;\n  width: 100%; }\n\n.Tracker_tracker__hSYp5 div:last-child {\n  margin-right: 0; }\n";
var Tracker$1 = {"tracker":"Tracker_tracker__hSYp5"};
var stylesheet$5=".Tracker_tracker__hSYp5 div {\n  border-radius: 1.5px;\n  height: 3px;\n  margin-right: 4px;\n  width: 100%; }\n\n.Tracker_tracker__hSYp5 div:last-child {\n  margin-right: 0; }\n";
styleInject(css_248z$7);

var Tracker$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    tracker: tracker,
    'default': Tracker$1,
    stylesheet: stylesheet$5
});

var styles$4 = /*@__PURE__*/getAugmentedNamespace(Tracker$2);

var Tracker_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


var Tracker = function (_a) {
    var data = _a.data, _b = _a.options, options = _b === void 0 ? {} : _b, testId = _a.testId;
    var stepItems = "";
    // start at index 1, since completedSteps is off 1
    for (var index = 1; index <= data.steps; index++) {
        // completed steps more than or equal to?
        stepItems +=
            data.completedSteps >= index
                ? '<div class="bg-functional-blue"></div>'
                : '<div class="bg-ui-light-gray"></div>';
    }
    return (React__default.createElement("div", { className: "mar-b-xs", "data-testid": testId },
        options.showHeading && React__default.createElement("h2", { className: "heading-md mar-b-none" }, options.heading),
        React__default.createElement("div", { className: "flex flex-items-center mar-t-xs mar-b-xxxs " + styles$4.tracker, dangerouslySetInnerHTML: { __html: stepItems } }),
        React__default.createElement("div", { className: "type-sm color-ui-black font-medium" },
            data.label,
            React__default.createElement("div", { className: "type-sm hidden-spoken" },
                "Step ",
                data.completedSteps,
                " of ",
                data.steps,
                " steps completed"))));
};
exports.default = Tracker;
});

var Tracker = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Tracker_1.default;
});

var usageMeter = "UsageMeter_usageMeter__YTs0m";
var bar = "UsageMeter_bar__vXSWZ";
var css_248z$6 = ".UsageMeter_usageMeter__YTs0m {\n  border-radius: 3px;\n  height: 12px;\n  margin-bottom: 4px;\n  margin-top: 4px;\n  outline: 1px solid transparent; }\n\n.UsageMeter_bar__vXSWZ {\n  border-radius: 3px; }\n\n.UsageMeter_usageMeter__YTs0m .UsageMeter_bar__vXSWZ {\n  transition: width 0.7s linear 0s; }\n";
var UsageMeter$1 = {"usageMeter":"UsageMeter_usageMeter__YTs0m","bar":"UsageMeter_bar__vXSWZ"};
var stylesheet$4=".UsageMeter_usageMeter__YTs0m {\n  border-radius: 3px;\n  height: 12px;\n  margin-bottom: 4px;\n  margin-top: 4px;\n  outline: 1px solid transparent; }\n\n.UsageMeter_bar__vXSWZ {\n  border-radius: 3px; }\n\n.UsageMeter_usageMeter__YTs0m .UsageMeter_bar__vXSWZ {\n  transition: width 0.7s linear 0s; }\n";
styleInject(css_248z$6);

var UsageMeter$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    usageMeter: usageMeter,
    bar: bar,
    'default': UsageMeter$1,
    stylesheet: stylesheet$4
});

var usageStyles = /*@__PURE__*/getAugmentedNamespace(UsageMeter$2);

var UsageMeter_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });


/* End of UsageMeter Component Class */
var UsageMeter = /** @class */ (function (_super) {
    __extends(UsageMeter, _super);
    /* Usage Meter on Initialization */
    function UsageMeter(props) {
        var _this = _super.call(this, props) || this;
        /* Usage Meter on Initialization */
        /* Calculate the Percentage based on totalValue and completedValue values */
        _this.getUsageBarWidth = function () {
            var data = _this.props.data;
            var completedValue = data.completedValue, totalValue = data.totalValue;
            return (completedValue / totalValue) * 100;
        };
        /* Calculate the Percentage based on totalValue and completedValue values */
        /* Process Usage usageMeterLabel */
        _this.getUsageMeterTopLeftMessage = function () {
            var data = _this.props.data;
            var completedValue = data.completedValue, totalValue = data.totalValue, topLeftMessage = data.topLeftMessage;
            return completedValue + " of " + totalValue + " " + topLeftMessage;
        };
        /* Process Usage usageMeterLabel */
        /* Animate Usage Meters based on Their bar type */
        _this.animateUsageMeter = function () {
            var progressElements = document.querySelectorAll("[data-bar-type='animated']");
            var progressElementsLength = progressElements.length;
            for (var i = 0; i < progressElementsLength; i++) {
                var eachAnimatedElement = progressElements[i];
                if (eachAnimatedElement) {
                    var elementBounds = eachAnimatedElement.getBoundingClientRect();
                    var animElmStyle = eachAnimatedElement.getAttribute("style");
                    var bottom = elementBounds.bottom, top_1 = elementBounds.top;
                    if (!(top_1 > innerHeight || bottom < 0) && animElmStyle === "width: 0%;") {
                        // Toggle between in viewport and out of view port
                        eachAnimatedElement.setAttribute("style", "width: " + eachAnimatedElement.getAttribute("data-percentage"));
                        eachAnimatedElement.setAttribute("data-bar-type", "animate-completed");
                    }
                }
            }
        };
        /* Animate Usage Meters based on Their bar type */
        /* On Component Mount */
        _this.componentDidMount = function () {
            if (_this.props.options && _this.props.options.isAnimated) {
                _this.animateUsageMeter(); // On mount Handle Animated Bars in View Port
                /* Dynamically Taking ID for Animated Progressbar and Applying Animation in Viewport */
                document.addEventListener("scroll", _this.animateUsageMeter);
                /* Dynamically Taking ID for Animated Progressbar and Applying Animation in Viewport */
            }
        };
        /* On Component Mount */
        /* On Component Will Unmount */
        _this.componentWillUnmount = function () {
            if (_this.props.options && _this.props.options.isAnimated) {
                document.removeEventListener("scroll", _this.animateUsageMeter);
            }
        };
        /* On Component Will Unmount */
        /* Get Progressbar Color by Percentage Ranges */
        _this.progressColorByPercentage = function () {
            var options = _this.props.options;
            var fillColor = options.fillColor;
            if (fillColor && fillColor.length > 0) {
                var progressBarColorArray = fillColor.filter(function (eachColor) {
                    var minValue = eachColor.minValue, maxValue = eachColor.maxValue;
                    return _this.percentage >= minValue && _this.percentage <= maxValue;
                });
                if (progressBarColorArray.length > 0) {
                    return progressBarColorArray[0].color ? progressBarColorArray[0].color : "";
                }
                else {
                    return "";
                }
            }
            else {
                var result = "";
                if (_this.percentage >= 1 && _this.percentage <= 64) {
                    result = "bg-functional-dk-green";
                }
                else if (_this.percentage > 64 && _this.percentage < 100) {
                    result = "bg-functional-dk-orange";
                }
                else if (_this.percentage >= 100) {
                    result = "bg-functional-dk-red";
                }
                return result;
            }
        };
        /* Get Progressbar Color by Percentage Ranges */
        /* Render Usage Meter HTML */
        _this.render = function () {
            var _a = _this.props, data = _a.data, options = _a.options, testId = _a.testId, remainingProps = __rest(_a, ["data", "options", "testId"]);
            var urlLink = data.urlLink, usageMeterLabel = data.usageMeterLabel, description = data.description, urlText = data.urlText, daysRemaining = data.daysRemaining, completedValue = data.completedValue, totalValue = data.totalValue, topLeftMessage = data.topLeftMessage;
            var tabIndex = options.tabIndex, isAnimated = options.isAnimated, ariaLabel = options.ariaLabel;
            var leftusageMeterLabel = topLeftMessage && topLeftMessage !== "" ? _this.getUsageMeterTopLeftMessage() : ""; // Usage Meter Label on Top Bar
            var progressColor = _this.progressColorByPercentage();
            return (React__default.createElement("div", __assign({ "data-testid": testId, tabIndex: tabIndex }, remainingProps),
                leftusageMeterLabel && leftusageMeterLabel !== "" ? (React__default.createElement("div", { className: "usage-data-used flex color-ui-black font-medium type-sm mar-b-none justify-between" },
                    React__default.createElement("div", { className: "text-left mar-r-xs type-sm" }, leftusageMeterLabel),
                    daysRemaining ? React__default.createElement("div", { className: "text-right" },
                        " ",
                        daysRemaining) : "")) : (""),
                React__default.createElement("div", { className: "bg-ui-light-gray" +
                        " " +
                        usageStyles.usageMeter +
                        " " +
                        "overflow-hidden pad-none rel", role: "progressbar", "aria-label": ariaLabel ? ariaLabel : "", "aria-valuenow": completedValue, "aria-valuemin": 0, "aria-valuemax": totalValue, "aria-valuetext": Math.floor(_this.percentage) + "% usage" },
                    React__default.createElement("div", { "data-bar-type": isAnimated ? "animated" : "non-animated", className: usageStyles.bar + " " + "height-full flex" + " " + progressColor, "data-percentage": _this.percentage + "%", style: { width: (isAnimated ? "0" : _this.percentage) + "%" } })),
                description || usageMeterLabel || urlLink || urlText ? (React__default.createElement("div", { className: "color-ui-dark-gray font-regular type-sm mar-b-none usage-desc-label" },
                    description ? (React__default.createElement("span", { "aria-hidden": "false" }, description)) : usageMeterLabel ? (React__default.createElement("span", { "aria-hidden": "false" }, usageMeterLabel)) : (""),
                    urlLink || urlText ? (React__default.createElement("a", { href: urlLink ? urlLink : undefined, className: usageMeterLabel
                            ? "block link-text3 nowrap font-medium"
                            : "link-text3 font-medium" }, urlText ? (React__default.createElement("span", { "aria-hidden": "false" }, urlText)) : (React__default.createElement("span", { "aria-hidden": "false" }, "Learn why")))) : (""))) : ("")));
        };
        var _a = props.data, totalValue = _a.totalValue, completedValue = _a.completedValue;
        _this.percentage = _this.getUsageBarWidth();
        try {
            if (totalValue <= 0) {
                throw new Error("Total value cannot be less than 1");
            }
            else if (completedValue < 0 || completedValue > totalValue) {
                throw new Error("Completed Value cannot be less than 1 or greater than total value");
            }
        }
        catch (error) {
            props.data.totalValue = 1;
            props.data.completedValue = 1;
        }
        return _this;
    }
    /* Default Properties */
    UsageMeter.defaultProps = {
        options: {
            fillColor: [],
        },
    };
    return UsageMeter;
}(React__default.PureComponent));
/* End of UsageMeter Component Class */
exports.default = UsageMeter;
});

var UsageMeter = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = UsageMeter_1.default;
});

var OnClickOutside_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });

var OnClickOutside = /** @class */ (function (_super) {
    __extends(OnClickOutside, _super);
    function OnClickOutside() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.outsideClick = function () {
            _this.props.events.onClickOutside();
        };
        return _this;
    }
    OnClickOutside.prototype.componentDidMount = function () {
        document.addEventListener("click", this.outsideClick);
    };
    OnClickOutside.prototype.componentWillUnmount = function () {
        document.removeEventListener("click", this.outsideClick);
    };
    OnClickOutside.prototype.render = function () {
        return this.props.children || null;
    };
    return OnClickOutside;
}(React__default.Component));
exports.default = OnClickOutside;
});

var OnClickOutside = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = OnClickOutside_1.default;
});

var OnEscape_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });

var ESCAPE_KEY = 27;
var OnEscape = /** @class */ (function (_super) {
    __extends(OnEscape, _super);
    function OnEscape() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // HACK: SEE ISSUE https://github.com/Microsoft/TypeScript/issues/1224
        _this.escapeClick = function (event) {
            if (event.keyCode === ESCAPE_KEY) {
                _this.props.events.onEscaped();
            }
        };
        return _this;
    }
    OnEscape.prototype.componentDidMount = function () {
        // // If we are in an environment without a DOM such
        // // as shallow rendering or snapshots then we exit
        // // early to prevent any unhandled errors being thrown.
        // if (typeof document === 'undefined' || !document.createElement) {
        //   return;
        // }
        document.addEventListener("keydown", this.escapeClick);
    };
    OnEscape.prototype.componentWillUnmount = function () {
        document.removeEventListener("keydown", this.escapeClick);
    };
    OnEscape.prototype.render = function () {
        return this.props.children || null;
    };
    return OnEscape;
}(React__default.Component));
exports.default = OnEscape;
});

var OnEscape = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = OnEscape_1.default;
});

var OnEscapeHoC_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });

function OnEscapeHoC(WrappedComponent) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(OnEscape, _super);
            function OnEscape() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    escapedClicked: false,
                };
                // HACK: SEE ISSUE https://github.com/Microsoft/TypeScript/issues/1224
                _this.escapeClick = function (event) {
                    var ESCAPE_KEY = 27;
                    if (event.keyCode === ESCAPE_KEY) {
                        _this.setState({ escapedClicked: true });
                    }
                };
                return _this;
            }
            OnEscape.prototype.componentDidMount = function () {
                // // If we are in an environment without a DOM such
                // // as shallow rendering or snapshots then we exit
                // // early to prevent any unhandled errors being thrown.
                // if (typeof document === 'undefined' || !document.createElement) {
                //   return;
                // }
                document.addEventListener("keydown", this.escapeClick);
            };
            OnEscape.prototype.componentWillUnmount = function () {
                document.removeEventListener("keydown", this.escapeClick);
            };
            OnEscape.prototype.render = function () {
                return React__default.createElement(WrappedComponent, __assign({}, this.props, { escapedClicked: this.state.escapedClicked }));
            };
            return OnEscape;
        }(React__default.Component)),
        _a.displayName = "OnEscape(" + (WrappedComponent.displayName ||
            WrappedComponent.name) + ")",
        _a;
}
exports.default = OnEscapeHoC;
});

var OnEscapeHoC = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = OnEscapeHoC_1.default;
});

var Collapse_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });


/**
 * A generic collapse that can hide or show content with animation.
 */
var Collapse = function (_a) {
    var _b, _c;
    var _d = _a.expanded, expanded = _d === void 0 ? false : _d, labelledbyId = _a.labelledbyId, _e = _a.immediate, immediate = _e === void 0 ? false : _e, style = _a.style, className = _a.className, wrapperClassName = _a.wrapperClassName, wrapperStyle = _a.wrapperStyle, children = _a.children, testId = _a.testId;
    var _f = __read(React__default.useState({
        oriantationChanged: true,
    }), 2), state = _f[0], setState = _f[1];
    React__default.useEffect(function () {
        window.addEventListener("orientationchange", function (e) {
            e.stopPropagation();
            setTimeout(function () {
                setState({ oriantationChanged: !state.oriantationChanged });
            }, 10);
        });
    }, []);
    var wrapper = React__default.useRef(null);
    var expStyle = !immediate
        ? {
            maxHeight: expanded ? ((_b = wrapper.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) + "px" : "0px",
            transition: "max-height 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95)",
        }
        : {
            maxHeight: expanded ? ((_c = wrapper.current) === null || _c === void 0 ? void 0 : _c.scrollHeight) + "px" : "0px",
        };
    return (React__default.createElement("div", { "data-testid": testId, style: __assign(__assign({}, expStyle), wrapperStyle), className: Join.join("rel", "overflow-hidden", wrapperClassName), "aria-labelledby": labelledbyId, role: "region" },
        React__default.createElement("div", { ref: wrapper, style: style, className: Join.join(className, "rel") }, children)));
};
exports.default = Collapse;
});

var CollapseProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
});

var Collapse = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });

__exportStar(Collapse_1, exports);
__exportStar(CollapseProps, exports);
exports.default = Collapse_1.default;
});

var jumpLinksOuterContSticky = "JumpLinks_jumpLinksOuterContSticky__kaaFo";
var jumpLinksOuterCont = "JumpLinks_jumpLinksOuterCont__ywmJg";
var jumpLinksCont = "JumpLinks_jumpLinksCont__TWpIc";
var jumpLinksRow = "JumpLinks_jumpLinksRow__WhqBV";
var jumpLinksBtn = "JumpLinks_jumpLinksBtn__i8M5i";
var jumpLinksBtnInner = "JumpLinks_jumpLinksBtnInner__TP4qA";
var jumpLinksBtnBlk = "JumpLinks_jumpLinksBtnBlk__NKk1W";
var jumpLinksBtnDkGry = "JumpLinks_jumpLinksBtnDkGry__s0njd";
var jumpLinksUnderline = "JumpLinks_jumpLinksUnderline__IhHae";
var jumpLinksUnderlineTransition = "JumpLinks_jumpLinksUnderlineTransition__-Jvxd";
var css_248z$5 = ".JumpLinks_jumpLinksOuterContSticky__kaaFo {\n  background-color: rgba(255, 255, 255, 0.9) !important;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);\n  position: fixed; }\n\n.JumpLinks_jumpLinksOuterCont__ywmJg {\n  background-color: rgba(255, 255, 255, 0.85) !important; }\n\n.JumpLinks_jumpLinksCont__TWpIc {\n  margin: 0 auto; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksRow__WhqBV {\n    scrollbar-width: none;\n    -ms-overflow-style: none; }\n    .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksRow__WhqBV::-webkit-scrollbar {\n      display: none; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtn__i8M5i {\n    background: 0;\n    border: 0;\n    min-height: 44px;\n    min-width: 44px;\n    text-decoration: none !important;\n    white-space: nowrap; }\n    .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtn__i8M5i:focus {\n      outline: 0; }\n      .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtn__i8M5i:focus .JumpLinks_jumpLinksBtnInner__TP4qA {\n        outline: 1px dotted currentColor;\n        outline-offset: 4px; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtnBlk__NKk1W,\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtnBlk__NKk1W:hover {\n    color: #1d2329 !important; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtnDkGry__s0njd,\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtnDkGry__s0njd:hover {\n    color: #454b52 !important; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksUnderline__IhHae {\n    border-radius: 1px;\n    height: 2px;\n    top: 38px; }\n    @media (min-width: 768px) and (max-width: 1024px) {\n      .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksUnderline__IhHae {\n        top: 37px; } }\n    @media (max-width: 767px) {\n      .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksUnderline__IhHae {\n        top: 35px; } }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksUnderlineTransition__-Jvxd {\n    transition: all 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n";
var JumpLinks$1 = {"jumpLinksOuterContSticky":"JumpLinks_jumpLinksOuterContSticky__kaaFo","jumpLinksOuterCont":"JumpLinks_jumpLinksOuterCont__ywmJg","jumpLinksCont":"JumpLinks_jumpLinksCont__TWpIc","jumpLinksRow":"JumpLinks_jumpLinksRow__WhqBV","jumpLinksBtn":"JumpLinks_jumpLinksBtn__i8M5i","jumpLinksBtnInner":"JumpLinks_jumpLinksBtnInner__TP4qA","jumpLinksBtnBlk":"JumpLinks_jumpLinksBtnBlk__NKk1W","jumpLinksBtnDkGry":"JumpLinks_jumpLinksBtnDkGry__s0njd","jumpLinksUnderline":"JumpLinks_jumpLinksUnderline__IhHae","jumpLinksUnderlineTransition":"JumpLinks_jumpLinksUnderlineTransition__-Jvxd"};
var stylesheet$3=".JumpLinks_jumpLinksOuterContSticky__kaaFo {\n  background-color: rgba(255, 255, 255, 0.9) !important;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);\n  position: fixed; }\n\n.JumpLinks_jumpLinksOuterCont__ywmJg {\n  background-color: rgba(255, 255, 255, 0.85) !important; }\n\n.JumpLinks_jumpLinksCont__TWpIc {\n  margin: 0 auto; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksRow__WhqBV {\n    scrollbar-width: none;\n    -ms-overflow-style: none; }\n    .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksRow__WhqBV::-webkit-scrollbar {\n      display: none; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtn__i8M5i {\n    background: 0;\n    border: 0;\n    min-height: 44px;\n    min-width: 44px;\n    text-decoration: none !important;\n    white-space: nowrap; }\n    .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtn__i8M5i:focus {\n      outline: 0; }\n      .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtn__i8M5i:focus .JumpLinks_jumpLinksBtnInner__TP4qA {\n        outline: 1px dotted currentColor;\n        outline-offset: 4px; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtnBlk__NKk1W,\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtnBlk__NKk1W:hover {\n    color: #1d2329 !important; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtnDkGry__s0njd,\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksBtnDkGry__s0njd:hover {\n    color: #454b52 !important; }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksUnderline__IhHae {\n    border-radius: 1px;\n    height: 2px;\n    top: 38px; }\n    @media (min-width: 768px) and (max-width: 1024px) {\n      .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksUnderline__IhHae {\n        top: 37px; } }\n    @media (max-width: 767px) {\n      .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksUnderline__IhHae {\n        top: 35px; } }\n  .JumpLinks_jumpLinksCont__TWpIc .JumpLinks_jumpLinksUnderlineTransition__-Jvxd {\n    transition: all 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n";
styleInject(css_248z$5);

var JumpLinks$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    jumpLinksOuterContSticky: jumpLinksOuterContSticky,
    jumpLinksOuterCont: jumpLinksOuterCont,
    jumpLinksCont: jumpLinksCont,
    jumpLinksRow: jumpLinksRow,
    jumpLinksBtn: jumpLinksBtn,
    jumpLinksBtnInner: jumpLinksBtnInner,
    jumpLinksBtnBlk: jumpLinksBtnBlk,
    jumpLinksBtnDkGry: jumpLinksBtnDkGry,
    jumpLinksUnderline: jumpLinksUnderline,
    jumpLinksUnderlineTransition: jumpLinksUnderlineTransition,
    'default': JumpLinks$1,
    stylesheet: stylesheet$3
});

var styles$3 = /*@__PURE__*/getAugmentedNamespace(JumpLinks$2);

var JumpLinks_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });



/**
 *
 * <style>
 * #JumpLinks-container ul[class*="rsg--list-"]{margin:20px 0;padding:0;}
 * #JumpLinks-container li[class*="rsg--li-"]{display:inline;border:1px solid #ccc;border-radius:12px;}
 * #JumpLinks-container li[class*="rsg--li-"]{background:#d12127;padding:4px 8px;color:#fff;margin-right:16px;}
 * #JumpLinks-container li[class*="rsg--li-"]:last-child{background:#007a3e;}
 * #JumpLinks-container li[class*="rsg--li-"] p{display:inline;color:#fff;}
 * </style>
 * <ul style="">
 * <li style="">Phase - Beta Unreleased</li>
 * <li style="">Approval - Pending</li>
 * </ul>
 *
 * @visibleName JumpLinks
 */
var JumpLinks = /** @class */ (function (_super) {
    __extends(JumpLinks, _super);
    function JumpLinks(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            window.addEventListener("resize", _this.onScreenResize);
            window.addEventListener("scroll", _this.onScroll);
            _this.onScreenResize();
        };
        _this.componentWillUnmount = function () {
            clearTimeout(_this.animationTimeout);
            clearTimeout(_this.scrollingTimeout);
            clearTimeout(_this.scrollIntoViewTimeout);
            clearTimeout(_this.withTransitionTimeout);
            window.removeEventListener("resize", _this.onScreenResize);
            window.addEventListener("scroll", _this.onScroll);
        };
        _this.calcMarginRight = function () {
            var data = _this.props.data;
            var uniqueId = _this.state.uniqueId;
            var alignCenterMargin = _this.calcAlignCenterMargin();
            var viewportWidth = document.getElementsByTagName("body")[0].clientWidth;
            if (_this.jumpLinksOuterContRef) {
                var outerContWidth = _this.jumpLinksOuterContRef.offsetWidth;
                var minMargin_1 = viewportWidth > 1024 ? 64 : viewportWidth > 767 ? 48 : 32;
                var leftFirst = document
                    .getElementById(uniqueId + "-jumplink-0")
                    .getBoundingClientRect().left;
                var leftCont = document
                    .getElementById(uniqueId + "-jumplinksoutercontplaceholder")
                    .getBoundingClientRect().left;
                var testingWidthA = (leftFirst === 0 ? alignCenterMargin : leftFirst) -
                    leftCont +
                    _this.linksRef[0].offsetWidth;
                var testingWidthB = testingWidthA;
                var testingWidthC = testingWidthA;
                for (var i = 1; i < data.length; i++) {
                    testingWidthB += minMargin_1 + _this.linksRef[i].offsetWidth;
                }
                if (testingWidthB < outerContWidth) {
                    _this.setState(function (_a) {
                        _a.isSticky;
                        return ({
                            alignCenterMargin: alignCenterMargin,
                            isFullWidth: false,
                            marginRight: minMargin_1,
                            jumpLinksHeight: viewportWidth > 1024 ? 64 : viewportWidth > 767 ? 56 : 48,
                        });
                    }, _this.resetUnderline);
                    return;
                }
                var stoppingIndex = 0;
                for (var i = 1; i < data.length; i++) {
                    var test_1 = testingWidthC + minMargin_1 + _this.linksRef[i].offsetWidth / 2;
                    if (test_1 > outerContWidth) {
                        stoppingIndex = i - 1;
                        break;
                    }
                    testingWidthC += minMargin_1 + _this.linksRef[i].offsetWidth;
                }
                if (stoppingIndex === 0) {
                    stoppingIndex = data.length - 1;
                }
                testingWidthA += alignCenterMargin;
                for (var i = 1; i <= stoppingIndex; i++) {
                    if (i !== stoppingIndex) {
                        testingWidthA += _this.linksRef[i].offsetWidth;
                    }
                    else {
                        testingWidthA += _this.linksRef[i].offsetWidth / 2 - alignCenterMargin;
                    }
                }
                var marginRight_1 = (outerContWidth - testingWidthA) / stoppingIndex;
                _this.setState(function (_a) {
                    _a.isSticky;
                    return ({
                        alignCenterMargin: alignCenterMargin,
                        isFullWidth: true,
                        marginRight: marginRight_1,
                        jumpLinksHeight: viewportWidth > 1024 ? 64 : viewportWidth > 767 ? 56 : 48,
                    });
                }, _this.resetUnderline);
            }
        };
        _this.calcAlignCenterMargin = function () {
            var uniqueId = _this.state.uniqueId;
            var elA = document.getElementById(uniqueId + "-jumplinkscontplaceholder");
            var elB = document.getElementById(uniqueId + "-jumplinksgridplaceholder");
            if (elA && elB) {
                var stylesA = window.getComputedStyle(elA);
                var stylesB = window.getComputedStyle(elB);
                var padLeftA = stylesA.getPropertyValue("padding-left");
                var padLeftB = stylesB.getPropertyValue("padding-left");
                var padLeftAInt = parseInt(padLeftA.slice(0, padLeftA.length - 2), 10);
                var padLeftBInt = parseInt(padLeftB.slice(0, padLeftB.length - 2), 10);
                return padLeftAInt + padLeftBInt;
            }
            return 0;
        };
        _this.checkIfSticky = function () {
            var _a = _this.state, isSticky = _a.isSticky, uniqueId = _a.uniqueId;
            var el = document.getElementById(isSticky
                ? uniqueId + "-jumplinksoutercontplaceholder"
                : uniqueId + "-jumplinksoutercont");
            if (el) {
                var needsToBeSticky = el.getBoundingClientRect().top < 0;
                if (!isSticky && needsToBeSticky) {
                    _this.setState({ isSticky: true });
                }
                else if (isSticky && !needsToBeSticky) {
                    _this.setState({ isSticky: false });
                }
            }
        };
        _this.moveUnderline = function (i, options) {
            var isPressed = options.isPressed, isSmall = options.isSmall, scrollIntoView = options.scrollIntoView, withFocus = options.withFocus, withSmoothScroll = options.withSmoothScroll, withTransition = options.withTransition;
            var data = _this.props.data;
            var uniqueId = _this.state.uniqueId;
            if (_this.linksRef[i]) {
                var linkWidth = _this.linksRef[i].offsetWidth;
                var underlineWidth_1 = isSmall ? 20 : linkWidth;
                var rowEl = document.getElementById(uniqueId + "-jumplinksrow");
                var linkEl = document.getElementById(uniqueId + "-jumplink-" + i);
                if (rowEl && linkEl) {
                    var leftRow = rowEl.getBoundingClientRect().left;
                    var leftLink = linkEl.getBoundingClientRect().left;
                    var underlineLeftPos_1 = isSmall
                        ? leftLink - leftRow + (linkWidth - 20) / 2
                        : leftLink - leftRow;
                    if (isPressed) {
                        _this.scrollTo(data[i].anchor, withSmoothScroll);
                    }
                    if (withFocus) {
                        _this.linksRef[i].focus();
                    }
                    _this.setState(function (_a) {
                        var selectedIndex = _a.selectedIndex;
                        return ({
                            hoverIndex: i,
                            selectedIndex: isSmall ? selectedIndex : i,
                            underlineLeftPos: underlineLeftPos_1,
                            underlineWidth: underlineWidth_1,
                            withTransition: withTransition,
                        });
                    }, function () {
                        var _a = _this.state, isFullWidth = _a.isFullWidth, stateWithTransition = _a.withTransition;
                        if (isFullWidth && scrollIntoView) {
                            _this.scrollIntoViewTimeout = setTimeout(function () { return _this.scrollIntoView(withTransition); }, 250);
                        }
                        if (!stateWithTransition) {
                            _this.withTransitionTimeout = setTimeout(function () {
                                _this.setState({ withTransition: true });
                            }, 501);
                        }
                    });
                }
            }
        };
        _this.onKeyUp = function (e) {
            _this.props.data;
            var hoverIndex = _this.state.hoverIndex;
            if (keyPress.KeyPress.tabIsPressed(e) || keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
                _this.toggleFocus(true);
            }
            if (keyPress.KeyPress.enterIsPressed(e) || keyPress.KeyPress.spaceIsPressed(e)) {
                _this.moveUnderline(hoverIndex, {
                    isPressed: true,
                    isSmall: false,
                    scrollIntoView: true,
                    withFocus: false,
                    withSmoothScroll: true,
                    withTransition: true,
                });
            } /*else if (KeyPress.leftArrowIsPressed(e)) {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                this.setState({ showFocus: true });
                this.onFocus((hoverIndex - (1 % data.length)) % data.length);
            } else if (KeyPress.rightArrowIsPressed(e)) {
                if (e.preventDefault) {
                    e.preventDefault();
                }
                this.setState({ showFocus: true });
                this.onFocus((hoverIndex + (1 % data.length)) % data.length);
            }*/
        };
        _this.onFocus = function (index) {
            var selectedIndex = _this.state.selectedIndex;
            _this.moveUnderline(index, {
                isPressed: false,
                isSmall: index !== selectedIndex,
                scrollIntoView: false,
                withFocus: true,
                withSmoothScroll: undefined,
                withTransition: true,
            });
        };
        _this.onMouseOver = function (index) {
            var selectedIndex = _this.state.selectedIndex;
            _this.moveUnderline(index, {
                isPressed: false,
                isSmall: index !== selectedIndex,
                scrollIntoView: false,
                withFocus: false,
                withSmoothScroll: undefined,
                withTransition: true,
            });
        };
        _this.onMouseLeave = function () {
            var selectedIndex = _this.state.selectedIndex;
            _this.moveUnderline(selectedIndex, {
                isPressed: false,
                isSmall: false,
                scrollIntoView: false,
                withFocus: false,
                withSmoothScroll: undefined,
                withTransition: true,
            });
        };
        _this.onMouseUp = function (index) {
            _this.moveUnderline(index, {
                isPressed: true,
                isSmall: false,
                scrollIntoView: true,
                withFocus: false,
                withTransition: true,
                withSmoothScroll: true,
            });
        };
        _this.onScreenResize = function () {
            _this.calcMarginRight();
        };
        _this.onScroll = function () {
            _this.checkIfSticky();
            if (_this.isScrollingTo) {
                clearTimeout(_this.scrollingTimeout);
                _this.scrollingTimeout = setTimeout(function () {
                    _this.updateUnderline();
                    _this.isScrollingTo = false;
                }, 150);
            }
            else {
                _this.updateUnderline();
            }
        };
        _this.resetUnderline = function () {
            var selectedIndex = _this.state.selectedIndex;
            _this.moveUnderline(selectedIndex, {
                isPressed: false,
                isSmall: false,
                scrollIntoView: false,
                withFocus: false,
                withSmoothScroll: undefined,
                withTransition: false,
            });
        };
        _this.scrollIntoView = function (withTransition) {
            var data = _this.props.data;
            var _a = _this.state, alignCenterMargin = _a.alignCenterMargin, selectedIndex = _a.selectedIndex, underlineLeftPos = _a.underlineLeftPos, underlineWidth = _a.underlineWidth, uniqueId = _a.uniqueId;
            var scrollEl = document.getElementById(uniqueId + "-jumplinksrow");
            var scrollLeft = scrollEl.scrollLeft;
            var left = underlineLeftPos;
            var width = underlineWidth;
            var right = left + width;
            var scrollContWidth = _this.jumpLinksRowRef ? _this.jumpLinksRowRef.offsetWidth : 0;
            var scrollToObj = {
                behavior: withTransition ? "smooth" : "auto",
                top: 0,
            };
            if (selectedIndex === data.length - 1) {
                scrollEl.scrollTo(__assign(__assign({}, scrollToObj), { left: scrollEl.scrollLeft = scrollContWidth }));
            }
            else if (left < scrollLeft) {
                scrollEl.scrollTo(__assign(__assign({}, scrollToObj), { left: scrollEl.scrollLeft = left - alignCenterMargin }));
            }
            else if (right > scrollLeft + scrollContWidth) {
                scrollEl.scrollTo(__assign(__assign({}, scrollToObj), { left: left - scrollContWidth + width + alignCenterMargin }));
            }
        };
        _this.scrollTo = function (anchor, withSmoothScroll) {
            var options = _this.props.options;
            var jumpLinksHeight = _this.state.jumpLinksHeight;
            var anchoredSection = document.querySelector("a[name=" + anchor + "]");
            if (anchoredSection) {
                var top_1 = anchoredSection.getBoundingClientRect().top;
                _this.isScrollingTo = true;
                var scrollLoc = (window.pageYOffset || document.documentElement.scrollTop) +
                    top_1 -
                    jumpLinksHeight +
                    (options && options.jumpToOffset ? options.jumpToOffset : 0) +
                    1;
                var supportsNativeSmoothScroll = "scrollBehavior" in document.documentElement.style;
                if ((supportsNativeSmoothScroll && withSmoothScroll) || !withSmoothScroll) {
                    window.scrollTo({
                        left: 0,
                        top: scrollLoc,
                        behavior: withSmoothScroll ? "smooth" : "auto",
                    });
                }
                else {
                    var duration = Math.sqrt(Math.abs(Math.abs(scrollLoc) -
                        Math.abs(window.pageYOffset || document.documentElement.scrollTop))) * 15;
                    _this.smoothScrollTo(scrollLoc, duration);
                }
            }
        };
        // polyfilled smooth scrolling for IE, Edge & Safari
        _this.smoothScrollTo = function (to, duration) {
            var element = document.scrollingElement || document.documentElement;
            var start = element.scrollTop;
            var change = to - start;
            var startDate = +new Date();
            // t = current time
            // b = start value
            // c = change in value
            // d = duration
            var easeInOutQuad = function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) {
                    return (c / 2) * t * t + b;
                }
                t--;
                return (-c / 2) * (t * (t - 2) - 1) + b;
            };
            var animateScroll = function () {
                var currentDate = +new Date();
                var currentTime = currentDate - startDate;
                element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration).toString(), 10);
                if (currentTime < duration) {
                    requestAnimationFrame(animateScroll);
                }
                else {
                    element.scrollTop = to;
                }
            };
            animateScroll();
        };
        _this.toggleFocus = function (showFocus) {
            _this.setState({ showFocus: showFocus });
        };
        _this.updateUnderline = function () {
            var _a = _this.props, data = _a.data, options = _a.options;
            var jumpLinksHeight = _this.state.jumpLinksHeight;
            for (var i = data.length - 1; i >= 0; i--) {
                var testAnchor = data[i].anchor;
                var anchoredSection = document.querySelector("a[name=" + testAnchor + "]");
                if (anchoredSection) {
                    var top_2 = anchoredSection.getBoundingClientRect().top;
                    var anchorLoc = top_2 -
                        jumpLinksHeight +
                        (options && options.jumpToOffset ? options.jumpToOffset : 0);
                    if (anchorLoc < 0) {
                        _this.moveUnderline(i, {
                            isPressed: false,
                            isSmall: false,
                            scrollIntoView: false,
                            withFocus: false,
                            withSmoothScroll: true,
                            withTransition: true,
                        });
                        return;
                    }
                }
            }
        };
        _this.renderUnderline = function () {
            var _a = _this.state, underlineLeftPos = _a.underlineLeftPos, underlineWidth = _a.underlineWidth, withTransition = _a.withTransition;
            return (React__default.createElement("div", { className: "" + styles$3.jumpLinksUnderline + (withTransition ? " " + styles$3.jumpLinksUnderlineTransition : "") + " absolute bg-cobalt", style: {
                    marginLeft: 0,
                    left: underlineLeftPos,
                    width: underlineWidth,
                } }));
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, options = _a.options, testId = _a.testId;
            var _b = _this.state, alignCenterMargin = _b.alignCenterMargin; _b.hoverIndex; var isSticky = _b.isSticky, jumpLinksHeight = _b.jumpLinksHeight, marginRight = _b.marginRight, selectedIndex = _b.selectedIndex, showFocus = _b.showFocus, uniqueId = _b.uniqueId;
            return (React__default.createElement("div", { "data-testid": testId },
                React__default.createElement("div", { className: "" + (options && options.className ? options.className : "") + (isSticky && options && options.classNameSticky
                        ? " " + options.classNameSticky
                        : ""), id: uniqueId + "-jumplinksoutercontplaceholder", ref: function (ref) { return (_this.jumpLinksOuterContPlaceholderRef = ref); }, style: __assign(__assign({ height: jumpLinksHeight }, (options && options.styleOuter ? options.styleOuter : {})), (isSticky && options && options.styleOuterSticky
                        ? options.styleOuterSticky
                        : {})) },
                    React__default.createElement("div", { className: "container" + (options && options.classNameInner
                            ? " " + (options && options.classNameInner)
                            : ""), id: uniqueId + "-jumplinkscontplaceholder", style: __assign(__assign({}, (options && options.styleInner ? options.styleInner : {})), (isSticky && options && options.styleInnerSticky
                            ? options.styleInnerSticky
                            : {})) },
                        React__default.createElement("div", { className: "row" },
                            React__default.createElement("div", { className: "grid-col-12", id: uniqueId + "-jumplinksgridplaceholder" })))),
                React__default.createElement("div", { className: "flex flex-items-center bg-rgba-white-85 " + (options &&
                        options.className) + (isSticky
                        ? " " + styles$3.jumpLinksOuterContSticky + (options && options.classNameSticky
                            ? " " + options.classNameSticky
                            : "") + " top"
                        : ""), id: uniqueId + "-jumplinksoutercont", ref: function (ref) { return (_this.jumpLinksOuterContRef = ref); }, style: __assign(__assign({ height: jumpLinksHeight, marginTop: !isSticky ? -jumpLinksHeight : 0, width: "100%", maxWidth: "100%", marginLeft: "auto", marginRight: "auto", left: 0 }, (options && options.styleOuter ? options.styleOuter : {})), (isSticky && options && options.styleOuterSticky
                        ? options.styleOuterSticky
                        : {})) },
                    React__default.createElement("div", { className: "container " + styles$3.jumpLinksCont + " pad-l-none pad-r-none" + (options && options.classNameInner ? " " + options.classNameInner : ""), style: __assign(__assign({}, (options && options.styleInner ? options.styleInner : {})), (isSticky && options && options.styleInnerSticky
                            ? options.styleInnerSticky
                            : {})) },
                        React__default.createElement("div", { className: "row" },
                            React__default.createElement("div", { className: "grid-col-12 pad-none" },
                                React__default.createElement("div", { className: "rel" },
                                    React__default.createElement("div", { className: styles$3.jumpLinksRow + " flex overflow-x-auto", id: uniqueId + "-jumplinksrow", onScroll: _this.resetUnderline, ref: function (ref) { return (_this.jumpLinksRowRef = ref); } }, data.map(function (item, index) { return (React__default.createElement("div", { key: index, style: __assign(__assign(__assign({}, (index === 0 &&
                                            options &&
                                            options.alignment === "center"
                                            ? { marginLeft: "auto" }
                                            : {})), (index === data.length - 1 &&
                                            options &&
                                            options.alignment === "center"
                                            ? { marginRight: "auto" }
                                            : {})), { paddingLeft: index === 0 && alignCenterMargin
                                                ? alignCenterMargin
                                                : 0, paddingRight: index === data.length - 1 &&
                                                alignCenterMargin
                                                ? alignCenterMargin
                                                : 0 }) },
                                        React__default.createElement("button", { "aria-label": "Jump link to " + item.name + " section (" + (index + 1) + " of " + data.length + ")", className: styles$3.jumpLinksBtn + " flex flex-items-center font-medium justify-center link-text2 mar-b-none type-base " + (selectedIndex === index
                                                ? styles$3.jumpLinksBtnBlk
                                                : styles$3.jumpLinksBtnDkGry), id: uniqueId + "-jumplink-" + index, onFocus: _this.onFocus.bind(null, index), onKeyUp: _this.onKeyUp, onMouseDown: _this.toggleFocus.bind(null, false), onMouseLeave: _this.onMouseLeave, onMouseOver: _this.onMouseOver.bind(null, index), onMouseUp: _this.onMouseUp.bind(null, index), ref: function (ref) { return (_this.linksRef[index] = ref); }, style: {
                                                lineHeight: 1.6,
                                                marginRight: index !== data.length - 1 && marginRight
                                                    ? marginRight
                                                    : 0,
                                            }, tabIndex: 0 },
                                            React__default.createElement("span", { className: showFocus
                                                    ? styles$3.jumpLinksBtnInner
                                                    : "" }, item.name)))); })),
                                    _this.renderUnderline())))))));
        };
        _this.state = {
            alignCenterMargin: 0,
            isFullWidth: false,
            isSticky: false,
            jumpLinksHeight: 0,
            hoverIndex: 0,
            marginRight: 0,
            selectedIndex: 0,
            showFocus: true,
            underlineLeftPos: 0,
            underlineWidth: 0,
            uniqueId: props.testId,
            withTransition: false,
        };
        _this.animationTimeout = 0;
        _this.isScrollingTo = false;
        _this.linksRef = [];
        _this.jumpLinksOuterContPlaceholderRef = null;
        _this.jumpLinksOuterContRef = null;
        _this.jumpLinksRowRef = null;
        _this.scrollingTimeout = 0;
        _this.scrollIntoViewTimeout = 0;
        _this.withTransitionTimeout = 0;
        return _this;
    }
    return JumpLinks;
}(React__default.PureComponent));
exports.default = JumpLinks;
});

var JumpLinks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = JumpLinks_1.default;
});

var css_248z$4 = " {\n  /* this breathe class should be removed from here when moved to 2.0 styles as this class is available in global styles */\n  /* White section - SMALL spacing */\n  /* White section - MEDIUM spacing */\n  /* White section - LARGE spacing */\n  /* White section - XL spacing */ }\n  @media (min-width: 1601px) {\n    .breathe {\n      margin-top: 32px;\n      margin-bottom: 24px; } }\n  .max-width-container.mar-t-sm:not([class*=\"bg-\"]) {\n    margin-top: 24px;\n    margin-bottom: 16px; }\n  .max-width-container.mar-t-sm:not([class*=\"bg-\"]) + .max-width-container.mar-t-sm:not([class*=\"bg-\"]) {\n    margin-top: 0px; }\n  .max-width-container.mar-t-sm:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n    margin-top: 24px; }\n  .max-width-container.mar-t-md:not([class*=\"bg-\"]) {\n    margin-top: 32px;\n    margin-bottom: 24px; }\n  .max-width-container.mar-t-md:not([class*=\"bg-\"]) + .max-width-container.mar-t-md:not([class*=\"bg-\"]) {\n    margin-top: 0px; }\n  .max-width-container.mar-t-md:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n    margin-top: 32px; }\n  .max-width-container.mar-t-lg:not([class*=\"bg-\"]) {\n    margin-top: 48px;\n    margin-bottom: 32px; }\n  .max-width-container.mar-t-lg:not([class*=\"bg-\"]) + .max-width-container.mar-t-lg:not([class*=\"bg-\"]) {\n    margin-top: 0px; }\n  .max-width-container.mar-t-lg:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n    margin-top: 48px; }\n  .max-width-container.mar-t-xl:not([class*=\"bg-\"]) {\n    margin-top: 64px;\n    margin-bottom: 48px; }\n  .max-width-container.mar-t-xl:not([class*=\"bg-\"]) + .max-width-container.mar-t-xl:not([class*=\"bg-\"]) {\n    margin-top: 0px; }\n  .max-width-container.mar-t-xl:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n    margin-top: 64px; }\n  @media (min-width: 768px) and (max-width: 1024px) {\n     {\n      /* White section - SMALL spacing */\n      /* White section - MD spacing */\n      /* White section - LG spacing */\n      /* White section - XL spacing */ }\n      .max-width-container.mar-t-sm:not([class*=\"bg-\"]) {\n        margin-top: 16px;\n        margin-bottom: 8px; }\n      .max-width-container.mar-t-sm:not([class*=\"bg-\"]) + .max-width-container.mar-t-sm:not([class*=\"bg-\"]) {\n        margin-top: 0px; }\n      .max-width-container.mar-t-sm:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n        margin-top: 16px; }\n      .max-width-container.mar-t-md:not([class*=\"bg-\"]) {\n        margin-top: 24px;\n        margin-bottom: 16px; }\n      .max-width-container.mar-t-md:not([class*=\"bg-\"]) + .max-width-container.mar-t-md:not([class*=\"bg-\"]) {\n        margin-top: 0px; }\n      .max-width-container.mar-t-md:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n        margin-top: 24px; }\n      .max-width-container.mar-t-lg:not([class*=\"bg-\"]) {\n        margin-top: 32px;\n        margin-bottom: 24px; }\n      .max-width-container.mar-t-lg:not([class*=\"bg-\"]) + .max-width-container.mar-t-lg:not([class*=\"bg-\"]) {\n        margin-top: 0px; }\n      .max-width-container.mar-t-lg:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n        margin-top: 32px; }\n      .max-width-container.mar-t-xl:not([class*=\"bg-\"]) {\n        margin-top: 48px;\n        margin-bottom: 32px; }\n      .max-width-container.mar-t-xl:not([class*=\"bg-\"]) + .max-width-container.mar-t-xl:not([class*=\"bg-\"]) {\n        margin-top: 0px; }\n      .max-width-container.mar-t-xl:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n        margin-top: 48px; } }\n  @media (max-width: 767px) {\n     {\n      /*\n    .section [class*=\"grid-\"] {\n       padding: 8px 12px;\n    }\n    */\n      /* White section - SMALL spacing */\n      /* White section - MD spacing */\n      /* White section - LG spacing */\n      /* White section - XL spacing */ }\n      .max-width-container.mar-t-sm:not([class*=\"bg-\"]) {\n        margin-top: 8px;\n        margin-bottom: 0px; }\n      .max-width-container.mar-t-sm:not([class*=\"bg-\"]) + .max-width-container.mar-t-sm:not([class*=\"bg-\"]) {\n        margin-top: 0px; }\n      .max-width-container.mar-t-sm:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n        margin-top: 8px; }\n      .max-width-container.mar-t-md:not([class*=\"bg-\"]) {\n        margin-top: 16px;\n        margin-bottom: 8px; }\n      .max-width-container.mar-t-md:not([class*=\"bg-\"]) + .max-width-container.mar-t-md:not([class*=\"bg-\"]) {\n        margin-top: 0px; }\n      .max-width-container.mar-t-md:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n        margin-top: 16px; }\n      .max-width-container.mar-t-lg:not([class*=\"bg-\"]) {\n        margin-top: 24px;\n        margin-bottom: 16px; }\n      .max-width-container.mar-t-lg:not([class*=\"bg-\"]) + .max-width-container.mar-t-lg:not([class*=\"bg-\"]) {\n        margin-top: 0px; }\n      .max-width-container.mar-t-lg:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n        margin-top: 24px; }\n      .max-width-container.mar-t-xl:not([class*=\"bg-\"]) {\n        margin-top: 32px;\n        margin-bottom: 24px; }\n      .max-width-container.mar-t-xl:not([class*=\"bg-\"]) + .max-width-container.mar-t-xl:not([class*=\"bg-\"]) {\n        margin-top: 0px; }\n      .max-width-container.mar-t-xl:not([class*=\"bg-\"]) + .max-width-container[class*=\"bg-\"] {\n        margin-top: 32px; } }\n";
styleInject(css_248z$4);

var Layout_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });


var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.bindAll();
        return _this;
    }
    Layout.prototype.bindAll = function () {
        this.onClick = this.onClick.bind(this);
    };
    Layout.prototype.render = function () {
        var _a = this.props, testId = _a.testId, row = _a.row, col = _a.col, events = _a.events, colOptions = _a.colOptions, rowOptions = _a.rowOptions, layoutOptions = _a.layoutOptions;
        var classes = row ? this.rowClasses(rowOptions) :
            (col ? this.colClasses(colOptions) :
                this.layoutClasses(layoutOptions));
        var offsetClass = this.offsetClass(colOptions);
        var customOptions = (colOptions && colOptions.customOptions ?
            colOptions.customOptions : rowOptions && rowOptions.customOptions ?
            rowOptions.customOptions : layoutOptions && layoutOptions.customOptions ?
            layoutOptions.customOptions : {});
        return (React__default.createElement(React__default.Fragment, null,
            col && colOptions && colOptions.offset &&
                React__default.createElement("div", { className: offsetClass.join(' ') }),
            React__default.createElement("div", __assign({ "data-test-id": testId, className: classes.join(' ') }, customOptions, { onClick: events && events.onClick ? this.onClick : undefined }), this.props.children)));
    };
    Layout.prototype.layoutClasses = function (options) {
        var classnames = [];
        if (options && options.fullWidth) {
            classnames.push('full-width-container');
        }
        else if (options && options.maxWidth) {
            classnames.push('max-width-container');
        }
        else {
            classnames.push('container');
        }
        if (options && options.breathe) {
            classnames.push('breathe');
        }
        if (options && options.className) {
            classnames.push(options.className);
        }
        return classnames;
    };
    Layout.prototype.colClasses = function (options) {
        var classnames = [];
        if (options && options.size) {
            classnames.push(["grid-col-" + options.size]);
        }
        if (options && options.sizeSM) {
            classnames.push(["grid-col-" + options.sizeSM + "-sm"]);
        }
        if (options && options.sizeMD) {
            classnames.push(["grid-col-" + options.sizeMD + "-md"]);
        }
        if (options && options.alignSelf) {
            classnames.push(["flex-self-" + options.alignSelf]);
        }
        if (options && options.alighItems) {
            classnames.push(["flex-items-" + options.alighItems]);
        }
        if (options && options.justifyContent) {
            classnames.push(["justify-" + options.justifyContent]);
        }
        if (options && options.className) {
            classnames.push(options.className);
        }
        return classnames;
    };
    Layout.prototype.offsetClass = function (options) {
        var offsetclass = [];
        if (options && options.offset) {
            offsetclass.push(["offset" + options.offset]);
        }
        if (options && options.offsetSM) {
            offsetclass.push(["offset" + options.offsetSM + "-sm"]);
        }
        if (options && options.offsetMD) {
            offsetclass.push(["offset" + options.offsetMD + "-md"]);
        }
        return offsetclass;
    };
    Layout.prototype.rowClasses = function (options) {
        var classnames = [];
        if (options && options.noWrap) {
            classnames.push('row-nowrap');
        }
        else if (options && options.forceWrap) {
            classnames.push('row', 'flex-wrap');
        }
        else {
            classnames.push('row');
        }
        if (options && options.className) {
            classnames.push(options.className);
        }
        if (options && options.alignItems) {
            classnames.push([("flex-items-" + (options.alignItems
                    .charAt(0).toUpperCase() + options.alignItems.slice(1))).toLowerCase()]);
        }
        if (options && options.justifyContent) {
            classnames.push(["justify-" + options.justifyContent]);
        }
        if (options && options.alignSelf) {
            classnames.push([("flex-self-" + (options.alignSelf
                    .charAt(0).toUpperCase() + options.alignSelf.slice(1))).toLowerCase()]);
        }
        if (options && options.noPad) {
            classnames.push('nopad');
        }
        return classnames;
    };
    Layout.prototype.onClick = function () {
        if (this.props.events && this.props.events.onClick) {
            return this.props.events.onClick();
        }
    };
    return Layout;
}(React__default.Component));
exports.default = Layout;
});

var Layout = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Layout_1.default;
});

var priceLarge = "PromotionalPricing_price-large__LIILx";
var priceSmall = "PromotionalPricing_price-small__J-KP3";
var previousPrice = "PromotionalPricing_previous-price__5pvAp";
var withCents = "PromotionalPricing_with-cents__iXqnt";
var previousCents = "PromotionalPricing_previous-cents__xexDS";
var currentPrice = "PromotionalPricing_current-price__Woj0M";
var priceAmount = "PromotionalPricing_price-amount__-24xL";
var priceAfter = "PromotionalPricing_price-after__PKNVS";
var textCenter = "PromotionalPricing_text-center__26Wf6";
var priceAfterTop = "PromotionalPricing_price-after-top__RpZlC";
var priceAfterBottom = "PromotionalPricing_price-after-bottom__jJMOK";
var priceDivider = "PromotionalPricing_price-divider__GbeVk";
var priceLegal = "PromotionalPricing_price-legal__R5B1X";
var priceInline = "PromotionalPricing_price-inline__DhGWs";
var priceSlash = "PromotionalPricing_price-slash__7D0xG";
var cssBold = "PromotionalPricing_css-bold__NzIkd";
var headingXxl = "PromotionalPricing_heading-xxl__VIx5B";
var headingMd = "PromotionalPricing_heading-md__vQ7ca";
var price = "PromotionalPricing_price-__YMkKQ";
var css_248z$3 = ".PromotionalPricing_price-large__LIILx,\n.PromotionalPricing_price-small__J-KP3 {\n  font-size: 0; }\n\n.PromotionalPricing_previous-price__5pvAp {\n  align-items: flex-start;\n  bottom: -1px;\n  display: inline-flex;\n  font-family: font-regular;\n  font-size: 3.1rem;\n  line-height: .7;\n  margin-right: .8rem;\n  padding-left: .8rem;\n  position: relative; }\n\n.PromotionalPricing_previous-price__5pvAp:before {\n  content: \"$\";\n  font-size: 1.6rem;\n  left: -.1rem;\n  position: absolute;\n  top: -.1rem; }\n\n.PromotionalPricing_previous-price__5pvAp:after {\n  background-color: currentColor;\n  content: \"\";\n  display: inline-block;\n  height: 1px;\n  left: 5px;\n  position: absolute;\n  top: 50%;\n  transform: rotate(-30deg);\n  width: calc(100% - 1px); }\n\n.PromotionalPricing_previous-price__5pvAp.PromotionalPricing_with-cents__iXqnt:after {\n  transform: rotate(-20deg); }\n\n.PromotionalPricing_previous-cents__xexDS {\n  position: relative;\n  margin-left: .2rem; }\n\n.PromotionalPricing_current-price__Woj0M {\n  display: inline-block;\n  line-height: .7; }\n\n.PromotionalPricing_price-amount__-24xL:before {\n  content: \"$\";\n  font-size: 3.6rem;\n  position: relative;\n  left: 0;\n  top: -2.6rem; }\n\n.PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n  font-size: 7.2rem; }\n\n.PromotionalPricing_price-amount__-24xL {\n  position: relative; }\n\n.PromotionalPricing_price-after__PKNVS {\n  display: inline-block;\n  position: relative;\n  margin-left: .6rem; }\n\n.PromotionalPricing_text-center__26Wf6 .PromotionalPricing_price-after__PKNVS {\n  text-align: left; }\n\n.PromotionalPricing_price-large__LIILx .PromotionalPricing_price-after__PKNVS {\n  top: 0rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after__PKNVS {\n  top: 0rem; }\n\n.PromotionalPricing_price-after-top__RpZlC,\n.PromotionalPricing_price-after-bottom__jJMOK {\n  display: block;\n  line-height: .75; }\n\n.PromotionalPricing_price-after-top__RpZlC {\n  font-size: 2.0rem; }\n\n.PromotionalPricing_price-divider__GbeVk {\n  display: block;\n  height: 2px;\n  background-color: currentColor;\n  margin-top: .4rem;\n  margin-bottom: .2rem; }\n\n.PromotionalPricing_price-after-bottom__jJMOK {\n  font-size: 1.8rem; }\n\n.PromotionalPricing_price-legal__R5B1X {\n  margin-top: 10px; }\n\n.PromotionalPricing_price-inline__DhGWs {\n  align-items: flex-start;\n  display: inline-flex;\n  white-space: nowrap; }\n\n.PromotionalPricing_price-slash__7D0xG {\n  position: relative;\n  font-size: calc(100% - .22em);\n  line-height: 1.05; }\n\n@supports (-webkit-touch-callout: none) {\n  .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    -webkit-text-stroke: .025em currentColor; }\n  .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL:before,\n  .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after-top__RpZlC,\n  .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after-bottom__jJMOK {\n    -webkit-text-stroke: .005em currentColor; } }\n\n@media (min-width: 1025px) {\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.6rem;\n    top: -.1rem; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.0rem;\n    top: 0rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-after-bottom__jJMOK {\n    letter-spacing: -.04rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: -.06rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: 0; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: .01em; } }\n\n@media (max-width: 1024px) and (min-width: 768px) {\n  .PromotionalPricing_previous-price__5pvAp:before {\n    font-size: 1.4rem;\n    top: .1rem; }\n  .PromotionalPricing_previous-price__5pvAp {\n    font-size: 2.8rem;\n    bottom: -1px;\n    margin-right: .75rem; }\n  .PromotionalPricing_previous-price__5pvAp.PromotionalPricing_with-cents__iXqnt {\n    margin-right: .5rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.4rem;\n    top: 0; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.0rem;\n    top: .3rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n    font-size: 6.0rem; }\n  .PromotionalPricing_price-amount__-24xL:before {\n    font-size: 3.0rem;\n    top: -2.1rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: -.06rem; }\n  .PromotionalPricing_price-after__PKNVS {\n    margin-left: .4rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-after__PKNVS {\n    top: .05rem; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after__PKNVS {\n    top: 0rem; }\n  .PromotionalPricing_price-after-top__RpZlC {\n    font-size: 1.8rem; }\n  .PromotionalPricing_price-after-bottom__jJMOK {\n    font-size: 1.6rem; }\n  .PromotionalPricing_heading-xxl__VIx5B .PromotionalPricing_price-slash__7D0xG {\n    line-height: 1.1; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: .01em; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: 0; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after__PKNVS {\n    margin-left: 0.4rem; } }\n\n@media (max-width: 767px) {\n  .PromotionalPricing_previous-price__5pvAp:before {\n    font-size: 1.2rem;\n    top: .1rem; }\n  .PromotionalPricing_previous-price__5pvAp {\n    font-size: 2.0rem;\n    bottom: 0px;\n    margin-right: 0.6rem;\n    padding-left: 0.6rem; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-cents__xexDS,\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.0rem;\n    top: .1rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n    font-size: 4.0rem; }\n  .PromotionalPricing_price-amount__-24xL:before {\n    font-size: 1.7rem;\n    top: -1.65rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-after__PKNVS {\n    top: 0rem;\n    margin-left: .2rem; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after__PKNVS {\n    top: 0rem; }\n  .PromotionalPricing_price-after-top__RpZlC {\n    font-size: 1.6rem; }\n  .PromotionalPricing_price-after-bottom__jJMOK {\n    font-size: 1.2rem; }\n  .PromotionalPricing_heading-md__vQ7ca .PromotionalPricing_price-slash__7D0xG {\n    line-height: 1.1; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: .01em; }\n  .PromotionalPricing_price-__YMkKQ .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: .01em; } }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-price__5pvAp:before {\n  font-size: 1.2rem;\n  top: .2rem;\n  left: -.05rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-price__5pvAp {\n  font-size: 2.0rem;\n  bottom: 0px; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-amount__-24xL {\n  font-size: 4.0rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-amount__-24xL:before {\n  font-size: 1.7rem;\n  top: -1.65rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after__PKNVS {\n  top: 0rem;\n  margin-left: .2rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after-top__RpZlC {\n  font-size: 1.6rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after-bottom__jJMOK {\n  font-size: 1.2rem; }\n\n.PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after-top__RpZlC,\n.PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL,\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL,\n.PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after-bottom__jJMOK {\n  letter-spacing: .04rem; }\n";
var PromotionalPricing$1 = {"price-large":"PromotionalPricing_price-large__LIILx","price-small":"PromotionalPricing_price-small__J-KP3","previous-price":"PromotionalPricing_previous-price__5pvAp","with-cents":"PromotionalPricing_with-cents__iXqnt","previous-cents":"PromotionalPricing_previous-cents__xexDS","current-price":"PromotionalPricing_current-price__Woj0M","price-amount":"PromotionalPricing_price-amount__-24xL","price-after":"PromotionalPricing_price-after__PKNVS","text-center":"PromotionalPricing_text-center__26Wf6","price-after-top":"PromotionalPricing_price-after-top__RpZlC","price-after-bottom":"PromotionalPricing_price-after-bottom__jJMOK","price-divider":"PromotionalPricing_price-divider__GbeVk","price-legal":"PromotionalPricing_price-legal__R5B1X","price-inline":"PromotionalPricing_price-inline__DhGWs","price-slash":"PromotionalPricing_price-slash__7D0xG","css-bold":"PromotionalPricing_css-bold__NzIkd","heading-xxl":"PromotionalPricing_heading-xxl__VIx5B","heading-md":"PromotionalPricing_heading-md__vQ7ca","price-":"PromotionalPricing_price-__YMkKQ","priceLarge":"PromotionalPricing_price-large__LIILx","priceSmall":"PromotionalPricing_price-small__J-KP3","previousPrice":"PromotionalPricing_previous-price__5pvAp","withCents":"PromotionalPricing_with-cents__iXqnt","previousCents":"PromotionalPricing_previous-cents__xexDS","currentPrice":"PromotionalPricing_current-price__Woj0M","priceAmount":"PromotionalPricing_price-amount__-24xL","priceAfter":"PromotionalPricing_price-after__PKNVS","textCenter":"PromotionalPricing_text-center__26Wf6","priceAfterTop":"PromotionalPricing_price-after-top__RpZlC","priceAfterBottom":"PromotionalPricing_price-after-bottom__jJMOK","priceDivider":"PromotionalPricing_price-divider__GbeVk","priceLegal":"PromotionalPricing_price-legal__R5B1X","priceInline":"PromotionalPricing_price-inline__DhGWs","priceSlash":"PromotionalPricing_price-slash__7D0xG","cssBold":"PromotionalPricing_css-bold__NzIkd","headingXxl":"PromotionalPricing_heading-xxl__VIx5B","headingMd":"PromotionalPricing_heading-md__vQ7ca","price":"PromotionalPricing_price-__YMkKQ"};
var stylesheet$2=".PromotionalPricing_price-large__LIILx,\n.PromotionalPricing_price-small__J-KP3 {\n  font-size: 0; }\n\n.PromotionalPricing_previous-price__5pvAp {\n  align-items: flex-start;\n  bottom: -1px;\n  display: inline-flex;\n  font-family: font-regular;\n  font-size: 3.1rem;\n  line-height: .7;\n  margin-right: .8rem;\n  padding-left: .8rem;\n  position: relative; }\n\n.PromotionalPricing_previous-price__5pvAp:before {\n  content: \"$\";\n  font-size: 1.6rem;\n  left: -.1rem;\n  position: absolute;\n  top: -.1rem; }\n\n.PromotionalPricing_previous-price__5pvAp:after {\n  background-color: currentColor;\n  content: \"\";\n  display: inline-block;\n  height: 1px;\n  left: 5px;\n  position: absolute;\n  top: 50%;\n  transform: rotate(-30deg);\n  width: calc(100% - 1px); }\n\n.PromotionalPricing_previous-price__5pvAp.PromotionalPricing_with-cents__iXqnt:after {\n  transform: rotate(-20deg); }\n\n.PromotionalPricing_previous-cents__xexDS {\n  position: relative;\n  margin-left: .2rem; }\n\n.PromotionalPricing_current-price__Woj0M {\n  display: inline-block;\n  line-height: .7; }\n\n.PromotionalPricing_price-amount__-24xL:before {\n  content: \"$\";\n  font-size: 3.6rem;\n  position: relative;\n  left: 0;\n  top: -2.6rem; }\n\n.PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n  font-size: 7.2rem; }\n\n.PromotionalPricing_price-amount__-24xL {\n  position: relative; }\n\n.PromotionalPricing_price-after__PKNVS {\n  display: inline-block;\n  position: relative;\n  margin-left: .6rem; }\n\n.PromotionalPricing_text-center__26Wf6 .PromotionalPricing_price-after__PKNVS {\n  text-align: left; }\n\n.PromotionalPricing_price-large__LIILx .PromotionalPricing_price-after__PKNVS {\n  top: 0rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after__PKNVS {\n  top: 0rem; }\n\n.PromotionalPricing_price-after-top__RpZlC,\n.PromotionalPricing_price-after-bottom__jJMOK {\n  display: block;\n  line-height: .75; }\n\n.PromotionalPricing_price-after-top__RpZlC {\n  font-size: 2.0rem; }\n\n.PromotionalPricing_price-divider__GbeVk {\n  display: block;\n  height: 2px;\n  background-color: currentColor;\n  margin-top: .4rem;\n  margin-bottom: .2rem; }\n\n.PromotionalPricing_price-after-bottom__jJMOK {\n  font-size: 1.8rem; }\n\n.PromotionalPricing_price-legal__R5B1X {\n  margin-top: 10px; }\n\n.PromotionalPricing_price-inline__DhGWs {\n  align-items: flex-start;\n  display: inline-flex;\n  white-space: nowrap; }\n\n.PromotionalPricing_price-slash__7D0xG {\n  position: relative;\n  font-size: calc(100% - .22em);\n  line-height: 1.05; }\n\n@supports (-webkit-touch-callout: none) {\n  .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    -webkit-text-stroke: .025em currentColor; }\n  .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL:before,\n  .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after-top__RpZlC,\n  .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after-bottom__jJMOK {\n    -webkit-text-stroke: .005em currentColor; } }\n\n@media (min-width: 1025px) {\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.6rem;\n    top: -.1rem; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.0rem;\n    top: 0rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-after-bottom__jJMOK {\n    letter-spacing: -.04rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: -.06rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: 0; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: .01em; } }\n\n@media (max-width: 1024px) and (min-width: 768px) {\n  .PromotionalPricing_previous-price__5pvAp:before {\n    font-size: 1.4rem;\n    top: .1rem; }\n  .PromotionalPricing_previous-price__5pvAp {\n    font-size: 2.8rem;\n    bottom: -1px;\n    margin-right: .75rem; }\n  .PromotionalPricing_previous-price__5pvAp.PromotionalPricing_with-cents__iXqnt {\n    margin-right: .5rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.4rem;\n    top: 0; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.0rem;\n    top: .3rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n    font-size: 6.0rem; }\n  .PromotionalPricing_price-amount__-24xL:before {\n    font-size: 3.0rem;\n    top: -2.1rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: -.06rem; }\n  .PromotionalPricing_price-after__PKNVS {\n    margin-left: .4rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-after__PKNVS {\n    top: .05rem; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after__PKNVS {\n    top: 0rem; }\n  .PromotionalPricing_price-after-top__RpZlC {\n    font-size: 1.8rem; }\n  .PromotionalPricing_price-after-bottom__jJMOK {\n    font-size: 1.6rem; }\n  .PromotionalPricing_heading-xxl__VIx5B .PromotionalPricing_price-slash__7D0xG {\n    line-height: 1.1; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: .01em; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: 0; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after__PKNVS {\n    margin-left: 0.4rem; } }\n\n@media (max-width: 767px) {\n  .PromotionalPricing_previous-price__5pvAp:before {\n    font-size: 1.2rem;\n    top: .1rem; }\n  .PromotionalPricing_previous-price__5pvAp {\n    font-size: 2.0rem;\n    bottom: 0px;\n    margin-right: 0.6rem;\n    padding-left: 0.6rem; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-cents__xexDS,\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_previous-cents__xexDS {\n    font-size: 1.0rem;\n    top: .1rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-amount__-24xL {\n    font-size: 4.0rem; }\n  .PromotionalPricing_price-amount__-24xL:before {\n    font-size: 1.7rem;\n    top: -1.65rem; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_price-after__PKNVS {\n    top: 0rem;\n    margin-left: .2rem; }\n  .PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after__PKNVS {\n    top: 0rem; }\n  .PromotionalPricing_price-after-top__RpZlC {\n    font-size: 1.6rem; }\n  .PromotionalPricing_price-after-bottom__jJMOK {\n    font-size: 1.2rem; }\n  .PromotionalPricing_heading-md__vQ7ca .PromotionalPricing_price-slash__7D0xG {\n    line-height: 1.1; }\n  .PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: .01em; }\n  .PromotionalPricing_price-__YMkKQ .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL {\n    letter-spacing: .01em; } }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-price__5pvAp:before {\n  font-size: 1.2rem;\n  top: .2rem;\n  left: -.05rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_previous-price__5pvAp {\n  font-size: 2.0rem;\n  bottom: 0px; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-amount__-24xL {\n  font-size: 4.0rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-amount__-24xL:before {\n  font-size: 1.7rem;\n  top: -1.65rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after__PKNVS {\n  top: 0rem;\n  margin-left: .2rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after-top__RpZlC {\n  font-size: 1.6rem; }\n\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_price-after-bottom__jJMOK {\n  font-size: 1.2rem; }\n\n.PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after-top__RpZlC,\n.PromotionalPricing_price-large__LIILx .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL,\n.PromotionalPricing_price-small__J-KP3 .PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-amount__-24xL,\n.PromotionalPricing_css-bold__NzIkd .PromotionalPricing_price-after-bottom__jJMOK {\n  letter-spacing: .04rem; }\n";
styleInject(css_248z$3);

var PromotionalPricing$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    priceLarge: priceLarge,
    priceSmall: priceSmall,
    previousPrice: previousPrice,
    withCents: withCents,
    previousCents: previousCents,
    currentPrice: currentPrice,
    priceAmount: priceAmount,
    priceAfter: priceAfter,
    textCenter: textCenter,
    priceAfterTop: priceAfterTop,
    priceAfterBottom: priceAfterBottom,
    priceDivider: priceDivider,
    priceLegal: priceLegal,
    priceInline: priceInline,
    priceSlash: priceSlash,
    cssBold: cssBold,
    headingXxl: headingXxl,
    headingMd: headingMd,
    price: price,
    'default': PromotionalPricing$1,
    stylesheet: stylesheet$2
});

var styles$2 = /*@__PURE__*/getAugmentedNamespace(PromotionalPricing$2);

var PromotionalPricing_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });


var PromotionalPricing = /** @class */ (function (_super) {
    __extends(PromotionalPricing, _super);
    function PromotionalPricing(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isServer: true };
        return _this;
    }
    PromotionalPricing.prototype.componentDidMount = function () {
        this.setState({ isServer: false });
    };
    PromotionalPricing.prototype.render = function () {
        var _a = this.props, data = _a.data, options = _a.options;
        var strikePrice = data.strikePrice
            ? this.checkPrice(data.strikePrice)
                .toString()
                .split(".")
            : "";
        var price = data.price
            ? this.checkPrice(data.price)
                .toString()
                .split(".")
            : "";
        var pricingTypeClass = options && options.pricingType === "small" ? styles$2.priceSmall : styles$2.priceLarge;
        return (React__default.createElement("div", { className: pricingTypeClass + " " + (options && options.onDark ? "color-ui-white" : "color-ui-black") + " inline-block rel" },
            this.props.data.priceDescription && (React__default.createElement("div", { className: "type-base font-bold mar-b-xxs", "aria-hidden": "true" }, data.priceDescription)),
            strikePrice[0] && (React__default.createElement("span", { className: styles$2.previousPrice + " " + styles$2.withCents, "aria-hidden": "true" },
                strikePrice[0],
                strikePrice[1] && (React__default.createElement("span", { className: styles$2.previousCents }, strikePrice[1])))),
            React__default.createElement("span", { className: styles$2.currentPrice + " inline-flex font-bold", "aria-hidden": "true" },
                price[0] && React__default.createElement("span", { className: styles$2.priceAmount }, price[0]),
                price[1] && (React__default.createElement("span", { className: styles$2.priceAfter },
                    React__default.createElement("span", { className: styles$2.priceAfterTop }, price[1]),
                    React__default.createElement("span", { className: styles$2.priceDivider }),
                    React__default.createElement("span", { className: styles$2.priceAfterBottom }, data.billingNote ? data.billingNote : ""))),
                !price[1] && (React__default.createElement("span", { className: styles$2.priceAfter },
                    React__default.createElement("span", { className: styles$2.priceAfterBottom }, data.billingNote ? data.billingNote : ""),
                    React__default.createElement("span", { className: styles$2.priceDivider })))),
            this.props.data.discountDetails && (React__default.createElement("span", { className: "hidden-spoken type-xxl" }, data.discountDetails)),
            this.props.data.priceLegal && (React__default.createElement("div", { className: styles$2.priceLegal + " type-xxs" }, data.priceLegal))));
    };
    PromotionalPricing.prototype.checkPrice = function (priceVal) {
        var options = this.props.options;
        var decimalPoints = (options && options.decimalPoints) || 0;
        var price = priceVal || 0;
        if (typeof price === "string") {
            price = parseFloat(price);
            // console.log("price: ", parseFloat(price));
        }
        if (options && options.showAbsolute) {
            price = Number.isInteger(price) ? price : price.toFixed(2);
        }
        else if (decimalPoints > 0) {
            price = price.toFixed(decimalPoints);
        }
        // console.log("price: ", price)
        return price;
    };
    PromotionalPricing.defaultProps = {
        options: {
            className: "",
            showAbsolute: false,
            pricingType: "large",
            decimalPoints: 2,
        },
    };
    return PromotionalPricing;
}(React__default.Component));
exports.default = PromotionalPricing;
});

var PromotionalPricing = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = PromotionalPricing_1.default;
});

var nModal = "SimpleModal_nModal__swAcl";
var nModalContent = "SimpleModal_nModalContent__oto3S";
var nModalSm = "SimpleModal_nModalSm__XwfWc";
var nModalMd = "SimpleModal_nModalMd__ePPr1";
var nModalLg = "SimpleModal_nModalLg__uR2y1";
var nModalXLg = "SimpleModal_nModalXLg__usqV9";
var nModalSt = "SimpleModal_nModalSt__AeX8C";
var nModalFs = "SimpleModal_nModalFs__HDkaz";
var nModalNormal = "SimpleModal_nModalNormal__waH-O";
var nModalFull = "SimpleModal_nModalFull__nbI3j";
var nCloseButton = "SimpleModal_nCloseButton__pP4J8";
var nClose = "SimpleModal_nClose__Wqu34";
var nModalOverylayClose = "SimpleModal_nModalOverylayClose__yvBNX";
var nModalOverylayOpen = "SimpleModal_nModalOverylayOpen__QJEUF";
var css_248z$2 = ".SimpleModal_nModal__swAcl {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.85); }\n\n/* Modal Content */\n.SimpleModal_nModalContent__oto3S {\n  top: 50%;\n  transform: translateY(-50%);\n  margin: auto;\n  min-height: 100px;\n  max-height: 100%;\n  border-radius: 3px;\n  z-index: 1001; }\n\n/* Modal Sizes */\n.SimpleModal_nModalSm__XwfWc {\n  max-width: 400px; }\n\n.SimpleModal_nModalMd__ePPr1 {\n  max-width: 560px; }\n\n.SimpleModal_nModalLg__uR2y1 {\n  max-width: 720px; }\n\n.SimpleModal_nModalXLg__usqV9 {\n  max-width: 960px; }\n\n.SimpleModal_nModalSt__AeX8C {\n  max-width: none; }\n\n.SimpleModal_nModalFs__HDkaz {\n  height: 100vh;\n  width: 100vw;\n  border-radius: 0px; }\n\n.SimpleModal_nModalNormal__waH-O {\n  max-height: 90vh; }\n\n@media (max-width: 1020px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalXLg__usqV9 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 960px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalXLg__usqV9 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 780px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalLg__uR2y1 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 720px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalLg__uR2y1 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 620px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalMd__ePPr1 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 560px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalMd__ePPr1 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 460px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalSm__XwfWc {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 400px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalSm__XwfWc {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n/* The Close Button */\n.SimpleModal_nCloseButton__pP4J8 {\n  border: none;\n  border-radius: 50%;\n  font-size: 10px !important;\n  right: 16px;\n  top: 16px;\n  height: 24px;\n  width: 24px; }\n  .SimpleModal_nCloseButton__pP4J8 .SimpleModal_nClose__Wqu34 {\n    fill: #1d2329;\n    height: 24px; }\n\n.SimpleModal_nCloseButton__pP4J8:focus {\n  outline: 2px solid #0057b8; }\n\n.SimpleModal_nCloseButton__pP4J8:hover .SimpleModal_nClose__Wqu34 {\n  fill: #686e74; }\n\n.SimpleModal_nModalOverylayClose__yvBNX {\n  opacity: 0;\n  transition: opacity ease-in-out 450ms; }\n\n.SimpleModal_nModalOverylayOpen__QJEUF {\n  opacity: 1;\n  transition: opacity ease-in-out 450ms; }\n";
var SimpleModal$1 = {"nModal":"SimpleModal_nModal__swAcl","nModalContent":"SimpleModal_nModalContent__oto3S","nModalSm":"SimpleModal_nModalSm__XwfWc","nModalMd":"SimpleModal_nModalMd__ePPr1","nModalLg":"SimpleModal_nModalLg__uR2y1","nModalXLg":"SimpleModal_nModalXLg__usqV9","nModalSt":"SimpleModal_nModalSt__AeX8C","nModalFs":"SimpleModal_nModalFs__HDkaz","nModalNormal":"SimpleModal_nModalNormal__waH-O","nModalFull":"SimpleModal_nModalFull__nbI3j","nCloseButton":"SimpleModal_nCloseButton__pP4J8","nClose":"SimpleModal_nClose__Wqu34","nModalOverylayClose":"SimpleModal_nModalOverylayClose__yvBNX","nModalOverylayOpen":"SimpleModal_nModalOverylayOpen__QJEUF"};
var stylesheet$1=".SimpleModal_nModal__swAcl {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.85); }\n\n/* Modal Content */\n.SimpleModal_nModalContent__oto3S {\n  top: 50%;\n  transform: translateY(-50%);\n  margin: auto;\n  min-height: 100px;\n  max-height: 100%;\n  border-radius: 3px;\n  z-index: 1001; }\n\n/* Modal Sizes */\n.SimpleModal_nModalSm__XwfWc {\n  max-width: 400px; }\n\n.SimpleModal_nModalMd__ePPr1 {\n  max-width: 560px; }\n\n.SimpleModal_nModalLg__uR2y1 {\n  max-width: 720px; }\n\n.SimpleModal_nModalXLg__usqV9 {\n  max-width: 960px; }\n\n.SimpleModal_nModalSt__AeX8C {\n  max-width: none; }\n\n.SimpleModal_nModalFs__HDkaz {\n  height: 100vh;\n  width: 100vw;\n  border-radius: 0px; }\n\n.SimpleModal_nModalNormal__waH-O {\n  max-height: 90vh; }\n\n@media (max-width: 1020px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalXLg__usqV9 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 960px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalXLg__usqV9 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 780px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalLg__uR2y1 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 720px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalLg__uR2y1 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 620px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalMd__ePPr1 {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 560px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalMd__ePPr1 {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n@media (max-width: 460px) {\n  .SimpleModal_nModalNormal__waH-O.SimpleModal_nModalSm__XwfWc {\n    margin-left: 30px;\n    margin-right: 30px; } }\n\n@media (max-width: 400px) {\n  .SimpleModal_nModalFull__nbI3j.SimpleModal_nModalSm__XwfWc {\n    height: 100vh;\n    width: 100vw;\n    border-radius: 0px; } }\n\n/* The Close Button */\n.SimpleModal_nCloseButton__pP4J8 {\n  border: none;\n  border-radius: 50%;\n  font-size: 10px !important;\n  right: 16px;\n  top: 16px;\n  height: 24px;\n  width: 24px; }\n  .SimpleModal_nCloseButton__pP4J8 .SimpleModal_nClose__Wqu34 {\n    fill: #1d2329;\n    height: 24px; }\n\n.SimpleModal_nCloseButton__pP4J8:focus {\n  outline: 2px solid #0057b8; }\n\n.SimpleModal_nCloseButton__pP4J8:hover .SimpleModal_nClose__Wqu34 {\n  fill: #686e74; }\n\n.SimpleModal_nModalOverylayClose__yvBNX {\n  opacity: 0;\n  transition: opacity ease-in-out 450ms; }\n\n.SimpleModal_nModalOverylayOpen__QJEUF {\n  opacity: 1;\n  transition: opacity ease-in-out 450ms; }\n";
styleInject(css_248z$2);

var SimpleModal$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    nModal: nModal,
    nModalContent: nModalContent,
    nModalSm: nModalSm,
    nModalMd: nModalMd,
    nModalLg: nModalLg,
    nModalXLg: nModalXLg,
    nModalSt: nModalSt,
    nModalFs: nModalFs,
    nModalNormal: nModalNormal,
    nModalFull: nModalFull,
    nCloseButton: nCloseButton,
    nClose: nClose,
    nModalOverylayClose: nModalOverylayClose,
    nModalOverylayOpen: nModalOverylayOpen,
    'default': SimpleModal$1,
    stylesheet: stylesheet$1
});

var SimpleModalProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleModalSize = exports.SimpleModalSizing = void 0;
(function (SimpleModalSizing) {
    SimpleModalSizing["NORMAL"] = "normal";
    SimpleModalSizing["FULL"] = "full";
})(exports.SimpleModalSizing || (exports.SimpleModalSizing = {}));
(function (SimpleModalSize) {
    SimpleModalSize["SMALL"] = "small";
    SimpleModalSize["MEDIUM"] = "medium";
    SimpleModalSize["LARGE"] = "large";
    SimpleModalSize["EXTRA_LARGE"] = "extralarge";
    SimpleModalSize["SHEET"] = "sheet";
    SimpleModalSize["FULL_SCREEN"] = "fullscreen";
})(exports.SimpleModalSize || (exports.SimpleModalSize = {}));
});

var styles$1 = /*@__PURE__*/getAugmentedNamespace(SimpleModal$2);

var SimpleModalStylesMaps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizingMap = exports.sizeMap = void 0;


exports.sizeMap = new Map([
    [SimpleModalProps.SimpleModalSize.SMALL, styles$1.nModalSm],
    [SimpleModalProps.SimpleModalSize.MEDIUM, styles$1.nModalMd],
    [SimpleModalProps.SimpleModalSize.LARGE, styles$1.nModalLg],
    [SimpleModalProps.SimpleModalSize.EXTRA_LARGE, styles$1.nModalXLg],
    [SimpleModalProps.SimpleModalSize.SHEET, styles$1.nModalSt],
    [SimpleModalProps.SimpleModalSize.FULL_SCREEN, styles$1.nModalFs],
]);
exports.sizingMap = new Map([
    [SimpleModalProps.SimpleModalSizing.NORMAL, styles$1.nModalNormal],
    [SimpleModalProps.SimpleModalSizing.FULL, styles$1.nModalFull],
]);
});

var SimpleModal_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });






var SimpleModal = /** @class */ (function (_super) {
    __extends(SimpleModal, _super);
    function SimpleModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabElements = null;
        _this.firstEl = null;
        _this.lastEl = null;
        _this.previousEl = null;
        _this.state = {
            escaped: false,
            shown: false,
            transition: _this.props.show ? styles$1.nModalOverylayOpen : styles$1.nModalOverylayClose,
            transitioning: false,
        };
        _this.addEscapeListener = function () {
            utils.ssrSafe(function () {
                if (window && window.addEventListener) {
                    window.addEventListener("keydown", _this.onEscape, false);
                }
            });
        };
        _this.removeEscapeListener = function () {
            utils.ssrSafe(function () {
                if (window && window.removeEventListener) {
                    window.removeEventListener("keydown", _this.onEscape, false);
                }
            });
        };
        _this.componentWillUnmount = function () {
            utils.ssrSafe(function () {
                if (document && document.documentElement) {
                    document.documentElement.classList.remove("overflow-hidden");
                }
                _this.removeEscapeListener();
            });
            _this.removeFocusListener();
        };
        _this.componentDidUpdate = function () {
            var _a = _this.props, disableOnFocus = _a.disableOnFocus, fade = _a.fade, focusFirstElement = _a.focusFirstElement, show = _a.show;
            var _b = _this.state, escaped = _b.escaped, shown = _b.shown, transition = _b.transition, transitioning = _b.transitioning;
            if (fade && show && !shown && transition !== styles$1.nModalOverylayOpen) {
                _this.setState({ transition: styles$1.nModalOverylayClose, transitioning: true });
            }
            if (fade && show && transitioning && transition === styles$1.nModalOverylayClose) {
                _this.setState({ transition: styles$1.nModalOverylayOpen });
            }
            if (escaped) {
                _this.onClose();
            }
            if (show && _this.containerRef && !escaped) {
                if (_this.modalRef) {
                    _this.tabElements = _this.modalRef.querySelectorAll('input, button, a, select, textarea, div[tabindex="0"], div[role="button"]:not([aria-hidden=true]), div[role="checkbox"]:not([aria-hidden=true]), div[role="radio"]:not([aria-hidden=true])');
                    _this.firstEl = _this.tabElements[0];
                    _this.lastEl = _this.tabElements[_this.tabElements.length - 1];
                    if (!shown) {
                        if (disableOnFocus !== true) {
                            _this.addFocusListener();
                        }
                        else {
                            _this.removeFocusListener();
                        }
                    }
                    if (!shown && !transitioning) {
                        if (focusFirstElement && _this.firstEl) {
                            _this.firstEl.focus();
                        }
                        else {
                            _this.containerRef.focus();
                        }
                        _this.setState({ shown: true });
                    }
                }
            }
        };
        _this.addFocusListener = function () {
            utils.ssrSafe(function () {
                if (document && document.addEventListener) {
                    document.addEventListener("focus", _this.onFocus, true);
                }
            });
        };
        _this.removeFocusListener = function () {
            utils.ssrSafe(function () {
                if (document && document.removeEventListener) {
                    document.removeEventListener("focus", _this.onFocus, true);
                }
            });
        };
        _this.onFocus = function (e) {
            var _a;
            var disableOnFocus = _this.props.disableOnFocus;
            if (disableOnFocus !== true) {
                var c_1 = false;
                if (_this.tabElements && _this.tabElements.length > 0) {
                    _this.tabElements.forEach(function (item) {
                        if (item === e.target) {
                            item.focus();
                            _this.previousEl = item;
                            c_1 = true;
                            return;
                        }
                    });
                    if (!c_1 && e.target !== _this.containerRef && !((_a = _this.containerRef) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                        if (_this.previousEl === _this.firstEl) {
                            _this.lastEl.focus();
                        }
                        else {
                            _this.firstEl.focus();
                        }
                    }
                }
            }
        };
        _this.onTab = function (e, ref, shift) {
            if (e.which === 9 && shift) {
                e.preventDefault();
                ref.focus();
            }
        };
        _this.onClose = function (e) {
            _this.removeFocusListener();
            _this.setState({
                shown: false,
                transition: styles$1.nModalOverylayClose,
                transitioning: _this.props.fade ? true : false,
                escaped: false,
            });
            if (_this.wasFocused) {
                _this.wasFocused.focus();
                _this.wasFocused = undefined;
            }
            var close = _this.props.close;
            if (close) {
                close(e);
            }
        };
        _this.onEscape = function (e) {
            var noEscape = _this.props.noEscape;
            if (!noEscape && e.key === "Escape") {
                _this.setState({ escaped: true });
            }
        };
        _this.childClick = function (e) {
            e.stopPropagation();
        };
        _this.handleTransEnd = function () {
            _this.setState({ transitioning: false });
        };
        _this.render = function () {
            var _a = _this.props, accessibilityTitle = _a.accessibilityTitle, children = _a.children, closeButtonAccessibilityText = _a.closeButtonAccessibilityText, closeButtonClass = _a.closeButtonClass, closeHidden = _a.closeHidden, containerClass = _a.containerClass, contentClass = _a.contentClass, describedbyId = _a.describedbyId, fade = _a.fade, labelledbyId = _a.labelledbyId, propsRoot = _a.root, show = _a.show, propsSize = _a.size, propsSizing = _a.sizing, testId = _a.testId;
            utils.ssrSafe(function () {
                var _a = _this.state, escaped = _a.escaped, shown = _a.shown;
                if (document && document.documentElement && document.getElementById) {
                    var root = document.getElementById(propsRoot ? propsRoot : "root");
                    if (show) {
                        if (!_this.wasFocused) {
                            _this.wasFocused = document.activeElement || undefined;
                        }
                        if (root) {
                            root.setAttribute("aria-hidden", "true");
                        }
                        document.documentElement.classList.add("overflow-hidden");
                        if (!shown && !escaped) {
                            _this.addEscapeListener();
                        }
                    }
                    else {
                        if (_this.wasFocused) {
                            _this.wasFocused.focus();
                            _this.wasFocused = undefined;
                        }
                        if (root) {
                            root.removeAttribute("aria-hidden");
                        }
                        document.documentElement.classList.remove("overflow-hidden");
                        _this.removeEscapeListener();
                    }
                }
            });
            var _b = _this.state, transition = _b.transition, transitioning = _b.transitioning;
            var size = propsSize ? propsSize : SimpleModalProps.SimpleModalSize.MEDIUM;
            var sizing = propsSizing ? propsSizing : undefined;
            var renderModal = function () {
                return ((show || transitioning) && (React__default.createElement("div", { "data-testid": testId, onMouseDown: _this.onClose, onTransitionEnd: fade ? _this.handleTransEnd : undefined, ref: function (ref) {
                        _this.modalRef = ref;
                    }, className: [
                        fade ? transition : "",
                        containerClass,
                        styles$1.nModal,
                        "height-full left top block",
                    ].join(" ") },
                    React__default.createElement("div", { "aria-modal": true, tabIndex: -1, "aria-labelledby": labelledbyId, "aria-describedby": describedbyId, "aria-label": accessibilityTitle, role: "dialog", onMouseDown: _this.childClick, ref: function (ref) {
                            _this.containerRef = ref;
                        }, className: [
                            _this.getSizing(sizing),
                            contentClass,
                            _this.getSize(size),
                            styles$1.nModalContent,
                            "overflow-y-auto overflow-hidden rel bg-ui-white",
                        ].join(" ") },
                        !closeHidden && (React__default.createElement("button", { type: "button", "aria-label": closeButtonAccessibilityText || 'Close', onClick: _this.onClose, name: "close", className: [
                                "min-width-sm-all pad-none-all icon-close absolute color-ui-black",
                                closeButtonClass,
                                styles$1.nCloseButton,
                                "bg-ui-white absolute bg-ui-white",
                            ].join(" ") })),
                        children))));
            };
            if (typeof document !== "undefined") {
                return react_dom_1.createPortal(renderModal(), document.body);
            }
            return renderModal();
        };
        return _this;
    }
    SimpleModal.prototype.getSize = function (size) {
        if (size) {
            return SimpleModalStylesMaps.sizeMap.get(size);
        }
    };
    SimpleModal.prototype.getSizing = function (sizing) {
        if (sizing) {
            return SimpleModalStylesMaps.sizingMap.get(sizing);
        }
    };
    return SimpleModal;
}(React__default.Component));
exports.default = SimpleModal;
});

var SimpleModal = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = SimpleModal_1.default;
});

var tabsShowTopPadding = "TabsContainer_tabs-show-top-padding__b2G6u";
var tabsBgOpacity = "TabsContainer_tabs-bg-opacity__gD2Qo";
var tabsPadMarAdjustA = "TabsContainer_tabs-pad-mar-adjust-a__sHh5b";
var tabsPadMarAdjustB = "TabsContainer_tabs-pad-mar-adjust-b__HoXxm";
var tabsGrid = "TabsContainer_tabs-grid__jifJY";
var tabsNoBorderRadiusA = "TabsContainer_tabs-no-border-radius-a__C-nQH";
var tabsRow = "TabsContainer_tabs-row__ibOPB";
var tabsRowInner = "TabsContainer_tabs-row-inner__BHKlC";
var tabsRowInnerPadA = "TabsContainer_tabs-row-inner-pad-a__qUgaO";
var tabsRowInnerPadB = "TabsContainer_tabs-row-inner-pad-b__9PvYL";
var tabsRowInnerLeft = "TabsContainer_tabs-row-inner-left__fQHN-";
var tabsTabHideFocus = "TabsContainer_tabs-tab-hide-focus__l5qEk";
var tabsTab = "TabsContainer_tabs-tab__goKOd";
var tabsTabHoverBlue = "TabsContainer_tabs-tab-hover-blue__Esh1t";
var tabsTabHoverUnderline = "TabsContainer_tabs-tab-hover-underline__zxRdJ";
var tabsTabTransition = "TabsContainer_tabs-tab-transition__ilT4q";
var tabsTabInitialMar = "TabsContainer_tabs-tab-initial-mar__x3vS2";
var tabsTabLastMar = "TabsContainer_tabs-tab-last-mar__GX9iY";
var tabsTabLeftMar = "TabsContainer_tabs-tab-left-mar__8TFvD";
var tabsTabWhiteFocus = "TabsContainer_tabs-tab-white-focus__9mT7L";
var tabsTabUiBlackFocus = "TabsContainer_tabs-tab-ui-black-focus__XTzNe";
var tabsTabButtonSpace = "TabsContainer_tabs-tab-button-space__PjFBV";
var tabsBlackTabTransition = "TabsContainer_tabs-black-tab-transition__M49bO";
var tabsBlackTabOuter = "TabsContainer_tabs-black-tab-outer__XX5Ys";
var tabsBlackTab = "TabsContainer_tabs-black-tab__wtRuh";
var tabsContentSlideInLeft = "TabsContainer_tabs-content-slide-in-left__9SCsq";
var tabsSlideInLeft = "TabsContainer_tabsSlideInLeft__xSJFr";
var tabsContentSlideInRight = "TabsContainer_tabs-content-slide-in-right__WMa4N";
var tabsSlideInRight = "TabsContainer_tabsSlideInRight__zRWIg";
var tabsContentSlideOutRight = "TabsContainer_tabs-content-slide-out-right__aVJbk";
var tabsSlideOutLeft = "TabsContainer_tabsSlideOutLeft__G5MGo";
var tabsContentSlideOutLeft = "TabsContainer_tabs-content-slide-out-left__lymKl";
var tabsSlideOutRight = "TabsContainer_tabsSlideOutRight__nzfIP";
var tabsContent = "TabsContainer_tabs-content__jqBOB";
var tabsContentDefaultAnimation = "TabsContainer_tabs-content-default-animation__OdDb5";
var tabsContentDefaultAnimationOff = "TabsContainer_tabs-content-default-animation-off__O2Y1w";
var tabsContainer = "TabsContainer_tabs-container__FLYes";
var tabsNoBorderRadiusB = "TabsContainer_tabs-no-border-radius-b__eqcnY";
var css_248z$1 = ".TabsContainer_tabs-show-top-padding__b2G6u {\n  padding-top: 32px; }\n\n.TabsContainer_tabs-bg-opacity__gD2Qo {\n  background-color: rgba(255, 255, 255, 0.65); }\n\n.TabsContainer_tabs-pad-mar-adjust-a__sHh5b {\n  margin-top: 16px;\n  padding: 0 !important; }\n\n.TabsContainer_tabs-pad-mar-adjust-b__HoXxm {\n  margin-bottom: 32px;\n  margin-top: 0px; }\n\n.TabsContainer_tabs-grid__jifJY {\n  margin-bottom: 32px;\n  padding: 0 32px; }\n\n.TabsContainer_tabs-no-border-radius-a__C-nQH {\n  border-radius: 0 !important;\n  width: 100% !important; }\n\n.TabsContainer_tabs-row__ibOPB {\n  border-radius: 3px;\n  height: 64px; }\n\n.TabsContainer_tabs-row-inner__BHKlC {\n  scroll-behavior: smooth; }\n\n.TabsContainer_tabs-row-inner-pad-a__qUgaO {\n  padding: 0 32px; }\n\n.TabsContainer_tabs-row-inner-pad-b__9PvYL {\n  padding: 0 8px !important; }\n\n.TabsContainer_tabs-row-inner-left__fQHN- {\n  width: 100%; }\n  @media (min-width: 768px) {\n    .TabsContainer_tabs-row-inner-left__fQHN- {\n      padding-left: 0;\n      padding-right: 0; } }\n\n.TabsContainer_tabs-tab-hide-focus__l5qEk:focus {\n  border-color: transparent !important; }\n\n.TabsContainer_tabs-tab__goKOd {\n  background-color: transparent;\n  border: 1px solid transparent;\n  cursor: pointer;\n  padding: 4px;\n  white-space: nowrap;\n  z-index: 2 !important; }\n  .TabsContainer_tabs-tab__goKOd:focus {\n    border-color: #1d2329;\n    border-style: dotted;\n    border-width: 1px;\n    box-sizing: content-box;\n    outline: 0 !important; }\n  .TabsContainer_tabs-tab__goKOd:hover {\n    text-decoration: none; }\n\n.TabsContainer_tabs-tab-hover-blue__Esh1t:hover {\n  color: #0057b8 !important; }\n\n.TabsContainer_tabs-tab-hover-underline__zxRdJ:hover {\n  text-decoration: underline !important; }\n\n.TabsContainer_tabs-tab-transition__ilT4q {\n  transition: color 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n\n.TabsContainer_tabs-tab-initial-mar__x3vS2 {\n  margin-left: 10px !important; }\n\n.TabsContainer_tabs-tab-last-mar__GX9iY {\n  margin-right: 16px !important; }\n\n.TabsContainer_tabs-tab-left-mar__8TFvD {\n  margin-left: 4px; }\n\n.TabsContainer_tabs-tab-white-focus__9mT7L:focus {\n  border-color: #ffffff; }\n\n.TabsContainer_tabs-tab-ui-black-focus__XTzNe:focus {\n  border-color: #454b52; }\n\n.TabsContainer_tabs-tab-button-space__PjFBV {\n  height: 1px;\n  padding-right: 36px;\n  width: 1px !important; }\n\n.TabsContainer_tabs-black-tab-transition__M49bO {\n  transition: all 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n\n.TabsContainer_tabs-black-tab-outer__XX5Ys {\n  top: 8px;\n  z-index: 1 !important; }\n\n.TabsContainer_tabs-black-tab__wtRuh {\n  height: 48px;\n  border-radius: 3px;\n  margin-right: 32px;\n  z-index: 1; }\n\n.TabsContainer_tabs-content-slide-in-left__9SCsq {\n  -webkit-animation-name: TabsContainer_tabsSlideInLeft__xSJFr;\n          animation-name: TabsContainer_tabsSlideInLeft__xSJFr; }\n\n.TabsContainer_tabs-content-slide-in-right__WMa4N {\n  -webkit-animation-name: TabsContainer_tabsSlideInRight__zRWIg;\n          animation-name: TabsContainer_tabsSlideInRight__zRWIg; }\n\n.TabsContainer_tabs-content-slide-out-right__aVJbk {\n  -webkit-animation-name: TabsContainer_tabsSlideOutLeft__G5MGo;\n          animation-name: TabsContainer_tabsSlideOutLeft__G5MGo; }\n\n.TabsContainer_tabs-content-slide-out-left__lymKl {\n  -webkit-animation-name: TabsContainer_tabsSlideOutRight__nzfIP;\n          animation-name: TabsContainer_tabsSlideOutRight__nzfIP; }\n\n.TabsContainer_tabs-content__jqBOB {\n  top: 0; }\n\n.TabsContainer_tabs-content-default-animation__OdDb5,\n.TabsContainer_tabs-content-default-animation-off__O2Y1w {\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n  -webkit-animation-duration: 0.5s;\n          animation-duration: 0.5s;\n  -webkit-animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\n          animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n\n.TabsContainer_tabs-content-default-animation-off__O2Y1w {\n  -webkit-animation-timing-function: steps(1, end);\n          animation-timing-function: steps(1, end); }\n\n@media (min-width: 1025px) {\n  .TabsContainer_tabs-container__FLYes {\n    margin: auto;\n    max-width: 1324px; } }\n\n@media (max-width: 1024px) {\n  .TabsContainer_tabs-show-top-padding__b2G6u {\n    padding-top: 24px; }\n  .TabsContainer_tabs-row__ibOPB {\n    height: 56px; }\n  .TabsContainer_tabs-grid__jifJY {\n    margin-bottom: 24px !important;\n    margin-top: 0 !important;\n    padding-top: 0 !important; }\n  .TabsContainer_tabs-tab-hover-blue__Esh1t:hover {\n    color: inherit; }\n  .TabsContainer_tabs-tab-hover-underline__zxRdJ:hover {\n    text-decoration: none; }\n  .TabsContainer_tabs-tab-initial-mar__x3vS2 {\n    margin-left: 10.5px !important; }\n  .TabsContainer_tabs-tab-last-mar__GX9iY {\n    margin-right: 10.5px !important; }\n  .TabsContainer_tabs-black-tab-outer__XX5Ys {\n    top: 8px; }\n  .TabsContainer_tabs-black-tab__wtRuh {\n    height: 40px; } }\n\n@media (max-width: 767px) {\n  .TabsContainer_tabs-pad-mar-adjust-b__HoXxm {\n    margin-bottom: 24px;\n    margin-top: 0px;\n    padding: 0 !important; }\n  .TabsContainer_tabs-no-border-radius-b__eqcnY {\n    border-radius: 0 !important; }\n  .TabsContainer_tabs-row__ibOPB {\n    height: 48px; }\n  .TabsContainer_tabs-row-inner-pad-a__qUgaO {\n    padding: 0 32px; }\n  .TabsContainer_tabs-row-inner-pad-b__9PvYL {\n    padding: 0 32px !important; }\n  .TabsContainer_tabs-tab-initial-mar__x3vS2 {\n    margin-left: 3.5px !important; }\n  .TabsContainer_tabs-tab-last-mar__GX9iY {\n    margin-right: 3.5px !important; }\n  .TabsContainer_tabs-black-tab-outer__XX5Ys {\n    top: 8px; }\n  .TabsContainer_tabs-black-tab__wtRuh {\n    height: 32px; } }\n\n@media (max-width: 666px), (max-width: 767px) and (orientation: portrait) {\n  .TabsContainer_tabs-row-inner-pad-a__qUgaO {\n    padding: 0 24px; }\n  .TabsContainer_tabs-row-inner-pad-b__9PvYL {\n    padding: 0 24px !important; } }\n\n@-webkit-keyframes TabsContainer_tabsSlideInLeft__xSJFr {\n  0% {\n    min-width: 100%;\n    transform: translateX(-100%); }\n  100% {\n    min-width: 100%;\n    transform: translateX(0%); } }\n\n@keyframes TabsContainer_tabsSlideInLeft__xSJFr {\n  0% {\n    min-width: 100%;\n    transform: translateX(-100%); }\n  100% {\n    min-width: 100%;\n    transform: translateX(0%); } }\n\n@-webkit-keyframes TabsContainer_tabsSlideInRight__zRWIg {\n  0% {\n    min-width: 100%;\n    transform: translateX(0%); }\n  100% {\n    min-width: 100%;\n    transform: translateX(-100%); } }\n\n@keyframes TabsContainer_tabsSlideInRight__zRWIg {\n  0% {\n    min-width: 100%;\n    transform: translateX(0%); }\n  100% {\n    min-width: 100%;\n    transform: translateX(-100%); } }\n\n@-webkit-keyframes TabsContainer_tabsSlideOutLeft__G5MGo {\n  0% {\n    min-width: 100%;\n    transform: translateX(0%); }\n  100% {\n    visibility: hidden;\n    min-width: 100%;\n    transform: translateX(-100%); } }\n\n@keyframes TabsContainer_tabsSlideOutLeft__G5MGo {\n  0% {\n    min-width: 100%;\n    transform: translateX(0%); }\n  100% {\n    visibility: hidden;\n    min-width: 100%;\n    transform: translateX(-100%); } }\n\n@-webkit-keyframes TabsContainer_tabsSlideOutRight__nzfIP {\n  0% {\n    min-width: 100%;\n    transform: translateX(-100%); }\n  100% {\n    visibility: hidden;\n    min-width: 100%;\n    transform: translateX(0%); } }\n\n@keyframes TabsContainer_tabsSlideOutRight__nzfIP {\n  0% {\n    min-width: 100%;\n    transform: translateX(-100%); }\n  100% {\n    visibility: hidden;\n    min-width: 100%;\n    transform: translateX(0%); } }\n";
var TabsContainer$1 = {"tabs-show-top-padding":"TabsContainer_tabs-show-top-padding__b2G6u","tabs-bg-opacity":"TabsContainer_tabs-bg-opacity__gD2Qo","tabs-pad-mar-adjust-a":"TabsContainer_tabs-pad-mar-adjust-a__sHh5b","tabs-pad-mar-adjust-b":"TabsContainer_tabs-pad-mar-adjust-b__HoXxm","tabs-grid":"TabsContainer_tabs-grid__jifJY","tabs-no-border-radius-a":"TabsContainer_tabs-no-border-radius-a__C-nQH","tabs-row":"TabsContainer_tabs-row__ibOPB","tabs-row-inner":"TabsContainer_tabs-row-inner__BHKlC","tabs-row-inner-pad-a":"TabsContainer_tabs-row-inner-pad-a__qUgaO","tabs-row-inner-pad-b":"TabsContainer_tabs-row-inner-pad-b__9PvYL","tabs-row-inner-left":"TabsContainer_tabs-row-inner-left__fQHN-","tabs-tab-hide-focus":"TabsContainer_tabs-tab-hide-focus__l5qEk","tabs-tab":"TabsContainer_tabs-tab__goKOd","tabs-tab-hover-blue":"TabsContainer_tabs-tab-hover-blue__Esh1t","tabs-tab-hover-underline":"TabsContainer_tabs-tab-hover-underline__zxRdJ","tabs-tab-transition":"TabsContainer_tabs-tab-transition__ilT4q","tabs-tab-initial-mar":"TabsContainer_tabs-tab-initial-mar__x3vS2","tabs-tab-last-mar":"TabsContainer_tabs-tab-last-mar__GX9iY","tabs-tab-left-mar":"TabsContainer_tabs-tab-left-mar__8TFvD","tabs-tab-white-focus":"TabsContainer_tabs-tab-white-focus__9mT7L","tabs-tab-ui-black-focus":"TabsContainer_tabs-tab-ui-black-focus__XTzNe","tabs-tab-button-space":"TabsContainer_tabs-tab-button-space__PjFBV","tabs-black-tab-transition":"TabsContainer_tabs-black-tab-transition__M49bO","tabs-black-tab-outer":"TabsContainer_tabs-black-tab-outer__XX5Ys","tabs-black-tab":"TabsContainer_tabs-black-tab__wtRuh","tabs-content-slide-in-left":"TabsContainer_tabs-content-slide-in-left__9SCsq","tabsSlideInLeft":"TabsContainer_tabsSlideInLeft__xSJFr","tabs-content-slide-in-right":"TabsContainer_tabs-content-slide-in-right__WMa4N","tabsSlideInRight":"TabsContainer_tabsSlideInRight__zRWIg","tabs-content-slide-out-right":"TabsContainer_tabs-content-slide-out-right__aVJbk","tabsSlideOutLeft":"TabsContainer_tabsSlideOutLeft__G5MGo","tabs-content-slide-out-left":"TabsContainer_tabs-content-slide-out-left__lymKl","tabsSlideOutRight":"TabsContainer_tabsSlideOutRight__nzfIP","tabs-content":"TabsContainer_tabs-content__jqBOB","tabs-content-default-animation":"TabsContainer_tabs-content-default-animation__OdDb5","tabs-content-default-animation-off":"TabsContainer_tabs-content-default-animation-off__O2Y1w","tabs-container":"TabsContainer_tabs-container__FLYes","tabs-no-border-radius-b":"TabsContainer_tabs-no-border-radius-b__eqcnY","tabsShowTopPadding":"TabsContainer_tabs-show-top-padding__b2G6u","tabsBgOpacity":"TabsContainer_tabs-bg-opacity__gD2Qo","tabsPadMarAdjustA":"TabsContainer_tabs-pad-mar-adjust-a__sHh5b","tabsPadMarAdjustB":"TabsContainer_tabs-pad-mar-adjust-b__HoXxm","tabsGrid":"TabsContainer_tabs-grid__jifJY","tabsNoBorderRadiusA":"TabsContainer_tabs-no-border-radius-a__C-nQH","tabsRow":"TabsContainer_tabs-row__ibOPB","tabsRowInner":"TabsContainer_tabs-row-inner__BHKlC","tabsRowInnerPadA":"TabsContainer_tabs-row-inner-pad-a__qUgaO","tabsRowInnerPadB":"TabsContainer_tabs-row-inner-pad-b__9PvYL","tabsRowInnerLeft":"TabsContainer_tabs-row-inner-left__fQHN-","tabsTabHideFocus":"TabsContainer_tabs-tab-hide-focus__l5qEk","tabsTab":"TabsContainer_tabs-tab__goKOd","tabsTabHoverBlue":"TabsContainer_tabs-tab-hover-blue__Esh1t","tabsTabHoverUnderline":"TabsContainer_tabs-tab-hover-underline__zxRdJ","tabsTabTransition":"TabsContainer_tabs-tab-transition__ilT4q","tabsTabInitialMar":"TabsContainer_tabs-tab-initial-mar__x3vS2","tabsTabLastMar":"TabsContainer_tabs-tab-last-mar__GX9iY","tabsTabLeftMar":"TabsContainer_tabs-tab-left-mar__8TFvD","tabsTabWhiteFocus":"TabsContainer_tabs-tab-white-focus__9mT7L","tabsTabUiBlackFocus":"TabsContainer_tabs-tab-ui-black-focus__XTzNe","tabsTabButtonSpace":"TabsContainer_tabs-tab-button-space__PjFBV","tabsBlackTabTransition":"TabsContainer_tabs-black-tab-transition__M49bO","tabsBlackTabOuter":"TabsContainer_tabs-black-tab-outer__XX5Ys","tabsBlackTab":"TabsContainer_tabs-black-tab__wtRuh","tabsContentSlideInLeft":"TabsContainer_tabs-content-slide-in-left__9SCsq","tabsContentSlideInRight":"TabsContainer_tabs-content-slide-in-right__WMa4N","tabsContentSlideOutRight":"TabsContainer_tabs-content-slide-out-right__aVJbk","tabsContentSlideOutLeft":"TabsContainer_tabs-content-slide-out-left__lymKl","tabsContent":"TabsContainer_tabs-content__jqBOB","tabsContentDefaultAnimation":"TabsContainer_tabs-content-default-animation__OdDb5","tabsContentDefaultAnimationOff":"TabsContainer_tabs-content-default-animation-off__O2Y1w","tabsContainer":"TabsContainer_tabs-container__FLYes","tabsNoBorderRadiusB":"TabsContainer_tabs-no-border-radius-b__eqcnY"};
var stylesheet=".TabsContainer_tabs-show-top-padding__b2G6u {\n  padding-top: 32px; }\n\n.TabsContainer_tabs-bg-opacity__gD2Qo {\n  background-color: rgba(255, 255, 255, 0.65); }\n\n.TabsContainer_tabs-pad-mar-adjust-a__sHh5b {\n  margin-top: 16px;\n  padding: 0 !important; }\n\n.TabsContainer_tabs-pad-mar-adjust-b__HoXxm {\n  margin-bottom: 32px;\n  margin-top: 0px; }\n\n.TabsContainer_tabs-grid__jifJY {\n  margin-bottom: 32px;\n  padding: 0 32px; }\n\n.TabsContainer_tabs-no-border-radius-a__C-nQH {\n  border-radius: 0 !important;\n  width: 100% !important; }\n\n.TabsContainer_tabs-row__ibOPB {\n  border-radius: 3px;\n  height: 64px; }\n\n.TabsContainer_tabs-row-inner__BHKlC {\n  scroll-behavior: smooth; }\n\n.TabsContainer_tabs-row-inner-pad-a__qUgaO {\n  padding: 0 32px; }\n\n.TabsContainer_tabs-row-inner-pad-b__9PvYL {\n  padding: 0 8px !important; }\n\n.TabsContainer_tabs-row-inner-left__fQHN- {\n  width: 100%; }\n  @media (min-width: 768px) {\n    .TabsContainer_tabs-row-inner-left__fQHN- {\n      padding-left: 0;\n      padding-right: 0; } }\n\n.TabsContainer_tabs-tab-hide-focus__l5qEk:focus {\n  border-color: transparent !important; }\n\n.TabsContainer_tabs-tab__goKOd {\n  background-color: transparent;\n  border: 1px solid transparent;\n  cursor: pointer;\n  padding: 4px;\n  white-space: nowrap;\n  z-index: 2 !important; }\n  .TabsContainer_tabs-tab__goKOd:focus {\n    border-color: #1d2329;\n    border-style: dotted;\n    border-width: 1px;\n    box-sizing: content-box;\n    outline: 0 !important; }\n  .TabsContainer_tabs-tab__goKOd:hover {\n    text-decoration: none; }\n\n.TabsContainer_tabs-tab-hover-blue__Esh1t:hover {\n  color: #0057b8 !important; }\n\n.TabsContainer_tabs-tab-hover-underline__zxRdJ:hover {\n  text-decoration: underline !important; }\n\n.TabsContainer_tabs-tab-transition__ilT4q {\n  transition: color 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n\n.TabsContainer_tabs-tab-initial-mar__x3vS2 {\n  margin-left: 10px !important; }\n\n.TabsContainer_tabs-tab-last-mar__GX9iY {\n  margin-right: 16px !important; }\n\n.TabsContainer_tabs-tab-left-mar__8TFvD {\n  margin-left: 4px; }\n\n.TabsContainer_tabs-tab-white-focus__9mT7L:focus {\n  border-color: #ffffff; }\n\n.TabsContainer_tabs-tab-ui-black-focus__XTzNe:focus {\n  border-color: #454b52; }\n\n.TabsContainer_tabs-tab-button-space__PjFBV {\n  height: 1px;\n  padding-right: 36px;\n  width: 1px !important; }\n\n.TabsContainer_tabs-black-tab-transition__M49bO {\n  transition: all 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n\n.TabsContainer_tabs-black-tab-outer__XX5Ys {\n  top: 8px;\n  z-index: 1 !important; }\n\n.TabsContainer_tabs-black-tab__wtRuh {\n  height: 48px;\n  border-radius: 3px;\n  margin-right: 32px;\n  z-index: 1; }\n\n.TabsContainer_tabs-content-slide-in-left__9SCsq {\n  -webkit-animation-name: TabsContainer_tabsSlideInLeft__xSJFr;\n          animation-name: TabsContainer_tabsSlideInLeft__xSJFr; }\n\n.TabsContainer_tabs-content-slide-in-right__WMa4N {\n  -webkit-animation-name: TabsContainer_tabsSlideInRight__zRWIg;\n          animation-name: TabsContainer_tabsSlideInRight__zRWIg; }\n\n.TabsContainer_tabs-content-slide-out-right__aVJbk {\n  -webkit-animation-name: TabsContainer_tabsSlideOutLeft__G5MGo;\n          animation-name: TabsContainer_tabsSlideOutLeft__G5MGo; }\n\n.TabsContainer_tabs-content-slide-out-left__lymKl {\n  -webkit-animation-name: TabsContainer_tabsSlideOutRight__nzfIP;\n          animation-name: TabsContainer_tabsSlideOutRight__nzfIP; }\n\n.TabsContainer_tabs-content__jqBOB {\n  top: 0; }\n\n.TabsContainer_tabs-content-default-animation__OdDb5,\n.TabsContainer_tabs-content-default-animation-off__O2Y1w {\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n  -webkit-animation-duration: 0.5s;\n          animation-duration: 0.5s;\n  -webkit-animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95);\n          animation-timing-function: cubic-bezier(0.445, 0.05, 0.55, 0.95); }\n\n.TabsContainer_tabs-content-default-animation-off__O2Y1w {\n  -webkit-animation-timing-function: steps(1, end);\n          animation-timing-function: steps(1, end); }\n\n@media (min-width: 1025px) {\n  .TabsContainer_tabs-container__FLYes {\n    margin: auto;\n    max-width: 1324px; } }\n\n@media (max-width: 1024px) {\n  .TabsContainer_tabs-show-top-padding__b2G6u {\n    padding-top: 24px; }\n  .TabsContainer_tabs-row__ibOPB {\n    height: 56px; }\n  .TabsContainer_tabs-grid__jifJY {\n    margin-bottom: 24px !important;\n    margin-top: 0 !important;\n    padding-top: 0 !important; }\n  .TabsContainer_tabs-tab-hover-blue__Esh1t:hover {\n    color: inherit; }\n  .TabsContainer_tabs-tab-hover-underline__zxRdJ:hover {\n    text-decoration: none; }\n  .TabsContainer_tabs-tab-initial-mar__x3vS2 {\n    margin-left: 10.5px !important; }\n  .TabsContainer_tabs-tab-last-mar__GX9iY {\n    margin-right: 10.5px !important; }\n  .TabsContainer_tabs-black-tab-outer__XX5Ys {\n    top: 8px; }\n  .TabsContainer_tabs-black-tab__wtRuh {\n    height: 40px; } }\n\n@media (max-width: 767px) {\n  .TabsContainer_tabs-pad-mar-adjust-b__HoXxm {\n    margin-bottom: 24px;\n    margin-top: 0px;\n    padding: 0 !important; }\n  .TabsContainer_tabs-no-border-radius-b__eqcnY {\n    border-radius: 0 !important; }\n  .TabsContainer_tabs-row__ibOPB {\n    height: 48px; }\n  .TabsContainer_tabs-row-inner-pad-a__qUgaO {\n    padding: 0 32px; }\n  .TabsContainer_tabs-row-inner-pad-b__9PvYL {\n    padding: 0 32px !important; }\n  .TabsContainer_tabs-tab-initial-mar__x3vS2 {\n    margin-left: 3.5px !important; }\n  .TabsContainer_tabs-tab-last-mar__GX9iY {\n    margin-right: 3.5px !important; }\n  .TabsContainer_tabs-black-tab-outer__XX5Ys {\n    top: 8px; }\n  .TabsContainer_tabs-black-tab__wtRuh {\n    height: 32px; } }\n\n@media (max-width: 666px), (max-width: 767px) and (orientation: portrait) {\n  .TabsContainer_tabs-row-inner-pad-a__qUgaO {\n    padding: 0 24px; }\n  .TabsContainer_tabs-row-inner-pad-b__9PvYL {\n    padding: 0 24px !important; } }\n\n@-webkit-keyframes TabsContainer_tabsSlideInLeft__xSJFr {\n  0% {\n    min-width: 100%;\n    transform: translateX(-100%); }\n  100% {\n    min-width: 100%;\n    transform: translateX(0%); } }\n\n@keyframes TabsContainer_tabsSlideInLeft__xSJFr {\n  0% {\n    min-width: 100%;\n    transform: translateX(-100%); }\n  100% {\n    min-width: 100%;\n    transform: translateX(0%); } }\n\n@-webkit-keyframes TabsContainer_tabsSlideInRight__zRWIg {\n  0% {\n    min-width: 100%;\n    transform: translateX(0%); }\n  100% {\n    min-width: 100%;\n    transform: translateX(-100%); } }\n\n@keyframes TabsContainer_tabsSlideInRight__zRWIg {\n  0% {\n    min-width: 100%;\n    transform: translateX(0%); }\n  100% {\n    min-width: 100%;\n    transform: translateX(-100%); } }\n\n@-webkit-keyframes TabsContainer_tabsSlideOutLeft__G5MGo {\n  0% {\n    min-width: 100%;\n    transform: translateX(0%); }\n  100% {\n    visibility: hidden;\n    min-width: 100%;\n    transform: translateX(-100%); } }\n\n@keyframes TabsContainer_tabsSlideOutLeft__G5MGo {\n  0% {\n    min-width: 100%;\n    transform: translateX(0%); }\n  100% {\n    visibility: hidden;\n    min-width: 100%;\n    transform: translateX(-100%); } }\n\n@-webkit-keyframes TabsContainer_tabsSlideOutRight__nzfIP {\n  0% {\n    min-width: 100%;\n    transform: translateX(-100%); }\n  100% {\n    visibility: hidden;\n    min-width: 100%;\n    transform: translateX(0%); } }\n\n@keyframes TabsContainer_tabsSlideOutRight__nzfIP {\n  0% {\n    min-width: 100%;\n    transform: translateX(-100%); }\n  100% {\n    visibility: hidden;\n    min-width: 100%;\n    transform: translateX(0%); } }\n";
styleInject(css_248z$1);

var TabsContainer$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    tabsShowTopPadding: tabsShowTopPadding,
    tabsBgOpacity: tabsBgOpacity,
    tabsPadMarAdjustA: tabsPadMarAdjustA,
    tabsPadMarAdjustB: tabsPadMarAdjustB,
    tabsGrid: tabsGrid,
    tabsNoBorderRadiusA: tabsNoBorderRadiusA,
    tabsRow: tabsRow,
    tabsRowInner: tabsRowInner,
    tabsRowInnerPadA: tabsRowInnerPadA,
    tabsRowInnerPadB: tabsRowInnerPadB,
    tabsRowInnerLeft: tabsRowInnerLeft,
    tabsTabHideFocus: tabsTabHideFocus,
    tabsTab: tabsTab,
    tabsTabHoverBlue: tabsTabHoverBlue,
    tabsTabHoverUnderline: tabsTabHoverUnderline,
    tabsTabTransition: tabsTabTransition,
    tabsTabInitialMar: tabsTabInitialMar,
    tabsTabLastMar: tabsTabLastMar,
    tabsTabLeftMar: tabsTabLeftMar,
    tabsTabWhiteFocus: tabsTabWhiteFocus,
    tabsTabUiBlackFocus: tabsTabUiBlackFocus,
    tabsTabButtonSpace: tabsTabButtonSpace,
    tabsBlackTabTransition: tabsBlackTabTransition,
    tabsBlackTabOuter: tabsBlackTabOuter,
    tabsBlackTab: tabsBlackTab,
    tabsContentSlideInLeft: tabsContentSlideInLeft,
    tabsSlideInLeft: tabsSlideInLeft,
    tabsContentSlideInRight: tabsContentSlideInRight,
    tabsSlideInRight: tabsSlideInRight,
    tabsContentSlideOutRight: tabsContentSlideOutRight,
    tabsSlideOutLeft: tabsSlideOutLeft,
    tabsContentSlideOutLeft: tabsContentSlideOutLeft,
    tabsSlideOutRight: tabsSlideOutRight,
    tabsContent: tabsContent,
    tabsContentDefaultAnimation: tabsContentDefaultAnimation,
    tabsContentDefaultAnimationOff: tabsContentDefaultAnimationOff,
    tabsContainer: tabsContainer,
    tabsNoBorderRadiusB: tabsNoBorderRadiusB,
    'default': TabsContainer$1,
    stylesheet: stylesheet
});

var styles = /*@__PURE__*/getAugmentedNamespace(TabsContainer$2);

var TabsContainer_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });



var TabsContainer = /** @class */ (function (_super) {
    __extends(TabsContainer, _super);
    function TabsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            _this.mounted = true;
            // sets variable margin between each tab item and also original location of black button overlay
            _this.calcMargin(function () {
                return _this.moveTab(_this.props.defaultIndex ? _this.props.defaultIndex : 0, true, false, function () { return _this.setState({ transitionOn: true }); }, true);
            }, true);
            _this.calcMargin(function () {
                return _this.moveTab(_this.props.defaultIndex ? _this.props.defaultIndex : 0, true, false, function () {
                    return _this.setState({ transitionOn: true });
                });
            });
            // listens for screen size changes
            window.addEventListener("resize", _this.onScreenResize);
        };
        _this.componentWillUnmount = function () {
            window.removeEventListener("resize", _this.onScreenResize);
            _this.mounted = false;
        };
        _this.calcMargin = function (cb, initial) {
            var data = _this.props.data;
            var fullWidthTab = _this.state.fullWidthTab;
            var viewportWidth = _this.tabsOuterContRef ? _this.tabsOuterContRef.offsetWidth : 0;
            var offset = viewportWidth > 1024 ? 50.75 : viewportWidth > 767 ? 34.75 : 18.75;
            var tabContWidth = fullWidthTab
                ? viewportWidth
                : _this.tabsContRef
                    ? _this.tabsContRef.offsetWidth
                    : 0;
            var sum = (viewportWidth >= 768 ? 36 : 32) + _this.tabsRef[0].offsetWidth + offset;
            var stoppingIndex;
            // calculates if tabs fits using mininum space
            for (var i = 1; i < data.length; i++) {
                var temp = sum +
                    4 +
                    _this.tabsRef[i].offsetWidth / 2 -
                    (viewportWidth >= 768 &&
                        !(viewportWidth <= 666 || window.matchMedia("(orientation: portrait)").matches)
                        ? 32
                        : 24);
                if (temp > tabContWidth && stoppingIndex === undefined) {
                    stoppingIndex = i - 1;
                }
                else {
                    sum += 4 + _this.tabsRef[i].offsetWidth + offset;
                }
            }
            // if the width of the tab container is greater than the sum of tabs and spaces
            if (tabContWidth > sum) {
                // use the real offset
                var realOffset = viewportWidth > 1024 ? 50 : viewportWidth > 767 ? 34 : 18;
                if (initial) {
                    _this.tabMarR = realOffset + "px";
                    _this.fullWidthTab = false;
                    if (cb) {
                        cb();
                    }
                }
                else {
                    _this.setState({
                        tabMarR: realOffset + "px",
                        fullWidthTab: false,
                    }, cb ? cb : function () { return null; });
                }
            }
            else {
                // cases for last index as stopping index
                if (!stoppingIndex) {
                    stoppingIndex = data.length - 1;
                }
                // calculates what padding should be to make it show half of a tab with variable space
                sum = viewportWidth > 767 ? 36 : 24;
                for (var i = 0; i <= stoppingIndex; i++) {
                    if (i === stoppingIndex) {
                        sum += 4 + _this.tabsRef[i].offsetWidth / 2;
                    }
                    else {
                        sum += 4 + _this.tabsRef[i].offsetWidth;
                    }
                }
                var spaceLeft = tabContWidth - sum;
                var realSpace = spaceLeft / stoppingIndex;
                var tabMarR = realSpace + "px";
                if (initial) {
                    _this.tabMarR = tabMarR;
                    _this.fullWidthTab = true;
                    if (cb) {
                        cb();
                    }
                }
                else {
                    _this.setState({
                        tabMarR: tabMarR,
                        fullWidthTab: true,
                    }, cb ? cb : function () { return null; });
                }
            }
        };
        _this.moveTab = function (index, hideFocus, focusTab, cb, initial) {
            if (hideFocus === void 0) { hideFocus = true; }
            if (focusTab === void 0) { focusTab = false; }
            if (initial) {
                _this.moveTabInner(index, hideFocus, focusTab, cb, initial);
            }
            else {
                // setTimeout fixes not moving tab in inspect mode bug
                setTimeout(function () {
                    _this.moveTabInner(index, hideFocus, focusTab, cb, initial);
                }, 1);
            }
        };
        _this.moveTabInner = function (index, hideFocus, focusTab, cb, initial) {
            if (hideFocus === void 0) { hideFocus = true; }
            if (focusTab === void 0) { focusTab = false; }
            // moves the black button overlay
            var _a = _this.props; _a.alignment; _a.isTransparent;
            var _b = _this.state; _b.fullWidthTab; var initializedA = _b.initializedA, tabMarR = _b.tabMarR;
            parseFloat((initializedA ? tabMarR : _this.tabMarR).substring(0, (initializedA ? tabMarR : _this.tabMarR).length - 2));
            var viewportWidth = window.innerWidth;
            var offset = viewportWidth >= 768 ? 22 : 6;
            var left = 0;
            var width = 0;
            for (var i = 0; i <= index; i++) {
                if (_this.tabsRef[i] !== null) {
                    if (i === index) {
                        width = _this.tabsRef[i].offsetWidth + offset;
                    }
                }
            }
            left = viewportWidth > 767 ? _this.tabsRef[index].offsetLeft - 10 : _this.tabsRef[index].offsetLeft - 2;
            if (focusTab) {
                _this.tabsRef[index].focus();
            }
            if (_this.mounted) {
                if (initial) {
                    _this.blackTabStyleLeft = left + "px";
                    _this.blackTabStyleWidth = width + "px";
                    _this.currentIndex = index;
                    _this.prevIndex = 0;
                    _this.setState({ visible: true });
                }
                else {
                    _this.setState(function (_a) {
                        var currentIndex = _a.currentIndex;
                        return ({
                            blackTabStyle: {
                                left: left + "px",
                                width: width + "px",
                            },
                            currentIndex: index,
                            initializedA: true,
                            prevIndex: currentIndex,
                        });
                    }, 
                    // scrolls after black button overlay moves
                    function () {
                        setTimeout(function () {
                            if (_this.mounted) {
                                _this.setState({ initializedB: true, transitionOn: false, hideFocus: hideFocus }, function () {
                                    _this.scrollToRightPos(index);
                                    if (cb) {
                                        cb();
                                    }
                                });
                            }
                        }, 500);
                        clearTimeout(_this.resizeTimeout);
                        _this.resizeTimeout = window.setTimeout(function () {
                            _this.setState(function (_a) {
                                var currentIndex = _a.currentIndex;
                                return ({
                                    blackTabStyle: {
                                        left: left + "px",
                                        width: width + "px",
                                    },
                                    currentIndex: index,
                                    initializedA: true,
                                    prevIndex: currentIndex,
                                });
                            });
                        }, 501);
                    });
                }
            }
        };
        _this.onKeyUp = function (e) {
            var data = _this.props.data;
            var currentTarget = e.currentTarget;
            var id = currentTarget.id;
            var el = document.getElementById(id);
            var value = el.getAttribute("index");
            var valueInt = parseInt(value, 10);
            if (keyPress.KeyPress.leftArrowIsPressed(e)) {
                _this.tabsRef[valueInt].blur();
                if (valueInt !== 0) {
                    _this.tabsRef[valueInt - 1].focus();
                    _this.setState({ transitionOn: true, hideFocus: true }, function () {
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                        _this.moveTab(valueInt - 1, false, true);
                    });
                }
                else {
                    _this.tabsRef[data.length - 1].focus();
                    _this.setState({ transitionOn: true, hideFocus: true }, function () {
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                        _this.moveTab(data.length - 1, false, true);
                    });
                }
            }
            else if (keyPress.KeyPress.rightArrowIsPressed(e)) {
                _this.tabsRef[valueInt].blur();
                if (valueInt !== data.length - 1) {
                    _this.tabsRef[valueInt + 1].focus();
                    _this.setState({ transitionOn: true, hideFocus: true }, function () {
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                        _this.moveTab(valueInt + 1, false, true);
                    });
                }
                else {
                    _this.tabsRef[0].focus();
                    _this.setState({ transitionOn: true, hideFocus: true }, function () {
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                        _this.moveTab(0, false, true);
                    });
                }
            }
            else if (keyPress.KeyPress.tabIsPressed(e)) {
                _this.setState({ hideFocus: false });
            }
        };
        _this.onMouseDown = function (e) {
            if (e.button === 0) {
                if (_this.onClickTimeout) {
                    clearTimeout(_this.onClickTimeout);
                }
                var id = e.currentTarget.id;
                var el = document.getElementById(id);
                var value_1 = el.getAttribute("index");
                _this.onClickTimeout = window.setTimeout(function () {
                    var valueInt = parseInt(value_1, 10);
                    if (_this.mounted) {
                        _this.setState({ hideFocus: true, transitionOn: true }, function () {
                            return _this.moveTab(valueInt, true, true);
                        });
                        if (_this.props.onSelect) {
                            _this.props.onSelect(valueInt);
                        }
                    }
                }, 150);
            }
        };
        _this.onScreenResize = function () {
            // re-calculates margin every time screen is resized
            var _a = _this.state, currentIndex = _a.currentIndex, hideFocus = _a.hideFocus;
            _this.calcMargin(function () { return _this.moveTab(currentIndex, hideFocus); });
        };
        _this.scrollToRightPos = function (index) {
            // adjusts horizontal scroll position to fit black button overlay within view
            var _a = _this.props, data = _a.data, name = _a.name;
            var scrollEl = document.getElementById("tab_scroll_" + name);
            if (scrollEl) {
                var scrollLeft = scrollEl.scrollLeft;
                var blackTabStyle = _this.state.blackTabStyle;
                var left = blackTabStyle.left, width = blackTabStyle.width;
                var leftNum = parseFloat(left.substring(0, left.length - 2));
                var widthNum = parseFloat(width.substring(0, left.length - 2));
                var right = leftNum + widthNum;
                var scrollContWidth = _this.tabsScrollRef ? _this.tabsScrollRef.offsetWidth : 0;
                if (index === 0) {
                    scrollEl.scrollLeft = 0;
                }
                else if (index === data.length) {
                    scrollEl.scrollLeft = scrollContWidth;
                }
                else if (leftNum < scrollLeft) {
                    scrollEl.scrollLeft = leftNum - 16;
                }
                else if (right > scrollLeft + scrollContWidth) {
                    scrollEl.scrollLeft =
                        parseFloat((leftNum - scrollContWidth + widthNum).toString()) + 16;
                }
            }
        };
        _this.render = function () {
            var _a = _this.props, _b = _a.alignment, alignment = _b === void 0 ? "center" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.contentClassName, contentClassName = _d === void 0 ? "" : _d, _e = _a.bgType, bgType = _e === void 0 ? "dark" : _e, _f = _a.bottomClassName, bottomClassName = _f === void 0 ? "" : _f, data = _a.data, _g = _a.isTransparent, isTransparent = _g === void 0 ? false : _g, name = _a.name, _h = _a.tabGridCol, tabGridCol = _h === void 0 ? 12 : _h, testId = _a.testId, _j = _a.topClassName, topClassName = _j === void 0 ? "" : _j;
            var _k = _this.state, blackTabStyle = _k.blackTabStyle, currentIndex = _k.currentIndex, hideFocus = _k.hideFocus, fullWidthTab = _k.fullWidthTab, initializedA = _k.initializedA, initializedB = _k.initializedB, prevIndex = _k.prevIndex, tabMarR = _k.tabMarR, transitionOn = _k.transitionOn, visible = _k.visible;
            var ariaOwns = "";
            for (var i = 0; i < data.length; i++) {
                ariaOwns += "" + (i === 0 ? "" : " ") + name + "-" + i;
            }
            return (React__default.createElement("div", { "data-testid": testId, style: { visibility: visible ? "visible" : "hidden" } },
                React__default.createElement("div", { className: styles.tabsContainer + " " + className },
                    React__default.createElement("div", { className: "row " + styles.tabsShowTopPadding + (topClassName ? " " + topClassName : ""), ref: function (ref) { return (_this.tabsOuterContRef = ref); } },
                        React__default.createElement("div", { className: (isTransparent
                                ? ""
                                : bgType === "light" &&
                                    (initializedA ? fullWidthTab : _this.fullWidthTab)
                                    ? "bg-ui-white "
                                    : bgType === "dark" &&
                                        (initializedA ? fullWidthTab : _this.fullWidthTab)
                                        ? "bg-black "
                                        : bgType === "grey" &&
                                            (initializedA ? fullWidthTab : _this.fullWidthTab)
                                            ? "bg-ui-background-gray "
                                            : "") + "grid-col-" + (alignment === "left" ? 12 : tabGridCol) + " grid-col-12-md grid-col-12-sm mar-none-md mar-none-sm offset" + (12 -
                                (alignment === "left" ? 12 : tabGridCol)) /
                                2 + (bgType === "gradient" &&
                                (initializedA ? fullWidthTab : _this.fullWidthTab)
                                ? " " + styles.tabsBgOpacity
                                : "") + ((initializedA
                                ? fullWidthTab
                                : _this.fullWidthTab)
                                ? " " + styles.tabsPadMarAdjustA
                                : "") + " " + styles.tabsPadMarAdjustB + " " + styles.tabsGrid + (bottomClassName ? " " + bottomClassName : "") },
                            React__default.createElement("div", { className: (isTransparent
                                    ? ""
                                    : bgType === "light" &&
                                        !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                        ? "bg-ui-white "
                                        : bgType === "dark" &&
                                            !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                            ? "bg-black "
                                            : bgType === "grey" &&
                                                !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                                ? "bg-ui-background-gray "
                                                : "") + "flex justify-center " + (bgType === "gradient" &&
                                    !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                    ? styles.tabsBgOpacity + " "
                                    : "") + ((initializedA
                                    ? fullWidthTab
                                    : _this.fullWidthTab)
                                    ? styles.tabsNoBorderRadiusA + " "
                                    : "") + styles.tabsNoBorderRadiusB + " " + styles.tabsRow, ref: function (ref) { return (_this.tabsContRef = ref || undefined); }, style: isTransparent ? { backgroundColor: "transparent" } : {} },
                                React__default.createElement("div", { "aria-owns": ariaOwns, className: "flex flex-items-center overflow-x-auto overflow-y-hidden rel scrollbar-hidden " + styles.tabsRowInner + ((initializedA ? fullWidthTab : _this.fullWidthTab) ||
                                        (alignment === "left" && isTransparent)
                                        ? " " + styles.tabsRowInnerPadA
                                        : "") + (alignment === "left"
                                        ? " " + styles.tabsRowInnerLeft + (!isTransparent &&
                                            !(initializedA ? fullWidthTab : _this.fullWidthTab)
                                            ? " " + styles.tabsRowInnerPadB
                                            : "")
                                        : ""), id: "tab_scroll_" + name, ref: function (ref) { return (_this.tabsScrollRef = ref || undefined); }, role: "tablist" },
                                    data.map(function (item, index) {
                                        var btnWrapperFunction = item.btnWrapperFunction, id = item.id, tabName = item.tabName;
                                        var isActive = (initializedA ? currentIndex : _this.currentIndex) ===
                                            index;
                                        var isFirst = index === 0;
                                        var isLast = index === data.length - 1;
                                        var tabProps = {
                                            "aria-controls": name + "-tab-" + index,
                                            "aria-posinset": index + 1,
                                            "aria-selected": isActive,
                                            "aria-setsize": data.length,
                                            className: (isActive
                                                ? bgType === "dark"
                                                    ? "color-ui-dark-gray"
                                                    : "color-ui-white"
                                                : bgType === "dark"
                                                    ? "color-ui-white"
                                                    : "color-ui-dark-gray") + " font-medium line-h-base mar-b-none rel " + styles.tabsTab + (isActive
                                                ? ""
                                                : bgType === "light" || bgType === "grey"
                                                    ? " " + styles.tabsTabHoverBlue
                                                    : " " + styles.tabsTabHoverUnderline) + (isFirst ? " " + styles.tabsTabInitialMar : "") + " " + styles.tabsTabLeftMar + (isLast ? " " + styles.tabsTabLastMar : "") + (transitionOn ? " " + styles.tabsTabTransition : "") + "\n                                          " + (hideFocus
                                                ? " " + styles.tabsTabHideFocus
                                                : (isActive && bgType !== "dark") ||
                                                    (!isActive && bgType === "dark")
                                                    ? " " + styles.tabsTabWhiteFocus
                                                    : " " + styles.tabsTabUiBlackFocus) + " text-center type-base",
                                            id: name + "-" + index,
                                            index: index,
                                            key: id,
                                            onClick: _this.onMouseDown,
                                            onKeyUp: _this.onKeyUp,
                                            onMouseDown: _this.onMouseDown,
                                            role: "tab",
                                            style: isLast
                                                ? {}
                                                : {
                                                    marginRight: initializedA
                                                        ? tabMarR
                                                        : _this.tabMarR,
                                                },
                                            tabIndex: isActive ? 0 : -1,
                                        };
                                        return btnWrapperFunction ? (btnWrapperFunction(React__default.createElement("a", __assign({}, tabProps, { ref: function (ref) {
                                                return ref && (_this.tabsRef[index] = ref);
                                            } }), tabName))) : (React__default.createElement("button", __assign({}, tabProps, { ref: function (ref) {
                                                return ref && (_this.tabsRef[index] = ref);
                                            } }), tabName));
                                    }),
                                    (initializedA ? fullWidthTab : _this.fullWidthTab) && (React__default.createElement("div", { className: "tabs-tab-button-space" })),
                                    React__default.createElement("div", { className: "absolute flex flex-items-start height-full" + (transitionOn ? " " + styles.tabsBlackTabTransition : "") + " " + styles.tabsBlackTabOuter, style: {
                                            left: initializedA
                                                ? blackTabStyle.left
                                                : _this.blackTabStyleLeft,
                                            width: parseFloat((initializedA
                                                ? blackTabStyle.width
                                                : _this.blackTabStyleWidth).substring(0, (initializedA
                                                ? blackTabStyle.width
                                                : _this.blackTabStyleWidth).length - 2)) + 32 + "px",
                                        } },
                                        React__default.createElement("div", { className: (bgType === "dark" ? "bg-ui-white" : "bg-ui-black") + " " + styles.tabsBlackTab + (transitionOn
                                                ? " " + styles.tabsBlackTabTransition
                                                : ""), style: {
                                                width: initializedA
                                                    ? blackTabStyle.width
                                                    : _this.blackTabStyleWidth,
                                            } }))))))),
                React__default.createElement("div", { className: "rel flex overflow-hidden" + (contentClassName ? " " + contentClassName : "") }, data.map(function (item, index) {
                    var component = item.component, id = item.id;
                    var slideDirClass = "";
                    if ((initializedA ? currentIndex : _this.currentIndex) !==
                        (initializedA ? prevIndex : _this.prevIndex)) {
                        if (index === (initializedA ? currentIndex : _this.currentIndex)) {
                            if ((initializedA ? currentIndex : _this.currentIndex) >
                                (initializedA ? prevIndex : _this.prevIndex)) {
                                slideDirClass = " " + styles.tabsContentSlideInRight;
                            }
                            else {
                                slideDirClass = " " + styles.tabsContentSlideInLeft;
                            }
                        }
                        else if (index === (initializedA ? prevIndex : _this.prevIndex)) {
                            if ((initializedA ? prevIndex : _this.prevIndex) >
                                (initializedA ? currentIndex : _this.currentIndex)) {
                                slideDirClass = " " + styles.tabsContentSlideOutLeft;
                            }
                            else {
                                slideDirClass = " " + styles.tabsContentSlideOutRight;
                            }
                        }
                    }
                    return (React__default.createElement("div", { "aria-labelledby": name + "-" + index, className: (index !== (initializedA ? currentIndex : _this.currentIndex) &&
                            index !== (initializedA ? prevIndex : _this.prevIndex)
                            ? "hide "
                            : "") + "rel " + styles.tabsContent + " " + (initializedB
                            ? styles.tabsContentDefaultAnimation
                            : styles.tabsContentDefaultAnimationOff) + slideDirClass, id: name + "-tab-" + index, key: id, role: "tabpanel", style: { top: 0, width: "100%" }, tabIndex: 0 }, component));
                }))));
        };
        _this.state = {
            // style of black button overlay
            blackTabStyle: {
                left: "0px",
                width: "0px",
            },
            // current shown index
            currentIndex: 0,
            // determines if container is full-bleed
            fullWidthTab: false,
            // used to determine if focus is hidden
            hideFocus: false,
            // used to determine if component is initialized
            initializedA: false,
            // used to determine if component is initialized
            initializedB: false,
            // previous shown index
            prevIndex: 0,
            // variable padding between tab items
            tabMarR: "0px",
            // used to turn transition off for hover effects
            transitionOn: false,
            // sets if component is visible
            visible: false,
        };
        _this.blackTabStyleLeft = "0px";
        _this.blackTabStyleWidth = "0px";
        _this.currentIndex = 0;
        _this.fullWidthTab = false;
        _this.onClickTimeout = 0;
        _this.prevIndex = 0;
        _this.resizeTimeout = 0;
        _this.tabMarR = "0px";
        _this.tabsRef = [];
        _this.mounted = false;
        return _this;
    }
    return TabsContainer;
}(React__default.Component));
exports.default = TabsContainer;
});

var TabsContainer = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = TabsContainer_1.default;
});

var components = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

Object.defineProperty(exports, "Accordion", { enumerable: true, get: function () { return Accordion.default; } });

Object.defineProperty(exports, "AccordionBlock", { enumerable: true, get: function () { return AccordionBlock.default; } });

Object.defineProperty(exports, "Alert", { enumerable: true, get: function () { return Alert.default; } });

Object.defineProperty(exports, "AlertBanner", { enumerable: true, get: function () { return AlertBanner.default; } });

Object.defineProperty(exports, "AlertList", { enumerable: true, get: function () { return AlertList.default; } });

Object.defineProperty(exports, "BaseCta", { enumerable: true, get: function () { return BaseCta.default; } });

Object.defineProperty(exports, "Button", { enumerable: true, get: function () { return Button.default; } });

Object.defineProperty(exports, "ButtonGroup", { enumerable: true, get: function () { return ButtonGroup.default; } });

Object.defineProperty(exports, "CaptchaGeneratorV3", { enumerable: true, get: function () { return CaptchaGeneratorV3.default; } });

Object.defineProperty(exports, "CardShell", { enumerable: true, get: function () { return CardShell.default; } });

Object.defineProperty(exports, "CardShellRow", { enumerable: true, get: function () { return CardShellRow.default; } });

Object.defineProperty(exports, "Checkbox", { enumerable: true, get: function () { return Checkbox.default; } });

Object.defineProperty(exports, "ColorSelector", { enumerable: true, get: function () { return ColorSelector.default; } });

Object.defineProperty(exports, "ComboBox", { enumerable: true, get: function () { return ComboBox.default; } });

Object.defineProperty(exports, "ContextualMessage", { enumerable: true, get: function () { return ContextualMessage.default; } });

Object.defineProperty(exports, "DropdownButton", { enumerable: true, get: function () { return DropdownButton.default; } });

Object.defineProperty(exports, "HorizontalRule", { enumerable: true, get: function () { return HorizontalRule.default; } });

Object.defineProperty(exports, "IconButton", { enumerable: true, get: function () { return IconButton.default; } });

Object.defineProperty(exports, "IconSvg", { enumerable: true, get: function () { return IconSvg.default; } });

Object.defineProperty(exports, "Legal", { enumerable: true, get: function () { return Legal.default; } });

Object.defineProperty(exports, "Link", { enumerable: true, get: function () { return Link.default; } });

Object.defineProperty(exports, "LinkList", { enumerable: true, get: function () { return LinkList.default; } });

Object.defineProperty(exports, "Lists", { enumerable: true, get: function () { return Lists.default; } });

Object.defineProperty(exports, "MultiSelectInput", { enumerable: true, get: function () { return MultiSelectInput.default; } });

Object.defineProperty(exports, "MultiSelectInputList", { enumerable: true, get: function () { return MultiSelectInputList.default; } });

Object.defineProperty(exports, "NotificationTimed", { enumerable: true, get: function () { return NotificationTimed.default; } });

Object.defineProperty(exports, "NumberBadge", { enumerable: true, get: function () { return NumberBadge.default; } });

Object.defineProperty(exports, "Popover", { enumerable: true, get: function () { return Popover.default; } });

Object.defineProperty(exports, "ProgressIndicator", { enumerable: true, get: function () { return ProgressIndicator.default; } });

Object.defineProperty(exports, "PromoBadge", { enumerable: true, get: function () { return PromoBadge.default; } });

Object.defineProperty(exports, "RadioGroup", { enumerable: true, get: function () { return RadioGroup.default; } });

Object.defineProperty(exports, "RadioButton", { enumerable: true, get: function () { return RadioButton.default; } });

Object.defineProperty(exports, "Select", { enumerable: true, get: function () { return Select.default; } });

Object.defineProperty(exports, "SelectionMenu", { enumerable: true, get: function () { return SelectionMenu.default; } });

Object.defineProperty(exports, "Spinner", { enumerable: true, get: function () { return Spinner.default; } });

Object.defineProperty(exports, "StarRating", { enumerable: true, get: function () { return StarRating.default; } });

Object.defineProperty(exports, "Star", { enumerable: true, get: function () { return Star.default; } });

Object.defineProperty(exports, "StatusTag", { enumerable: true, get: function () { return StatusTag.default; } });

Object.defineProperty(exports, "Tags", { enumerable: true, get: function () { return Tags.default; } });

Object.defineProperty(exports, "Tag", { enumerable: true, get: function () { return Tag.default; } });

Object.defineProperty(exports, "TextArea", { enumerable: true, get: function () { return TextArea.default; } });

Object.defineProperty(exports, "TextField", { enumerable: true, get: function () { return TextField.default; } });

Object.defineProperty(exports, "Timer", { enumerable: true, get: function () { return Timer.default; } });

Object.defineProperty(exports, "Toggle", { enumerable: true, get: function () { return Toggle.default; } });

Object.defineProperty(exports, "Tooltip", { enumerable: true, get: function () { return Tooltip.default; } });

Object.defineProperty(exports, "Tracker", { enumerable: true, get: function () { return Tracker.default; } });

Object.defineProperty(exports, "UsageMeter", { enumerable: true, get: function () { return UsageMeter.default; } });

Object.defineProperty(exports, "OnClickOutside", { enumerable: true, get: function () { return OnClickOutside.default; } });

Object.defineProperty(exports, "OnEscape", { enumerable: true, get: function () { return OnEscape.default; } });

Object.defineProperty(exports, "OnEscapeHoC", { enumerable: true, get: function () { return OnEscapeHoC.default; } });

Object.defineProperty(exports, "Collapse", { enumerable: true, get: function () { return Collapse.default; } });

Object.defineProperty(exports, "JumpLinks", { enumerable: true, get: function () { return JumpLinks.default; } });

Object.defineProperty(exports, "Layout", { enumerable: true, get: function () { return Layout.default; } });

Object.defineProperty(exports, "PromotionalPricing", { enumerable: true, get: function () { return PromotionalPricing.default; } });

Object.defineProperty(exports, "SimpleModal", { enumerable: true, get: function () { return SimpleModal.default; } });

Object.defineProperty(exports, "TabsContainer", { enumerable: true, get: function () { return TabsContainer.default; } });
});

var insuranceModalEnrollButton = "SignupModal-module_insuranceModalEnrollButton__b0sOQ";
var modal = "SignupModal-module_modal__Uwckg";
var modalHeader = "SignupModal-module_modalHeader__5XOHW";
var modalContent = "SignupModal-module_modalContent__-l-lw";
var close = "SignupModal-module_close__SQhuQ";
var scroll = "SignupModal-module_scroll__EtG0Q";
var signupContent = "SignupModal-module_signupContent__8-3k1";
var css_248z = ".SignupModal-module_insuranceModalEnrollButton__b0sOQ, .SignupModal-module_insuranceModalEnrollButton__b0sOQ:hover, .SignupModal-module_insuranceModalEnrollButton__b0sOQ:focus, .SignupModal-module_insuranceModalEnrollButton__b0sOQ:hover:focus, .SignupModal-module_insuranceModalEnrollButton__b0sOQ:active, .SignupModal-module_insuranceModalEnrollButton__b0sOQ:visited {\n  border: 1px solid black;\n  background-color: black;\n  color: white;\n  padding: 8px 16px;\n  box-shadow: none;\n  float: right;\n  font-size: 12px; }\n\n.SignupModal-module_insuranceModalEnrollButton__b0sOQ i svg {\n  fill: black;\n  margin-top: 1px;\n  margin-left: 10px; }\n\n.SignupModal-module_insuranceModalCancelButton__iNowX, .SignupModal-module_insuranceModalCancelButton__iNowX:hover, .SignupModal-module_insuranceModalCancelButton__iNowX:focus, .SignupModal-module_insuranceModalCancelButton__iNowX:hover:focus, .SignupModal-module_insuranceModalCancelButton__iNowX:active, .SignupModal-module_insuranceModalCancelButton__iNowX:visited {\n  border: 1px solid black;\n  background-color: white;\n  color: black;\n  margin: 24px;\n  padding: 8px 16px;\n  box-shadow: none;\n  font-size: 12px; }\n\n.SignupModal-module_insuranceModalCancelButton__iNowX i svg {\n  fill: black;\n  margin-top: 1px;\n  margin-left: 10px; }\n\n.SignupModal-module_modal__Uwckg {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  z-index: 1000;\n  padding-bottom: 24px;\n  padding-top: 24px;\n  padding-left: 24px;\n  padding-right: 24px; }\n\n.SignupModal-module_modalHeader__5XOHW {\n  text-align: center;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  font-size: 15px; }\n\n.SignupModal-module_modalContent__-l-lw {\n  width: 560px;\n  height: auto;\n  overflow: hidden;\n  background-color: #fff;\n  border-radius: 3px;\n  align-items: center; }\n  @media (min-width: 252px) and (max-width: 320px) {\n    .SignupModal-module_modalContent__-l-lw {\n      overflow-y: auto; } }\n\n.SignupModal-module_close__SQhuQ {\n  font-size: 2rem;\n  font-weight: 500;\n  line-height: 1;\n  color: #000;\n  border: none;\n  background-color: #fff;\n  float: right; }\n\n.SignupModal-module_customBtn__jfWrM {\n  padding: 0px 14px;\n  height: 48px;\n  line-height: 48px;\n  border-radius: 3px;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500; }\n\n.SignupModal-module_scroll__EtG0Q {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 75vh; }\n\n.SignupModal-module_signupContent__8-3k1 {\n  display: block; }\n  @media (max-width: 425px) {\n    .SignupModal-module_signupContent__8-3k1 {\n      padding-right: 16px; } }\n  @media (min-width: 1025px) {\n    .SignupModal-module_signupContent__8-3k1 {\n      padding-right: 32px; } }\n  @media (min-width: 426px) and (max-width: 1024px) {\n    .SignupModal-module_signupContent__8-3k1 {\n      padding-right: 24px; } }\n\n.SignupModal-module_signupContent__8-3k1 ul {\n  list-style: disc; }\n  @media (max-width: 425px) {\n    .SignupModal-module_signupContent__8-3k1 ul {\n      padding-right: 16px; } }\n  @media (min-width: 1025px) {\n    .SignupModal-module_signupContent__8-3k1 ul {\n      padding-right: 32px; } }\n  @media (min-width: 426px) and (max-width: 1024px) {\n    .SignupModal-module_signupContent__8-3k1 ul {\n      padding-right: 24px; } }\n  .SignupModal-module_signupContent__8-3k1 ul li {\n    display: list-item; }\n  .SignupModal-module_signupContent__8-3k1 ul li a {\n    color: black;\n    text-decoration: underline; }\n  .SignupModal-module_signupContent__8-3k1 ul ul {\n    padding-left: 32px; }\n  .SignupModal-module_signupContent__8-3k1 ul details ul li {\n    margin: auto;\n    padding: 2px 10px; }\n  .SignupModal-module_signupContent__8-3k1 ul details ul {\n    padding: 3px 0px 10px 60px;\n    list-style: disc; }\n";
styleInject(css_248z);

var SignupModal = function (props) {
    var _a = useState(props.show), show = _a[0]; _a[1];
    var insuranceModalContent = props.insuranceContent.feedData.master.insurancesList;
    if (!show) {
        return null;
    }
    var _b = useState({
        heading: '',
        legalText: '',
    }), legalShortPath = _b[0], setLegalShortPath = _b[1];
    useEffect(function () {
        loadSignupModalContent();
    }, []);
    var loadSignupModalContent = function () {
        var offerIdArray = [];
        var legalObj;
        if (insuranceModalContent && insuranceModalContent.length > 0) {
            insuranceModalContent.map(function (content) {
                if (content.master && content.master.offerId && !content.master.offerId.includes('NA')) {
                    if (content.master.offerId.indexOf(',') != -1) {
                        offerIdArray = content.master.offerId.split(',');
                        offerIdArray.map(function (offerId) {
                            if (offerId === props.offerID) {
                                legalObj = content.master.legalIDP.master.legalShortPath.master;
                            }
                        });
                    }
                    else {
                        if (content.master.offerId === props.offerID) {
                            legalObj = content.master.legalIDP.master.legalShortPath.master;
                        }
                    }
                }
            });
            setLegalShortPath(legalObj);
        }
    };
    var getCollapsibleContent = function (legalText) {
        var detailStart = /#!/gm;
        var detailEnd = /!#/gm;
        var summaryStart = /#\*/gm;
        var summaryEnd = /\*#/gm;
        legalText = legalText.replace(detailStart, "<details>");
        legalText = legalText.replace(detailEnd, "</details>");
        legalText = legalText.replace(summaryStart, "<summary>");
        legalText = legalText.replace(summaryEnd, "</summary>");
        return { __html: legalText };
    };
    return (React.createElement("div", { className: modal + " flex flex-items-center justify-center" },
        React.createElement("div", { className: modalContent },
            React.createElement("div", { className: "pad-xxs" },
                React.createElement("button", { type: "button", className: close, onClick: props.onCancelBtnClick, "aria-label": "Close" },
                    React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
            legalShortPath && legalShortPath.heading !== '' && legalShortPath.legalText !== '' ? (React.createElement(React.Fragment, null,
                React.createElement("div", { "data-qa": "signupHeader", className: modalHeader + " pad-l-md pad-r-md pad-t-md pad-b-xs type-md color-ui-black text-center" }, legalShortPath.heading),
                React.createElement("div", { className: scroll },
                    React.createElement("div", { "data-qa": "signupContent", className: "pad-l-md mar-l-xs text-align-left full-width mar-b-none type-sm font-regular " + signupContent },
                        React.createElement("div", { dangerouslySetInnerHTML: getCollapsibleContent(legalShortPath.legalText) })),
                    React.createElement("div", { className: "flex justify-center flex-wrap mar-t-xs pad-b-md" },
                        React.createElement("button", { "data-qa": "cancelBtn", className: "btn false false btn-secondary btn-small mar-r-xxs mar-l-xxs mar-t-xxs mar-b-xxs", onClick: props.onCancelBtnClick }, signupModalConstants.cancelCTALabel),
                        React.createElement("button", { "data-qa": "signupBtn", className: "btn false false btn-secondary btn-small mar-r-xxs mar-l-xxs mar-t-xxs mar-b-xxs " + insuranceModalEnrollButton, onClick: props.onSignupBtnClick }, signupModalConstants.signUpCTALabel))))) : (React.createElement("div", { className: "pad-md text-center" }, signupModalConstants.modalErrorMessage)))));
};

var InsuranceModal = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = useState({
        feedData: props.insuranceFeedData || plansContentFragment,
    }), InsuranceModalState = _f[0], updateInsuranceModalState = _f[1];
    var _g = useState([]), insuranceList = _g[0], setInsuranceList = _g[1];
    var _h = useState(props.expandOnLoad || false), expanded$1 = _h[0], setExpanded = _h[1];
    var _j = useState(false), noThanksChecked = _j[0], setNoThanksChecked = _j[1];
    var _k = useState(false), continueCTA = _k[0], setContinueCTA = _k[1];
    var _l = useState(false), hideNoThanks = _l[0], setHideNoThanks = _l[1];
    var noInsuranceData = {
        offerId: 'NA',
        displayName: '',
        price: {
            mrc: null,
            uom: '',
        },
    };
    var _m = useState(props.currentSelection || {
        offerId: '',
        displayName: '',
        price: {
            mrc: null,
            uom: '',
        },
    }), selectedInsurance = _m[0], setSelectedInsurance = _m[1];
    var _o = useState(false), isInsuranceSelected = _o[0], setIsInsuranceSelected = _o[1];
    var _p = useState(false), collapseZipCode = _p[0], setZipCodeCollapsible = _p[1];
    var _q = useState(''), newZipCode = _q[0], setNewZipCode = _q[1];
    var _r = React__default.useState(''), updatedZipCode = _r[0], setUpdatedZipCode = _r[1];
    var _s = useState(true), validZipCode = _s[0], setIsZipCodeValid = _s[1];
    var _t = useState(true), buttonStatus = _t[0], setButtonStatus = _t[1];
    var _u = useState([]), protectedPlansList = _u[0], setProtectedPlansList = _u[1];
    var _v = useState([]), mobilePlansList = _v[0], setMobilePlansList = _v[1];
    var _w = useState(false), toggleClicked = _w[0], setToggleClicked = _w[1];
    var _x = useState(''), showModal = _x[0], setShowModal = _x[1];
    var _y = useState(null), currentInsurance = _y[0], setCurrentInsurance = _y[1];
    var _z = useState('btn-primary-2'), btnColor = _z[0], setBtnColor = _z[1];
    var _0 = useState('btn-secondary'), selectedbtn = _0[0], setSelectedBtn = _0[1];
    var _1 = useState(!props.expandOnLoad), showEdit = _1[0], setShowEdit = _1[1];
    var _2 = useState(false), priceChangedAlert = _2[0], setPriceChangedAlert = _2[1];
    var _3 = useState(false), apiFailAlert = _3[0], setApiFailAlert = _3[1];
    var _4 = useState(false), insuranceProps = _4[0], setInsuranceProps = _4[1];
    var setNewCookie = false;
    var price = props.deviceFullPrice ? props.deviceFullPrice.price : null;
    var noThanksRef = useRef(null);
    var ContinuCTARef = useRef(null);
    props.insuranceResponseObject;
    var campaignIdHeader = props.campaignIdHeader || '';
    console.log('rendered');
    useEffect(function () {
        getUserZipCode();
        //fallback if no feedData recieved from the consumer application
        if (!props.insuranceFeedData) {
            getContent();
        }
    }, []);
    useEffect(function () {
        setSelectedInsurance(props.currentSelection);
        loadInsuranceDetails();
    }, [props.currentSelection]);
    useEffect(function () {
        setExpanded(props.expandOnLoad);
    }, [props.expandOnLoad]);
    useEffect(function () {
        if (newZipCode != '') {
            loadInsuranceDetails();
        }
    }, [newZipCode]);
    var getContent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, feed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = apiUrl.planContentFragments;
                    return [4 /*yield*/, fetchInsuranceSupportUI(url, campaignIdHeader)];
                case 1:
                    feed = _a.sent();
                    if (feed != undefined || null || '') {
                        updateInsuranceModalState(__assign(__assign({}, InsuranceModalState), { feedData: feed }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var loadInsuranceDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var processedList, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    processedList = [];
                    if (props.insuranceResponseObject) {
                        Object.keys(props.insuranceResponseObject).forEach(function (productId) {
                            var insuranceItem = props.insuranceResponseObject[productId];
                            appendShotDetailsExpanded(insuranceItem, productId);
                            processedList.push(insuranceItem);
                        });
                    }
                    if (!(processedList.length && !insuranceProps)) return [3 /*break*/, 1];
                    getInsurancePlanData(processedList);
                    return [3 /*break*/, 4];
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchInsuranceList(props.skuID, props.productCode, newZipCode, campaignIdHeader, props.requestObject)];
                case 2:
                    response = _a.sent();
                    response && getInsurancePlanData(response);
                    if (updatedZipCode !== '' && validZipCode) {
                        setPriceChangedAlert(true);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error('loadInsuranceDetails: fetch error: ' + e_1);
                    setApiFailAlert(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var processedShortDetailsExpandedItem = function (shortDetails) {
        var descList = [];
        shortDetails &&
            shortDetails.forEach(function (shortDetailsDesc) {
                var description = get_1(shortDetailsDesc, 'master.description', undefined);
                if (description) {
                    descList.push(description);
                }
            });
        return descList;
    };
    var sortRankingBasedInsurance = function (response) {
        if (response.length) {
            response = response.sort(function (resp1, resp2) {
                return resp1.product.ranking - resp2.product.ranking;
            });
        }
        return response;
    };
    var getInsurancePlanData = function (response) {
        var responseList = [];
        response = sortRankingBasedInsurance(response);
        var newInsuranceRespObj = {};
        response &&
            response.length > 0 &&
            response.map(function (resp) {
                if (resp && resp.product && resp.product.childSkus) {
                    resp.product.childSkus.forEach(function (child) {
                        responseList.push({
                            displayName: child.displayName,
                            descList: processedShortDetailsExpandedItem(resp.shortDetailsExpanded),
                            skuId: child.skuId,
                            price: resp.product.price || {},
                            insuranceType: child.insuranceType,
                            offerId: resp.offerId,
                        });
                        if (props.currentSelection &&
                            props.currentSelection.offerId &&
                            props.currentSelection.offerId === resp.offerId) {
                            setShowEdit(true);
                            setIsInsuranceSelected(true);
                        }
                        else if (props.currentSelection &&
                            props.currentSelection.offerId &&
                            props.currentSelection.offerId === 'NA') {
                            setShowEdit(true);
                            setNoThanksChecked(true);
                            setContinueCTA(true);
                            setHideNoThanks(true);
                        }
                    });
                }
            });
        var protectedAdvantage = [];
        var MobileInsurance = [];
        responseList.map(function (list) {
            if (list.insuranceType && list.insuranceType === 'MI') {
                MobileInsurance.push(list);
            }
            else {
                protectedAdvantage.push(list);
            }
        });
        setMobilePlansList(MobileInsurance);
        setProtectedPlansList(protectedAdvantage);
        setInsuranceList(protectedAdvantage);
        setZipCodeCollapsible(false);
        if (props.letUpdateZipCode) {
            response.map(function (item) {
                newInsuranceRespObj[item.offerId] = item;
            });
            props.updatedInsuranceResponseObj && props.updatedInsuranceResponseObj(newInsuranceRespObj);
        }
    };
    var onChangeInsurancePlan = function (insurance, index) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setCurrentInsurance(insurance);
            props.onLinkClick && props.onLinkClick(insurance.displayName);
            if (props.showModal) {
                setShowModal('Y');
                setIsInsuranceSelected(true);
                setApiFailAlert(false);
                props.modalPageLoadEvent && props.modalPageLoadEvent(modalPageLoadValues);
                if (((selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.offerId) !== 'NA' && noThanksChecked)) {
                    setNoThanksChecked(false);
                }
                if (((selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.offerId) === 'NA' && noThanksChecked && !continueCTA)) {
                    setNoThanksChecked(false);
                    setSelectedInsurance(props.currentSelection);
                }
            }
            else {
                props.changeInsurancePlan(insurance);
                props.insuranceSelectionEvent && props.insuranceSelectionEvent(insurance);
                setSelectedInsurance(insurance);
                setIsInsuranceSelected(true);
                setNoThanksChecked(false);
                setExpanded(!expanded$1);
                setShowEdit(true);
                setHideNoThanks(false);
            }
            return [2 /*return*/];
        });
    }); };
    var onCancelModal = function () {
        props.insuranceSelectionEvent && props.insuranceSelectionEvent(selectedInsurance);
        setShowModal('N');
        if (props.onModalCancellation) {
            props.onModalCancellation();
        }
        props.modalPageLoadEvent && props.modalPageLoadEvent(cancel);
    };
    var onSignupModal = function () {
        setShowModal('N');
        if (props.onModalConfirmation) {
            props.onModalConfirmation();
        }
        props.changeInsurancePlan(currentInsurance);
        props.insuranceSelectionEvent && props.insuranceSelectionEvent(currentInsurance);
        setSelectedInsurance(currentInsurance);
        setExpanded(!expanded$1);
        setShowEdit(true);
        setHideNoThanks(false);
        setPriceChangedAlert(false);
        setApiFailAlert(false);
        setNoThanksChecked(false);
        props.modalPageLoadEvent && props.modalPageLoadEvent(signup);
        setContinueCTA(false);
    };
    var updateNoThanks = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsInsuranceSelected(false);
            setNoThanksChecked(true);
            setSelectedInsurance(noInsuranceData);
            setApiFailAlert(false);
            setTimeout(function () {
                noThanksRef.current.scrollIntoView({
                    behavior: 'smooth',
                });
                ContinuCTARef.current.scrollIntoView({
                    behavior: 'smooth',
                });
                ContinuCTARef.current.focus({ behaviour: 'smooth' });
            }, 10);
            return [2 /*return*/];
        });
    }); };
    var handleInputChange = function (e) {
        var re = /^[0-9\b]+$/;
        if (e.target.value == '' || re.test(e.target.value)) {
            setUpdatedZipCode(e.target.value);
        }
        if (e.target.value.trim().length === 5) {
            setButtonStatus(false);
        }
        else {
            setButtonStatus(true);
        }
    };
    var handleOnClick = function () {
        setApiFailAlert(false);
        setInsuranceProps(true);
        validateZipCode(updatedZipCode);
    };
    var validateZipCode = function (updatedZip) { return __awaiter(void 0, void 0, void 0, function () {
        var response, cookieValue;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0: return [4 /*yield*/, updateValidZipcode(updatedZip, campaignIdHeader)];
                case 1:
                    response = _l.sent();
                    if (response && response.content && response.content.status == 'FAILURE') {
                        setIsZipCodeValid(false);
                        props.zipCodeValidationEvent &&
                            props.zipCodeValidationEvent((_b = (_a = response.content) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.errormsg, (_d = (_c = response.content) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.errorcode, zipCodeContent.zipCodeUpdateCTA, 200, (_e = response.content) === null || _e === void 0 ? void 0 : _e.status, 0, updatedZip);
                    }
                    else {
                        cookieValue = getCookie('attPersistantLocalization', updatedZipCode, true);
                        updateCookie(cookieValue, setNewCookie ? true : false);
                        setIsZipCodeValid(true);
                        setNewZipCode(updatedZipCode);
                        setShowEdit(true);
                        props.zipCodeValidationEvent &&
                            props.zipCodeValidationEvent((_g = (_f = response.content) === null || _f === void 0 ? void 0 : _f.payload) === null || _g === void 0 ? void 0 : _g.errormsg, (_j = (_h = response.content) === null || _h === void 0 ? void 0 : _h.payload) === null || _j === void 0 ? void 0 : _j.errorcode, zipCodeContent.zipCodeUpdateCTA, 200, (_k = response.content) === null || _k === void 0 ? void 0 : _k.status, 1, updatedZip);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getUserZipCode = function () {
        var ZipCodeCookie = getCookie('attPersistantLocalization');
        if (ZipCodeCookie) {
            setNewZipCode(ZipCodeCookie);
        }
    };
    var getCookie = function (cookieName, zipCodeValue, updatedValue) {
        var newValue;
        var cookiesList = document.cookie ? document.cookie.split("; ") : [""];
        var zipIndex = 0;
        for (var _i = 0, cookiesList_1 = cookiesList; _i < cookiesList_1.length; _i++) {
            var cookie = cookiesList_1[_i];
            cookie = cookie.trim();
            // If cookie contains cookieName.
            if (cookie.indexOf(cookieName) + 1) {
                var param = cookie.split('|');
                for (var _a = 0, param_1 = param; _a < param_1.length; _a++) {
                    var value = param_1[_a];
                    var KeyValue = value.split('=');
                    if (KeyValue.includes('zip') || KeyValue.includes('zipCode')) {
                        zipIndex = KeyValue.includes('zip') ? KeyValue.indexOf('zip') : KeyValue.indexOf('zipCode');
                    }
                    if (updatedValue === true) {
                        if (KeyValue.includes('zip') || KeyValue.includes('zipCode')) {
                            var string = KeyValue[zipIndex + 1].replace(/[^a-zA-Z0-9]/g, '');
                            newValue = cookie.replace("" + string, "" + zipCodeValue);
                        }
                    }
                    else {
                        if (KeyValue.includes('zip') || KeyValue.includes('zipCode')) {
                            newValue = KeyValue[zipIndex + 1].replace(/[^a-zA-Z0-9]/g, '');
                        }
                    }
                }
                if (newValue) {
                    return newValue;
                }
                else {
                    return updateZipCode(zipCodeValue);
                }
            }
        }
        return;
    };
    var updateZipCode = function (zipCodeValue) {
        setNewCookie = true;
        var newValue = 'zipCode=' + zipCodeValue;
        return newValue;
    };
    var updateCookie = function (cookieValue, type) {
        props.updateCookie('attPersistantLocalization', cookieValue, type);
    };
    var addText = InsuranceModalState.feedData.master.addInsuranceLabel;
    var editText = InsuranceModalState.feedData.master.edit;
    var insuranceSelectionHeadingExpanded = InsuranceModalState.feedData.master.insuranceSelectionHeadingExpanded;
    var protectedAdvantage = insuranceConstants.protectedAdvantage;
    var mobileInsurance = insuranceConstants.mobileInsurance;
    var addInsuranceSubHeading = InsuranceModalState.feedData.master.addInsuranceSubHeading;
    var addInsuranceSubHeadingCollapsed = InsuranceModalState.feedData.master.addInsuranceSubHeadingCollapsed;
    var zipCodeCopy = zipCodeContent.zipCodeCopy;
    var zipCodeLabel = zipCodeContent.zipCodeLabel;
    var zipCodeUpdateCTA = zipCodeContent.zipCodeUpdateCTA;
    var noInsuranceCopy = InsuranceModalState.feedData.master.noThanks;
    var insuranceHeadsUpModalDescription = InsuranceModalState.feedData.master.insuranceHeadsUpModalDescription;
    var noInsuranceModalSubHeader = processedNoInsuranceHeader(insuranceHeadsUpModalDescription);
    insuranceHeadsUpModalDescription = processedNoInsuranceContent(insuranceHeadsUpModalDescription, price);
    var continueWithoutCTALabel = InsuranceModalState.feedData.master.continueWithoutCTALabel;
    var wrapperClass = props.className ? props.className : '';
    var panelSpacing = 'pad-r-none pad-l-none rwd';
    var noSpacing = 'pad-b-none';
    var noThanksAnalyticsObj = {
        desc: noInsuranceModalSubHeader,
        displayName: noInsuranceCopy,
        insuranceType: 'NA',
        offerId: props.productCode,
        price: {},
        skuId: props.skuID,
    };
    var modalPageLoadValues = {
        friendlyPageName: 'INSURANCE SIGNUP MODAL',
        url: '/signup/modal',
    };
    var signup = {
        onClick: 'signedup',
    };
    var cancel = {
        onclick: 'cancel/closed',
    };
    var zipCodeUpdateContent = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "color-ui-black font-regular type-xs pad-l-xxxs " + (priceChangedAlert ? "pad-t-none" : "pad-t-xs"), style: { width: '100%' } },
            ' ',
            zipCodeCopy,
            ' '),
        React__default.createElement("button", { "data-qa": "Zipcode-Update", onClick: function () {
                props.onLinkClick && props.onLinkClick(zipCodeLabel);
                setZipCodeCollapsible(!collapseZipCode);
                setUpdatedZipCode(newZipCode);
                setIsZipCodeValid(true);
            }, className: "pad-l-xxxs " + panel + " " + (collapseZipCode ? ' ' + expanded : '') },
            React__default.createElement("div", { className: panelMain + " " + container + " " + panelSpacing + " rwd" },
                React__default.createElement("div", { className: "" + bannerText },
                    React__default.createElement("span", { className: "color-ui-black font-medium formfield-label pad-b--lg cursor flex-direction-row" },
                        React__default.createElement("span", { className: zipCodeFont + "type-base font-bold color-ui-black mar-b-none line-h-xs" }, zipCodeLabel),
                        React__default.createElement("span", { className: "type-sm font-medium color-cobalt pad-l-xxxs" },
                            " ",
                            newZipCode,
                            " "),
                        React__default.createElement("span", { className: "mar-l-xxxs mar-t-xxxs color-cobalt " + arrowIcon })))))));
    var toggleContent = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("button", { value: "ProtectedAdvantage", className: "btn-small mar-r-xs pad-l-none pad-r-none " + btnColor, onClick: function () {
                setInsuranceList(protectedPlansList);
                setToggleClicked(!toggleClicked);
                btnColor ? setBtnColor("btn-primary-2") : '';
                setSelectedBtn("btn-secondary");
            } }, protectedAdvantage),
        React__default.createElement("button", { value: "MobileInsurance", className: "btn-small mar-r-xs pad-l-none pad-r-none " + selectedbtn, onClick: function () {
                setInsuranceList(mobilePlansList);
                selectedbtn ? setSelectedBtn('btn-primary-2') : '';
                setBtnColor("btn-secondary");
            } }, mobileInsurance)));
    var alertUser = priceChangedAlert && !apiFailAlert ? (React__default.createElement("div", { className: alertIcon, style: { width: '100%' } },
        React__default.createElement(components.Alert, { type: "warning", style: { padding: '0px !important' } },
            React__default.createElement("p", { className: "font-regular type-sm pad-l-none pad-r-none" }, alertMessage)))) : null;
    var alertApiFail = apiFailAlert ? (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: alertIcon },
            React__default.createElement(components.Alert, { type: "warning" },
                React__default.createElement("p", { className: "font-bold type-sm pad-l-none pad-r-none" }, alertOnApiFail))))) : null;
    var insuranceContent = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "color-ui-black font-regular type-xs mar-b-none pad-l-xxxs", id: "insurance-subheading" },
            ' ',
            addInsuranceSubHeading,
            ' '),
        alertUser,
        props.letUpdateZipCode && zipCodeUpdateContent,
        collapseZipCode && (React__default.createElement("div", { style: { width: '275px', position: 'relative' }, className: "type-base color-ui-black font-regular pad-l-xxxs pad-b--lg cursor flex-direction-row" },
            React__default.createElement(components.TextField, { id: "zipcode-id", data: {
                    input: updatedZipCode,
                    placeHolder: newZipCode,
                    name: 'zipCode',
                }, events: {
                    onChange: handleInputChange,
                }, options: {
                    type: TextFieldProps.TextFieldType.TEXT,
                    maxLength: 5,
                    error: !validZipCode ? true : false,
                    errorText: errorLabel,
                } }),
            React__default.createElement("button", { className: "btn-primary-2 btn-small " + buttonClass, onClick: handleOnClick, disabled: buttonStatus }, zipCodeUpdateCTA))),
        React__default.createElement("div", { "data-qa": "individual-content", className: "pad-t-none pad-b-none", style: { width: '100%' } }, alertApiFail),
        React__default.createElement(components.CardShellRow, { className: noSpacing + " pad-t-none" },
            insuranceList.map(function (insurance, index) {
                var _a, _b;
                return (React__default.createElement("div", { key: index, className: "grid-col-12 pad-l-none pad-r-none pad-b-none pad-t-xs " + (selectedInsurance && selectedInsurance.offerId === insurance.offerId
                        ? cardShell
                        : noSelection) },
                    React__default.createElement(components.CardShell, { onClick: function () {
                            onChangeInsurancePlan(insurance);
                        }, type: "radio", isChecked: selectedInsurance && selectedInsurance.offerId === insurance.offerId ? true : false },
                        React__default.createElement("div", { className: insurancePlanWrapper + " full-width font-regular type-base color-ui-black mar-b-none" },
                            React__default.createElement("div", { className: insurancePlanHeading + " pad-r-xxxs", dangerouslySetInnerHTML: { __html: purify.sanitize(insurance.displayName) } }),
                            React__default.createElement("div", { className: "type-base text-right font-medium pad-r-none " + insurancePlanHeading + " " + labelPosition },
                                React__default.createElement("span", { className: "font-medium type-base" }, "+$"),
                                React__default.createElement("span", { className: "font-bold", dangerouslySetInnerHTML: {
                                        __html: purify.sanitize((_b = (_a = insurance === null || insurance === void 0 ? void 0 : insurance.price) === null || _a === void 0 ? void 0 : _a.mrc) === null || _b === void 0 ? void 0 : _b.toFixed(2)),
                                    } }),
                                React__default.createElement("span", { className: "font-bold" }, "/mo."))),
                        !props.hideDescription ? (React__default.createElement("div", { className: planDescription + " pad-t-xs" },
                            React__default.createElement(components.HorizontalRule, null),
                            React__default.createElement("ul", null, insurance.descList &&
                                Array.isArray(insurance.descList) &&
                                insurance.descList.length > 0 ? (insurance.descList.map(function (desc) { return (React__default.createElement("li", { className: "font-regular type-sm", dangerouslySetInnerHTML: { __html: purify.sanitize(desc) } })); })) : (React__default.createElement("li", { className: "font-regular type-sm", dangerouslySetInnerHTML: {
                                    __html: purify.sanitize(insurance.descList),
                                } }))))) : (''))));
            }),
            React__default.createElement("div", { className: "grid-col-12 pad-l-none pad-r-none pad-b-none pad-t-xs " + (noThanksChecked ? cardShell : noSelection) },
                React__default.createElement(components.CardShell, { onClick: updateNoThanks, isChecked: noThanksChecked, type: "radio" },
                    React__default.createElement("div", { className: "font-regular " + fontNothanks }, noInsuranceCopy))))));
    return insuranceList && insuranceList.length > 0 ? (React__default.createElement("div", { "data-qa": "insurance-modal", className: insuranceModal + " " + insuranceModelSize + " " + wrapperClass + " " + roundBorder + " bg-ui-white" },
        React__default.createElement("div", { className: "pad-none" },
            React__default.createElement("div", { className: "type-base font-medium color-ui-black " + (expanded$1 && collapseSection) },
                React__default.createElement("button", { "aria-labelledby": 'Insurance_Heading', "aria-expanded": expanded$1, id: 'insurance_heading', "aria-controls": 'insurance_content', onClick: function () {
                        var analyticsClickText = addText;
                        if (showEdit && (expanded$1 || (selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.displayName) || continueCTA)) {
                            analyticsClickText = editText;
                        }
                        props.onLinkClick && props.onLinkClick(analyticsClickText, !expanded$1 ? 'expanded' : 'collapsed');
                        if ((!showEdit && selectedInsurance) || (!showEdit && !noThanksChecked)) {
                            setExpanded(expanded$1);
                        }
                        else {
                            setExpanded(!expanded$1);
                            setZipCodeCollapsible(false);
                            if (props.insurancePanelOnClick) {
                                props.insurancePanelOnClick('Button', !expanded$1);
                            }
                        }
                        if ((selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.offerId) !== 'NA' && noThanksChecked) {
                            setIsInsuranceSelected(true);
                            setNoThanksChecked(false);
                        }
                        if ((((selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.offerId) === 'NA' && !isInsuranceSelected) && noThanksChecked) && !continueCTA) {
                            setSelectedInsurance(props.currentSelection);
                        }
                        if ((selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.offerId) === 'NA' && isInsuranceSelected && noThanksChecked && !continueCTA) {
                            setSelectedInsurance(props.currentSelection);
                            setNoThanksChecked(false);
                        }
                    }, className: panel + " " + (expanded$1 ? 'pad-l-xxxs ' + expanded : '') },
                    React__default.createElement("div", { className: panelMain + " " + container + " " + panelSpacing + " rwd " },
                        React__default.createElement("div", { className: "" + bannerText },
                            insuranceSelectionHeadingExpanded ? (React__default.createElement("span", { className: insuranceHeading + "  font-medium color-ui-black mar-b-none pad-r-xxxs line-h-md" }, insuranceSelectionHeadingExpanded)) : null,
                            showEdit && (expanded$1 || (selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.displayName) || continueCTA) && (React__default.createElement("div", { className: bannerToggle + " " + labelPosition },
                                React__default.createElement("span", { className: toggleText + " type-sm font-medium color-cobalt mar-r-xxs" }, editText),
                                React__default.createElement("span", { className: "pad-r-xxs " + editArrowIcon }))),
                            !expanded$1 && !(selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.displayName) && !noThanksChecked && (React__default.createElement("div", { className: bannerToggle + " " + labelPosition },
                                React__default.createElement("span", { className: toggleText + " type-sm font-medium color-cobalt mar-r-xxs" }, addText))),
                            !expanded$1 && !(selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.displayName) && noThanksChecked && !continueCTA && (React__default.createElement("div", { className: bannerToggle + " " + labelPosition },
                                React__default.createElement("span", { className: toggleText + " type-sm font-medium color-cobalt mar-r-xxs" }, addText)))))),
                insuranceList && insuranceList.length > 0 && (React__default.createElement(components.Collapse, { expanded: expanded$1 },
                    mobilePlansList &&
                        mobilePlansList.length > 0 &&
                        protectedPlansList &&
                        protectedPlansList.length > 0 && (React__default.createElement("div", { className: "flex color-ui-black font-regular type-sm mar-t-xs  mar-b-xs " + toggleScroll }, toggleContent)),
                    React__default.createElement("div", { id: 'insurance_content', className: drawerOuter + " flex flex-wrap justify-start " + container }, insuranceContent))),
                expanded$1 && noThanksChecked && !isInsuranceSelected && (React__default.createElement("div", { ref: noThanksRef, className: noThanksDesc, style: hideNoThanks ? { display: 'none' } : {} },
                    React__default.createElement("div", { className: "" + error$1 },
                        React__default.createElement(components.Alert, { type: "error", className: "" + alert$1 },
                            React__default.createElement("p", { className: "font-regular type-sm pad-l-none pad-r-none " + fontsize }, noInsuranceModalSubHeader))),
                    React__default.createElement("div", { className: noThanksSubcontent + " text-align-left full-width mar-b-none type-sm font-regular", dangerouslySetInnerHTML: { __html: purify.sanitize(insuranceHeadsUpModalDescription) } }),
                    React__default.createElement("div", { "data-qa": "CTA" },
                        React__default.createElement("button", { ref: ContinuCTARef, className: "btn false false btn-primary btn-small full-width mar-t-xs", style: { width: '100%' }, onClick: function () {
                                setContinueCTA(true);
                                setSelectedInsurance(noInsuranceData);
                                props.insuranceSelectionEvent &&
                                    props.insuranceSelectionEvent(noThanksAnalyticsObj);
                                setHideNoThanks(true);
                                setExpanded(!expanded$1);
                                props.noThanksSelected();
                                props.changeInsurancePlan(noInsuranceData);
                                setPriceChangedAlert(false);
                                setShowEdit(true);
                                props.onLinkClick && props.onLinkClick(continueWithoutCTALabel);
                            } }, continueWithoutCTALabel)))),
                !expanded$1 && !noThanksChecked && !isInsuranceSelected && !continueCTA && (React__default.createElement("div", { className: "color-ui-black font-regular type-xs mar-b-none" },
                    ' ',
                    addInsuranceSubHeadingCollapsed,
                    ' ')),
                !expanded$1 && noThanksChecked && isInsuranceSelected && !continueCTA && !selectedInsurance && (React__default.createElement("div", { className: "color-ui-black font-regular type-xs mar-b-none" },
                    ' ',
                    addInsuranceSubHeadingCollapsed,
                    ' ')),
                !expanded$1 && noThanksChecked && !isInsuranceSelected && !continueCTA && !selectedInsurance && (React__default.createElement("div", { className: "color-ui-black font-regular type-xs mar-b-none" },
                    ' ',
                    addInsuranceSubHeadingCollapsed,
                    ' ')),
                !selectedInsurance && !expanded$1 && !noThanksChecked && isInsuranceSelected && !continueCTA && (React__default.createElement("div", { className: "color-ui-black font-regular type-xs mar-b-none" },
                    ' ',
                    addInsuranceSubHeadingCollapsed,
                    ' ')),
                !expanded$1 && noThanksChecked && !isInsuranceSelected && !continueCTA && hideNoThanks && (React__default.createElement("div", { className: "color-ui-black font-regular type-xs mar-b-none" },
                    ' ',
                    addInsuranceSubHeadingCollapsed,
                    ' ')),
                continueCTA && !expanded$1 && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("div", { className: overallPadding + " flex full-width font-regular color-ui-black  " + panelSpacing + " " + insurancePlanHeading },
                        React__default.createElement("div", null, noInsuranceCopy)))),
                ((selectedInsurance && isInsuranceSelected) || noThanksChecked) && !expanded$1 && !continueCTA && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("div", { "data-qa": "insurancePlanContent", className: insurancePlanWrapper + " full-width color-ui-black pad-r-none pad-l-none rwd" },
                        React__default.createElement("div", { "data-qa": "collapsed-selected-insurance", className: insurancePlanHeading + " font-regular", dangerouslySetInnerHTML: {
                                __html: purify.sanitize(selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.displayName),
                            } }),
                        ((_a = selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.price) === null || _a === void 0 ? void 0 : _a.mrc) !== null ? (React__default.createElement("div", { className: "font-medium " + labelPosition }, selectedInsurance && selectedInsurance.price && selectedInsurance.price.mrc && (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement("span", { className: "font-medium" }, "+$"),
                            React__default.createElement("span", { className: "font-medium" }, ((_b = selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.price) === null || _b === void 0 ? void 0 : _b.mrc) !== null
                                ? (_d = (_c = selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.price) === null || _c === void 0 ? void 0 : _c.mrc) === null || _d === void 0 ? void 0 : _d.toFixed(2) : (_e = selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.price) === null || _e === void 0 ? void 0 : _e.mrc),
                            React__default.createElement("span", { className: "font-medium" }, "/mo."))))) : (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement("div", { className: " color-ui-black font-regular type-xs mar-b-none" }, addInsuranceSubHeadingCollapsed)))))),
                showModal == 'Y' ? (React__default.createElement(SignupModal, { offerID: currentInsurance.offerId, show: true, insuranceContent: InsuranceModalState, onCancelBtnClick: onCancelModal, onSignupBtnClick: onSignupModal })) : (''))))) : null;
};

export { InsuranceModal };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sales/insurance-modal-duc2.0/dist/insurance-modal.es.js
// module id = 2304
// module chunks = 8